(function() {
  'use strict';

  angular
    .module('frispo', [
      'ngAnimate',
      'ngCookies',
      'ngSanitize',
      'ngMessages',
      'ui.router',
      'puigcerber.camelize',
      'toastr',
      'ezfb',
      'ui.bootstrap',
      'isteven-multi-select',
      'angularUtils.directives.dirPagination',
      'ngFileSaver',
      'dndLists'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('scorersBox', scorersBox);

  /** @ngInject */
  function scorersBox() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/calendar/advancedEdit/scorersBox/scorersBox.html',
      controller: ScorersBoxController,
      controllerAs: 'scorersBox',
      bindToController: true,
      replace: true,
      scope: {
        scorers: '=',
        teamName: '=',
        teamId: '=',
        matchId: '=',
        autocomplete: '=',
        scorersKey: '@'
      }
    };

    return directive;

    /** @ngInject */
    function ScorersBoxController(utils, $q, matches, teams, $scope, models) {
      var vm = this;
      vm.scores = utils.scores();
      vm.scores.splice(0,1);

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.createScorer = function () {
        vm.setLoading(vm.form)
          .then(matches.form2Scorer)
          .then(function (scorerData) {
            return matches.createScorer(vm.matchId, scorerData, vm.scorersKey);
          })
          .then(vm.resetForm)
          // manually update the scorers list because for some reasons
          // the binding with variable scorers has been lost
          .then(function(newScorer) {
              var toUpdate = vm.scorers.filter(
                function(scorer) { return scorer.playId === newScorer.playId });
              if (toUpdate.length !== 0)
                toUpdate[0].goal = newScorer.goal;
              else vm.scorers.push(newScorer);
          })
          .finally(vm.unsetLoading);
      }

      vm.destroyScorer = function (scorer) {
        vm.setLoading()
          .then(function () {
            return matches.destroyScorer(vm.matchId, scorer.playId, vm.scorersKey)
          })
          // manually update the scorers list because for some reasons
          // the binding with variable scorers has been lost
          .then(function() {
            var toRemoveIndex = vm.scorers
              .map(function(actual, index) {
                return actual.playId === scorer.playId ? index : 0;
            }).reduce(
              function(a, b) { return a + b; }, 0);

            vm.scorers.splice(toRemoveIndex, 1);
          })
          .finally(vm.unsetLoading);
      }

      vm.resetFormModel = function () {
        vm.form = { teamId: vm.teamId, goals: 1, playId: 0 }
      }

      vm.resetFormFields = function () {
        $scope['createScorerForm' + vm.teamId].$setPristine();
        $scope['createScorerForm' + vm.teamId].$setUntouched();
      }

      vm.resetForm = function (res) {
        vm.resetFormModel();
        vm.resetFormFields();
        return res;
      }

      // GetterSetter function - see angular docs for ng-model-options
      vm.typeaheadName = function (val) {
        if(arguments.length){
          if(angular.isString(val)){
            vm.form.name = val;
            vm.form.playId = 0;
          }
          else if(angular.isObject(val)){
            vm.populateForm(val);
          }
        }
        else{
          return vm.form.name;
        }
      }

      // GetterSetter function - see angular docs for ng-model-options
      vm.typeaheadSurname = function (val) {
        if(arguments.length){
          if(angular.isString(val)){
            vm.form.surname = val;
            vm.form.playId = 0;
          }
          else if(angular.isObject(val)){
            vm.populateForm(val);
          }
        }
        else{
          return vm.form.surname;
        }
      }

      vm.populateForm = function (obj) {
        if(angular.isString(obj.name)) vm.form.name = obj.name;
        if(angular.isString(obj.surname)) vm.form.surname = obj.surname;
        if(angular.isNumber(obj.teamId)) vm.form.teamId = obj.teamId;
        if(angular.isNumber(obj.playId)) vm.form.playId = obj.playId;
      }

      vm.resetFormModel();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('cardsBox', cardsBox);

  /** @ngInject */
  function cardsBox() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/calendar/advancedEdit/cardsBox/cardsBox.html',
      controller: CardsBoxController,
      controllerAs: 'cardsBox',
      bindToController: true,
      replace: true,
      scope: {
        cards: '=',
        teamName: '=',
        teamId: '=',
        matchId: '=',
        cardsKey: '@',
        autocomplete: '='
      }
    };

    return directive;

    /** @ngInject */
    function CardsBoxController(utils, $q, matches, $scope, teams) {
      var vm = this;

      vm.cardTypes = utils.cardTypes();
      vm.disqualificationDays = utils.scores();

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.createCard = function () {
        vm.setLoading(vm.form)
          .then(matches.form2Card)
          .then(function (cardData) {
            return matches.createCard(vm.matchId, cardData, vm.cardsKey);
          })
          .then(vm.resetForm)
          // manually update the cards list
          .then(function(newCard) {
            var toUpdate = vm.cards.filter(
              function(card) { return card.cardId === newCard.cardId });
            if (toUpdate.length === 0)
              vm.cards.push(newCard);
          })
          .finally(vm.unsetLoading);
      }

      vm.destroyCard = function (card) {
        vm.setLoading()
          .then(function () {
            return matches.destroyMatchCard(vm.matchId, card.cardId, vm.cardsKey)
          })
          // manually update the cards list
          .then(function() {
            vm.cards = vm.cards.filter(
              function(c) { return c.cardId !== card.cardId });
          })
          .finally(vm.unsetLoading);
      }

      vm.resetFormModel = function () {
        vm.form = { teamId: vm.teamId, goals: 1, playId: 0 }
      }

      vm.resetFormFields = function () {
        $scope['createCardForm' + vm.teamId].$setPristine();
        $scope['createCardForm' + vm.teamId].$setUntouched();
      }

      vm.resetForm = function (res) {
        vm.resetFormModel();
        vm.resetFormFields();
        return res;
      }

      // GetterSetter function - see angular docs for ng-model-options
      vm.typeaheadName = function (val) {
        if(arguments.length){
          if(angular.isString(val)){
            vm.form.name = val;
            vm.form.playId = 0;
          }
          else if(angular.isObject(val)){
            vm.populateForm(val);
          }
        }
        else{
          return vm.form.name;
        }
      }

      // GetterSetter function - see angular docs for ng-model-options
      vm.typeaheadSurname = function (val) {
        if(arguments.length){
          if(angular.isString(val)){
            vm.form.surname = val;
            vm.form.playId = 0;
          }
          else if(angular.isObject(val)){
            vm.populateForm(val);
          }
        }
        else{
          return vm.form.surname;
        }
      }

      vm.populateForm = function (obj) {
        if(angular.isString(obj.name)) vm.form.name = obj.name;
        if(angular.isString(obj.surname)) vm.form.surname = obj.surname;
        if(angular.isNumber(obj.teamId)) vm.form.teamId = obj.teamId;
        if(angular.isNumber(obj.playId)) vm.form.playId = obj.playId;
      }

      teams.listPlayers(vm.teamId)
        .then(function (res) {
          vm.autocomplete = [];
          if(angular.isArray(res)){
            angular.forEach(res, function (el) {
              vm.autocomplete.push({
                playId: el.playId,
                name: el.playFirstname,
                surname: el.playSurname,
                teamId: el.playTeamId
              });
            });
          }
        });

      vm.resetFormModel();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('amendsBox', amendsBox);

  /** @ngInject */
  function amendsBox() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/calendar/advancedEdit/amendsBox/amendsBox.html',
      controller: AmendsBoxController,
      controllerAs: 'amendsBox',
      bindToController: true,
      replace: true,
      scope: {
        amends: '=',
        teamName: '=',
        teamId: '=',
        matchId: '=',
        amendsKey: '@',
        autocomplete: '='
      }
    };

    return directive;

    /** @ngInject */
    function AmendsBoxController(utils, $q, matches, $scope) {
      var vm = this;

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.createAmend = function () {
        vm.setLoading(vm.form)
          .then(matches.form2Amend)
          .then(function (amendData) {
            return matches.createAmend(vm.matchId, amendData, vm.amendsKey);
          })
          .then(vm.resetForm)
          .finally(vm.unsetLoading);
      }

      vm.destroyAmend = function (amend) {
        vm.setLoading()
          .then(function () {
            return matches.destroyMatchAmend(vm.matchId, amend.amenId, vm.amendsKey)
          })
          .finally(vm.unsetLoading);
      }

      vm.resetFormModel = function () {
        vm.form = { teamId: vm.teamId }
      }

      vm.resetFormFields = function () {
        $scope['createAmendForm' + vm.teamId].$setPristine();
        $scope['createAmendForm' + vm.teamId].$setUntouched();
      }

      vm.resetForm = function (res) {
        vm.resetFormModel();
        vm.resetFormFields();
        return res;
      }

      vm.resetFormModel();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('teamShow', teamShow);

  /** @ngInject */
  function teamShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/teams/show/show.html',
      controller: TeamShowController,
      controllerAs: 'teamShow',
      bindToController: true,
      replace: true,
      link: TeamShowLink,
      scope: {
        team: '=teamShow'
      }
    };

    return directive;

    /** @ngInject */
    function TeamShowController($uibModal, teams, models) {
      var vm = this;
      vm.models = models;

      vm.destroy = function() {

        $uibModal.open({
            templateUrl: 'app/pages/teams/destroy/destroy.html',
            controller: 'TeamDestroyController',
            controllerAs: 'teamDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res){
              if (vm.team.teamTemp === 1) {
                teams.destroy(vm.team);
            //    teams.list();
              } else {
                teams.destroyTemp(vm.team);
              //  teams.listTemp();
              }
            }
          })
          .then(teams.list)
          .then(teams.listTemp)
      }

      vm.models = models;
    }

    /** @ngInject */
    function TeamShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('TeamUpdatePlaceController', TeamUpdatePlaceController);

  /** @ngInject */
  function TeamUpdatePlaceController($uibModalInstance, luogo) {
    var vm = this;
    vm.luogo=luogo;
    vm.ok = function () {
      $uibModalInstance.close(vm.luogo);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('teamEdit', teamEdit);

  /** @ngInject */
  function teamEdit() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/teams/edit/edit.html',
      controller: TeamEditController,
      controllerAs: 'teamEdit',
      link: TeamEditLink,
      bindToController: true,
      replace: true,
      scope: {
        team: '=teamEdit'
      }
    };

    return directive;

    /** @ngInject */
    function TeamEditController(models, $q, teams, $window, utils, $uibModal) {
      var vm = this;

      vm.models = models;

      vm.teamFormulas = utils.teamOptions();

      vm.week = [
        {
          id: 1,
          value: "Lunedì"
        },
        {
          id: 2,
          value: "Martedì"
        },
        {
          id: 3,
          value: "Mercoledì"
        },
        {
          id: 4,
          value: "Giovedì"
        },
        {
          id: 5,
          value: "Venerdì"
        },
        {
          id: 6,
          value: "Sabato"
        },
        {
          id: 7,
          value: "Domenica"
        }
      ]

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.loadtmp = function() {
        return vm.setLoading()
          .then(function () {
            var span = angular.element('#'+vm.team.teamId+'-upload-file-info');
            span.html('Immagine caricata, premere Salva per confermare');
          })
          .finally(vm.unsetLoading);
      }

      vm.updatePlace = function (luogo) {
        $uibModal.open({
          templateUrl: 'app/pages/teams/edit/updatePlace.html',
          controller: 'TeamUpdatePlaceController',
          controllerAs: 'teamUpdatePlace',
          windowClass: 'modal-warning',
          resolve: {
            luogo: function() {
              return luogo;
            }
          }
        }).result
        .then(function (res) {
          if(res){
            return vm.setLoading(vm.team.teamId, res)
              .then(teams.updatePlace(vm.team.teamId, res))
              .then(function () {
                return teams.show(vm.team.teamId);
              })
              .finally(vm.unsetLoading);
          }
        })

      }

      vm.submit = function () {
        var updateplace = vm.form.place!=vm.team.teamPlace;
        return vm.setLoading(vm.form)
          .then(teams.getTokenS3)
          .then(function(data){
            var angularFile = angular.element('#teamEditForm'+vm.team.teamId+'-teamUrlLogo');
            var file = angularFile[0].files[0];

            if (file) {
              var deferred = $q.defer();
              var credentials = {accessKeyId: data.data[0].keyid, secretAccessKey: data.data[0].secretid, sessionToken: data.data[0].session_token};
              AWS.config.update(credentials);
              AWS.config.region = 'eu-west-1';
              AWS.config.sslEnabled = true;
              var bucket = new AWS.S3({params:{Bucket:'com.codeploy.frispo.image.teams/original'}});
              var fileName = "";
              if (file) fileName = angularFile[0].files[0].name;
              var ts = new Date().getTime();
              var fileNameEscape = fileName.replace(/\s+/g,'_');
              vm.form.teamUrlLogo = ts +  "-" + fileNameEscape;
              if(file){
                var params = {Key: '' + ts+"-" + fileNameEscape, ContentType: file.type, Body: file };
                bucket.upload(params, function(err, data){
                  if(data){
                    deferred.resolve(data);
                  }else if(err){
                    deferred.reject(err);
                  }
                })
              }else{
                deferred.reject(false);
              }
              return deferred.promise;
            }
          })
          .then(function(){
            return teams.form2Team(vm.form)
          })
          .then(function (teamData) {
            return teams.update(vm.team.teamId, teamData);
          })
          .then(function () {
            var span = angular.element('#'+vm.team.teamId+'-upload-file-info');
            span.html('');
          })
          .then(teams.list)
          .then(teams.listTemp)
          .finally(vm.unsetLoading);
      }

      vm.showLogo = function (linkLogo){
        $window.open(linkLogo, '_blank');
      }

    }

    function TeamEditLink(scope, el, attrs, vm) {
      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('TeamDestroyController', TeamDestroyController);

  /** @ngInject */
  function TeamDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('frispo')
        .controller('TeamCreateController', TeamCreateController);

    /** @ngInject */
    function TeamCreateController($uibModalInstance, models, utils) {
        var vm = this;

        vm.roundNames = utils.alphabetChars();
        vm.models = models;
        vm.teamFormulas = utils.teamOptions();
        vm.ok = function() {
            vm.loading = true;
            $uibModalInstance.close(vm.form);
        }

        vm.cancel = function() {
            $uibModalInstance.dismiss();
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('scorerShow', scorerShow);

  /** @ngInject */
  function scorerShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/scorers/show/show.html',
      controller: ScorerShowController,
      controllerAs: 'scorerShow',
      bindToController: true,
      replace: true,
      link: ScorerShowLink,
      scope: {
        scorer: '=scorerShow'
      }
    };

    return directive;

    /** @ngInject */
    function ScorerShowController($uibModal, models) {
      var vm = this;
      vm.models = models;
    }

    /** @ngInject */
    function ScorerShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('frispo')
        .controller('ScorersImportController', ScorersImportController);

    /** @ngInject */
    function ScorersImportController($uibModalInstance) {
        var vm = this;

        vm.ok = function () {
            vm.loading = true;
            var angularFile = angular.element('#importScorersFormFile');
            var payload = {
                file: angularFile[0].files[0]
            }
            $uibModalInstance.close(payload);
        }

        vm.loadtmp = function () {
            var span = angular.element('#esitoFileImportScorers');
            var angularFile = angular.element('#importScorersFormFile');
            span.html('File '+angularFile[0].files[0].name+' selezionato');
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('scorerEdit', scorerEdit);

  /** @ngInject */
  function scorerEdit() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/scorers/edit/edit.html',
      controller: ScorerEditController,
      controllerAs: 'scorerEdit',
      link: ScorerEditLink,
      bindToController: true,
      replace: true,
      scope: {
        scorer: '=scorerEdit'
      }
    };

    return directive;

    /** @ngInject */
    function ScorerEditController(models, $q, $uibModal, events) {
      var vm = this;

      vm.models = models;

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.createNewScorerMatch = function () {
        $uibModal.open({
            templateUrl: 'app/pages/scorerMatch/create/create.html',
            controller: 'ScorerMatchCreateController',
            controllerAs: 'scorerMatchCreate',
            windowClass: 'modal-success'
          }).result
          .then(function (res) {
            if(angular.isDefined(res)){
              vm.setLoading(res)
                .then(events.form2ScorerMatch)
                .then(events.createScorerMatch)
                .finally(vm.unsetLoading);
            }
          })
      }
    }

    function ScorerEditLink(scope, el, attrs, vm) {
      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('scoreboardShoworder', scoreboardShoworder);

  /** @ngInject */
  function scoreboardShoworder() {
    return {
      restrict: 'EA',
      templateUrl: 'app/pages/scoreboard/showorder/showorder.html',
      controller: ScoreboardShowController,
      controllerAs: 'scoreboardShoworder',
      bindToController: true,
      replace: true,
      scope: { lists: '=scoreboardShoworder' }
    };

    /** @ngInject */
    function ScoreboardShowController($scope, models, events, $q) {
      var vm = this;
      vm.selected = null;

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.getOrderCriteria = function() { return vm.lists || null; }

      $scope.$watch(vm.getOrderCriteria, function(criteria) {
        vm.lists = criteria.map(function(crt, idx) {
          crt.order = idx + 1; return crt;
        });
      }, true);     // use object equality and not memory address

      vm.saveOrder = function () {
        events.postScoreboardOrdreCriteria(models.currentEvent, vm.lists);

        vm.setLoading(models.currentEvent)         // Set a spinning loader on the page
          .then(events.showScoreboard)      // Get the scoreboard for given event
          .finally(vm.unsetLoading);
      }

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('scoreboardShow', scoreboardShow);

  /** @ngInject */
  function scoreboardShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/scoreboard/show/show.html',
      controller: ScoreboardShowController,
      controllerAs: 'scoreboardShow',
      bindToController: true,
      replace: true,
      link: ScoreboardShowLink,
      scope: {
        event: '=scoreboardShow',
        hideControls: '='
      }
    };

    return directive;

    /** @ngInject */
    function ScoreboardShowController() {
      var vm = this;

      vm.models = "";
    }

    /** @ngInject */
    function ScoreboardShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('scoreboardEdit', scoreboardEdit);

  /** @ngInject */
  function scoreboardEdit(teams) {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/scoreboard/edit/edit.html',
      controller: ScoreboardEditController,
      controllerAs: 'scoreboardEdit',
      link: ScoreboardEditLink,
      bindToController: true,
      replace: true,
      scope: {
        event: '=scoreboardEdit'
      }
    };

    return directive;

    /** @ngInject */
    function ScoreboardEditController(models, $q) {
      var vm = this;

      vm.models = models;

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.submit = function () {

        var payload = {rank_team_id:vm.event.rankTeamId,rank_var_points:vm.form.punti,rank_var_foul:vm.form.disciplina}
        return vm.setLoading(payload)
          .then(teams.updatePointfoul)
          .then(teams.showScoreboard)
          .finally(vm.unsetLoading);
      }


    }

    function ScoreboardEditLink(scope, el, attrs, vm) {

      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('scorerMatchShow', scorerMatchShow);

  /** @ngInject */
  function scorerMatchShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/scorerMatch/show/show.html',
      controller: ScorerMatchShowController,
      controllerAs: 'scorerMatchShow',
      bindToController: true,
      replace: true,
      link: ScorerMatchShowLink,
      scope: {
        scorerMatch: '=scorerMatchShow',
        scorerMatchPlayerId: '=scorerMatchPlayerId'
      }
    };

    return directive;

    /** @ngInject */
    function ScorerMatchShowController($uibModal, models, utils, events) {
      var vm = this;
      vm.scores = utils.scores();

      vm.submitGoal = function (){
        return events
          .updateScorerMatch(models.currentEvent.evenId, vm.scorerMatch.matcId, {
            scor_play_id: vm.scorerMatchPlayerId,
            scor_goal: vm.form.goal
          })
          .then(function () {
            return vm.models.currentEvent.evenId;
          })
          .then(events.showScorers)
          .finally(vm.unsetLoading);
      }

      vm.destroy = function() {

        $uibModal.open({
            templateUrl: 'app/pages/scorerMatch/destroy/destroy.html',
            controller: 'ScorerMatchDestroyController',
            controllerAs: 'scorerMatchDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res === true){
              events.destroyScorerMatch(models.currentEvent.evenId, vm.scorerMatchPlayerId, vm.scorerMatch);
            }
          })
      }

      vm.models = models;
    }

    /** @ngInject */
    function ScorerMatchShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('ScorerMatchDestroyController', ScorerMatchDestroyController);

  /** @ngInject */
  function ScorerMatchDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('frispo')
        .controller('ProfileDestroyController', ProfileDestroyController);

    /** @ngInject */
    function ProfileDestroyController($uibModalInstance) {
        var vm = this;

        vm.ok = function() {
            $uibModalInstance.close(true);
        }

        vm.cancel = function() {
            $uibModalInstance.dismiss();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('pressShow', pressShow);

  /** @ngInject */
  function pressShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/press/show/show.html',
      controller: PressShowController,
      controllerAs: 'pressShow',
      bindToController: true,
      replace: true,
      link: PressShowLink,
      scope: {
        press: '=pressShow'
      }
    };

    return directive;

    /** @ngInject */
    function PressShowController($uibModal, press, models) {
      var vm = this;

      vm.destroy = function() {

        $uibModal.open({
            templateUrl: 'app/pages/press/destroy/destroy.html',
            controller: 'PressDestroyController',
            controllerAs: 'pressDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res === true){
              press.destroy(vm.press);
            }
          })
      }

      vm.models = models;
    }

    /** @ngInject */
    function PressShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() { 'use strict'

  angular.module('frispo')
    .controller('PressLoadController', PressLoadController);

  /** @ngInject */
  function PressLoadController($uibModalInstance, models, press, utils) {

    var vm = this; vm.models = models;
    vm.multiSelectTranslation = utils.istevenMultiSelectTranslation();
    vm.events = angular.copy(models.events);
    vm.fileText = "";

    function getAWSBucket() {
      return press.getTokenS3().then(function(res) {
          var credentials = {
            accessKeyId: res.data[0].keyid,
            secretAccessKey: res.data[0].secretid,
            sessionToken: res.data[0].session_token
          };
          AWS.config.update(credentials);
          AWS.config.region = 'eu-west-1';
          AWS.config.sslEnabled = true;
          return new AWS.S3({
            params: { Bucket: 'com.iaetp.frispo' }
          });
        },
        function(err) { vm.uploadArray.press_url = err; });
    }

    function loadComunicate(file, bucket) {
      var params = {
        ContentType: file.type,
        Body: file,
        Key: 'comunicati/' + new Date().getTime() + file.name.replace(/\s+/g,'_')
      };
      bucket.upload(params, function (err, data) {
        vm.uploadArray.press_url = data ? data.Location : err;
        vm.uploadArray.press_name = vm.form.name;
        vm.uploadArray.press_events = vm.form.events;

        vm.uploadArray.press_events.forEach(function(event) {
          event.pres_even_id = event.evenId;
          delete event.evenId;
        });
        $uibModalInstance.close(vm.uploadArray);
      });
    }

    vm.ok = function () {
      vm.uploadArray = {};
      var angularFile = angular.element('#pressLoadForm-file');
      var file = angularFile[0].files[0];

      if (file) getAWSBucket().then(
        function(bucket) { loadComunicate(file, bucket); });
    }

    vm.cancel = function () { $uibModalInstance.dismiss(); }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('pressEdit', pressEdit);

  /** @ngInject */
  function pressEdit() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/press/edit/edit.html',
      controller: PressEditController,
      controllerAs: 'pressEdit',
      link: PressEditLink,
      bindToController: true,
      replace: true,
      scope: {
        press: '=pressEdit'
      }
    };

    return directive;

    /** @ngInject */
    function PressEditController(models, $q, press, utils) {
      var vm = this;

      vm.models = models;
      vm.pressStatuses = utils.pressStatuses();

      vm.setLoading = function(res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function(res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.submit = function() {
        return vm.setLoading(vm.form)
          .then(press.form2Press)
          .then(function(pressData) {
            return press.update(vm.press.presId, pressData);
          })
          .then(press.list)
          .finally(vm.unsetLoading);
      }
    }

    function PressEditLink(scope, el, attrs, vm) {
      vm.cancel = function() {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('PressDestroyController', PressDestroyController);

  /** @ngInject */
  function PressDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('PressCreateController', PressCreateController);

  /** @ngInject */
  function PressCreateController($uibModalInstance, models, utils) {
    var vm = this;
    vm.models = models;

    vm.events = angular.copy(models.events);
    vm.multiSelectTranslation = utils.istevenMultiSelectTranslation();

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(vm.form);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }

    vm.selectFields = [
      {
        key: 'ranking',
        name: 'Risultati & Classifica',
        options: [
          {
            id: 0,
            name: 'No'
          },
          {
            id: 1,
            name: 'Sì'
          }
        ]
      },
      {
        key: 'matches',
        name: 'Calendario prossime partite',
        options: [
          {
            id: 0,
            name: 'Tutto il calendario'
          },
          {
            id: 1,
            name: 'Prossima giornata'
          },
          {
            id: 2,
            name: 'Prossime due giornate'
          },
          {
            id: 3,
            name: 'Prossime tre giornate'
          }
        ]
      },
      {
        key: 'scorers',
        name: 'Marcatori',
        options: [
          {
            id: 0,
            name: 'No'
          },
          {
            id: 1,
            name: 'Solo i primi 10'
          },
          {
            id: 2,
            name: 'Solo i primi 3'
          },
          {
            id: 3,
            name: 'Tutti i marcatori'
          }
        ]
      },
      {
        key: 'yellowcards',
        name: 'Ammonizioni',
        options: [
          {
            id: 0,
            name: 'No'
          },
          {
            id: 1,
            name: 'Sì'
          }
        ]
      },
      {
        key: 'diffide',
        name: 'Diffidati',
        options: [
          {
            id: 0,
            name: 'No'
          },
          {
            id: 1,
            name: 'Sì'
          }
        ]
      },
      {
        key: 'squalifications',
        name: 'Squalifiche',
        options: [
          {
            id: 0,
            name: 'No'
          },
          {
            id: 1,
            name: 'Sì'
          }
        ]
      },
      {
        key: 'amends',
        name: 'Ammende',
        options: [
          {
            id: 0,
            name: 'No'
          },
          {
            id: 1,
            name: 'Sì'
          }
        ]
      }
    ];
  }
})();


(function() { 'use strict';

  angular.module('frispo')
    .controller('MovePlayerConfirmController', MovePlayerConfirmController);

  /** @ngInject */
  function MovePlayerConfirmController($uibModalInstance, op,$scope) {
    var vm = this;
    vm.op=op;

    if (vm.op=='copy')$scope.operazione = 'Copia giocatori';
    else $scope.operazione = 'Sposta giocatori';


    var operazione = vm.op;


    vm.ok = function () {
      $uibModalInstance.close(true);
    }
    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('playerShow', playerShow);

  /** @ngInject */
  function playerShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/players/show/show.html',
      controller: PlayerShowController,
      controllerAs: 'playerShow',
      bindToController: true,
      replace: true,
      link: PlayerShowLink,
      scope: {
        player: '=playerShow'
      }
    };

    return directive;

    /** @ngInject */
    function PlayerShowController($uibModal, teams, models) {
      var vm = this;

      vm.destroy = function() {

        $uibModal.open({
            templateUrl: 'app/pages/players/destroy/destroy.html',
            controller: 'PlayerDestroyController',
            controllerAs: 'playerDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res === true){
              teams.destroyPlayer(vm.player);
            }
          });
      }

      vm.models = models;
    }

    /** @ngInject */
    function PlayerShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('frispo')
        .controller('PlayersImportController', PlayersImportController);

    /** @ngInject */
    function PlayersImportController($uibModalInstance) {
        var vm = this;

        vm.ok = function () {
            vm.loading = true;
            var angularFile = angular.element('#importPlayersFormFile');

            var payload = {
                file: angularFile[0].files[0]
            }
            $uibModalInstance.close(payload);

        }

        vm.loadtmp = function () {
            var span = angular.element('#esitoFileImportPlayers');
            var angularFile = angular.element('#importPlayersFormFile');
            span.html('File '+angularFile[0].files[0].name+' selezionato');
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss();
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('playerEdit', playerEdit);

  /** @ngInject */
  function playerEdit() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/players/edit/edit.html',
      controller: PlayerEditController,
      controllerAs: 'playerEdit',
      link: PlayerEditLink,
      bindToController: true,
      replace: true,
      scope: {
        player: '=playerEdit'
      }
    };

    return directive;

    /** @ngInject */
    function PlayerEditController(models, $q, teams, utils) {
      var vm = this;

      vm.models = models;

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.submit = function () {
        return vm.setLoading(vm.form)
          .then(teams.form2Player)
          .then(function (playerData) {
            return teams.updatePlayer(vm.player.playId, playerData);
          })
          .finally(vm.unsetLoading);
      }

      vm.scores = utils.scores();

      vm.form = { };
    }

    function PlayerEditLink(scope, el, attrs, vm) {
      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('PlayerDestroyController', PlayerDestroyController);

  /** @ngInject */
  function PlayerDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('PlayerCreateController', PlayerCreateController);

  /** @ngInject */
  function PlayerCreateController($uibModalInstance, models, utils) {
    var vm = this;

    vm.scores = utils.scores();
    vm.models = models;

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(vm.form);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('managerMatchShow', managerMatchShow);

  /** @ngInject */
  function managerMatchShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/managerMatches/show/show.html',
      controller: ManagerMatchShowController,
      controllerAs: 'managerMatchShow',
      bindToController: true,
      replace: true,
      link: ManagerMatchShowLink,
      scope: {
        match: '=managerMatchShow'
      }
    };

    return directive;

    /** @ngInject */
    function ManagerMatchShowController($uibModal, matches, models) {
      var vm = this;
      vm.models = models;
    }

    /** @ngInject */
    function ManagerMatchShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('managerMatchEdit', managerMatchEdit);

  /** @ngInject */
  function managerMatchEdit() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/managerMatches/edit/edit.html',
      controller: ManagerMatchEditController,
      controllerAs: 'managerMatchEdit',
      link: ManagerMatchEditLink,
      bindToController: true,
      replace: true,
      scope: {
        match: '=managerMatchEdit'
      }
    };

    return directive;

    /** @ngInject */
    function ManagerMatchEditController(models, $q, matches, utils) {
      var vm = this;

      vm.models = models;

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.submit = function () {
        return vm.setLoading(vm.form)
          .then(matches.form2Match)
          .then(function (matchData) {
            return matches.update(vm.match.matcDayId, matchData);
          })
          .finally(vm.unsetLoading);
      }

      vm.scores = utils.scores();

      vm.form = { matchId: vm.match.matcId };
    }

    function ManagerMatchEditLink(scope, el, attrs, vm) {
      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('iscrizioneShow', iscrizioneShow);

  /** @ngInject */
  function iscrizioneShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/iscrizioni/show/show.html',
      controller: IscrizioneShowController,
      controllerAs: 'iscrizioneShow',
      bindToController: true,
      replace: true,
      link: IscrizioneShowLink,
      scope: {
        iscrizione: '=iscrizioneShow'
      }
    };

    return directive;

    /** @ngInject */
    function IscrizioneShowController($uibModal, teams, models, iscrizioni) {
      var vm = this;

      vm.destroy = function() {
        $uibModal.open({
            templateUrl: 'app/pages/iscrizioni/destroy/destroy.html',
            controller: 'IscrizioneDestroyController',
            controllerAs: 'iscrizioneDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res === true){
              iscrizioni.destroyIscrizione(vm.iscrizione);
            }
          });
      }

      vm.models = models;
    }

    /** @ngInject */
    function IscrizioneShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('iscrizioneEdit', iscrizioneEdit);

  /** @ngInject */
  function iscrizioneEdit() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/iscrizioni/edit/edit.html',
      controller: IscrizioneEditController,
      controllerAs: 'iscrizioneEdit',
      link: IscrizioneEditLink,
      bindToController: true,
      replace: true,
      scope: {
        iscrizione: '=iscrizioneEdit'
      }
    };

    return directive;

    /** @ngInject */
    function IscrizioneEditController(models, $q, teams, utils, iscrizioni) {
      var vm = this;

      vm.models = models;

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.submit = function () {
        return vm.setLoading(vm.form)
          .then(teams.form2Iscrizione)
          .then(function (iscrizioneData) {
            return iscrizioni.updateIscrizione(vm.iscrizione.subscribe_id, iscrizioneData);
          })
          .then(function(updated) { vm.iscrizione = updated; })
          .finally(vm.unsetLoading);
      }

      vm.scores = utils.scores();

      vm.form = { };
    }

    function IscrizioneEditLink(scope, el, attrs, vm) {
      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('UpdateDaySuccessController', UpdateDaySuccessController);

  /** @ngInject */
  function UpdateDaySuccessController($uibModalInstance, models, utils) {
    var vm = this;

    vm.scores = utils.scores();
    vm.models = models;

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('UpdateDayErrorController', UpdateDayErrorController);

  /** @ngInject */
  function UpdateDayErrorController($uibModalInstance, models, utils) {
    var vm = this;

    vm.scores = utils.scores();
    vm.models = models;

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('UpdateDayCreateController', UpdateDayCreateController);

  /** @ngInject */
  function UpdateDayCreateController($uibModalInstance, models, utils) {
    var vm = this;

    vm.scores = utils.scores();
    vm.models = models;

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('IscrizioneDestroyController', IscrizioneDestroyController);

  /** @ngInject */
  function IscrizioneDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('giornateShow', giornateShow);

  /** @ngInject */
  function giornateShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/giornate/show/show.html',
      controller: GiornateShowController,
      controllerAs: 'giornateShow',
      bindToController: true,
      replace: true,
      link: GiornateShowLink,
      scope: {
        match: '=giornateShow'
      }
    };

    return directive;

    /** @ngInject */
    function GiornateShowController($uibModal, matches, models) {
      var vm = this;

      vm.destroy = function() {
        $uibModal.open({
            templateUrl: 'app/pages/giornate/destroy/destroy.html',
            controller: 'GiornateDestroyController',
            controllerAs: 'giornateDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res){
              matches.destroyGiornata(vm.match);
            }
          });
      }

      vm.models = models;
    }

    /** @ngInject */
    function GiornateShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
    'use strict';

    angular
        .module('frispo')
        .directive('giornateEdit', giornateEdit);

    /** @ngInject */
    function giornateEdit() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/pages/giornate/edit/edit.html',
            controller: GiornateEditController,
            controllerAs: 'giornateEdit',
            link: GiornateEditLink,
            bindToController: true,
            replace: true,
            scope: {
                giornata: '=giornateEdit'
            }
        };

        return directive;

        /** @ngInject */
        function GiornateEditController(models, $q, matches, utils) {
            var vm = this;

            vm.models = models;

            vm.setLoading = function(res) {
                vm.loading = true;
                return $q.resolve(res);
            }

            vm.unsetLoading = function(res) {
                vm.loading = false;
                return $q.resolve(res);
            }

            vm.submit = function() {
                return vm.setLoading(vm.form)
                    .then(matches.form2Giornata)
                    .then(function(giornataData) {
                        return matches.updateGiornata(vm.giornata.matcDayId, giornataData);
                    })
                    .finally(vm.unsetLoading);
            }

            vm.scores = utils.scores();

            vm.getWeeksOfYear = function() {
                matches.getWeeksOfYear(vm.form.year)
                    .then(function(data) {
                        vm.weeksOfYear = data;
                    })
            }
        }

        function GiornateEditLink(scope, el, attrs, vm) {
            vm.cancel = function() {
                el.find('.accordion-body').collapse('hide');
            }
        }
    }

})();
(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('GiornateDestroyController', GiornateDestroyController);

  /** @ngInject */
  function GiornateDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('invitationShow', invitationShow);

  /** @ngInject */
  function invitationShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/invitations/show/show.html',
      controller: InvitationShowController,
      controllerAs: 'invitationShow',
      bindToController: true,
      replace: true,
      link: InvitationShowLink,
      scope: {
        invitation: '=invitationShow'
      }
    };

    return directive;

    /** @ngInject */
    function InvitationShowController($uibModal, invitations, models) {
      var vm = this;

      vm.destroy = function() {

        $uibModal.open({
            templateUrl: 'app/pages/invitations/destroy/destroy.html',
            controller: 'InvitationDestroyController',
            controllerAs: 'invitationDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res === true){
              invitations
                .destroy(vm.invitation)
                .then(invitations.listSent);
            }
          })
      }

      vm.models = models;
    }

    /** @ngInject */
    function InvitationShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('InvitationDestroyController', InvitationDestroyController);

  /** @ngInject */
  function InvitationDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('InvitationCreateController', InvitationCreateController);

  /** @ngInject */
  function InvitationCreateController($uibModalInstance, models, utils) {
    var vm = this;
    vm.events = angular.copy(models.events);
    vm.multiSelectTranslation = utils.istevenMultiSelectTranslation();

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(vm.form);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('EventRecreateCalendarController', EventRecreateCalendarController);

  /** @ngInject */
  function EventRecreateCalendarController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('frispo')
        .controller('CalendarImportController', CalendarImportController);

    /** @ngInject */
    function CalendarImportController($uibModalInstance) {
        var vm = this;

        vm.ok = function () {
            vm.loading = true;
            var angularFile = angular.element('#importCalendarFormFile');
            var payload = {
                file: angularFile[0].files[0]
            }
            $uibModalInstance.close(payload);
        }

        vm.loadtmp = function () {
            var span = angular.element('#esitoFileImportCalendar');
            span.html('File caricato');
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('frispo')
        .controller('CalendarExportController', CalendarExportController);

    /** @ngInject */
    function CalendarExportController($uibModalInstance) {
        var vm = this;

        vm.ok = function () {
            $uibModalInstance.close(true);
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('frispo')
        .directive('eventEdit', eventEdit);

    /** @ngInject */
    function eventEdit(events) {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/pages/events/edit/edit.html',
            controller: EventEditController,
            controllerAs: 'eventEdit',
            link: EventEditLink,
            bindToController: true,
            replace: true,
            scope: {
                event: '=eventEdit'
            }
        };

        return directive;

        /** @ngInject */
        function EventEditController(models, matches, $uibModal, $q, utils, $window, toastr) {
            var vm = this;
            vm.models = models;
            vm.pointsOptions = utils.scores();
            vm.eventTypes = utils.eventTypes();
            vm.eventFormulas = utils.eventFormulas();
            vm.even_flg_subscribe = [{
                id: 0,
                value: "No"
            }, {
                id: 1,
                value: "Si"
            }];

            vm.setLoading = function (res) {
                vm.loading = true;
                return $q.resolve(res);
            }

            vm.unsetLoading = function (res) {
                vm.loading = false;
                return $q.resolve(res);
            }

            vm.submit = function () {
                return vm.setLoading(vm.form)
                    .then(events.getTokenS3)
                    .then(function (data) {
                        var angularFile = angular.element('#eventEditForm' + vm.event.evenId + '-evenUrlLogo');
                        var file = angularFile[0].files[0];
                        if (file) {
                            var deferred = $q.defer();
                            var credentials = {
                                accessKeyId: data.data[0].keyid,
                                secretAccessKey: data.data[0].secretid,
                                sessionToken: data.data[0].session_token
                            };
                            AWS.config.update(credentials);
                            AWS.config.region = 'eu-west-1';
                            AWS.config.sslEnabled = true;
                            var bucket = new AWS.S3({
                                params: {
                                    Bucket: 'com.codeploy.frispo.image.events'
                                }
                            });
                            var fileName = "";
                            if (file) fileName = angularFile[0].files[0].name;
                            var ts = new Date().getTime();
                            var fileNameEscape = fileName.replace(/\s+/g, '_');
                            vm.form.evenUrlLogo = ts + "-" + fileNameEscape;


                            if (file) {
                                var params = {
                                    Key: '' + ts + "-" + fileNameEscape,
                                    ContentType: file.type,
                                    Body: file
                                };
                                bucket.upload(params, function (err, data) {
                                    if (data) {
                                        deferred.resolve(data);
                                    } else if (err) {
                                        deferred.reject(err);
                                    }
                                })
                            } else {
                                deferred.reject(false);
                            }
                            return deferred.promise;
                        }
                    })
                    .then(function () {
                        return events.form2Event(vm.form);
                    })
                    .then(function (eventData) {
                        return events.update(vm.event.evenId, eventData);
                    })
                    .then(function () {
                        var span = angular.element('#' + vm.event.evenId + '-upload-file-info');
                        span.html('');
                    })
                    .finally(vm.unsetLoading);
            }

            vm.publish = function () {
                return vm.setLoading()
                    .then(function () {
                        return events.update(vm.event.evenId, {
                            even_stato_evento: 1
                        });
                    })
                    .finally(vm.unsetLoading);
            }

            vm.unpublish = function () {
                return vm.setLoading()
                    .then(function () {
                        return events.update(vm.event.evenId, {
                            even_stato_evento: 0
                        });
                    })
                    .finally(vm.unsetLoading);
            }

            vm.loadtmp = function () {
                return vm.setLoading()
                    .then(function () {
                        var span = angular.element('#' + vm.event.evenId + '-upload-file-info');
                        span.html('Immagine caricata, premere Salva per confermare');
                    })
                    .finally(vm.unsetLoading);
            }

            vm.showLogo = function (linkLogo) {
                $window.open(linkLogo, '_blank');
            }

            vm.recreateCalendar = function () {
                $uibModal.open({
                    templateUrl: 'app/pages/events/edit/recreateCalendar.html',
                    controller: 'EventRecreateCalendarController',
                    controllerAs: 'eventRecreateCalendar',
                    windowClass: 'modal-warning'
                }).result
                    .then(function (res) {
                        if (res === true) {
                            return vm.setLoading(vm.event.evenId)
                                .then(matches.createCalendar)
                                .then(function () {
                                    return events.show(vm.event.evenId);
                                })
                                .finally(vm.unsetLoading);
                        }
                    })

            }

            vm.importCalendar = function () {
                $uibModal.open({
                    templateUrl: 'app/pages/events/edit/importCalendar.html',
                    controller: 'CalendarImportController',
                    controllerAs: 'importCalendar',
                    windowClass: 'modal-warning'
                }).result
                    .then(function (res) {
                        vm.setLoading(res)
                            .then(function (res) {
                                if (angular.isDefined(res)) {
                                    var file = res.file;
                                    events.getTokenS3Import()
                                        .then(function (data) {
                                            var deferred = $q.defer();
                                            var credentials = {
                                                accessKeyId: data.data[0].keyid,
                                                secretAccessKey: data.data[0].secretid,
                                                sessionToken: data.data[0].session_token
                                            };
                                            AWS.config.update(credentials);
                                            AWS.config.region = 'eu-west-1';
                                            AWS.config.sslEnabled = true;
                                            var bucket = new AWS.S3({ params: { Bucket: 'com.codeploy.frispoleague/events/import' } });
                                            if (file) {
                                                var fileNameEscape = new Date().getTime() + "-" + file.name.replace(/\s+/g, '_');
                                                var params = { Key: '' + fileNameEscape, ContentType: file.type, Body: file };
                                                bucket.upload(params, function (err, data) {
                                                    if (data) {
                                                        var payloadToImport = {
                                                            filename: fileNameEscape
                                                        }
                                                        matches.importCalendar(vm.event.evenId, payloadToImport)
                                                            .then(function () {
                                                                toastr.success("Calendario importato e partite caricate correttamente. Vai alla pagina delle partite");
                                                                deferred.resolve(data);
                                                            })
                                                    } else if (err) {
                                                        deferred.reject(err);
                                                    }
                                                })
                                            } else {
                                                deferred.reject(false);
                                            }
                                            return deferred.promise;
                                        })
                                }
                            })
                            .finally(vm.unsetLoading);
                    })

            }

            vm.exportCalendar = function () {
                $uibModal.open({
                    templateUrl: 'app/pages/events/edit/exportCalendar.html',
                    controller: 'CalendarExportController',
                    controllerAs: 'exportCalendar',
                    windowClass: 'modal-success'
                }).result
                    .then(function (res) {
                        if (res) {
                            matches.exportCalendar(vm.event.evenId)
                                .then(function () {
                                    toastr.success("L'operazione potrebbe richiedere del tempo. Il calendario ti verrò inoltrato via mail");
                                })
                        }
                    })

            }
        }

        function EventEditLink(scope, el, attrs, vm) {

            el.find('.accordion-body').on('show.bs.collapse', function () {
                events.show(vm.event.evenId);
                events.listRegions();
            });

            vm.cancel = function () {
                el.find('.accordion-body').collapse('hide');
            }

            scope.$watch('eventEdit.event.evenCurrentDay', function (newVal, oldVal) {
                if (angular.isDefined(newVal) && newVal !== oldVal) {
                    vm.form.currentDay = vm.event.evenCurrentDay;
                }
            });
        }
    }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('eventShow', eventShow);

  /** @ngInject */
  function eventShow(events) {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/events/show/show.html',
      controller: EventShowController,
      controllerAs: 'eventShow',
      bindToController: true,
      replace: true,
      link: EventShowLink,
      scope: {
        event: '=eventShow',
        hideControls: '='
      }
    };

    return directive;

    /** @ngInject */
    function EventShowController(models, $uibModal) {
      var vm = this;

      vm.destroy = function() {

        $uibModal.open({
            templateUrl: 'app/pages/events/destroy/destroy.html',
            controller: 'EventDestroyController',
            controllerAs: 'eventDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res === true){
              events.destroy(vm.event);
            }
          })
      }

      vm.models = models;
    }

    /** @ngInject */
    function EventShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('EventDestroyController', EventDestroyController);

  /** @ngInject */
  function EventDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('cardShow', cardShow);

  /** @ngInject */
  function cardShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/disciplinary/show/show.html',
      controller: CardShowController,
      controllerAs: 'cardShow',
      bindToController: true,
      replace: true,
      link: CardShowLink,
      scope: {
        card: '=cardShow',
        config: '='
      }
    };

    return directive;

    /** @ngInject */
    function CardShowController($uibModal, matches, models) {
      var vm = this;

      vm.models = models;
    }

    /** @ngInject */
    function CardShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('cardEdit', cardEdit);

  /** @ngInject */
  function cardEdit() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/disciplinary/edit/edit.html',
      controller: CardEditController,
      controllerAs: 'cardEdit',
      link: CardEditLink,
      bindToController: true,
      replace: true,
      scope: {
        card: '=cardEdit',
        config: '='
      }
    };

    return directive;

    /** @ngInject */
    function CardEditController(models, $q) {
      var vm = this;

      vm.models = models;

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }
    }

    function CardEditLink(scope, el, attrs, vm) {
      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }

})();

(function() {
    'use strict';

    angular
        .module('frispo')
        .controller('CatalogThanksController', CatalogThanksController);

    /** @ngInject */
    function CatalogThanksController($uibModalInstance, models) {
        var vm = this;
        vm.models = models;

        vm.ok = function() {
            $uibModalInstance.close(true);
        }

        vm.cancel = function() {
            $uibModalInstance.dismiss();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('frispo')
        .directive('catalogShow', catalogShow);

    /** @ngInject */
    function catalogShow() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/pages/catalog/show/show.html',
            controller: CatalogShowController,
            controllerAs: 'catalogShow',
            bindToController: true,
            replace: true,
            scope: {
                product: '=catalogShow',
                hideControls: '='
            }
        };

        return directive;

        /** @ngInject */
        function CatalogShowController(models, $uibModal) {
            var vm = this;
            vm.models = models;

            vm.info = function() {
                $uibModal.open({
                        templateUrl: 'app/pages/catalog/info/info.html',
                        controller: 'CatalogInfoController',
                        controllerAs: 'catalogInfo',
                        windowClass: 'modal-success',
                        resolve: {
                            product: vm.product
                        }
                    }).result
                    .then();
            }

        }

    }
})();
(function() {
    'use strict';

    angular
        .module('frispo')
        .controller('CatalogInfoController', CatalogInfoController);

    /** @ngInject */
    function CatalogInfoController($uibModalInstance, product, models, $sce) {
        var vm = this;
        vm.models = models
        vm.product = product;
        vm.description = $sce.trustAsHtml(product.product_description);

        vm.cancel = function() {
            $uibModalInstance.dismiss();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('frispo')
        .controller('CatalogConfirmController', CatalogConfirmController);

    /** @ngInject */
    function CatalogConfirmController($uibModalInstance, models) {
        var vm = this;
        vm.models = models;

        vm.ok = function() {
            $uibModalInstance.close(true);
        }

        vm.cancel = function() {
            $uibModalInstance.dismiss();
        }
    }
})();
(function() { 'use strict';

    angular.module('frispo')
        .directive('arbiterShow', arbiterShow);

    /** @ngInject */
    function arbiterShow() {

        return {
            restrict: 'EA',
            templateUrl: 'app/pages/arbiter/show/show.html',
            controller: ArbiterShowController,
            controllerAs: 'arbiterShow',
            bindToController: true,
            replace: true,
            link: ArbiterShowLink,
            scope: {
                opts: '=arbiterShow'
            }
        };

        /** @ngInject */
        function ArbiterShowController($uibModal, arbiters) {

          var vm = this; vm.arbiter = vm.opts.arbiter;

          vm.destroy = function() {

            $uibModal.open({
                templateUrl: 'app/pages/arbiter/destroy/destroy.html',
                controller: 'ArbiterDestroyController',
                controllerAs: 'arbiterDestroy',
                windowClass: 'modal-danger'
            })
            .result.then(function(res) {
                if (res === true) {
                  arbiters.delete(vm.arbiter)
                    .then(function() {
                      var idx = vm.opts.list.findIndex(
                        function(e) { return e.arbi_id === vm.arbiter.arbi_id });
                      vm.opts.list.splice(idx, 1);
                    });
                }
            });
          }
        }

        /** @ngInject */
        function ArbiterShowLink(scope, el, attrs, vm) {
            el.hover(
                function() {
                    scope.$apply(function() {
                        vm.showControls = true;
                    })
                },
                function() {
                    scope.$apply(function() {
                        vm.showControls = false;
                    })
                }
            );
        }
    }

})();

(function() { 'use strict';

  angular.module('frispo')
    .directive('arbiterEdit', arbiterEdit);

  /** @ngInject */
  function arbiterEdit() {

    return {
      restrict: 'EA',
      templateUrl: 'app/pages/arbiter/edit/edit.html',
      controller: ArbiterEditController,
      controllerAs: 'arbiterEdit',
      link: ArbiterEditLink,
      bindToController: true,
      replace: true,
      scope: {
        opts: '=arbiterEdit'
      }
    };

    /** @ngInject */
    function ArbiterEditController(arbiters, $q) {

      var vm = this;
      vm.submitted = false;
      vm.loading = false;
      vm.arbiter = vm.opts.arbiter;

      vm.submit = function(arbiterForm) {
        vm.submitted = true;
        if (!arbiterForm.$valid) { return; }

        vm.setLoading(vm.form)
          .then(function(arbiter) {
              return arbiters.edit(vm.arbiter.arbi_id, arbiter); })
          .then(function(edited) {
            var idx = vm.opts.list.findIndex(
              function(e) { return e.arbi_id === vm.arbiter.arbi_id });
            vm.opts.list[idx] = edited;
          })
          .finally(vm.unsetLoading);
      }

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }
    }

    function ArbiterEditLink(scope, el, attrs, vm) {

      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }

})();

(function() {
  'use strict';

  angular.module('frispo')
    .controller('ArbiterDestroyController', ArbiterDestroyController);

  /** @ngInject */
  function ArbiterDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular.module('frispo')
    .controller('ArbiterCreateController', ArbiterCreateController);

  /** @ngInject */
  function ArbiterCreateController($uibModalInstance, models) {

    var vm = this;
    vm.event = models.currentEvent;
    vm.submitted = false;

    vm.ok = function (arbiterForm) {
      vm.submitted = true;
      if (arbiterForm.$valid) { $uibModalInstance.close(vm.form); }
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('frispo')
        .directive('matchShow', matchShow);

    /** @ngInject */
    function matchShow() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/pages/calendar/show/show.html',
            controller: MatchShowController,
            controllerAs: 'matchShow',
            bindToController: true,
            replace: true,
            link: MatchShowLink,
            scope: {
                match: '=matchShow'
            }
        };

        return directive;

        /** @ngInject */
        function MatchShowController($uibModal, matches, models) {
            var vm = this;

            vm.destroy = function() {

                $uibModal.open({
                        templateUrl: 'app/pages/calendar/destroy/destroy.html',
                        controller: 'MatchDestroyController',
                        controllerAs: 'matchDestroy',
                        windowClass: 'modal-danger'
                    }).result
                    .then(function(res) {
                        if (res === true) {
                            matches.destroy(vm.match);
                        }
                    });
            }

            vm.advancedEdit = function() {
                $uibModal.open({
                        templateUrl: 'app/pages/calendar/advancedEdit/advancedEdit.html',
                        controller: 'MatchAdvancedEditController',
                        controllerAs: 'matchAdvEdit',
                        windowClass: 'modal-default',
                        size: 'lg',
                        resolve: {
                            match: vm.match
                        }
                    }).result
                    .then();
            }

            vm.models = models;
        }

        /** @ngInject */
        function MatchShowLink(scope, el, attrs, vm) {
            el.hover(
                function() {
                    scope.$apply(function() {
                        vm.showControls = true;
                    })
                },
                function() {
                    scope.$apply(function() {
                        vm.showControls = false;
                    })
                }
            );
        }
    }

})();
(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('matchEdit', matchEdit);
   

  /** @ngInject */
  function matchEdit() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/calendar/edit/edit.html',
      controller: MatchEditController,
      controllerAs: 'matchEdit',
      link: MatchEditLink,
      bindToController: true,
      replace: true,
      scope: {
        input: '=matchEdit'
      }
    };
   
    return directive;

    /** @ngInject */
    function MatchEditController(models, $q, matches, utils, $scope) {
      var vm = this;
    
      vm.models = models;
      vm.groups = vm.input.groups;
      vm.match  = vm.input.match;

      console.log(vm)

      vm.setLoading = function (res) {
        console.log(models)
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.submit = function () {
        return vm.setLoading(vm.form)
          .then(matches.form2Match)
          .then(function (matchData) {
            return matches.update(vm.match.matcDayId, matchData);
          })
          .finally(vm.unsetLoading);
      }

      vm.scores = utils.scores();

      vm.form = { matchId: vm.match.matcId };

      $scope.$watch('matchEdit.match.matcScoreTeamA', function (newVal, oldVal) {
        if(newVal !== oldVal) {
          vm.form.scoreA = newVal;
        }
      });
      $scope.$watch('matchEdit.match.matcScoreTeamB', function (newVal, oldVal) {
        if(newVal !== oldVal) {
          vm.form.scoreB = newVal;
        }
      });
    }

    function MatchEditLink(scope, el, attrs, vm) {

      el.find('.accordion-body').on('show.bs.collapse', function () {
        angular.element('.match-add-arbiter-form-' + vm.match.matcId)
          .collapse('hide');
      });

      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }


})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('MatchDestroyController', MatchDestroyController);

  /** @ngInject */
  function MatchDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('GroupCreateController', GroupCreateController);

  /** @ngInject */
  function GroupCreateController($uibModalInstance, models) {
    var vm = this;

    vm.models = models;

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(vm.form);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('DayCreateController', DayCreateController);

  /** @ngInject */
  function DayCreateController($uibModalInstance, models) {
    var vm = this;

    vm.models = models;

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(vm.form);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('MatchCreateController', MatchCreateController);

  /** @ngInject */
  function MatchCreateController($uibModalInstance, models, utils) {
    var vm = this;

    vm.scores = utils.scores();
    vm.models = models;

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(vm.form);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('frispo')
        .controller('MatchAdvancedEditController', MatchAdvancedEditController);

    /** @ngInject */
    function MatchAdvancedEditController($q, $uibModalInstance, match, utils, matches, teams) {
        var vm = this;
        vm.match = match;
        vm.scores = utils.scores();

        vm.ok = function() {
            $uibModalInstance.close(true);
        }

        vm.cancel = function() {
            $uibModalInstance.dismiss();
        }

        vm.submit = function() {
            return vm.setLoading(vm.form)
                .then(matches.form2Match)
                .then(function(matchData) {
                    return matches.update(vm.match.matcDayId, matchData);
                })
        }

        vm.setLoading = function(res) {
            vm.loading = true;
            return $q.resolve(res);
        }

        vm.unsetLoading = function(res) {
            vm.loading = false;
            return $q.resolve(res);
        }

        vm.form = {
            matchId: vm.match.matcId,
            teamA: {
                teamId: vm.match.matcTeamIdA
            },
            teamB: {
                teamId: vm.match.matcTeamIdB
            },
            played: {
                value: vm.match.matcFlgPlay
            }
        }

        vm.createAutocompleteObj = function(players) {
            var autocomplete = [];
            if (angular.isArray(players)) {
                angular.forEach(players, function(player) {
                    autocomplete.push({
                        playId: player.playId,
                        name: player.playFirstname,
                        surname: player.playSurname,
                        teamId: player.playTeamId
                    });
                });
            }
            return autocomplete;
        }

        vm.autocompleteA = [];
        vm.autocompleteB = [];

        matches.show(vm.match.matcId)
            .then(function() { // Retrieve players for autocomplete
                teams
                    .listPlayers(vm.match.matcTeamIdA)
                    .then(vm.createAutocompleteObj)
                    .then(function(res) {
                        vm.autocompleteA = res;
                    })
                teams
                    .listPlayers(vm.match.matcTeamIdB)
                    .then(vm.createAutocompleteObj)
                    .then(function(res) {
                        vm.autocompleteB = res;
                    })
            });
    }
})();

(function() { 'use strict';

  angular.module('frispo')
    .directive('matchArbiter', matchArbiter);

  /** @ngInject */
  function matchArbiter() {
    return {
      restrict: 'EA',
      templateUrl: 'app/pages/calendar/addArbiter/add.arbiter.html',
      controller: matchArbiterController,
      controllerAs: 'matchArbiter',
      link: matchArbiterLink,
      bindToController: true,
      replace: true,
      scope: {
        opts: '=matchArbiter'
      }
    };

    /** @ngInject */
    function matchArbiterController($q, arbiters) {

      var vm = this;
      vm.match    = vm.opts.match;
      vm.arbiters = vm.opts.arbiters;
      vm.submitted = false;
      vm.actualLink = '';
      vm.code = '';

      vm.arbiter = !vm.match.matcArbiId ? null :
        vm.arbiters.filter(function(arbi) {
          return arbi.arbi_id === vm.match.matcArbiId })[0];

/*
      vm.getArbiterPageLink = function() {
        if (!vm.form.arbiter) return ;
        arbiters.getPageLink(vm.form.arbiter.arbi_id, vm.match.matcId)
          .then (function(res) { vm.actualLink = res; })
          .catch(function(   ) { vm.actualLink = ''; });
      }

*/


      vm.getArbiterDataMail = function() {
        if (!vm.form.arbiter) return ;
        arbiters.getPageDataMail(vm.form.arbiter.arbi_id, vm.match.matcId)
          .then (function(res) { vm.actualLink = res.link; vm.code=res.code; })
          .catch(function(   ) { vm.actualLink = '';  vm.code='';});
      }

      vm.onArbiterSelection = function() { vm.actualLink = ''; }

      vm.submit = function(arbiterForm) {
        vm.submitted = true;
        if (!arbiterForm.$valid) { return; }

        vm.setLoading(vm.form.arbiter)
          .then(function(arbiter) {
            return arbiters.attachToMatch(arbiter.arbi_id, vm.match.matcId); })
          .finally(vm.unsetLoading);
      }

      vm.setLoading = function (res) {
        vm.loading = true;
        return $q.resolve(res);
      }

      vm.unsetLoading = function (res) {
        vm.loading = false;
        return $q.resolve(res);
      }

      vm.sendEmail = function () {

        vm.setLoading(vm.form.arbiter)
          .then(function(arbiter) {
            return arbiters.sendEmailWithData(arbiter.arbi_id, vm.match.matcId); })
          .then(function(res) { vm.actualLink = res.link; vm.code=res.code;})
          .finally(vm.unsetLoading);
      }
    }

    function matchArbiterLink(scope, el, attrs, vm) {

      el.find('.accordion-body').on('show.bs.collapse', function () {
        angular.element('.match-edit-form-' + vm.match.matcId)
          .collapse('hide');
      });

      vm.cancel = function () {
        el.find('.accordion-body').collapse('hide');
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('cardMatchShow', cardMatchShow);

  /** @ngInject */
  function cardMatchShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/cardMatch/show/show.html',
      controller: ScorerMatchShowController,
      controllerAs: 'cardMatchShow',
      bindToController: true,
      replace: true,
      link: ScorerMatchShowLink,
      scope: {
        cardMatch: '=cardMatchShow',
        config: '=',
        cardMatchPlayerId: '=cardMatchPlayerId',
        cardMatchTeamId: '=cardMatchTeamId'
      }
    };

    return directive;

    /** @ngInject */
    function ScorerMatchShowController($uibModal, models, utils, matches) {
      var vm = this;
      vm.scores = utils.scores();

      vm.submit = function (){
        if(vm.cardMatch.cardId){
          return matches
            .form2CardMatch(vm.form)
            .then(function (cardData) {
              return matches.updateEventCard(
                vm.cardMatch.matcId,
                vm.cardMatchPlayerId,
                vm.cardMatch.cardId,
                vm.cardsKey,
                vm.cardMatchKey,
                cardData
              );
            })
        }
        else if(vm.cardMatch.amenId){
          return matches
            .form2AmendMatch(vm.form)
            .then(function (cardData) {
              return matches.updateEventAmend(
                vm.cardMatch.matcId,
                vm.cardMatchTeamId,
                vm.cardMatch.amenId,
                vm.cardsKey,
                vm.cardMatchKey,
                cardData
              );
            })
        }
      }

      vm.destroy = function() {

        $uibModal.open({
            templateUrl: 'app/pages/cardMatch/destroy/destroy.html',
            controller: 'CardMatchDestroyController',
            controllerAs: 'cardMatchDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res === true){
              if(vm.cardMatch.cardId){
                matches.destroyEventCard(vm.cardMatch.matcId, vm.cardMatchPlayerId, vm.cardMatch.cardId, vm.config.cardsKey, vm.config.cardMatchKey);
              }
              else if(vm.cardMatch.amenId){
                matches.destroyEventAmend(vm.cardMatch.matcId, vm.cardMatchTeamId, vm.cardMatch.amenId, vm.config.cardsKey, vm.config.cardMatchKey);
              }
            }
          })
      }

      vm.models = models;
    }

    /** @ngInject */
    function ScorerMatchShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('CardMatchDestroyController', CardMatchDestroyController);

  /** @ngInject */
  function CardMatchDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('adminTeamShow', adminTeamShow);

  /** @ngInject */
  function adminTeamShow() {
    var directive = {
      restrict: 'EA',
      templateUrl: 'app/pages/adminTeam/show/show.html',
      controller: AdminTeamShowController,
      controllerAs: 'adminTeamShow',
      bindToController: true,
      replace: true,
      link: AdminTeamShowLink,
      scope: {
        invitation: '=adminTeamShow'
      }
    };

    return directive;

    /** @ngInject */
    function AdminTeamShowController($uibModal, adminTeam, models) {
      var vm = this;

      vm.destroy = function() {
        $uibModal.open({
            templateUrl: 'app/pages/adminTeam/destroy/destroy.html',
            controller: 'AdminTeamDestroyController',
            controllerAs: 'adminTeamDestroy',
            windowClass: 'modal-danger'
          }).result
          .then(function (res) {
            if(res === true){
              adminTeam
                .destroy(vm.invitation)
                .then(adminTeam.listSentAdminTeam);
            }
          })
      }

      vm.models = models;
    }

    /** @ngInject */
    function AdminTeamShowLink(scope, el, attrs, vm){
      el.hover(
        function () {
          scope.$apply(function () {
            vm.showControls = true;
          })
        },
        function () {
          scope.$apply(function () {
            vm.showControls = false;
          })
        }
      );
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('AdminTeamDestroyController', AdminTeamDestroyController);

  /** @ngInject */
  function AdminTeamDestroyController($uibModalInstance) {
    var vm = this;

    vm.ok = function () {
      $uibModalInstance.close(true);
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frispo')
    .controller('AdminTeamCreateController', AdminTeamCreateController);

  /** @ngInject */
  function AdminTeamCreateController($uibModalInstance, models, utils, events, $q, teams) {
    var vm = this;
    vm.events = angular.copy(models.events);
    vm.multiSelectTranslation = utils.istevenMultiSelectTranslation();

    vm.ok = function () {
      vm.loading = true;
      $uibModalInstance.close(vm.form);
    }

    vm.updateCurrentEventB = function () {
      models.currentEvent = models.events
        .filter(function(event) {
          return event.evenId === vm.form.events.evenId;
      })[0];
      teams.list()
       .then(function (res) { vm.teams = res; })
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('wizardStepBox', wizardStepBox);

  /** @ngInject */
  function wizardStepBox() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/wizard/wizardStepBox/wizardStepBox.html',
      controller: WizardStepBoxController,
      controllerAs: 'wizardStepBox',
      bindToController: true,
      scope: {
        wizard: '=',
        step: '=',
        title: '@'
      },
      link: WizardStepBoxLink,
      transclude: true
    };

    return directive;

    /** @ngInject */
    function WizardStepBoxController() {
    }

    function WizardStepBoxLink(scope, el, attrs, vm) {
      if(vm.step === vm.wizard.currentStep){
        vm.active = true;
      }
      else{
        el.find('.wizard-step-box').first().addClass('collapsed-box');
        el.find('.box-body').first().hide();
      }

      scope.$watch('wizardStepBox.wizard.currentStep', function (newVal, oldVal) {
        if(newVal === oldVal) return;
        // Activate the box
        if(newVal === vm.step && !vm.active){
          vm.active = true;
          angular.element.AdminLTE.boxWidget.collapse(el.find('[data-widget]'));
        }
        // Deactivate the box
        else if(newVal !== vm.step && vm.active){
          vm.active = false;
          angular.element.AdminLTE.boxWidget.collapse(el.find('[data-widget]'));
        }
      })
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('wizardProgress', wizardProgress);

  /** @ngInject */
  function wizardProgress() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/wizard/wizardProgress/wizardProgress.html',
      controller: WizardProgressController,
      controllerAs: 'wizardProgress',
      bindToController: true,
      scope: {
        wizard: '='
      }
    };

    return directive;

    /** @ngInject */
    function WizardProgressController() {
      var vm = this;

      vm.range = function (n) {
        return new Array(n);
      }
    }
  }

})();

(function() { 'use strict';

  angular.module('frispo')
    .controller('TeamsController', TeamsController);

  /** @ngInject */
  function TeamsController(models, $scope, teams, $q, $uibModal, objToCsv) {

    var vm = this; vm.models = models; vm.loading = false;

    vm.getCurrentEvent = function() { return models.currentEvent || null; }

    // watch for changes in models.currentEvent and load
    // team and temp team info if current event has changed
    $scope.$watch(vm.getCurrentEvent, function(currentEvent) {
      if (!vm.loading && currentEvent &&
         (!currentEvent.teams || !currentEvent.tempTeams)) {
        vm.setLoading(currentEvent.evenId)        // Set a spinning loader on the page
          .then(teams.list)                       // List the teams of the event
          .then(teams.listTemp)                   // List the temp teams of the event
          .finally(vm.unsetLoading)               // Remove the loader from the page
      }
    }, true);     // use object equality and not memory address

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }

    vm.createNewTeam = function () {
      $uibModal.open({
          templateUrl: 'app/pages/teams/create/create.html',
          controller: 'TeamCreateController',
          controllerAs: 'teamCreate',
          windowClass: 'modal-success'
        })
        .result.then(function (res) {
          if(angular.isDefined(res)){
            vm.setLoading(res)
              .then(teams.form2Team)
              .then(teams.create)
              .then(teams.list)
              .then(teams.listTemp)
              .finally(vm.unsetLoading);
          }
        })
    }

    vm.reloaData = function (res) {
			vm.setLoading(res)     // Set a spinning loader on the page
				.then(teams.list)                // Update the match day
				.finally(vm.unsetLoading);
		}

    vm.exportData = function (data) {

      var csv = objToCsv(data.map(function(team) {
        return {
          Nome: team.teamName,
          Capitano: team.teamCaptain,
          Telefono: team.teamMobilePhone,
          "Orario Preferito": team.teamTime,
          "Giorno Preferito": team.teamPlayday.value,
          "Indirizzo Preferito": team.teamPlace
        }
      }));
      var blob = new Blob([csv], { type: 'text/csv' })
      saveAs(blob, "Squadre.csv");
    }

  }
})();

(function () {
	'use strict';

	angular.module('frispo')
		.controller('ScorersController', ScorersController);

	/** @ngInject */
	function ScorersController(models, $scope, events, $q, objToCsv, $uibModal, scorers) {

		var vm = this; vm.models = models; vm.loading = false;

		vm.getCurrentEvent = function () { return models.currentEvent || null; }

		// watch for changes in models.currentEvent and load
		// the calendar if current event has changed
		$scope.$watch(vm.getCurrentEvent, function (currentEvent) {
			if (!vm.loading &&
				currentEvent && !vm.models.currentEvent.scorers) {
				vm.setLoading(currentEvent.evenId)    // Set a spinning loader on the page
					.then(events.showScorers)           // Update the match day
					.finally(vm.unsetLoading);          // Remove the loader from the page
			}
		}, true);     // use object equality and not memory address

		vm.setLoading = function (res) {
			vm.loading = true;
			return $q.resolve(res);
		}

		vm.unsetLoading = function (res) {
			vm.loading = false;
			return $q.resolve(res);
		}

		vm.reloaData = function (currentEvent) {
			vm.setLoading(currentEvent.evenId)    // Set a spinning loader on the page
				.then(events.showScorers)        // Get the scoreboard for given event
				.finally(vm.unsetLoading);
		}

		vm.exportData = function (data) {

			var csv = objToCsv(data.map(function (player) {
				return {
					Nome: player.scorPlayFirstname,
					Cognome: player.scorPlaySurname,
					Squadra: player.scorTeamName,
					Goal: player.scorGoal
				}
			}));
			var blob = new Blob([csv], { type: 'text/csv' })
			saveAs(blob, "Marcatori.csv");
		}

		vm.importScorers = function () {
			$uibModal.open({
				templateUrl: 'app/pages/scorers/import/import.html',
				controller: 'ScorersImportController',
				controllerAs: 'importScorers',
				windowClass: 'modal-success'
			}).result
				.then(function (res) {
					if (angular.isDefined(res)) {
						var file = res.file;
						scorers.getTokenS3()
							.then(function (data) {
								var deferred = $q.defer();
								var credentials = {
									accessKeyId: data.data[0].keyid,
									secretAccessKey: data.data[0].secretid,
									sessionToken: data.data[0].session_token
								};
								AWS.config.update(credentials);
								AWS.config.region = 'eu-west-1';
								AWS.config.sslEnabled = true;
								var bucket = new AWS.S3({ params: { Bucket: 'com.codeploy.frispoleague/scorer/import' } });
								if (file) {
									var fileNameEscape = new Date().getTime() + "-" + file.name.replace(/\s+/g, '_');
									var params = { Key: '' + fileNameEscape, ContentType: file.type, Body: file };
									bucket.upload(params, function (err, data) {
										if (data) {
											var payloadToImport = {
												filename: fileNameEscape
											}
											scorers.importScorers(payloadToImport)
												.then(function () {
													deferred.resolve(data);
													vm.reloaData(vm.models.currentEvent);
												})
										} else if (err) {
											deferred.reject(err);
										}
									})
								} else {
									deferred.reject(false);
								}
								return deferred.promise;
							})
					}
				})
		}
	}
})();

(function() { 'use strict';

  angular.module('frispo')
    .controller('ScoreboardController', ScoreboardController);

  /** @ngInject */
  function ScoreboardController(models, $scope, events, $q, objToCsv) {

    var vm = this;
    vm.models = models; vm.loading = false;

    vm.orderCriteria = []; vm.order=[];
    vm.criteriaMap = {
      points: 'rankPoints',
      played: 'rankNumberPlayed',
      diffreti: 'rankDiffReti',
      disciplina: 'rankFoul'
    };

    vm.getCurrentEvent = function() { return models.currentEvent || null; }

    // watch for changes in models.currentEvent and load
    // the calendar if current event has changed
    $scope.$watch(vm.getCurrentEvent, function(currentEvent) {
      if (!vm.loading  &&
          currentEvent && !currentEvent.scoreboard) {
        vm.setLoading(currentEvent)           // Set a spinning loader on the page
          .then(events.showScoreboard)        // Get the scoreboard for given event
          .finally(vm.unsetLoading);          // Remove the loader from the page

        // get scoreboard order criteria
        events.getScoreboardOrdreCriteria(vm.getCurrentEvent())
          .then(function(res) {
            vm.orderCriteria = res[0].orderEvent
              .sort(function(e1, e2) { return e1.order - e2.order });
        });
      }
    }, true);     // use object equality and not memory address

    // get scoreboard order criteria
    if (vm.getCurrentEvent() !== null) {
      events.getScoreboardOrdreCriteria(vm.getCurrentEvent())
        .then(function(res) {
          vm.orderCriteria = res[0].orderEvent
            .sort(function(e1, e2) { return e1.order - e2.order });
      });
    }

    vm.getOrderCriteria = function() { return vm.orderCriteria || null; }

    // watch for changes in vm.orderCriteria and update
    // the order criteria of scoreboard
    $scope.$watch(vm.getOrderCriteria, function(criteria) {
      vm.order = criteria.map(function(crt) {
          return vm.criteriaMap[crt.code];
      });
    }, true);     // use object equality and not memory address

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }

    vm.exportData = function (data) {

      var csvObj = models.currentEvent &&
          models.currentEvent.evenType === 0 ?
        getCsvObj(data, false) :             // italiana
        data.map(function(scoresRound) {     // a gironi
          return getCsvObj(scoresRound.tournament, true);
        }).reduce(
          function(acc, value) { return acc.concat(value) });

      var blob = new Blob([ objToCsv(csvObj) ], { type: 'text/csv' })
      saveAs(blob, "Classifica.csv");
    }

    vm.reloaData = function (currentEvent) {
      vm.setLoading(currentEvent)         // Set a spinning loader on the page
        .then(events.showScoreboard)      // Get the scoreboard for given event
        .finally(vm.unsetLoading);

      // get scoreboard order criteria
      events.getScoreboardOrdreCriteria(vm.getCurrentEvent())
        .then(function(res) {
          vm.orderCriteria = res[0].orderEvent
            .sort(function(e1, e2) { return e1.order - e2.order });
      });
    }

    function getCsvObj(rowList, addRound) {

      return rowList.map(function(row) {

        var csvObj = {
          Squadra: row.rankTeamName,
          Punti: row.rankPoints,
          "Partite giocate": row.rankNumberPlayed,
          Vittorie: row.rankWon,
          Pareggi: row.rankSame,
          Sconfitte: row.rankLose,
          "Goal fatti": row.rankGoalScored,
          "Goal subiti": row.rankGoalConceded,
          "Diff reti": row.rankDiffReti,
          Disciplina: row.rankFoul
        }
        if (addRound) csvObj["Girone"] = row.rankNameGroups;
        return csvObj;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController(users, $state) {
    var vm = this;
    vm.user = vm.user || {};
    vm.privacy = vm.privacy || {};

    users.onLoggedOut(); // ensure the user is logged out

    vm.register = function (evt) {
      evt.preventDefault();
      for (var name in vm.privacy) {
        vm.user[name] = vm.privacy[name] ? 1 : 0;
      }
      if (vm.user.hasOwnProperty("flag_privacy")) {
        users.register(vm.user)
          .then(users.onLoggedIn)
          .then(function () { $state.go('main.access'); });
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frispo')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController(models, users, teams, $q, $uibModal) {
    var vm = this;
    vm.models = models;

    vm.userTypes = [{
      num: 0,
      name: 'Giocatore'
    },
    {
      num: 1,
      name: 'Organizzatore'
    }
    ];

    vm.userSubscriptions = [{
      num: 0,
      name: 'Gratuito'
    },
    {
      num: 1,
      name: 'Standard'
    },
    {
      num: 2,
      name: 'Premium'
    }
    ];

    vm.submit = function () {
      vm.setLoading(vm.form)
        .then(vm.updateForm)
        .then(users.form2User)
        .then(users.editUser)
        .then(users.info)
        .then(vm.initForm)
        .finally(vm.unsetLoading)
    }

    vm.submitInfo = function () {
      vm.setLoading(vm.formInfo)
        .then(vm.saveLogoS3)
        .then(vm.getFileName)
        .then(users.form2UserInfo)
        .then(users.update)
        .then(users.info)
        .then(vm.initFormInfo)
        .finally(vm.unsetLoading)
    }

    vm.submitIfLogoCanceledInfo = function () {
      vm.setLoading(vm.formInfo)
        .then(vm.deleteLogoS3)
        .then(vm.saveLogoS3)
        .then(vm.getFileName)
        .then(users.form2UserInfo)
        .then(users.update)
        .then(users.info)
        .then(vm.initFormInfo)
        .finally(vm.unsetLoading)
    }

    vm.deleteUser = function () {
      $uibModal.open({
        templateUrl: 'app/pages/profile/destroy/destroy.html',
        controller: 'ProfileDestroyController',
        controllerAs: 'profileDestroy',
        windowClass: 'modal-danger'
      }).result
        .then(function (res) {
          if (res === true) {
            users.deleteUser(vm.models.currentUser);
          }
        })
    }

    vm.destroy = function () {
      vm.setLoading(vm.form)
        .then(users.deleteUser)
        .finally(vm.unsetLoading)
    }

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }

    vm.initForm = function (res) {
      vm.form = {
        email: vm.models.currentUser.email,
        flagMarketing: vm.check(vm.models.currentUser.flagMarketing),
        flagProfilazione: vm.check(vm.models.currentUser.flagProfilazione)
      }
      return $q.resolve(res);
    }

    vm.initFormInfo = function (res) {
      var extra = vm.models.currentUser.extra
      if (extra == null) {
        extra = {
          logo: "",
          company_name: ""
        }
      }
      vm.formInfo = {
        username: vm.models.currentUser.userUsername,
        address: vm.models.currentUser.userAddress,
        phone: vm.models.currentUser.userPhone,
        teamUrlLogo: extra.logo
      }
      return $q.resolve(res);
    }

    vm.updateForm = function (res) {
      if (vm.form.flagMarketing == 1)
        vm.form.flagMarketing = true;
      else
        vm.form.flagMarketing = false;
      if (vm.form.flagProfilazione == 1)
        vm.form.flagProfilazione = true;
      else
        vm.form.flagProfilazione = false;
      if (vm.form.flagMarketing && vm.form.flagProfilazione) {
        vm.form = {
          email: vm.form.email,
          flagMarketing: 1,
          flagProfilazione: 1
        }
      } else if (!vm.form.flagMarketing && vm.form.flagProfilazione) {
        vm.form = {
          email: vm.form.email,
          flagMarketing: 0,
          flagProfilazione: 1
        }
      } else if (vm.form.flagMarketing && !vm.form.flagProfilazione) {
        vm.form = {
          email: vm.form.email,
          flagMarketing: 1,
          flagProfilazione: 0
        }
      } else {
        vm.form = {
          email: vm.form.email,
          flagMarketing: 0,
          flagProfilazione: 0
        }
      }
      res = vm.form;
      return $q.resolve(res);
    }

    vm.check = function (flag) {
      if (flag == 1) {
        return true;
      } else {
        return false;
      }
    }

    vm.getFileName = function (res) {
      var angularFile = angular.element('#userLogo');
      var file = angularFile[0].files[0];
      if (file) {
        var fileName = "";
        if (file) fileName = angularFile[0].files[0].name;
        var ts = new Date().getTime();
        var fileNameEscape = fileName.replace(/\s+/g, '_');
        vm.formInfo.teamUrlLogo = ts + "-" + fileNameEscape;
      } else {
        vm.formInfo.teamUrlLogo = null;
      }
      return $q.resolve(res);
    }

    vm.saveLogoS3 = function (res) {
      users.getTokenS3Logo()
        .then(function (data) {
          var angularFile = angular.element('#userLogo');
          var file = angularFile[0].files[0];
          if (file) {
            var deferred = $q.defer();
            var credentials = { accessKeyId: data.data[0].keyid, secretAccessKey: data.data[0].secretid, sessionToken: data.data[0].session_token };
            AWS.config.update(credentials);
            AWS.config.region = 'eu-west-1';
            AWS.config.sslEnabled = true;
            var bucket = new AWS.S3({ params: { Bucket: 'com.iaetp.frispo/frispo-logo' } });
            if (file) {
              var params = { Key: vm.formInfo.teamUrlLogo, ContentType: file.type, Body: file };
              bucket.upload(params, function (err, data) {
                if (data) {
                  deferred.resolve(data);
                } else if (err) {
                  deferred.reject(err);
                }
              })
            } else {
              deferred.reject(false);
            }
            angular.element(angularFile).val(null);
            return deferred.promise;
          }
        });
      return $q.resolve(res);
    }

    vm.check = function (string_1, string_2) {
      for (var c = 0; c < (string_1 ? string_1.length : 0); c++) {
        if (string_1.charCodeAt(c) != string_2.charCodeAt(c)) {
          alert('c:' + c + ' ' + string_1.charCodeAt(c) + '!=' + string_2.charCodeAt(c));
        }
      }
    }


    vm.deleteLogoS3 = function (res) {
      var logo = vm.formInfo.teamUrlLogo.toString();
      var logodefault = "https://s3-eu-west-1.amazonaws.com/com.iaetp.frispo/frispo-logo/logobianco.png"; //64
      var nameFile = logo.split('/').pop();
      users.getTokenS3Logo()
        .then(function (data) {
          if (!angular.equals(logo, logodefault)) {
            var deferred = $q.defer();
            var credentials = { accessKeyId: data.data[0].keyid, secretAccessKey: data.data[0].secretid, sessionToken: data.data[0].session_token };
            AWS.config.update(credentials);
            AWS.config.region = 'eu-west-1';
            AWS.config.sslEnabled = true;
            var bucket = new AWS.S3({ params: { Bucket: 'com.iaetp.frispo/frispo-logo' } });
            var params = { Key: nameFile };
            bucket.deleteObject(params, function (err, data) {
              if (data) {
                deferred.resolve(data);
              } else if (err) {
                deferred.reject(err);
              }
            })
            return deferred.promise;
          }
        });

      return $q.resolve(res);
    }



    vm.setLoading()
      .then(users.info)
      .then(vm.initForm)
      .then(vm.initFormInfo)
      .then(vm.unsetLoading);

  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('PressController', PressController);

  /** @ngInject */
  function PressController(models, $scope, events, press, $q, $uibModal) {

    var vm = this; vm.models = models; vm.loading = false;

    vm.getCurrentEvent = function() { return models.currentEvent || null; }

    // watch for changes in models.currentEvent and load
    // the calendar if current event has changed
    $scope.$watch(vm.getCurrentEvent, function(currentEvent) {
      if (!vm.loading && currentEvent && !currentEvent.press) {
        vm.setLoading(currentEvent.evenId)    // Set a spinning loader on the page
          .then(press.list)                   // List the press of the event
          .finally(vm.unsetLoading);          // Remove the loader from the page
      }
    }, true);     // use object equality and not memory address

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }

    vm.createNewPress = function () {
      $uibModal.open({
          templateUrl: 'app/pages/press/create/create.html',
          controller: 'PressCreateController',
          controllerAs: 'pressCreate',
          windowClass: 'modal-success'
        }).result
        .then(function (res) {
          if(angular.isDefined(res)){
            vm.setLoading(res)
              .then(press.form2Press)
              .then(press.create)
              .then(press.list)
              .finally(vm.unsetLoading);
          }
        })
    }

    vm.loadPress = function() {
      $uibModal.open({
        templateUrl: 'app/pages/press/load/load.html',
        controller: 'PressLoadController',
        controllerAs: 'pressLoad',
        windowClass: 'modal-success'
      })
      .result.then(function (res) {
        if (angular.isDefined(res)){
          vm.setLoading(res)
            .then(press.load)
            .then(press.list)
            .finally(vm.unsetLoading);
        }
      });
    }
  }
})();

(function() { 'use strict';

  angular.module('frispo')
    .controller('MovePlayersController', MovePlayersController);

  /** @ngInject */
  function MovePlayersController(frispoApi, resPipe, errorManager, models, $log, $uibModal) {

    var vm                = this;             // component variable
    vm.models             = models;
    vm.loading            = false;
    vm.selectedEventFrom  = null;
    vm.selectedEventTo    = null;
    vm.currentTeamsFrom   = [];
    vm.currentTeamsTo     = [];
    vm.selectedTeamFrom   = null;
    vm.selectedTeamTo     = null;
    vm.currentPlayerList  = [];
    vm.selectedPlayers    = [];

    vm.selectEventFrom = function(event) {
      vm.selectedEventFrom = event;           // reset
      vm.currentTeamsFrom  = [];
      vm.selectedTeamFrom  = null;
      vm.currentPlayerList = [];

      frispoApi.listTeams(event.evenId)       // load
        .then(resPipe.parseResponse)
        .then(resPipe.camelize)
        .then(function(teams) { vm.currentTeamsFrom = teams; })
        .catch(errorManager);
    }
    vm.selectTeam = function(team) {
      vm.selectedTeamFrom = team;
      frispoApi.listPlayers(team.teamId)
        .then(resPipe.parseResponse)
        .then(resPipe.camelize)
        .then(resPipe.updatePlayers)
        .then(function(players) { vm.currentPlayerList = players; })
        .catch(errorManager);
    }
    vm.selectEventTo = function(event) {
      vm.selectedEventTo = event;
      frispoApi.listTeams(event.evenId)
        .then(resPipe.parseResponse)
        .then(resPipe.camelize)
        .then(function(teams) { vm.currentTeamsTo = teams; })
        .catch(errorManager);
    }

    vm.getPlayerList = function() {
      return vm.selectedPlayers
        .filter(function(ele) { return ele !== false; });
    }

    function getFormData() {
      return { all_player: 0,
        event_id_from: vm.selectedEventFrom.evenId,
        event_id_to: vm.selectedEventTo.evenId,
        list_player: vm.getPlayerList(),
        team_id_from: vm.selectedTeamFrom.teamId,
        team_id_to: parseInt(vm.selectedTeamTo)
      };
    }

    vm.showConfirmPopup = function(op) {
      $uibModal.open({
        templateUrl: 'app/pages/playersMove/confirmPopup/confirm.html',
        controller: 'MovePlayerConfirmController',
        controllerAs: 'confirmPopup',
        resolve: {
                op: function () { return op; },
              }
      })
      .result.then(op === 'copy' ? copyPlayers : movePlayers)
    }
    function movePlayers() {
      frispoApi.movePlayers(getFormData()).then(function(res) {
        if (res.status_code === 200) {
          vm.selectedPlayers = [];
          vm.selectTeam(vm.selectedTeamFrom);
        } else { $log.error(res.msg) }
      });
    }
    function copyPlayers() {
      frispoApi.copyPlayers(getFormData())
        .then(function(res) {
          if (res.status_code === 200) {
            vm.selectedPlayers = [];
            vm.selectTeam(vm.selectedTeamFrom);
          } else { $log.error(res.msg) }
      });
    }
    vm.checkAll = function() {
      vm.selectedPlayers = vm.currentPlayerList
        .map(function(player) { return player.playId });
    }
  }
})();

(function () {
	'use strict';

	angular.module('frispo')
		.controller('PlayersController', PlayersController);

	/** @ngInject */
	function PlayersController(models, $scope, $q, $uibModal, teams, objToCsv, players) {

		var vm = this; vm.models = models; vm.loading = false;

		vm.getCurrentEvent = function () { return models.currentEvent || null; }

		// watch for changes in models.currentEvent and load
		// team info to fill up the team select options
		$scope.$watch(vm.getCurrentEvent, loadEventTeams, true);

		function loadEventTeams(currentEvent) {
			if (!vm.loading && currentEvent &&
				(!currentEvent.teams || !currentEvent.currentTeam)) {
				vm.setLoading(currentEvent.evenId)     // Set a spinning loader on the page
					.then(teams.list)                    // Get the event teams (API call) to fill up the select options
					.then(vm.updateTeam)                 // Update the match day
					.finally(vm.unsetLoading);           // Remove the loader from the page
			}
		}

		// Update the team (it's been selected now)
		vm.updateTeam = function () {
			// No current event selected, or no teams yet -> noop
			if (!models.currentEvent || !models.currentEvent.teams || models.currentEvent.teams.length === 0) {
				return;
			}

			// No day selected - check if the event has just changed
			if (!models.currentEvent.currentTeam) {
				// An event has been selected -> use it's first available team
				models.currentEvent.currentTeam = models.currentEvent.teams[0];
			}
			// Current day selected -> manually find and copy the real team from models (ng-options creates a new object)
			else {
				for (var i = 0; i < models.currentEvent.teams.length; i++) {
					if (models.currentEvent.teams[i].teamId === vm.models.currentEvent.currentTeam.teamId) {
						vm.models.currentEvent.currentTeam = models.currentEvent.teams[i];
						break;
					}
				}
			}

			return vm
				.setLoading()
				.then(teams.listPlayers)
				.finally(vm.unsetLoading);
		}

		vm.setLoading = function (res) {
			vm.loading = true;
			return $q.resolve(res);
		}

		vm.unsetLoading = function (res) {
			vm.loading = false;
			return $q.resolve(res);
		}

		vm.reloaData = function (res) {
			vm.setLoading(res)     // Set a spinning loader on the page
			//	.then(teams.list)                    // Get the event teams (API call) to fill up the select options
				.then(vm.updateTeam)                 // Update the match day
				.finally(vm.unsetLoading);
		}

		vm.importPlayers = function () {
			$uibModal.open({
				templateUrl: 'app/pages/players/import/import.html',
				controller: 'PlayersImportController',
				controllerAs: 'importPlayers',
				windowClass: 'modal-success'
			}).result
				.then(function (res) {
					vm.setLoading(res)
						.then(function (res) {
							if (angular.isDefined(res)) {
								var file = res.file;
								players.getTokenS3()
									.then(function (data) {
										var deferred = $q.defer();
										var credentials = {
											accessKeyId: data.data[0].keyid,
											secretAccessKey: data.data[0].secretid,
											sessionToken: data.data[0].session_token
										};
										AWS.config.update(credentials);
										AWS.config.region = 'eu-west-1';
										AWS.config.sslEnabled = true;
										var bucket = new AWS.S3({ params: { Bucket: 'com.codeploy.frispoleague/player/import' } });
										if (file) {
											var fileNameEscape = new Date().getTime() + "-" + file.name.replace(/\s+/g, '_');
											var params = { Key: '' + fileNameEscape, ContentType: file.type, Body: file };
											bucket.upload(params, function (err, data) {
												if (data) {
													players.importPlayers(fileNameEscape)
														.then(function () {
															deferred.resolve(data);
															vm.reloaData(vm.models.currentEvent);
														})
												} else if (err) {
													deferred.reject(err);
												}
											})
										} else {
											deferred.reject(false);
										}
										return deferred.promise;
									})
							}
						})
						.then(vm.reloaData);
				})

		}

		vm.createNewPlayer = function () {
			$uibModal.open({
				templateUrl: 'app/pages/players/create/create.html',
				controller: 'PlayerCreateController',
				controllerAs: 'playerCreate',
				windowClass: 'modal-success'
			}).result
				.then(function (res) {
					if (angular.isDefined(res)) {
						vm.setLoading(res)
							.then(teams.form2Player)
							.then(teams.createPlayer)
							.finally(vm.unsetLoading);
					}
				})
		}

		vm.exportData = function (data) {

			var csv = objToCsv(data.map(function (player) {
				return {
					Nome: player.playFirstname,
					Cognome: player.playSurname,
					Tessera: player.playTessera,
					Recapito: player.playRecapito
				}
			}));
			var blob = new Blob([csv], { type: 'text/csv' })
			saveAs(blob, "Giocatori.csv");
		};

		function init() {
			loadEventTeams(vm.getCurrentEvent());
		}
		init();
	}
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('ManagerMatchesController', ManagerMatchesController);

  /** @ngInject */
  function ManagerMatchesController(models, events, matches, $q, $uibModal, teams) {
    var vm = this;
    vm.models = models;

    // Update the current event (it's been selected now)
    vm.updateCurrentEvent = function () {
      // No current event selected -> noop
      if(!models.currentEvent) return;

      // Current event selected -> manually find and copy the real event from models (ng-options creates a new object)
      for (var i = 0; i < models.currentUser.managedEvents.length; i++) {
        if(models.currentUser.managedEvents[i].evenId === models.currentEvent.evenId){
          models.currentEvent = models.currentUser.managedEvents[i];
          break;
        }
      }

      return vm
        .setLoading(models.currentEvent.evenId) // Set a spinning loader on the page
        .then(events.show)                      // Get the event info (API call)
        .then(teams.listcalendarteam)                       // Get the event teams (API call), needed for filling up the select options
        .then(vm.updateMatchDay)                // Update the match day
        .finally(vm.unsetLoading);              // Remove the loader from the page
    }

    // Update the match day (it's been selected now)
    vm.updateMatchDay = function () {
      // No current event selected, or no match days yet -> noop
      if(!models.currentEvent || !models.currentEvent.matchDays || models.currentEvent.matchDays.length === 0){
        return;
      }

      // No day selected - check if the event has just changed
      if(!models.currentEvent.currentDay){
        // An event has been selected -> use it's first available day
        models.currentEvent.currentDay = models.currentEvent.matchDays[0];
      }
      // Current day selected -> manually find and copy the real day from models (ng-options creates a new object)
      else{
        for (var i = 0; i < models.currentEvent.matchDays.length; i++) {
          if(models.currentEvent.matchDays[i].matcDayId === vm.models.currentEvent.currentDay.matcDayId){
            vm.models.currentEvent.currentDay = models.currentEvent.matchDays[i];
            break;
          }
        }
      }

      return vm
        .setLoading()
        .then(matches.list)
        .finally(vm.unsetLoading);
    }

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }

    // API call to retrieve all the events
    events
      .listManaged()
      .then(vm.updateCurrentEvent);
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController(users, uiState, $state, ezfb) {
    var vm = this;
    vm.user = vm.user || {};
    vm.privacy = vm.privacy || {};

    users.onLoggedOut(); // ensure the user is logged out

    // Login with username and password
    vm.login = function () {
      users.login(vm.user)
        .then(function () {
          $state.go('main.access');
        });
    }
    // Login with facebook

    vm.facebookPrivacyAcceptance = function() {
      return uiState.privacyAcceptance;
    }

    vm.loginFacebook = function (evt) {
      evt.preventDefault();
      var privacyObj = { }
      for (var name in vm.privacy) {
        privacyObj[name] = vm.privacy[name] ? 1 : 0;
      }
      if (privacyObj.hasOwnProperty("flag_privacy") ||
          !uiState.privacyAcceptance) {
        users.configureFacebookCallbacks(privacyObj);
        ezfb.login(null, { scope: 'email,public_profile' });
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('ManagerEventsController', ManagerEventsController);

  /** @ngInject */
  function ManagerEventsController(models, events) {
    var vm = this;

    // Bind models to controller
    vm.models = models;

    // API call
    events.listManaged();
  }
})();


(function() { 'use strict';

  angular.module('frispo')
    .controller('IscrizioniController', IscrizioniController);

  /** @ngInject */
  function IscrizioniController(models, events, $q, $scope, iscrizioni) {

    var vm = this; vm.models = models;

    vm.getCurrentEvent = function() { return models.currentEvent || null; }

    $scope.$watch(vm.getCurrentEvent, function(currentEvent) {
      if (!vm.loading && currentEvent) {
        events.list().then(vm.updateCurrentEvent);
      }
    }, true);

    vm.updateCurrentEvent = function () {
      if(!models.currentEvent) return;
      for (var i = 0; i < models.events.length; i++) {
        if(models.events[i].evenId === models.currentEvent.evenId){
          models.events[i] = models.currentEvent;
          break;
        }
      }
      return vm.setLoading(models.currentEvent.evenId)
        .then(events.show)
        .then(iscrizioni.list)
        .finally(vm.unsetLoading);
    }

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('GiornateController', GiornateController);

  /** @ngInject */
  function GiornateController(models, $scope, events, matches, $q, $uibModal) {

    var vm = this; vm.models = models; vm.loading = false;

    vm.getCurrentEvent = function() { return models.currentEvent || null; }

    // watch for changes in models.currentEvent and load
    // the calendar if current event has changed
    $scope.$watch(vm.getCurrentEvent, function(currentEvent) {
      if (!vm.loading && currentEvent &&
         (!vm.models.currentEvent.currentDay ||
          !vm.models.currentEvent.currentDay.matches)) {
        vm.setLoading(currentEvent.evenId)    // Set a spinning loader on the page
          .then(vm.updateMatchDay)            // Update the match day
          .finally(vm.unsetLoading);          // Remove the loader from the page
      }
    }, true);     // use object equality and not memory address

    vm.updateMatchDay = function () {
      if(!models.currentEvent || !models.currentEvent.matchDays || models.currentEvent.matchDays.length === 0){
        return;
      }
      if(!models.currentEvent.currentDay){
        models.currentEvent.currentDay = models.currentEvent.matchDays[0];
      }
      else{
        for (var i = 0; i < models.currentEvent.matchDays.length; i++) {
          if(models.currentEvent.matchDays[i].matcDayId === vm.models.currentEvent.currentDay.matcDayId){
            vm.models.currentEvent.currentDay = models.currentEvent.matchDays[i];
            break;
          }
        }
      }
      return vm
        .setLoading()
        .then(matches.list)
        .finally(vm.unsetLoading);
    }

    vm.updateDayOfWeek = function (){
      $uibModal.open({
        templateUrl: 'app/pages/giornate/updateDay/create.html',
        controller: 'UpdateDayCreateController',
        controllerAs: 'updateDayCreate',
        windowClass: 'modal-danger'
      }).result
      .then(function (res) {
        if(angular.isDefined(res)){
          matches.updateDateMatchFromWeek()
          .then(function (){
            $uibModal.open({
              templateUrl: 'app/pages/giornate/updateDay/success.html',
              controller: 'UpdateDaySuccessController',
              controllerAs: 'updateDaySuccess',
              windowClass: 'modal-success'
            })
          })
          .catch(function(){
            $uibModal.open({
              templateUrl: 'app/pages/giornate/updateDay/error.html',
              controller: 'UpdateDayErrorController',
              controllerAs: 'updateDayError',
              windowClass: 'modal-danger'
            })
          })
        }
      })
    }

    vm.createNewDay = function () {
      $uibModal.open({
          templateUrl: 'app/pages/calendar/createDay/create.html',
          controller: 'DayCreateController',
          controllerAs: 'dayCreate',
          windowClass: 'modal-success'
        }).result
        .then(function (res) {
          if(angular.isDefined(res)){
            vm.setLoading(res)
              .then(matches.form2Day)
              .then(matches.createDay)
              .then(function (res) {
                models.currentEvent.currentDay = res;
                return res;
              })
              .then(vm.updateMatchDay)
              .finally(vm.unsetLoading);
          }
        })
    }

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('InvitationsController', InvitationsController);

  /** @ngInject */
  function InvitationsController(models, events, invitations, $q, $uibModal) {
    var vm = this;
    vm.models = models;

    vm.createNewInvitation = function () {
      $uibModal.open({
          templateUrl: 'app/pages/invitations/create/create.html',
          controller: 'InvitationCreateController',
          controllerAs: 'invitationCreate',
          windowClass: 'modal-success'
        }).result
        .then(function (res) {
          if(angular.isDefined(res)){
            vm.setLoading(res)
              .then(invitations.form2Invitation)
              .then(invitations.create)
              .then(invitations.listSent)
              .finally(vm.unsetLoading);
          }
        })
    }

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }

    events.list();
    invitations.listSent();
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController(users, $state) {
    var vm = this;

    vm.user = vm.user || {};

    // ForgotPassword
    vm.forgotPassword = function () {
      users
        .forgotPassword(vm.user)
        .then(function () {
          $state.go('main.login');
        });
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('frispo')
		.controller('CreateEventController', CreateEventController);

	/** @ngInject */
	function CreateEventController(Wizard, events, toastr, teams, matches, $log, $state, models, utils) {
		var vm = this;
		vm.models = models;

		console.log();

		vm.hasScorersPermission = models.currentUser.permissions.filter(function (permission) {
			return permission.permName === "scorers";
		}).length > 0;
		vm.hasEvents = models.events.length > 0;


		vm.hasEventPermission = models.currentUser.userSaas[0].subscription=='LEAGUEFREE';
		console.log(vm.hasEventPermission);

		const startWizardStep = vm.hasScorersPermission ? 1 : (vm.hasEvents ? 0 : 1);

		// Initialize the wizard object
		vm.wizard = new Wizard({ totalSteps: 3, startFromStep: startWizardStep });

		// If true, the user have to manually insert the rounds.
		// If false, the user can choose between "Inserimento gironi manuale" and "Inserimento gironi automatico".
		vm.forceManualRounds = true;

		vm.roundNames = utils.alphabetChars();

		vm.initDefaultTeams = function () {
			if (!vm.step2.teams) {
				vm.step2.teams = [];
				vm.addTeam();
				vm.addTeam();
			}
		}

		vm.addTeam = function () {
			if (vm.step2 && vm.step2.roundType === 1) {
				vm.step2.teams.push({ name: '' });
			}
			else {
				vm.step2.teams.push({ name: '', round: '' });
			}
		};

		vm.removeTeam = function (index) {
			if (vm.step2.teams.length <= 2) {
				toastr.error('E\' obbligatorio inserire almeno 2 squadre', 'Impossibile rimuovere la squadra');
			}
			else {
				vm.step2.teams.splice(index, 1);
			}
		}

		vm.step1Done = function () {
			if (!vm.step2) vm.step2 = {}; // Initialize step2 if needed

			// If not "Torneo a gironi"
			if (vm.step1.type != 1) {
				vm.step2.roundType = '1';
				vm.initDefaultTeams();
			}

			// If "torneo a gironi" and user can't choose manual or automatic round type
			else if (vm.forceManualRounds) {
				vm.step2.roundType = '0'; // Manual rounds
				vm.initDefaultTeams();
			}

			vm.wizard.next();
		}

		vm.submitStep1 = function () {
			$log.info('creando l\'evento..');
			return events
				.form2Event(vm.step1)
				.then(events.create);
		}

		vm.step2Done = function () {
			vm.wizard.next();
		}

		vm.submitStep2 = function () {
			$log.info('creando le squadre..');
			return teams
				.form2Teams(vm.step2)
				.then(teams.addGroup);
		}

		vm.step3Done = function () {
			vm.submitWizard();
		}

		vm.submitStep3 = function () {
			$log.info('creando il calendario..');
			return matches.createCalendar(models.currentEvent.evenId);
		}

		vm.submitWizard = function () {
			vm.wizard.loading = true;
			vm.submitStep1()
				.then(vm.submitStep2)
				.then(vm.submitStep3)
				.then(function () {
					$state.go('main.admin.events');
				})
				.finally(function () {
					vm.wizard.loading = false;
				});
		}

		vm.manualSubmit = function () {
			vm.wizard.loading = true;
			vm.submitStep1()
				.then(vm.submitStep2)
				.then(function () {
					$state.go('main.admin.events');
				})
				.finally(function () {
					vm.wizard.loading = false;
				})
		}
	}
})();

(function() {
    'use strict';

    angular
        .module('frispo')
        .controller('EventsController', EventsController);

    /** @ngInject */
    function EventsController(models, events, invitations, users) {


        var vm = this;
        // Bind models to controller
        vm.models = models;

        // Create filter objects to split events into published and not published
        vm.tableFilters = [
            // published events
            {
                eventFilter: {
                    evenStatoEvento: '0'
                },
                title: 'Tornei non pubblicati',
                boxClass: 'box-warning'
            },
            {
                eventFilter: {
                    evenStatoEvento: '1'
                },
                title: 'Tornei pubblicati',
                boxClass: 'box-success'
            }
        ];

        vm.acceptInvitation = function(invitation) {
            invitations
                .accept(invitation)
                .then(invitations.listReceived)
                .then(users.show); // Update user data because permissions may change
        }

        vm.declineInvitation = function(invitation) {
            invitations
                .decline(invitation)
                .then(invitations.listReceived);
        }

        // API call
        events.list();
        invitations.listReceived();

    }

})();

(function() { 'use strict';

  angular.module('frispo')
    .controller('DisciplinaryController', DisciplinaryController);

  /** @ngInject */
  function DisciplinaryController(models, $scope, events, $q) {

    var vm = this; vm.models = models; vm.loading = false;

    vm.getCurrentEvent = function() { return models.currentEvent || null; }

    // watch for changes in models.currentEvent and load
    // disciplinary stuff if current event has changed
    $scope.$watch(vm.getCurrentEvent, function(currentEvent) {
      if (!vm.loading && currentEvent) {
        vm.setLoading(currentEvent.evenId)    // Set a spinning loader on the page
          .then(function (eventId) {          // List disciplinary stuff
            return $q.all([
              events.listYellows(eventId),
              events.listDiffides(eventId),
              events.listSqualifications(eventId),
              events.listAmends(eventId)
            ]);
          }).finally(vm.unsetLoading);        // Remove the loader from the page
      }
    }, true);     // use object equality and not memory address

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }


    vm.cardConfigs = [
      {
        header: 'Ammonizioni',
        boxClass: 'box-success',
        emptyMessage: 'Non ci sono ammonizioni in questo evento',
        cardsKey: 'yellows',
        cardMatchKey: 'matcYellowCards',
        idKey: 'cardId',
        fields: [
          {
            name: 'Nome giocatore',
            key: 'playName'
          },
          {
            name: 'Cognome giocatore',
            key: 'playSurname'
          },
          {
            name: 'Squadra',
            key: 'teamName'
          },
          {
            name: 'Numero ammonizioni',
            key: 'nroYellowCards'
          }
        ],
        controls: {
          show: true,
          edit: true,
          editDetail: false,
          deleteDetail: true
        }
      },
      {
        header: 'Diffide',
        boxClass: 'box-warning',
        emptyMessage: 'Non ci sono diffide in questo evento',
        cardsKey: 'diffides',
        cardMatchKey: 'matcYellowCards',
        idKey: 'cardId',
        fields: [
          {
            name: 'Nome giocatore',
            key: 'playName'
          },
          {
            name: 'Cognome giocatore',
            key: 'playSurname'
          },
          {
            name: 'Squadra',
            key: 'teamName'
          },
          {
            name: 'Numero ammonizioni',
            key: 'nroYellowCards'
          }
        ],
        controls: {
          show: true,
          edit: false,
          editDetail: false,
          deleteDetail: false
        }
      },
      {
        header: 'Squalifiche',
        boxClass: 'box-danger',
        emptyMessage: 'Non ci sono squalifiche in questo evento',
        cardsKey: 'squalifications',
        cardMatchKey: 'matcRedCards',
        idKey: 'cardId',
        fields: [
          {
            name: 'Nome giocatore',
            key: 'playName'
          },
          {
            name: 'Cognome giocatore',
            key: 'playSurname'
          },
          {
            name: 'Squadra',
            key: 'teamName'
          },
          {
            name: 'Numero squalifiche',
            key: 'nroRedCards'
          }
        ],
        detailFields: [
          {
            name: 'Tipo di squalifica',
            key: 'typeSqualificationsPretty'
          },
          {
            name: 'Giornate di squalifica',
            key: 'daySqualifications'
          },
          {
            name: 'Stato',
            key: 'squalificationStatus'
          },
          {
            name: 'Note',
            key: 'note'
          }
        ],
        controls: {
          show: true,
          edit: true,
          editDetail: {
            daySqualifications: {
              type: 'select',
              options: [{name:'1',value:1},{name:'2',value:2},{name:'3',value:3},{name:'4',value:4},{name:'5',value:5},{name:'6',value:6},{name:'7',value:7},{name:'8',value:8},{name:'9',value:9},{name:'10',value:10},{name:'11',value:11},{name:'12',value:12},{name:'13',value:13},{name:'14',value:14},{name:'15',value:15},{name:'16',value:16},{name:'17',value:17},{name:'18',value:18},{name:'19',value:19},{name:'20',value:20}]
            },
            squalificationStatus: {
              type: 'select',
              options: [{name:'Non scontata',value:0},{name:'Scontata',value:1}]
            },
            note: {
              type: 'text'
            }
          },
          deleteDetail: true
        }
      },
      {
        header: 'Ammende',
        boxClass: 'box-danger',
        emptyMessage: 'Non ci sono ammende in questo evento',
        cardsKey: 'amends',
        cardMatchKey: 'amends',
        idKey: 'teamId',
        fields: [
          {
            name: 'Squadra',
            key: 'teamName'
          },
          {
            name: 'Ammende',
            key: 'totAmends'
          }
        ],
        detailFields: [
          {
            name: 'Descrizione',
            key: 'amenDescription'
          },
          {
            name: 'Punti',
            key: 'amenPoints'
          },
          {
            name: 'Euro',
            key: 'amenEuro'
          },
          {
            name: 'Stato',
            key: 'amenStatus'
          }
        ],
        controls: {
          show: true,
          edit: true,
          editDetail: {
            amenDescription: {
              type: 'text'
            },
            amenPoints: {
              type: 'text'
            },
            amenEuro: {
              type: 'text'
            },
            amenStatus: {
              type: 'select',
              options: [{name:'Non scontata',value:0},{name:'Scontata',value:1}]
            }
          },
          deleteDetail: true
        }
      }
    ];
  }
})();

(function () {
    'use strict';

    angular
        .module('frispo')
        .controller('CondividiTorneoController', CondividiTorneoController);

    /** @ngInject */
    function CondividiTorneoController(models, events, $q) {
        var vm = this;
        vm.models = models;
        vm.isLoading = false;

        vm.setCurrentEvent = function (event) {
            vm.currentEvent = event
        }

        vm.setLoading = function (res) {
            vm.isLoading = true;
            return $q.resolve(res);
        }

        vm.unsetLoading = function (res) {
            vm.isLoading = false;
            return $q.resolve(res);
        }

        vm.submit = function () {
            return vm.setLoading(vm.currentEvent)
                .then(events.getTokenS3Locandina)
                .then(function (data) {
                    var angularFile = angular.element('#condividiTorneoEditForm-evenLocandina');
                    var file = angularFile[0].files[0];
                    if (file) {
                        var deferred = $q.defer();
                        var credentials = {
                            accessKeyId: data.data[0].keyid,
                            secretAccessKey: data.data[0].secretid,
                            sessionToken: data.data[0].session_token
                        };
                        AWS.config.update(credentials);
                        AWS.config.region = 'eu-west-1';
                        AWS.config.sslEnabled = true;
                        var bucket = new AWS.S3({
                            params: {
                                Bucket: 'com.codeploy.frispo.events.locandine'
                            }
                        });
                        var fileName = "";
                        if (file) fileName = angularFile[0].files[0].name;

                        var ts = new Date().getTime();
                        var fileNameEscape = fileName.replace(/\s+/g, '_');
                        vm.currentEvent.evenLocandina = ts + "-" + fileNameEscape;
                        if (file) {
                            var params = {
                                Key: '' + ts + "-" + fileNameEscape,
                                ContentType: file.type,
                                Body: file
                            };
                            bucket.putObject(params, function (err, data) {
                                if (data) {
                                    deferred.resolve(data);
                                } else if (err) {
                                    deferred.reject(err);
                                }
                            })
                        } else {
                            deferred.reject(false);
                        }
                        return deferred.promise;
                    }
                })
                .then(function () {
                    return events.form2Event(vm.currentEvent);
                })
                .then(function (eventData) {
                    return events.update(vm.currentEvent.evenId, eventData);
                })
                .then(function () {
                    var span = angular.element('#confirm');
                    span.html('Modifiche salvate correttamente!');

                    vm.setCurrentEvent(null);
                })
                .finally(vm.unsetLoading);
        }

        vm.loading = function () {
            return vm.setLoading()
                .then(function () {
                    var span = angular.element('#upload-file-info');
                    span.html('Immagine caricata, premere Salva per confermare');
                })
                .finally(vm.unsetLoading);
        }

        events.list();
    }
})();

(function () {
    'use strict';

    angular
        .module('frispo')
        .controller('CatalogController', CatalogController);

    /** @ngInject */
    function CatalogController(models, users, $q, $uibModal) {
        var vm = this;
        vm.models = models;

        vm.plans = [
            {
                title: "Basic",
                price: "€0",
                time: "Per sempre",
                features: [
                    "1 Torneo Attivo (cancella e ricrea)",
                    "Gestisci Calendario e Risultati",
                    "Squadre e giocatori",
                    "Inserisci Risultati da App",
                    "Crea Evento da App",
                    "Locandina web"
                ]
            },
            {
                title: "Premium",
                price: "€250",
                time: "12 mesi",
                features: [
                    "Piano Standard",
                    "+",
                    "6 Dirigenti per aiutarti ad inserire i risultati",
                    "Disciplinare",
                    "Comunicati Pdf",
                    "Arbitri e referti di gara",
                    "Tuo sito web completo con disciplinare e comunicati"
                ],
                actionButton: "Richiedi piano PREMIUM",
                subscription: "LEAGUEPREMIUM12"
            }
        ];

        vm.userSaas = [];

        vm.confirmPlan = function (plan) {
            $uibModal.open({
                templateUrl: 'app/pages/catalog/confirm/confirm.html',
                controller: 'CatalogConfirmController',
                controllerAs: 'catalogConfirm',
                windowClass: 'modal-success'
            }).result
                .then(function (res) {
                    if (res === true) {
                        var planState = vm.setPlanPayload(models.currentUser, plan);
                        users.confirmUserPlan(planState)
                          .then(function(res) {
                            return users.addPlanToCMS(getOrderContent(res.data[0]));
                        });

                        $uibModal.open({
                            templateUrl: 'app/pages/catalog/thanks/thanks.html',
                            controller: 'CatalogThanksController',
                            controllerAs: 'catalogThanks',
                            windowClass: 'modal-success'
                        });

                    }
                });
        }

        function getOrderContent(planState) {
          return {
            refId: planState.related_obj_transaction_id,
            type: 'orderfrispo',
            data: planState.related_obj_extra
          };
        }


        function getNowDate() {
            //return string
            var returnDate = "";
            //get datetime now
            var today = new Date();
            //split
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //because January is 0!
            var yyyy = today.getFullYear();
            //Interpolation date
            returnDate += yyyy+'/';

            if (mm < 10) {
                returnDate += '0${mm}/'
            } else {
                returnDate += '${mm}/';
            }


            if (dd < 10) {
                returnDate += '0${dd}';
            } else {
                returnDate += '${dd}';
            }


            return returnDate;
        }

        vm.setPlanPayload = function (currentUser, plan) {
            var frispoPremium15Giorni = {
                type: 'productlite',
                id: 'e736ec05104e4423b4fe33fa2c5c1045',
                userId: currentUser.userUuid,
                data: {
                    name: 'Frispo Premium 15g prova',
                    category: 'prova gratuita',
                    disabled: false,
                    immagine: null,
                    quantity: 1,
                    category_id: 'cdd8ceadffd14decbab0e3b46583b55c',
                    description: 'Frispo Premium 15 giorni di prova',
                    prezzo_label: null,
                    prezzo_unita: 0,
                    long_description: null,
                    short_description: 'LEAGUEPREMIUM15G',
                    carouselImagescar1: null,
                    carouselImagescar2: null,
                    carouselImagescar3: null,
                    carouselImagescar4: null
                }
            };

            var frispoStandard15Giorni = {
                type: 'productlite',
                id: '639e036a5ae74ea5baaf03fe2a464615',
                userId: currentUser.userUuid,
                data: {
                  name: 'Frispo Standard 15g prova',
                  category: 'prova gratuita',
                  disabled: false,
                  immagine: null,
                  quantity: 1,
                  category_id: 'cdd8ceadffd14decbab0e3b46583b55c',
                  description: '15 giorni di prova gratuita per frispo league',
                  prezzo_label: null,
                  prezzo_unita: 0,
                  long_description: null,
                  short_description: 'LEAGUESTANDARD15G',
                  carouselImagescar1: null,
                  carouselImagescar2: null,
                  carouselImagescar3: null,
                  carouselImagescar4: null
                }
              }



            var planPayload = {
                //related_obj_date_start: getNowDate(),
                //related_obj_date_end: getNowDate(),
                related_obj_extra: {
                    order_form: {
                        name: currentUser.displayName,
                        surname: '',
                        phone: currentUser.userPhone,
                        mail: currentUser.userEmail,
                        address: currentUser.userAddress,
                        cap: '',
                        city: '',
                        message: 'Ciao vorrei provare questo piano',
                        delivery_type: '0'
                    },
                    order_products: [
                        plan.subscription === 'LEAGUESTANDARD12' ? frispoStandard15Giorni : frispoPremium15Giorni
                    ]
                },
                related_obj_name: 'order_store_lite',
                related_obj_ref_id: 'cdfrispoleague',
                related_obj_type: 'order_store_lite',
                related_obj_uuid_owner: 'HCNADXCF5K'
            }
            return planPayload;
        }

        vm.buy = function () {
            $uibModal.open({
                templateUrl: 'app/pages/catalog/buy/buy.html',
                controller: 'CatalogBuyController',
                controllerAs: 'catalogBuy',
                windowClass: 'modal-success'
            }).result
                .then(function () {
                    // if (res === true) {
                    // }
                });
            $uibModal.open({
                templateUrl: 'app/pages/catalog/thanks/thanks.html',
                controller: 'CatalogThanksController',
                controllerAs: 'catalogThanks',
                windowClass: 'modal-success'
            });
        }

        vm.setLoading = function (res) {
            vm.loading = true;
            return $q.resolve(res);
        }

        vm.setUserSaas = function (res) {
            vm.userSaas = res[1].userSaas.userSaas.filter(
                function (userSaas) {
                    return userSaas.saas == "frispoleague"
                })[0];
            return $q.resolve(res);
        }

        vm.unsetLoading = function (res) {
            vm.loading = false;
            return $q.resolve(res);
        }

        vm.setLoading()
            .then(users.info)
            .then(vm.setUserSaas)
            .then(vm.unsetLoading);

    }

})();

(function() { 'use strict';

  angular.module('frispo')
    .controller('ArbiterController', ArbiterController);

  /** @ngInject */
  function ArbiterController(models, arbiters, $uibModal, $q, $scope) {

    var vm = this;
    vm.loading = false;
    vm.arbiters = [ ];
    vm.models = models;

    vm.getCurrentEvent = function() { return models.currentEvent || null; }

    $scope.$watch(vm.getCurrentEvent, function(currentEvent) {
      if (!vm.loading && currentEvent) {
        vm.setLoading(currentEvent.evenId)
          .then(arbiters.list)
          .then(function(list) {
              vm.arbiters = list; $q.resolve(list); })
          .finally(vm.unsetLoading)
      }
    }, true);

    vm.createNewArbiter = function () {

      $uibModal.open({
        templateUrl: 'app/pages/arbiter/create/create.html',
        controller: 'ArbiterCreateController',
        controllerAs: 'arbiterCreate',
        windowClass: 'modal-success'
      })
      .result.then(function (arbiter) {
        vm.setLoading(arbiter)
          .then(arbiters.create)
          .then(arbiters.list)
          .then(function(list) {
              vm.arbiters = list; $q.resolve(list); })
          .finally(vm.unsetLoading);
      });
    }

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }
  }
})();

(function() { 'use strict';

  angular.module('frispo')
    .controller('CalendarController', CalendarController);

  /** @ngInject */
  function CalendarController(models, $scope, objToCsv, matches, $q, $uibModal, teams, arbiters) {

    var vm = this; vm.models = models; vm.loading = false;
    vm.arbiters = [];
    vm.groups = [];

    vm.getCurrentEvent = function() { return models.currentEvent || null; }

    // watch for changes in models.currentEvent and load
    // the calendar if current event has changed
    $scope.$watch(vm.getCurrentEvent, function(currentEvent) {
      if (!vm.loading && currentEvent) {
        vm.setLoading(currentEvent.evenId)    // Set a spinning loader on the page
          .then(teams.listcalendarteam)       // Get the event teams (API call), needed for filling up the select options
          .then(vm.updateMatchDay);            // Update the match day

        vm.setLoading(currentEvent.evenId)    // load event arbiters list
          .then(arbiters.list)
          .then(function(list) {
              vm.arbiters = list; $q.resolve(list); })
          .finally(vm.unsetLoading);

        vm.setLoading(currentEvent.evenId)    // load event groups
          .then(matches.listGroups)
          .then(function (list) { vm.groups = list; })
          .finally(vm.unsetLoading);
      }
    }, true);     // use object equality and not memory address

    vm.exportData = function (data) {

      var csv = objToCsv(data.map(function(match) {
        var csvObj = {
          "Squadra Casa": match.matcTeamA,
          "Squadra Ospite": match.matcTeamB,
          "Goal Casa": match.matcScoreTeamA,
          "Goal Ospiti": match.matcScoreTeamB,
          "Data Partita": match.matcDateMatchPretty,
          Ora: match.matcTime,
          Indirizzo: match.matcAddress,
          Giocata: match.matcFlgPlay === 1 ? 'si' :
            (match.matcFlgPlay === 0 ? 'no' : 'rinviata')
        }
        if (models.currentEvent.evenType == 1)
          csvObj['Girone'] = match.matcNameGroups;
        return csvObj
      }));
      var blob = new Blob([csv], { type: 'text/csv' })
      saveAs(blob, "Partite.csv");
    }

    // Update the match day (it's been selected now)
    vm.updateMatchDay = function () {
      // No current event selected, or no match days yet -> noop
      if(!models.currentEvent || !models.currentEvent.matchDays || models.currentEvent.matchDays.length === 0){
        return;
      }

      // No day selected - check if the event has just changed
      if(!models.currentEvent.currentDay){
        // An event has been selected -> use it's first available day
        models.currentEvent.currentDay = models.currentEvent.matchDays[0];
      }
      // Current day selected -> manually find and copy the real day from models (ng-options creates a new object)
      else{
        for (var i = 0; i < models.currentEvent.matchDays.length; i++) {
          if(models.currentEvent.matchDays[i].matcDayId === vm.models.currentEvent.currentDay.matcDayId){
            vm.models.currentEvent.currentDay = models.currentEvent.matchDays[i];
            break;
          }
        }
      }

      return vm
        .setLoading()
        .then(matches.list)
        .finally(vm.unsetLoading);
    }

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }

    vm.reloaData = function (currentEvent) {
      vm.setLoading(currentEvent.evenId)    // Set a spinning loader on the page
        .then(teams.listcalendarteam)       // Get the event teams (API call), needed for filling up the select options
        .then(vm.updateMatchDay);            // Update the match day

      vm.setLoading(currentEvent.evenId)    // load event arbiters list
        .then(arbiters.list)
        .then(function(list) {
            vm.arbiters = list; $q.resolve(list); })
        .finally(vm.unsetLoading);

    }

    vm.createNewMatch = function () {
      $uibModal.open({
          templateUrl: 'app/pages/calendar/create/create.html',
          controller: 'MatchCreateController',
          controllerAs: 'matchCreate',
          windowClass: 'modal-success'
        }).result
        .then(function (res) {
          if(angular.isDefined(res)){
            vm.setLoading(res)
              .then(matches.form2Match)
              .then(matches.create)
              .then(matches.list)
              .finally(vm.unsetLoading);
          }
        })
    }

    vm.createNewDay = function () {
      $uibModal.open({
          templateUrl: 'app/pages/calendar/createDay/create.html',
          controller: 'DayCreateController',
          controllerAs: 'dayCreate',
          windowClass: 'modal-success'
        }).result
        .then(function (res) {
          if(angular.isDefined(res)){
            vm.setLoading(res)
              .then(matches.form2Day)
              .then(matches.createDay)
              .then(function (res) {
                models.currentEvent.currentDay = res;
                return res;
              })
              .then(vm.updateMatchDay)
              .finally(vm.unsetLoading);
          }
        })
    }

    vm.createNewGroup = function() {
      $uibModal.open({
        templateUrl: 'app/pages/calendar/createGroup/create.html',
        controller: 'GroupCreateController',
        controllerAs: 'groupCreate',
        windowClass: 'modal-success'
      }).result
      .then(function (res) {
        if(angular.isDefined(res)){
          vm.setLoading(res)
            .then(matches.form2Girone)
            .then(matches.createGroup)
            .finally(vm.unsetLoading);
        }
      })
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('AdminTeamController', AdminTeamController);

  /** @ngInject */
  function AdminTeamController(models, events, adminTeam, $q, $uibModal) {
    var vm = this;
    vm.models = models;


    vm.createNewInvitation = function () {
      $uibModal.open({
          templateUrl: 'app/pages/adminTeam/create/create.html',
          controller: 'AdminTeamCreateController',
          controllerAs: 'adminTeamCreate',
          windowClass: 'modal-success'
        }).result
        .then(function (res) {
          if(angular.isDefined(res)){
            vm.setLoading(res)
              .then(adminTeam.form2Invitation)
              .then(adminTeam.create)
              .then(adminTeam.listSentAdminTeam)
              .finally(vm.unsetLoading);
          }
        })
    }

    vm.setLoading = function (res) {
      vm.loading = true;
      return $q.resolve(res);
    }

    vm.unsetLoading = function (res) {
      vm.loading = false;
      return $q.resolve(res);
    }

    //events.list();
    adminTeam.listSentAdminTeam();
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .controller('AccessController', AccessController);

  /** @ngInject */
  function AccessController(models, users) {
    // User cached
    if(models.currentUser && models.currentUser.userToken) {
      users
        .onLoggedIn(models.currentUser) // Treat the user as logged in
        .catch(users.onLoggedOut);      // In case of error -> logout
    }

    // User not logged in and not cached
    else {
      users.onLoggedOut();
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .filter('wizardTextProgress', wizardTextProgressFilter);

  /** @ngInject */
  function wizardTextProgressFilter() {
    return function(wizard) {
      return 'Step ' + wizard.currentStep + ' di ' + wizard.totalSteps;
    };
  }

})();

'use strict';

angular.module('frispo')
  /**
   * A wizard
   */
  .factory('Wizard', function () {
    var defaults = {
      totalSteps: 1,
      startFromStep: 1
    }

    return function Wizard (options) {
      this.options = angular.merge(defaults, options);

      this.totalSteps = this.options.totalSteps;
      this.currentStep = this.options.startFromStep;

      this.next = function () {
        if(this.currentStep < this.totalSteps){
          this.currentStep++;
        }
      }

      this.prev = function () {
        if(this.currentStep > 1){
          this.currentStep--;
        }
      }
    };
  });

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('timepicker', timepicker);

  /** @ngInject */
  function timepicker() {
    var directive = {
      restrict: 'A',
      link: timepickerLink
    };

    return directive;

    /** @ngInject */
    function timepickerLink(scope, el) {
      el.clockpicker({autoclose: true});
    }
  }

})();

'use strict';

/**
 * Utility per la conversione di un oggetto in una stringa in formato csv.
 * Codice copiato e incollato (it works !!) brutalmente da:
 *  https://medium.com/@polyismstudio/converting-json-to-csv-in-javascript-9ee95b4b5a54
 * */
angular.module('frispo')
  .factory('objToCsv', function () {

    return function(obj, opt) {
      if (!angular.isObject(obj)) return null;
      opt = opt || {};
      var scopechar = opt.scopechar || '/';
      var delimeter = opt.delimeter || ';';
      if (angular.isArray(obj) === false) obj = [obj];
      var curs, name, rownum, key, queue, values = [], rows = [], headers = {}, headersArr = [];
      for (rownum = 0; rownum < obj.length; rownum++) {
        queue = [obj[rownum], ''];
        rows[rownum] = {};
        while (queue.length > 0) {
          name = queue.pop();
          curs = queue.pop();
          if (curs !== null && angular.isObject(curs)) {
            for (key in curs) {
              if (curs.hasOwnProperty(key)) {
                queue.push(curs[key]);
                queue.push(name + (name ? scopechar : '') + key);
              }
            }
          } else {
            if (headers[name] === undefined) headers[name] = true;
            rows[rownum][name] = curs;
          }
        }
        values[rownum] = [];
      }
      // create csv text
      for (key in headers) {
        if (headers.hasOwnProperty(key)) {
          headersArr.push(key);
          for (rownum = 0; rownum < obj.length; rownum++) {
            values[rownum].push(rows[rownum][key] === undefined
              ? ''
              : JSON.stringify(rows[rownum][key]));
          }
        }
      }
      for (rownum = 0; rownum < obj.length; rownum++) {
        values[rownum] = values[rownum].join(delimeter);
      }
      return '"' + headersArr.join('"' + delimeter + '"') + '"\n' + values.join('\n');
    }
  })

'use strict';

angular.module('frispo')
  /**
   * Utilities functions.
   */
  .factory('utils', function () {
    var utils = {
      str2Date: function (str) {
        if(!str) return;

        var res = [];
        var range = str.split('->');
        angular.forEach(range, function (date) {
          var split = date.split('/');
          if(split.length !== 3) return;
          res.push(split[2].trim() + '-' + split[1].trim() + '-' + split[0].trim())
        })
        if(res.length === 1){
          return res[0];
        }
        else{
          return res;
        }
      },
      date2Str: function (dateStart, dateEnd) {
        if(!dateStart) return;

        var split = dateStart.split('-');
        if(split.length !== 3) return;
        var res = split[2].trim() + '/' + split[1].trim() + '/' + split[0].trim();

        if(dateEnd){
          res +=  ' -> ' + utils.date2Str(dateEnd);
        }
        return res;
      },
      str2Time: function (str) {
        return str;
        // if(!str) return;
        //
        // var res = null;
        // var splitted = str.trim().split(' ');
        // if(splitted.length == 2){
        //   var hm = splitted[0].trim().split(':');
        //   var pmAdd = (splitted[1] == 'PM' ? 12 : 0);
        //   if(hm.length == 2){
        //     res = (+hm[0] + pmAdd) + ':' + hm[1];
        //   }
        // }
        // return res;
      },
      alphabetChars: function () {
        return ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
      },
      scores: function () {
        return [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20];
      },
      istevenMultiSelectTranslation: function () {
        return {
            selectAll       : "Seleziona tutti",
            selectNone      : "Deseleziona tutti",
            reset           : "Reset",
            search          : "Cerca...",
            nothingSelected : "Nessuno selezionato"
        };
      },
      cardTypes: function () {
        return [
          {
            id: 0,
            name: 'Ammonizione'
          },
          {
            id: 1,
            name: 'Espulsione per somma ammonizioni'
          },
          {
            id: 2,
            name: 'Espulsione diretta'
          }
        ]
      },
      eventTypes: function () {
        return [
          {
            id: 0,
            name: 'Campionato Italiana'
          },
          {
            id: 1,
            name: 'Torneo a Gironi'
          }
        ]
      },
      eventFormulas: function () {
        return [
          {
            id: 0,
            name: 'Solo andata'
          },
          {
            id: 1,
            name: 'Andata e ritorno'
          }
        ]
      },
      teamOptions: function () {
        return [
          {
            id: 0,
            name: 'Temporanea'
          },
          {
            id: 1,
            name: 'Definitiva'
          }
        ]
      },
      pressStatuses: function () {
        return [
          {
            id: '0',
            name: 'Non pubblicato'
          },
          {
            id: '1',
            name: 'Pubblicato'
          }
        ]
      }
    };

    return utils;
  });

'use strict';

angular.module('frispo')
  /**
   * UI state service.
   * Keep application-wide shared variables
   */
  .factory('uiState', function () {
    var uiState = {};

    return uiState;
  });

'use strict';

angular.module('frispo')
  /**
   * Response management pipeline.
   * Utilities to process a response from the moment it arrives to the models update.
   * To use in a promise chain as a pipeline
   */
  .factory('resPipe', function ($q, $filter, models, longTermMemory, $log, utils) {
    var resPipe = {

      /**
       * Parse the initial response from the Frispo API
       */
      parseResponse: function(res) {
        // Look for the response status_code
        switch (res.status_code) {
          case 200:
            return res.data;
          default:
            return $q.reject({error: res.error});
        }
      },

      /**
       * Unwrap the response from a single element array
       */
      unwrapArray: function (res) {
        if(angular.isArray(res) && res.length === 1) return res[0];
        return res;
      },

      /**
       * Camelize the response
       */
      camelize: function (res) {
        var newRes;
        if(angular.isArray(res)){
          newRes = [];
          angular.forEach(res, function (el) {
            newRes.push(resPipe.camelize(el));
          })
          return newRes;
        }
        else if(angular.isObject(res)){
          newRes = {};
          angular.forEach(res, function(v,k){
            newRes[$filter('camelize')(k)] = resPipe.camelize(v);
          });
          return newRes;
        }
        else {
          return res;
        }
      },

      /**
       * Inject default fields to User objects
       */
      injectUserDefaults: function (res) {
        res.displayName = res.displayName || res.email || res.name || 'Profilo';
        return res;
      },


      /**
       * Update the current user
       */
      updateCurrentUser: function (res) {
        models.currentUser = res;
        return res;
      },

      updateSentInvitations: function (res) {
        models.currentUser.sentInvitations = res;
        return res;
      },

      updateReceivedInvitations: function (res) {
        models.currentUser.receivedInvitations = res;
        return res;
      },

      /**
       * Update the current user, merging data instead of replacing
       */
      updateMergeCurrentUser: function (res) {
        if(res.permissions){ models.currentUser.permissions = []; }
        if(res.flagMarketing){ models.currentUser.flagMarketing = []; }
        if(res.flagProfilazione){ models.currentUser.flagProfilazione = []; }
        return angular.merge(models.currentUser, res);
      },

      /**
       * Update the preferences current user
       */
      updatePreferences: function (res) {
        models.currentUser.preferences = res;
        return res;
      },

      /**
       * Mock an anonymous user for testing APIs
       */
      mockAnonymousUser: function (res) {
        res.accessToken = '4e66c966e021918f0b088ddc929847f7';
        res.uuid = '';
        return res;
      },

      /**
      * Memorize the current user in long term memory
      */
      memorizeCurrentUser: function (res) {
        longTermMemory.memorize('currentUser', models.currentUser);
        return res;
      },

      /**
       * Inject default fields to events
       */
      injectEventsDefaults: function (res) {
        // If the resource is an array, recurse for each element
        if(angular.isArray(res)){
          var newRes = [];
          angular.forEach(res, function (el) {
            newRes.push(resPipe.injectEventsDefaults(el));
          })
          return newRes;
        }

        // Prettify evenFormula
        if(res.evenFormula === 0)
          res.evenFormulaPretty = 'Solo andata';
        else if(res.evenFormula === 1)
          res.evenFormulaPretty = 'Andata e ritorno';

        // Prettify evenType
        if(res.evenType === 0)
          res.evenTypePretty = 'Campionato italiana';
        else if(res.evenType === 1)
          res.evenTypePretty = 'Torneo a giorni';

        // Make a dateRangePicker compliant field
        if(!res.dates && res.evenDateStart && res.evenDateEnd){
          res.dates = utils.date2Str(res.evenDateStart, res.evenDateEnd);
        }

        // Initialize a default published status
        if(angular.isUndefined(res.evenStatoEvento)){
          res.evenStatoEvento = 0; // Set as unpublished
        }

        // Initialize the currentDay based on its ID
        if(angular.isNumber(res.evenDayActive) && angular.isArray(res.matchDays)){
          for (var i = 0; i < res.matchDays.length; i++) {
            if(res.matchDays[i].matcDayId === res.evenDayActive){
              res.evenCurrentDay = res.matchDays[i];
              break;
            }
          }
        }

        // Make a search field
        res.search = [
          res.evenName,
          res.evenTypePretty,
          res.evenFormulaPretty,
          res.regions && res.regions.regiName || '',
          res.evenCode,
          res.evenSeason
        ].join(' ');

        // Sort the match days by prog number
        if(angular.isArray(res.matchDays)){
          res.matchDays.sort(function (a,b) {
            return a.matcProg - b.matcProg;
          });
        }

        return res;
      },

      /**
       * Inject default fields to invitations
       */
      injectInvitationsDefaults: function (res) {
        // If the resource is an array, recurse for each element
        if(angular.isArray(res)){
          var newRes = [];
          angular.forEach(res, function (el) {
            newRes.push(resPipe.injectInvitationsDefaults(el));
          })
          return newRes;
        }

        // Prettify status
        switch (res.status) {
          case '0':
            res.statusPretty = 'In attesa';
            break;
          case '1':
            res.statusPretty = 'Accettato';
            break;
          case '2':
            res.statusPretty = 'Rifiutato';
            break;
          case '3':
            res.statusPretty = 'Cancellato';
            break;
          default:
            break;
        }

        // Translate date format
        if(!res.dateInvitationPretty && res.dateInvitation){
          res.dateInvitationPretty = utils.date2Str(res.dateInvitation);
        }

        return res;
      },

      /**
       * Update the events
       */
      updateEvents: function (res) {
        models.events = res;
        return res;
      },

      /**
       * Update the managed events
       */
      updateManagedEvents: function (res) {
        models.currentUser.managedEvents = res;
        return res;
      },

      /**
       * Remove an event from the cache
       */
      removeEvent: function (res) {
        // Look for the event in cache
        var i = -1;
        for (i=0; i < models.events.length; i++) {
          if(models.events[i].evenId === res.evenId){
            break;
          }
        }
        // The event was found -> remove it
        if(i >= 0 && i < models.events.length){
          models.events.splice(i,1);
        }
        return res;
      },

      /**
       * Memorize the events user in long term memory
       */
      memorizeEvents: function (res) {
        longTermMemory.memorize('events', models.events);
        return res;
      },

      /**
      * Update the regions
      */
      updateRegions: function (res) {
        models.regions = res;
        return res;
      },

      /**
      * Memorize the regions user in long term memory
      */
      memorizeRegions: function (res) {
        longTermMemory.memorize('regions', models.regions);
        return res;
      },

      /**
       * Update the current event
       */
      updateCurrentEvent: function (res) {
        var currentEventMerged = false;
        if(models.currentEvent && models.currentEvent.evenId === res.evenId){
          angular.merge(models.currentEvent, res);
          currentEventMerged = true;
        }

        var i = 0;
        if(angular.isArray(models.events)){
          for (; i < models.events.length; i++) {
            if(models.events[i].evenId === res.evenId){
              if(currentEventMerged){
                //models.events[i] = models.currentEvent;
              }
              else{
                angular.merge(models.events[i], res);
                models.currentEvent = models.events[i];
              }
              break;
            }
          }
        }

        if(i === models.events.length){
          models.currentEvent = res;
          if(!angular.isArray(models.events)){
            models.events = [];
          }
          models.events.push(models.currentEvent);
        }

        return models.currentEvent;
      },

      /**
      * Memorize the events user in long term memory
      */
      memorizeCurrentEvent: function (res) {
        longTermMemory.memorize('currentEvent', models.currentEvent);
        return res;
      },


      /**
       * Update the matches
       */
      updateMatches: function (res) {
        if(!models.currentEvent || !models.currentEvent.currentDay) return res;
        models.currentEvent.currentDay.matches = res;
        return res;
      },

      /**
       * Update a match
       */
      updateMatch: function (res) {
        if(!models.currentEvent || !models.currentEvent.currentDay || !angular.isArray(models.currentEvent.currentDay.matches)){
          return res;
        }

        for (var i = 0; i < models.currentEvent.currentDay.matches.length; i++) {
          if(models.currentEvent.currentDay.matches[i].matcId === res.matcId){
            return angular.merge(models.currentEvent.currentDay.matches[i], res);
          }
        }
      },

      /**
       * Update a giornata
       */
      updateGiornata: function (res) {
        if(!models.currentEvent || !models.currentEvent.currentDay || !angular.isArray(models.currentEvent.matchDays)){
          return res;
        }

        for (var i = 0; i < models.currentEvent.matchDays.length; i++) {
          if(models.currentEvent.matchDays[i].matcDayId === res.matcDayId){
            return angular.merge(models.currentEvent.matchDays[i], res);
          }
        }
      },

      /**
       * Update the scorers of a match
       */
      updateMatchScorers: function (matchId, res) {
        if(!models.currentEvent || !models.currentEvent.currentDay || !angular.isArray(models.currentEvent.currentDay.matches)){
          return res;
        }

        for (var i = 0; i < models.currentEvent.currentDay.matches.length; i++) {
          if(models.currentEvent.currentDay.matches[i].matcId == matchId){
            models.currentEvent.currentDay.matches[i].scorers = res;
            return res;
          }
        }
      },

      injectMatchDefaults: function (res) {
        if(angular.isArray(res)){
          angular.forEach(res, resPipe.injectMatchDefaults);
        }

        else{
          if(res.matcDateMatch){
            res.matcDateMatchPretty = utils.date2Str(res.matcDateMatch);
          }

          if(angular.isArray(res.matchCardsTeamA)){
            resPipe.injectCardsDefaults(res.matchCardsTeamA);
          }

          if(angular.isArray(res.matchCardsTeamB)){
            resPipe.injectCardsDefaults(res.matchCardsTeamB);
          }


        }

        return res;
      },

      injectPressDefaults: function (res) {
        if(angular.isArray(res)){
          angular.forEach(res, resPipe.injectPressDefaults);
        }

        else{
          switch (res.pressStato) {
            case '0':
              res.pressStatoPretty = 'Non pubblicato';
              break;
            case '1':
              res.pressStatoPretty = 'Pubblicato';
              break;
            default:
              break;
          }

          if(res.pressDate){
            res.pressDatePretty = utils.date2Str(res.pressDate);
          }
        }

        return res;
      },

      injectEventCardsDefaults: function (res) {
        if(angular.isArray(res)){
          angular.forEach(res, resPipe.injectEventCardsDefaults);
        }

        else{
          if(res.matcRedCards) resPipe.injectCardsDefaults(res.matcRedCards);
          if(res.matcYellowCards) resPipe.injectCardsDefaults(res.matcYellowCards);
          if(res.amends) resPipe.injectAmendsDefaults(res.amends);
        }

        return res;
      },

      injectCardsDefaults: function (res) {
        if(angular.isArray(res)){
          angular.forEach(res, resPipe.injectCardsDefaults);
        }
        else{
          switch (res.flgCards) {
            case 0:
              res.flgCardsPretty = 'Ammonizione';
              break;
            case 1:
              res.flgCardsPretty = 'Espulsione per somma ammonizioni';
              break;
            case 2:
              res.flgCardsPretty = 'Espulsione diretta';
              break;
            case 3:
              res.flgCardsPretty = 'Squalifica da diffida';
              break;
            default:
              break;
          }
          switch (res.typeSqualifications) {
            case 0:
              res.typeSqualificationsPretty = 'Ammonizione';
              break;
            case 1:
              res.typeSqualificationsPretty = 'Espulsione per somma ammonizioni';
              break;
            case 2:
              res.typeSqualificationsPretty = 'Espulsione diretta';
              break;
            case 3:
              res.typeSqualificationsPretty = 'Squalifica da diffida';
              break;
            default:
              break;
          }
        }

        return res;
      },

      injectAmendsDefaults: function (res) {
        if(angular.isArray(res)){
          angular.forEach(res, resPipe.injectAmendsDefaults);
        }

        if(res.amenStatus === '1'){
          res.amenStatusPretty = 'Scontata'
        }
        if(res.amenStatus === '0'){
          res.amenStatusPretty = 'Non scontata'
        }

        return res;
      },

      /**
       * Insert a match day into current event
       */
      insertMatchDay: function (res) {
        if(models.currentEvent && angular.isArray(models.currentEvent.matchDays)) {
          models.currentEvent.matchDays.push(res);
        }
        return res;
      },

      /**
       * Insert an event group into current event
       */
       insertGroup: function (res) {
        if(models.currentEvent && angular.isArray(models.currentEvent.evenGironi)) {
          models.currentEvent.evenGironi.push(res);
        }
        else models.currentEvent.evenGironi = [res];
        return res;
      },

      /**
       * decodifica giorno settimana
       */
      decodificaGiorno: function (res) {
        for (var i = 0; i < res.length; i++) {
          switch(res[i].teamPlayday) {
            case "1":
                res[i].teamPlayday = { id:1, value: "Lunedì" }
                break;
            case "2":
                res[i].teamPlayday = { id:2, value: "Martedì" }
                break;
            case "3":
                res[i].teamPlayday = { id:3, value: "Mercoledì" }
                break;
            case "4":
                res[i].teamPlayday = { id:4, value: "Giovedì" }
                break;
            case "5":
                res[i].teamPlayday = { id:1, value: "Venerdì" }
                break;
            case "6":
                res[i].teamPlayday = { id:1, value: "Sabato" }
                break;
            case "7":
                res[i].teamPlayday = { id:1, value: "Domenica" }
                break;
          }
        }
        return res;
      },

      /**
       * Update the teams of current event
       */
      updateTeams: function (res) {
        if(models.currentEvent){
          models.currentEvent.teams = res;
        }
        return res;
      },

      /**
       * Update the temp teams of current event
       */
      updateTempTeams: function (res) {
        if(models.currentEvent){
          models.currentEvent.tempTeams = res;
        }
        return res;
      },

      /**
       * Update the scoreboard of current event
       */
      updateScoreboard: function (res) {
        if(models.currentEvent){
          models.currentEvent.scoreboard = res;
        }
        return res;
      },

      /**
       * Update the scorers of current event
       */
      updateScorers: function (res) {

        if(models.currentEvent){
          models.currentEvent.scorers = res;
        }
        return res;
      },

      updateListImportScorers: function (res) {
        if(models.currentEvent){
          for (var i = 0; i < res.length; i++) {
            if (res[i].stato === 0) { res[i].stato = "In attesa (potrebbero volerci un po' di minuti)" }
            if (res[i].stato === 1) { res[i].stato = "In elaborazione" }
            if (res[i].stato === 2) { res[i].stato = "Caricamento compleatato" }
          }
          models.currentEvent.listImportScorers = res;
        }
        return res;
      },

      updateYellows: function (res) {
        if(models.currentEvent){
          models.currentEvent.yellows = res;
        }
        return res;
      },

      updateDiffides: function (res) {
        if(models.currentEvent){
          models.currentEvent.diffides = res;
        }
        return res;
      },

      updateSqualifications: function (res) {
        if(models.currentEvent){
          models.currentEvent.squalifications = res;
        }
        return res;
      },

      updateAmends: function (res) {
        if(models.currentEvent){
          models.currentEvent.amends = res;
        }
        return res;
      },

      updatePress: function (res) {
        if(models.currentEvent){
          if(angular.isArray(res)){
            models.currentEvent.press = res;
          }
          else if(angular.isDefined(res.pressId) && angular.isArray(models.currentEvent.press)){
            for (var i = 0; i < models.currentEvent.press.length; i++) {
              if(models.currentEvent.press[i].pressId === res.pressId){
                return angular.merge(models.currentEvent.press[i], res);
              }
            }
          }
        }
        return res;
      },

      updateTeam: function (res) {
        if(models.currentEvent && res.teamId && angular.isArray(models.currentEvent.teams)){
          for (var i = 0; i < models.currentEvent.teams.length; i++) {
            if(models.currentEvent.teams[i].teamId === res.teamId){
              return angular.merge(models.currentEvent.teams[i], res);
            }
          }
        }
        return res;
      },

      updateIscrizioni: function (res) {
        if(models.currentEvent){
          models.currentEvent.iscrizioni = res;
        }
        return res;
      },

      updateIscrizione: function (res) {
        if(models.currentEvent && angular.isArray(models.currentEvent.iscrizioni)){
          for (var i = 0; i < models.currentEvent.iscrizioni.length; i++) {
            if(models.currentEvent.iscrizioni[i].subscribe_id === res.subscribe_id){
              return angular.merge(models.currentEvent.iscrizioni[i], res);
            }
          }
        }
        return res;
      },

      removeIscrizione: function (res) {
        if(!res.subscribe_id || !models.currentEvent || !angular.isArray(models.currentEvent.iscrizioni)) return res;

        // Look for the press in cache
        var i = -1;
        for (i=0; i < models.currentEvent.iscrizioni.length; i++) {
          if(models.currentEvent.iscrizioni[i].subscribe_id === res.subscribe_id){
            break;
          }
        }
        // The team was found -> remove it
        if(i >= 0 && i < models.currentEvent.iscrizioni.length){
          models.currentEvent.iscrizioni.splice(i,1);
        }
        return res;
      },

      updatePlayers: function (res) {
        if(models.currentEvent && models.currentEvent.currentTeam){
          models.currentEvent.currentTeam.players = res;
        }
        return res;
      },

      updatePlayer: function (res) {
        if(models.currentEvent && models.currentEvent.currentTeam && angular.isArray(models.currentEvent.currentTeam.players)){
          for (var i = 0; i < models.currentEvent.currentTeam.players.length; i++) {
            if(models.currentEvent.currentTeam.players[i].playId === res.playId){
              return angular.merge(models.currentEvent.currentTeam.players[i], res);
            }
          }
        }
        return res;
      },

      insertPlayer: function (res) {
        if(models.currentEvent && models.currentEvent.currentTeam){
          if(!angular.isArray(models.currentEvent.currentTeam.players)){
            models.currentEvent.currentTeam.players = [];
          }
          models.currentEvent.currentTeam.players.push(res);
        }
        return res;
      },

      insertScorer: function (matchId, res, scorersKey) {
        if(!scorersKey) scorersKey = 'scorers';
        if(models.currentEvent && angular.isArray(models.currentEvent.currentDay.matches)){
          for (var i = 0; i < models.currentEvent.currentDay.matches.length; i++) {
            var curMatch = models.currentEvent.currentDay.matches[i];
            if(curMatch.matcId === matchId){
              if(!angular.isArray(curMatch[scorersKey])){
                curMatch[scorersKey] = [];
              }
              curMatch[scorersKey].push(res);
              break;
            }
          }
        }
        return res;
      },

      insertCard: function (matchId, res, cardsKey) {
        if(!cardsKey) cardsKey = 'cards';
        if(models.currentEvent && angular.isArray(models.currentEvent.currentDay.matches)){
          for (var i = 0; i < models.currentEvent.currentDay.matches.length; i++) {
            var curMatch = models.currentEvent.currentDay.matches[i];
            if(curMatch.matcId === matchId){
              if(!angular.isArray(curMatch[cardsKey])){
                curMatch[cardsKey] = [];
              }
              curMatch[cardsKey].push(res);
              break;
            }
          }
        }
        return res;
      },

      insertAmend: function (matchId, res, amendsKey) {
        if(!amendsKey) amendsKey = 'amends';
        if(models.currentEvent && angular.isArray(models.currentEvent.currentDay.matches)){
          for (var i = 0; i < models.currentEvent.currentDay.matches.length; i++) {
            var curMatch = models.currentEvent.currentDay.matches[i];
            if(curMatch.matcId === matchId){
              if(!angular.isArray(curMatch[amendsKey])){
                curMatch[amendsKey] = [];
              }
              curMatch[amendsKey].push(res);
              break;
            }
          }
        }
        return res;
      },

      removeScorer: function (matchId, playerId, scorersKey) {
        if(!scorersKey) scorersKey = 'scorers';
        if(models.currentEvent && angular.isArray(models.currentEvent.currentDay.matches)){
          for (var i = 0; i < models.currentEvent.currentDay.matches.length; i++) {
            var curMatch = models.currentEvent.currentDay.matches[i];
            if(curMatch.matcId === matchId){
              if(!angular.isArray(curMatch[scorersKey])) break;
              var j = 0;
              for (; j < curMatch[scorersKey].length; j++) {
                if(curMatch[scorersKey][j].playId === playerId) break;
              }
              if(j < curMatch[scorersKey].length){
                curMatch[scorersKey].splice(j,1);
                break;
              }
            }
          }
        }
      },

      /**
       * Remove a card from the cache
       */
      removeEventCard: function (matchId, playerId, cardId, cardsKey, cardMatchKey) {
        if(!models.currentEvent || !angular.isArray(models.currentEvent[cardsKey])) return;

        // Look for the right player
        for (var i = 0; i < models.currentEvent[cardsKey].length; i++) {
          var curPlayer = models.currentEvent[cardsKey][i]
          if(curPlayer.playId === playerId && angular.isArray(curPlayer[cardMatchKey])){
            var j = 0;
            // Look for the right scorerMatch and remove it
            for (; j < curPlayer[cardMatchKey].length; j++) {
              if(curPlayer[cardMatchKey][j].matcId === matchId){
                curPlayer[cardMatchKey].splice(j,1);
                return;
              }
            }
          }
        }
      },

      /**
       * Remove a amend from the cache
       */
      removeEventAmend: function (matchId, teamId, amendId, amendsKey, amendMatchKey) {
        if(!models.currentEvent || !angular.isArray(models.currentEvent[amendsKey])) return;

        // Look for the right team
        for (var i = 0; i < models.currentEvent[amendsKey].length; i++) {
          var curTeam = models.currentEvent[amendsKey][i]
          if(curTeam.teamId === teamId && angular.isArray(curTeam[amendMatchKey])){
            var j = 0;
            // Look for the right scorerMatch and remove it
            for (; j < curTeam[amendMatchKey].length; j++) {
              if(curTeam[amendMatchKey][j].matcId === matchId){
                curTeam[amendMatchKey].splice(j,1);
                return;
              }
            }
          }
        }
      },

      /**
       * Update a card in cache
       */
      updateEventCard: function (matchId, playerId, cardId, cardsKey, cardMatchKey, cardData) {
        if(!models.currentEvent || !angular.isArray(models.currentEvent[cardsKey])) return;

        // Look for the right player
        for (var i = 0; i < models.currentEvent[cardsKey].length; i++) {
          var curPlayer = models.currentEvent[cardsKey][i]
          if(curPlayer.playId === playerId && angular.isArray(curPlayer[cardMatchKey])){
            var j = 0;
            // Look for the right scorerMatch and remove it
            for (; j < curPlayer[cardMatchKey].length; j++) {
              if(curPlayer[cardMatchKey][j].matcId === matchId){
                return angular.merge(curPlayer[cardMatchKey][j], cardData);
              }
            }
          }
        }
      },

      /**
       * Update an amend in cache
       */
      updateEventAmend: function (matchId, teamId, cardId, cardsKey, cardMatchKey, cardData) {
        if(!models.currentEvent || !angular.isArray(models.currentEvent[cardsKey])) return;

        // Look for the right team
        for (var i = 0; i < models.currentEvent[cardsKey].length; i++) {
          var curTeam = models.currentEvent[cardsKey][i]
          if(curTeam.teamId === teamId && angular.isArray(curTeam[cardMatchKey])){
            var j = 0;
            // Look for the right scorerMatch and remove it
            for (; j < curTeam[cardMatchKey].length; j++) {
              if(curTeam[cardMatchKey][j].matcId === matchId){
                return angular.merge(curTeam[cardMatchKey][j], cardData);
              }
            }
          }
        }
      },

      /**
       * Remove a team from the cache
       */
      removeTeam: function (res) {
        if(!res.teamId || !models.currentEvent || !angular.isArray(models.currentEvent.teams)) return res;

        // Look for the team in cache
        var i = -1;
        for (i=0; i < models.currentEvent.teams.length; i++) {
          if(models.currentEvent.teams[i].teamId === res.teamId){
            break;
          }
        }
        // The team was found -> remove it
        if(i >= 0 && i < models.currentEvent.teams.length){
          models.currentEvent.teams.splice(i,1);
        }
        return res;
      },

      /**
       * Remove a temp team from the cache
       */
      removeTempTeam: function (res) {
        if(!res.teamId || !models.currentEvent || !angular.isArray(models.currentEvent.tempTeams)) return res;

        // Look for the team in cache
        var i = -1;
        for (i=0; i < models.currentEvent.tempTeams.length; i++) {
          if(models.currentEvent.tempTeams[i].teamId === res.teamId){
            break;
          }
        }
        // The team was found -> remove it
        if(i >= 0 && i < models.currentEvent.tempTeams.length){
          models.currentEvent.tempTeams.splice(i,1);
        }
        return res;
      },

      /**
       * Remove a press from the cache
       */
      removePress: function (res) {
        if(!res.presId || !models.currentEvent || !angular.isArray(models.currentEvent.press)) return res;

        // Look for the press in cache
        var i = -1;
        for (i=0; i < models.currentEvent.press.length; i++) {
          if(models.currentEvent.press[i].presId === res.presId){
            break;
          }
        }
        // The team was found -> remove it
        if(i >= 0 && i < models.currentEvent.press.length){
          models.currentEvent.press.splice(i,1);
        }
        return res;
      },

      /**
       * [removePlayer description]
       * @param  {[type]} res [description]
       * @return {[type]}     [description]
       */
      removePlayer: function (res) {
        if(!res.playId || !models.currentEvent || !angular.isArray(models.currentEvent.currentTeam.players)) return res;

        // Look for the press in cache
        var i = -1;
        for (i=0; i < models.currentEvent.currentTeam.players.length; i++) {
          if(models.currentEvent.currentTeam.players[i].playId === res.playId){
            break;
          }
        }
        // The team was found -> remove it
        if(i >= 0 && i < models.currentEvent.currentTeam.players.length){
          models.currentEvent.currentTeam.players.splice(i,1);
        }
        return res;
      },

      /**
       * Remove a ScorerMatch from the cache
       */
      removeScorerMatch: function (playerId, res) {
        if(!res.matcId || !models.currentEvent || !angular.isArray(models.currentEvent.scorers)) return res;

        // Look for the right scorer
        for (var i = 0; i < models.currentEvent.scorers.length; i++) {
          var curScorer = models.currentEvent.scorers[i]
          if(curScorer.scorPlayId === playerId && angular.isArray(curScorer.matcScorers)){
            var j = 0;
            // Look for the right scorerMatch and remove it
            for (; j < curScorer.matcScorers.length; j++) {
              if(curScorer.matcScorers[j].matcId === res.matcId){
                curScorer.matcScorers.splice(j,1);
                return res;
              }
            }
          }
        }

        return res;
      },

       /**
        * Remove a card from a match
        */
      removeMatchCard: function (matchId, cardId, cardsKey) {
        if(!cardsKey) cardsKey = 'scorers';
        if(models.currentEvent && angular.isArray(models.currentEvent.currentDay.matches)){
          for (var i = 0; i < models.currentEvent.currentDay.matches.length; i++) {
            var curMatch = models.currentEvent.currentDay.matches[i];
            if(curMatch.matcId === matchId){
              if(!angular.isArray(curMatch[cardsKey])) break;
              var j = 0;
              for (; j < curMatch[cardsKey].length; j++) {
                if(curMatch[cardsKey][j].cardId === cardId) break;
              }
              if(j < curMatch[cardsKey].length){
                curMatch[cardsKey].splice(j,1);
                break;
              }
            }
          }
        }
      },

       /**
        * Remove an amend from a match
        */
      removeMatchAmend: function (matchId, amendId, amendsKey) {
        if(!amendsKey) amendsKey = 'amends';
        if(models.currentEvent && angular.isArray(models.currentEvent.currentDay.matches)){
          for (var i = 0; i < models.currentEvent.currentDay.matches.length; i++) {
            var curMatch = models.currentEvent.currentDay.matches[i];
            if(curMatch.matcId === matchId){
              if(!angular.isArray(curMatch[amendsKey])) break;
              var j = 0;
              for (; j < curMatch[amendsKey].length; j++) {
                if(curMatch[amendsKey][j].amenId === amendId) break;
              }
              if(j < curMatch[amendsKey].length){
                curMatch[amendsKey].splice(j,1);
                break;
              }
            }
          }
        }
      },

      /**
      * Update a ScorerMatch in cache
      */
      updateScorerMatch: function (playerId, res) {
        if(!res.matcId || !models.currentEvent || !angular.isArray(models.currentEvent.scorers)) return res;

        // Look for the right scorer
        for (var i = 0; i < models.currentEvent.scorers.length; i++) {
          var curScorer = models.currentEvent.scorers[i]
          if(curScorer.scorPlayId === playerId && angular.isArray(curScorer.matcScorers)){
            var j = 0;
            // Look for the right scorerMatch and update it
            for (; j < curScorer.matcScorers.length; j++) {
              if(curScorer.matcScorers[j].matcId === res.matcId){
                return angular.merge(curScorer.matcScorers[j], res);
              }
            }
          }
        }

        return res;
      },

      /**
       * Remove a match from the cache
       */
      removeMatch: function (res) {
        if(!res.matcId || !models.currentEvent || !models.currentEvent.currentDay || !angular.isArray(models.currentEvent.currentDay.matches)) return res;

        // Look for the match in cache
        var i = -1;
        for (i=0; i < models.currentEvent.currentDay.matches.length; i++) {
          if(models.currentEvent.currentDay.matches[i].matcId === res.matcId){
            break;
          }
        }
        // The team was found -> remove it
        if(i >= 0 && i < models.currentEvent.currentDay.matches.length){
          models.currentEvent.currentDay.matches.splice(i,1);
        }
        return res;
      },

      /**
       * Remove giornata from the cache
       */
      removeMatchGiornata: function (res) {
        if(!res.matcDayId || !models.currentEvent || !models.currentEvent.currentDay) return res;
        // Look for the match in cache
        var i = -1;
        for (i=0; i < models.currentEvent.matchDays.length; i++) {
          if(models.currentEvent.matchDays[i].matcDayId === res.matcDayId){
            break;
          }
        }
        // The team was found -> remove it
        if(i >= 0 && i < models.currentEvent.matchDays.length){
          models.currentEvent.matchDays.splice(i,1);
        }
        return res;
      },

      log: function (res) {
        $log.info(res);
        return res;
      },

      debugger: function (res) {
        debugger; // eslint-disable-line no-debugger
        return res;
      }
    };

    return resPipe;
  });

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('showOnHover', showOnHover);

  /** @ngInject */
  function showOnHover() {
    var directive = {
      restrict: 'A',
      link: linkFunc,
      scope: {
        showOnHover: '@',
        showAnimate: '='
      }
    };

    return directive;

    function linkFunc(scope, el) {
      var visible = false;
      var target = angular.element(scope.showOnHover);

      scope.$watch('showOnHover', function () {
        target.removeClass('show-on-hover-target').removeClass('not-visible').removeClass('show-animate');
        target = angular.element(scope.showOnHover);
        target.addClass('show-on-hover-target');
        if(scope.showAnimate){
          target.addClass('show-animate');
        }
        scope.updateVisibility();
      })

      scope.updateVisibility = function () {
        if(visible){
          target.removeClass('not-visible');
        }
        else{
          target.addClass('not-visible');
        }
      }

      el.hover(function() {
          if(!visible){
            visible = true;
            scope.updateVisibility();
          }
        },
        function() {
          if(visible){
            visible = false;
            scope.updateVisibility();
          }
        }
      );
    }
  }

})();

'use strict';

angular.module('frispo')
  /**
   * Long Term Memory
   * Persist data to make it available after the browser is closed
   */
  .factory('longTermMemory', function () {
    var allowedKeys = [
      'currentUser',
      'events',
      'regions',
      'currentEvent'
    ];

    var longTermMemory = {
      memorize: function(key, val) {
        if(allowedKeys.indexOf(key) < 0){
          return;
        }

        localStorage[key] = angular.toJson(val);
      },

      remember: function(key) {
        if(allowedKeys.indexOf(key) < 0){
          return null;
        }

        try {
          return angular.fromJson(localStorage[key]);
        }
        catch(e){
          delete localStorage[key];
          return null;
        }
      },

      forget: function(key) {
        if(allowedKeys.indexOf(key) < 0){
          return null;
        }

        delete localStorage[key];
      },

      oblivion: function() {
        angular.forEach(allowedKeys, function(key) {
          delete localStorage[key];
        });
        localStorage.clear();
      }
    };

    return longTermMemory;
  });

(function() { 'use strict';

  angular.module('frispo')
    .directive('infoPopover', infoPopover);

  /** @ngInject */
  function infoPopover() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/infoPopover/infoPopover.html',
      controller: InfoPopoverController,
      controllerAs: 'infoPopover',
      bindToController: true,
      scope: { title: '@', body: '@' },
      link: initPopover
    };
    function initPopover(scope, ele) {
      angular.element(document)
        .ready(function(){
          angular.element('[data-toggle="popover"]', ele).popover();
      });
    }

    /** @ngInject */
    function InfoPopoverController() { }
  }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('frispoSidebar', frispoSidebar);

  /** @ngInject */
  function frispoSidebar($timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/frispoSidebar/frispoSidebar.html',
      controller: SidebarController,
      controllerAs: 'sidebar',
      link: SidebarLink,
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SidebarController(models, $state) {
      var vm = this;

      vm.models = models;
      vm.state = $state;

      vm.manageMenuEntries = [
        'main.admin.createEvent',
        'main.admin.events',
        'main.admin.teams',
        'main.admin.calendar',
        'main.admin.scoreboard'
      ]
    }

    function SidebarLink(){
      $timeout(function () {
        angular.element(window).trigger('resize'); // Trigger a resize event to adjust AdminLTE height
      });
    }
  }

})();

(function() { 'use strict';

    angular.module('frispo')
        .directive('frispoHeader', frispoHeader);

    /** @ngInject */
    function frispoHeader($timeout) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/frispoHeader/frispoHeader.html',
            controller: HeaderController,
            controllerAs: 'header',
            link: HeaderLink,
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function HeaderController($scope, models, events) {

            var vm = this; vm.loadingEventInfo = false;

            // getter utilities

            vm.getUser = function() { return models.currentUser; }

            vm.getEventList = function() { return models.events || []; }

            vm.getCurrentEvent =
              function() { return models.currentEvent || null; }

            vm.getCurrentDay = function() {
              return models.currentEvent &&
                models.currentEvent.evenCurrentDay || null;
            }

            // watch for changes in models.currentEvent and load
            // event info if they are absent
            $scope.$watch(vm.getCurrentEvent, function(currentEvent) {
              if (!vm.loadingEventInfo &&
                  currentEvent && !currentEvent.evenCurrentDay) {
                vm.loadingEventInfo = true;
                events.show(currentEvent.evenId)
                  .finally(function() { vm.loadingEventInfo = false; });
              }
            }, true);     // use object equality and not memory address

            // selection event callbacks

            vm.selectEvent = function(event) { models.currentEvent = event; }

            vm.selectCurrentMatchDay = function(day) {
              models.currentEvent.evenCurrentDay = day;
              events.update(
                models.currentEvent.evenId, { "even_day_active": day.matcDayId });
            }
        }

        function HeaderLink() {
            $timeout(function() {
                // Trigger a resize event to adjust AdminLTE height
                angular.element(window).trigger('resize');
            });
        }
    }
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('frispoFooter', frispoFooter);

  /** @ngInject */
  function frispoFooter($timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/frispoFooter/frispoFooter.html',
      controller: FooterController,
      controllerAs: 'footer',
      link: FooterLink,
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function FooterController(models) {
      var vm = this;

      vm.models = models;
    }

    function FooterLink(){
      $timeout(function () {
        angular.element(window).trigger('resize'); // Trigger a resize event to adjust AdminLTE height
      });
    }
  }

})();

'use strict';

angular.module('frispo')
    /**
     * My Project Overview API service
     */
    .factory('frispoApi', function(
        $q,
        $log,
        $http,
        provisioningApiUrl,
        provisioningApiUrlB,
        eventsApiUrl,
        teamsApiUrl,
        pressApiUrl,
        matchesApiUrl,
        cardsApiUrl,
        scorersApiUrl,
        rankingApiUrl,
        authorization,
        anonymousToken,
        toastr,
        models,
        userApiUrl,
        uploadApiUrl,
        arbiterApiUrl,
        userPlanApiUrl,
        transferPlayerApiUrl,
        cmsApiUrl,
        cmsAuth
    ) {
        // Cache the promises (just to avoid to call the same API before the previous has finished)
        var cache = {};

        // Api Helpers (accessible only from this factory)
        var helpers = {
            /**
             * Try to retrieve the result from cache, or make HTTP call
             * @param  {String} method  The HTTP method
             * @param  {String} fullUrl The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @param  {Boolean} keep   If true, the promise is cached even after it's been fulfilled
             * @return {Promise}        A promise of the response
             */
            cacheOrHttp: function(method, fullUrl, data, headers, keep) {
                var key = method + fullUrl + (data ? angular.toJson(data) : '');

                var config = {};
                if (method) config.method = method.toUpperCase();
                if (fullUrl) config.url = fullUrl;
                if (data) config.data = data;
                if (headers) config.headers = headers;

                if (!cache[key]) {
                    var promise;
                    var err = false;
                    switch (method) {
                        case 'get':
                        case 'GET':
                        case 'post':
                        case 'POST':
                        case 'put':
                        case 'PUT':
                        case 'patch':
                        case 'PATCH':
                        case 'delete':
                        case 'DELETE':
                            promise = $http(config);
                            break;
                        default:
                            err = true;
                            promise = $q.reject();
                            break;
                    }
                    if (!err) {
                        cache[key] = promise.finally(function(response, err) {
                            if (!keep) {
                                delete cache[key]; // delete the cache, so the next call will be fresh
                            }
                            if (err) {
                                return $q.reject(err);
                            }
                            if (response) {
                                return response;
                            }
                        });
                    }
                }

                return cache[key];
            },

            /**
             * @param  {String} method  The HTTP method
             * @param  {Object} data    The body
             * @param  {String} url     The API url
             * @return {Promise}        A promise of the response
             */
            transferPlayerApiCall: function(method, body, url) {
              url = url || '/';
              return helpers.cacheOrHttp(method,
                transferPlayerApiUrl + url,
                body, { Authorization: authorization }
              );
            },

            /**
             * Perform an API call to the Users endpoint, using preset headers and required data
             * @param  {String} method  The HTTP method
             * @param  {String} url The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            provisioningApiCall: function(method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    provisioningApiUrl + url,
                    angular.merge({},
                        data
                    ),
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
            AGGIUNTO PERCHE IL provisioningApiUrl finisce con users
             * Perform an API call to the Users endpoint, using preset headers and required data
             * @param  {String} method  The HTTP method
             * @param  {String} url The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            provisioningApiCallB: function(method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    provisioningApiUrlB + url,
                    angular.merge({},
                        data
                    ),
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Events endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            eventsApiCall: function(method, url, data, headers, keep) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    eventsApiUrl + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    ),
                    keep
                );
            },

            /**
             * Perform an API call to the Teams endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            teamsApiCall: function(method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    teamsApiUrl + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Press endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            pressApiCall: function(method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    pressApiUrl + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Match endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            matchesApiCall: function(eventId, method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    matchesApiUrl + '/event/' + eventId + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Match endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            getWeeksOfYearApiCall: function(year, method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    matchesApiUrl + '/settimane/' + year + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Cards endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            cardsApiCall: function(eventId, method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    cardsApiUrl + '/events/' + eventId + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Scorers endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            scorersApiCall: function(eventId, matchId, method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    scorersApiUrl + '/events/' + eventId + '/match/' + matchId + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Scorers endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
            importScorersApiCall: function(eventId, method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    scorersApiUrl + '/events/' + eventId + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Players endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}        A promise of the response
             */
             importPlayersApiCall: function(eventId, method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    teamsApiUrl + '/events/' + eventId + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Ranking endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}         A promise of the response
             */
            rankingApiCall: function(eventId, method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    rankingApiUrl + '/event/' + eventId + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * Perform an API call to the Preferences endpoint, using preset headers
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}         A promise of the response
             */
            userApiCall: function(method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    userApiUrl + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            /**
             * API per ottenere Token per S3
             * @param  {String} method  The HTTP method
             * @param  {String} url     The API url
             * @param  {Object} data    The body
             * @param  {Object} headers The headers
             * @return {Promise}         A promise of the response
             */
            uploadApiCall: function(method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(
                    method,
                    uploadApiUrl + url,
                    data,
                    angular.merge({
                            Authorization: authorization
                        },
                        headers
                    )
                );
            },

            arbiterApiCall: function(method, url, data, headers) {
              url = url || '/';
              return helpers.cacheOrHttp(method,
                  arbiterApiUrl + url, data,
                  angular.merge(
                    { Authorization: authorization },
                    headers)
              );
            },

            userPlanApiCall: function(method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(method,
                    userPlanApiUrl + url, data,
                    angular.merge(
                      { Authorization: authorization },
                      headers)
                );
              },

              cmsApiCall: function(method, url, data, headers) {
                url = url || '/';
                return helpers.cacheOrHttp(method,
                    cmsApiUrl + url, data,
                    angular.merge(
                      { Authorization: cmsAuth },
                      headers)
                );
              },

            /**
             * Expect a 200 response and return data.
             * Otherwise, return a rejected promise.
             */
            expect200: function(response) {
                if (response.status === 200) {
                    return response.data;
                } else {
                    return $q.reject(response);
                }
            },

            notification: function(response) {
                if (response.msg && response.status_code === 200) {
                    toastr.success(response.msg);
                }
                return response;
            },

            unwrapData: function(response) {
                return response.data;
            }
        };

        var frispoApi = {
            /** USER API **/

            /**
             * Register a new user
             */
            register: function(userData) {
                return helpers.provisioningApiCall(
                    'post', '/register?user_token=' + anonymousToken,
                    Object.assign(userData, {
                        type: 1,
                        role_code: "frispo-free"
                    }))
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Authenticate the user
             */
            login: function(userData) {
                return helpers
                    .provisioningApiCall('post', '/login?user_token=' + anonymousToken, {
                        email: userData.email,
                        password: userData.password
                    })
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Recover the password of a user
             */
            forgotPassword: function(userData) {
                return helpers
                    .provisioningApiCall('post', '/recovery_password?user_token=' + anonymousToken, {
                        email: userData.email
                    })
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Authenticate the user using facebook
             */
            loginFacebook: function(facebookData, privacyObj) {
                return helpers.provisioningApiCall(
                    'post', '/login_facebook?user_token=' + anonymousToken,
                    Object.assign(privacyObj, {
                        facebook_token: facebookData.authResponse.accessToken,
                        role_code: "frispo-free"
                  }))
                  .then(helpers.expect200);
            },

            /**
             * Logout the user
             * @return {Promise}          A promise with the response
             */
            logout: function() {
                return helpers
                    .provisioningApiCall('post', '/logout?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /* ADMIN TEAM API */

            listSentAdminTeam: function() {
                return helpers
                    .userApiCall('get', '/user/adminteaminvitation/listinvitingmember?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },
            destroyAdminTeam: function(invitationDataId) {
                return helpers
                    .userApiCall('DELETE', '/user/adminteaminvitation/' + invitationDataId + '/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            createInvitationAdminTeam: function(invitationData) {
                return helpers
                    .userApiCall('post', '/user/adminteaminvitation/send?user_token=' + models.currentUser.userToken, invitationData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /* GET TOKEN S3 */

            getTokenS3: function(bucket) {
                return helpers
                    .uploadApiCall('get', '/getcredentials?user_token=' + models.currentUser.userToken + '&bucket_name=' + bucket)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /** CATALOG API **/

            buyProduct: function() {
                //console.log(models.currentUser.userToken);
                //console.log(cart);
                return helpers
                    .provisioningApiCallB('post', '/products/buy?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);

            },

            /* INVITATION API */

            listSentInvitations: function() {
                return helpers
                    .userApiCall('get', '/user/admininvitation/listinvitingmember?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            listReceivedInvitations: function() {
                return helpers
                    .userApiCall('get', '/user/admininvitation/listguest?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            createInvitation: function(invitationData) {
                return helpers
                    .userApiCall('post', '/user/admininvitation/send?user_token=' + models.currentUser.userToken, invitationData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            updateInvitation: function(invitationData) {
                return helpers
                    .userApiCall('post', '/user/admininvitation/edit?user_token=' + models.currentUser.userToken, invitationData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /* EVENTS API */

            /**
             * List the events of the current user
             * @return {Promise} A promise fulfilled with the event list
             */
            listEvents: function() {
                return helpers
                    .eventsApiCall('get', '/events/origin?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the events managed by current user
             */
            listManagedEvents: function() {
                return helpers
                    .eventsApiCall('get', '/events/guest?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Create a new event
             * @return {Promise} A promise fulfilled with the event created
             */
            createEvent: function(eventData) {
                return helpers
                    .eventsApiCall('post', '/events/add?user_token=' + models.currentUser.userToken, eventData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Update an event
             */
            updateEvent: function(eventId, eventData) {
                return helpers
                    .eventsApiCall('post', '/events/' + eventId + '/edit?user_token=' + models.currentUser.userToken, eventData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Destroy an event
             */
            destroyEvent: function(eventData) {
                return helpers
                    .eventsApiCall('delete', '/events/' + eventData.evenId + '/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Show an event
             * @return {Promise} A promise fulfilled with the event requested
             */
            showEvent: function(eventId) {
                return helpers
                    .eventsApiCall('get', '/event/' + eventId + '?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the active regions
             */
            listRegions: function() {
                return helpers
                    .eventsApiCall('get', '/regions?user_token=' + models.currentUser.userToken, null, null, true)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /** RANKING API **/

            /**
             * Show the scoreboard of an event
             */
            showEventScoreboard: function(eventId) {
                return helpers
                    .rankingApiCall(eventId, 'get', '/ranking?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Show the scoreboard of a tournament event
             */
            showTournamentScoreboard: function(eventId) {
                return helpers
                    .rankingApiCall(eventId, 'get', '/rankingtournament?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Show the players' scores of the event
             */
            showScorers: function(eventId) {
                return helpers
                    .rankingApiCall(eventId, 'get', '/scorers_matches?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            getScoreboardOrdreCriteria: function(eventId) {
              return helpers
                  .rankingApiCall(eventId, 'get', '/orderranking?user_token=' + models.currentUser.userToken)
                  .then(helpers.expect200)
                  .then(helpers.notification);
            },

            postScoreboardOrdreCriteria: function(eventId, criteria) {
              return helpers
                  .rankingApiCall(eventId, 'post',
                      '/orderranking?user_token=' + models.currentUser.userToken,
                      { order_event: criteria })
                  .then(helpers.expect200)
                  .then(helpers.notification);
            },

            /**
             * Create a new scorer
             */
            createScorer: function(eventId, matchId, scorerData) {
                return helpers
                    .scorersApiCall(eventId, matchId, 'post', '/scorers/add?user_token=' + models.currentUser.userToken, scorerData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Destroy a ScorerMatch
             */
            destroyScorerMatch: function(eventId, playerId, matchId) {
                return helpers
                    .scorersApiCall(eventId, matchId, 'delete', '/player/' + playerId + '/scorers/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Show the players' import scores of the event
             */
            listScorersImport: function(eventId) {
                return helpers
                    .importScorersApiCall(eventId, 'get', '/scorers/listimport?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Confirm import
             */
            importScorers: function(eventId, payload) {
                return helpers
                    .importScorersApiCall(eventId, 'post', '/scorers/import?user_token=' + models.currentUser.userToken, payload)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Destroy a import
             */
            removeImportScorer: function(eventId, importId) {
                return helpers
                    .importScorersApiCall(eventId, 'delete', '/import/' + importId + '?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Destroy a card
             */
            destroyCard: function(eventId, matchId, cardId) {
                return helpers
                    .cardsApiCall(eventId, 'delete', '/match/' + matchId + '/cards/' + cardId + '/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Destroy an amend
             */
            destroyAmend: function(eventId, matchId, amendId) {
                return helpers
                    .cardsApiCall(eventId, 'delete', '/match/' + matchId + '/amends/' + amendId + '/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Update a ScorerMatch
             */
            updateScorerMatch: function(eventId, matchId, scorerMatchData) {
                return helpers
                    .scorersApiCall(eventId, matchId, 'post', '/scorers/edit?user_token=' + models.currentUser.userToken, scorerMatchData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /* PRESS API */

            /**
             * List the press of an event
             * @param  {Number} eventId The id of the event
             */
            listPress: function(eventId) {
                return helpers
                    .pressApiCall('get', '/event/' + eventId + '/press?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * load a press
             */
            loadPress: function (pressData) {
              return helpers
                .pressApiCall('post', '/press/upload?user_token=' + models.currentUser.userToken, pressData)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            /**
             * update a press
             */
            updatePress: function(eventId, pressId, pressData) {
                return helpers
                    .pressApiCall('post', '/event/' + eventId + '/press/' + pressId + '/edit?user_token=' + models.currentUser.userToken, pressData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * update a press
             */
            createPress: function(pressData) {
                return helpers
                    .pressApiCall('post', '/press/create?user_token=' + models.currentUser.userToken, pressData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * destroy a press
             */
            destroyPress: function(eventId, pressId) {
                return helpers
                    .pressApiCall('delete', '/event/' + eventId + '/press/' + pressId + '/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * show a press
             */
            showPress: function(eventId, pressId) {
                return helpers
                    .pressApiCall('get', '/event/' + eventId + '/press/' + pressId + '?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /* TEAMS API */

            /**
             * List the teams of an event
             * @param  {Number} eventId The id of the event
             */
            listTeams: function(eventId) {
                return helpers
                    .teamsApiCall('get', '/events/' + eventId + '/teams?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the temp teams of an event
             * @param  {Number} eventId The id of the event
             */
            listTempTeams: function(eventId) {
                return helpers
                    .teamsApiCall('get', '/events/' + eventId + '/teamstemp?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the teams of an event on calendar section (with Riposo team)
             * @param  {[type]} eventId [description]
             * @return {[type]}         [description]
             */
            listCalendarTeams: function(eventId) {
                return helpers
                    .teamsApiCall('get', '/events/' + eventId + '/calendar/teams?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * update a team
             */
            updateTeam: function(eventId, teamId, teamData) {
                return helpers
                    .teamsApiCall('post', '/events/' + eventId + '/teams/' + teamId + '/edit?user_token=' + models.currentUser.userToken, teamData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * update a teamPlace
             */
            updateTeamPlace: function(eventId, teamId, teamPlace) {
                return helpers
                    .teamsApiCall('post', '/events/' + eventId + '/teams/' + teamId + '/updateaddressmatches?user_token=' + models.currentUser.userToken, teamPlace)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * update team points and foul
             */
            updatePointfoul: function(eventId, teamPointFoul) {
                return helpers
                    .rankingApiCall(eventId, 'post', '/ranking/edit?user_token=' + models.currentUser.userToken, teamPointFoul)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },


            /**
             * update a team
             */
            createTeam: function(eventId, teamData) {
                return helpers
                    .teamsApiCall('post', '/events/' + eventId + '/teams/add?user_token=' + models.currentUser.userToken, teamData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * destroy a team
             */
            destroyTeam: function(eventId, teamId) {
                return helpers
                    .teamsApiCall('delete', '/events/' + eventId + '/teams/' + teamId + '/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * show a team
             */
            showTeam: function(eventId, teamId) {
                return helpers
                    .teamsApiCall('get', '/events/' + eventId + '/teams/' + teamId + '?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Add a group of teams to an event
             * @param {Number} eventId   The id of the event to add the teams to
             * @param {Object} teamsData An object containing the informations about the teams we want to create
             */
            addGroupTeams: function(eventId, teamsData) {
                return helpers
                    .teamsApiCall('post', '/events/' + eventId + '/teams/add_group_teams?user_token=' + models.currentUser.userToken, teamsData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the iscrizioni of a avent
             */
            listIscrizioni: function(eventId) {
                return helpers
                    .eventsApiCall('get', '/event/' + eventId + '/subscribe?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Update the iscrizione of a avent
             */
            updateIscrizione: function(eventId, iscrizioneId, iscrizioneData) {
                return helpers
                    .eventsApiCall('post', '/events/' + eventId + '/subscribe/' + iscrizioneId + '/edit?user_token=' + models.currentUser.userToken, iscrizioneData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            destroyIscrizione: function(eventId, iscrizioneId) {
                return helpers
                    .eventsApiCall('delete', '/events/' + eventId + '/subscribe/' + iscrizioneId + '?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            movePlayers: function(body) {
              return helpers
                .transferPlayerApiCall('post', body,
                    '/moveplayer?user_token=' + models.currentUser.userToken)
                .then(helpers.expect200)
                .then(function(res) {
                  res.msg = 'Spostato con successo'; return res;
                })
                .then(helpers.notification);
            },

            copyPlayers: function(body) {
              return helpers
                .transferPlayerApiCall('post', body,
                    '/copyplayer?user_token=' + models.currentUser.userToken)
                .then(helpers.expect200)
                .then(function(res) {
                  res.msg = 'Copia effettuata con successo'; return res;
                })
                .then(helpers.notification);
            },
            /**
             * List the players of a team
             */
            listPlayers: function(teamId) {
                return helpers
                    .teamsApiCall('get', '/teams/' + teamId + '/players/list?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200);
            },

            importPlayers: function(eventId, teamId, filename) {
                return helpers
                    .importPlayersApiCall(eventId, 'get', '/teams/' + teamId + '/importplayer?user_token=' + models.currentUser.userToken + '&file_import='+filename)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            updatePlayer: function(teamId, playerId, playerData) {
                return helpers
                    .teamsApiCall('post', '/teams/' + teamId + '/players/' + playerId + '/edit?user_token=' + models.currentUser.userToken, playerData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            createPlayer: function(teamId, playerData) {
                return helpers
                    // TODO: check this call
                    .teamsApiCall('post', '/teams/' + teamId + '/players/add?user_token=' + models.currentUser.userToken, playerData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            destroyPlayer: function(teamId, playerId) {
                return helpers
                    .teamsApiCall('delete', '/teams/' + teamId + '/players/' + playerId + '/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /* PREFERENCES API */


            /**
             * Get the preferences of the current user
             */
            showPreferences: function() {
                return helpers
                    .userApiCall('get', '/preferences/list?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Get the basic info of the current user
             */
            showUser: function() {
                return helpers
                    .userApiCall('get', '/user/find?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Update the basic info of the current user
             */
            updateUser: function(userData) {
                return helpers
                    .userApiCall('post', '/user/edit?user_token=' + models.currentUser.userToken + "&uuid=" + models.currentUser.userUuid, userData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Edit the info of the current user
             */
            editUser: function(userData) {
                return helpers
                    .provisioningApiCallB('put', '/users/edit_profile?user_token=' + models.currentUser.userToken, userData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Delete the current user
             */
            deleteUser: function(userData) {
                return helpers
                    .provisioningApiCallB('delete', '/users/cancel_profile?user_token=' + models.currentUser.userToken, userData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },


            /* MATCHES API */


            /**
             * Create a new event
             * @return {Promise} A promise fulfilled with the event created
             */
            createMatchesCalendar: function(eventId) {
                return helpers
                    .matchesApiCall(eventId, 'post', '/match/create_calendar?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Export calendar
             * @return {Promise} A promise fulfilled with the event created
             */
             exportCalendar: function(eventId) {
                return helpers
                    .eventsApiCall('get', '/events/' + eventId + '/exportcalendars?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Import calendar
             * @return {Promise} A promise fulfilled with the event created
             */
             importCalendar: function(eventId, payload) {
                return helpers
                    .eventsApiCall('post', '/events/' + eventId + '/importcalendars?user_token=' + models.currentUser.userToken, payload)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the matches of an event for a given day
             * @return {Promise} A promise fulfilled with the matches data
             */
            listMatches: function(eventId, day) {
                return helpers
                    .matchesApiCall(eventId, 'get', '/day/' + day + '/matches?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Show a match
             */
            showMatch: function(eventId, matchId) {
                return helpers
                    .matchesApiCall(eventId, 'get', '/match/' + matchId + '?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the scorers of a match for a given event
             * @return {Promise} A promise fulfilled with the matches data
             */
            listMatchScorers: function(eventId, matchId) {
                return helpers
                    .matchesApiCall(eventId, 'get', '/match/' + matchId + '/scorers?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the weeks of a year
             * @return {Promise} A promise fulfilled with the matches data
             */
            getWeeksOfYear: function(year) {
                return helpers
                    .getWeeksOfYearApiCall(year, 'get', '?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the yellow cards of an event
             */
            listYellowCards: function(eventId) {
                return helpers
                    .cardsApiCall(eventId, 'get', '/cards/listyellow?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the diffides of an event
             */
            listDiffides: function(eventId) {
                return helpers
                    .cardsApiCall(eventId, 'get', '/cards/listdiffide?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the squalifications of an event
             */
            listSqualifications: function(eventId) {
                return helpers
                    .cardsApiCall(eventId, 'get', '/cards/listsqualifications?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * List the amends of an event
             */
            listAmends: function(eventId) {
                return helpers
                    .cardsApiCall(eventId, 'get', '/amends?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Create a new card
             */
            createCard: function(eventId, matchId, cardData) {
                return helpers
                    .cardsApiCall(eventId, 'post', '/match/' + matchId + '/cards/add?user_token=' + models.currentUser.userToken, cardData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Create a new amend
             */
            createAmend: function(eventId, matchId, amendData) {
                return helpers
                    .cardsApiCall(eventId, 'post', '/match/' + matchId + '/amends/add?user_token=' + models.currentUser.userToken, amendData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Update a card
             */
            updateCard: function(eventId, matchId, cardId, cardData) {
                return helpers
                    .cardsApiCall(eventId, 'post', '/match/' + matchId + '/cards/' + cardId + '/edit?user_token=' + models.currentUser.userToken, cardData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Update a amend
             */
            updateAmend: function(eventId, matchId, amendId, amendData) {
                return helpers
                    .cardsApiCall(eventId, 'post', '/match/' + matchId + '/amends/' + amendId + '/edit?user_token=' + models.currentUser.userToken, amendData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Update a match
             */
            updateMatch: function(eventId, matchData) {
                return helpers
                    .matchesApiCall(eventId, 'post', '/matches/update?user_token=' + models.currentUser.userToken, matchData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Update a giornata
             */
            updateGiornata: function(eventId, giornataId, giornataData) {
                return helpers
                    .matchesApiCall(eventId, 'post', '/day/' + giornataId + ' /edit?user_token=' + models.currentUser.userToken, giornataData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Create a match
             */
            createMatch: function(eventId, matchDayId, matchData) {
                return helpers
                    .matchesApiCall(eventId, 'post', '/day/' + matchDayId + '/matches/add?user_token=' + models.currentUser.userToken, matchData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Create a match day
             */
            createDay: function(eventId, dayData) {
                return helpers
                    .matchesApiCall(eventId, 'post', '/matches_day/add?user_token=' + models.currentUser.userToken, dayData)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Create a tournament group
             */
             createGroup: function(eventId, groupData) {
              return helpers
                  .eventsApiCall('post',
                      '/events/' + eventId + '/gironi?user_token=' + models.currentUser.userToken,
                      groupData)
                  .then(helpers.expect200)
                  .then(helpers.notification);
            },

            /**
             * List tournament groups
             */
             listGroups: function(eventId) {
              return helpers
                  .eventsApiCall('get',
                      '/events/' + eventId + '/gironi?user_token=' + models.currentUser.userToken
                  )
                  .then(helpers.expect200)
                  .then(helpers.notification);
            },

            /**
             * Destroy a match
             */
            destroyMatch: function(eventId, matchDayId, matchId) {
                return helpers
                    .matchesApiCall(eventId, 'delete', '/match_day/' + matchDayId + '/matches/' + matchId + '/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Destroy giornata
             */
            destroyGiornata: function(eventId, idGiornata) {
                return helpers
                    .matchesApiCall(eventId, 'delete', '/day/' + idGiornata + '/remove?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Destroy a match
             */
            updateDateMatchFromWeek: function(eventId) {
                return helpers
                    .matchesApiCall(eventId, 'post', '/matches/updatedatematch?user_token=' + models.currentUser.userToken)
                    .then(helpers.expect200)
                    .then(helpers.notification);
            },

            /**
             * Arbiters services
             */

            createArbiter: function(eventId, arbiter) {
              return helpers
                .arbiterApiCall('post',
                  '/arbiter/add?event_id=' + eventId
                      + '&user_token=' + models.currentUser.userToken,
                  arbiter)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            listArbiters: function(eventId) {
              return helpers
                .arbiterApiCall('get',
                  '/arbiter/list?event_id=' + eventId
                      + '&user_token=' + models.currentUser.userToken)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            deleteArbiter: function(arbiId) {
              return helpers
                .arbiterApiCall('delete',
                  '/arbiter/delete?arbi_id=' + arbiId
                      + '&user_token=' + models.currentUser.userToken)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            editArbiter: function(arbiId, data) {
              return helpers
                .arbiterApiCall('put',
                  '/arbiter/edit?arbi_id=' + arbiId
                      + '&user_token=' + models.currentUser.userToken,
                  data)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            attachArbiterToMatch: function(arbiterId, matchId) {
              return helpers
                .arbiterApiCall('get',
                  '/arbiter/match?arbiter_id=' + arbiterId
                      + '&match_id='   + matchId
                      + '&user_token=' + models.currentUser.userToken)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            getArbiterPageLink: function(arbiterId, matchId) {
              return helpers
                .arbiterApiCall('get',
                  '/arbiter/matchLink?arbiter_id=' + arbiterId
                      + '&match_id='   + matchId
                      + '&user_token=' + models.currentUser.userToken)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            getArbiterDataMail: function(arbiterId, matchId) {
              return helpers
                .arbiterApiCall('get',
                  '/arbiter/matchdatamail?arbiter_id=' + arbiterId
                      + '&match_id='   + matchId
                      + '&user_token=' + models.currentUser.userToken)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            sendEmailToArbiter: function(arbiterId, matchId) {
              return helpers
                .arbiterApiCall('get',
                  '/arbiter/sendEmail?arbiter_id=' + arbiterId
                      + '&match_id='   + matchId
                      + '&user_token=' + models.currentUser.userToken)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            sendEmailToArbiterWithData: function(arbiterId, matchId) {
              return helpers
                .arbiterApiCall('get',
                  '/arbiter/sendmaildata?arbiter_id=' + arbiterId
                      + '&match_id='   + matchId
                      + '&user_token=' + models.currentUser.userToken)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

//https://api.frispo.it/api/users/1.0.0/frispo/base/0/changeplan
            confirmUserPlan: function(userPlanPayload) {
                console.log('userPlanPayload', userPlanPayload);
              return helpers
                .userPlanApiCall('post',
                  '/changeplan',
                  userPlanPayload)
                .then(helpers.expect200)
                .then(helpers.notification);
            },

            addPlanToCMS: function(planContent) {
              return helpers
                .cmsApiCall('post', '/v1/content?user_token=' + models.currentUser.userToken
                    + '&component=cdfrispoleague',
                  planContent, {
                    'Content-Type': 'application/json',
                    'x-api-key'   : 'SVlAAhDoMf61mJZBJO86K7MGq8HfWiYq3ixO0Mjg'
                })
                .then(helpers.expect200)
                .then(helpers.notification);
            }
        };

        return frispoApi;
    });

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('compareTo', compareTo);

  /** @ngInject */
  function compareTo() {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        otherModelValue: '=compareTo'
      },
      link: compareToLink
    };

    return directive;

    /** @ngInject */
    function compareToLink(scope, element, attrs, ngModel) {
      ngModel.$validators.compareTo = function (modelvalue) {
        return modelvalue == scope.otherModelValue;
      }
      scope.$watch('otherModelValue', function () {
        ngModel.$validate();
      })
    }
  }

})();

'use strict';

angular.module('frispo')
  /**
   * Error Manager.
   * Handles common HTTP error messages
   */
  .factory('errorManager', function (toastr, $log, $state, $q, longTermMemory, models) {
    var errorManager = function(err) {
      // log every errors
      $log.error(err);

      // Unwrap HTTP errors and take actions if needed
      if(angular.isObject(err) && err.status){
        switch(err.status){
          case 401:
            $state.go('main.logout');
            err = err.data;
            break;
          case 403:
            $state.go('main.home');
            err = err.data;
            break;
          case 422:
            err = err.data;
            break;
          case 404:
            err = err.data;
            break;
          case 413:
            err = 'Il file che stai cercando di caricare è troppo grande';
            break;
          case -1:
            err = 'Il server non è raggiungibile o non sei connesso ad Internet';
            break;
          default:
            break;
        }
      }

      var getErrorString = function (err) {
        if(angular.isString(err)){
          return err;
        }
        else if(angular.isObject(err) && (err.full_messages || err.error_description || err.errors || err.data || err.msg || err.error)){
          return getErrorString(err.full_messages || err.error_description || err.errors || err.data || err.msg || err.error );
        }
        else if(angular.isArray(err)){
          var myErr = [];
          for (var i = 0; i < err.length; i++) {
            myErr[i] = getErrorString(err[i]);
          }
          return getErrorString(myErr.join('<br>'));
        }
        // Don't manage different kinds of error
        else{
          longTermMemory.oblivion(); // Forget everything. We don't want the app to be broken forever!
          models.reset(); // Reset all the models. We don't want the app to be broken forever!
          return 'Si è verificato un errore imprevisto. Si prega di riprovare più tardi.';
        }
      }

      toastr.error(getErrorString(err), 'Errore');

      return $q.reject(err);
    };

    return errorManager;
  });

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('datepicker', datepicker);

  /** @ngInject */
  function datepicker() {
    var directive = {
      restrict: 'A',
      link: datepickerLink,
      scope: {
        datepicker: '@',
        model: '='
      }
    };

    return directive;

    /** @ngInject */
    function datepickerLink(scope, el) {
      scope.watchInput = function () {
        scope.$watch('model', function () {
          scope.drp.elementChanged();
        });
      }

      if(scope.datepicker === 'range'){
        scope.drp = el.daterangepicker({
          autoUpdateInput: false,
          locale: {
            format: 'DD/MM/YYYY',
            separator: ' -> '
          }
        }).data('daterangepicker');
        el.on('apply.daterangepicker', function (ev, picker) {
          scope.$apply(function () {
            scope.model = picker.startDate.format('DD/MM/YYYY') + ' -> ' + picker.endDate.format('DD/MM/YYYY');
          })
        })
        el.on('cancel.daterangepicker', function () {
          scope.$apply(function () {
            scope.model = '';
          })
        })
        scope.watchInput();
      }
      else{
        scope.drp = el.daterangepicker({
          autoUpdateInput: false,
          singleDatePicker: true,
          locale: {
            format: 'DD/MM/YYYY',
            separator: ' -> '
          }
        }).data('daterangepicker');
        el.on('apply.daterangepicker', function (ev, picker) {
          scope.$apply(function () {
            scope.model = picker.startDate.format('DD/MM/YYYY');
          })
        })
        el.on('cancel.daterangepicker', function () {
          scope.$apply(function () {
            scope.model = '';
          })
        })
        scope.watchInput();
      }
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('can', canDirective);

  /** @ngInject */
  function canDirective($log, models) {
    var directive = {
      restrict: 'A',
      link: linkFunc,
      scope: {
        can: '@'
      }
    };

    return directive;

    function linkFunc(scope, el) {
      var watcher;
      var shown;
      var negative;
      var permission;
      scope.models = models;

      // Update the visibility of the element
      var updateVisibility = function() {
        var toShow = false;
        if(angular.isArray(models.currentUser.permissions)){ // look for permission
            for (var i = 0; i < models.currentUser.permissions.length; i++) {
              if(models.currentUser.permissions[i].permName === permission){
                toShow = true;
                break;
              }
            }
        }
        if(negative){ toShow = !toShow; } // invert the condition if needed

        // Show the element if not shown
        if(toShow && !shown){
          el.removeClass('can-hide');
          shown = true;
        }

        // Hide the element if shown
        else if(!toShow && shown){
          el.addClass('can-hide');
          shown = false;
        }
      };

      // If the action starts with "!", the action is negative
      negative = scope.can.slice(0, 1) === '!';


      // In that case, remove ! from the string
      if(negative){
        permission = scope.can.substr(1);
      }
      else{
        permission = scope.can;
      }

      // Update the visibility for the first time
      shown = true;
      updateVisibility();

      // Update the visibility as soon as the permissions change
      watcher = scope.$watch('models.currentUser.permissions', function(newVal, oldVal) {
        if(newVal && oldVal !== newVal){
          updateVisibility();
        }
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .directive('bootstrapMultiselect', bootstrapMultiselect);

  /** @ngInject */
  function bootstrapMultiselect() {
    var directive = {
      restrict: 'A',
      link: bootstrapMultiselectLink,
      terminal: true
    };

    return directive;

    /** @ngInject */
    function bootstrapMultiselectLink(scope, el) {
      el.multiselect();
    }
  }

})();

'use strict';

angular.module('frispo')
  /**
   * User models manager
   */
  .factory('users', function (frispoApi, errorManager, models, longTermMemory, resPipe, $state, $q, ezfb, $log, uiState, $timeout) {

    var users = {
      /**
       * Register a new user
       * @param  {Object} userData an object containing 'email' and 'password'
       * @return {Promise}         a promise with the authentication data for the user
       */
      register: function (userData) {
        return frispoApi
          .register(userData)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(function (res) {
            res.email = userData.email;
            return res;
          })
          .then(resPipe.camelize)
          .then(resPipe.injectUserDefaults)
          .then(resPipe.updateCurrentUser)
          .then(resPipe.memorizeCurrentUser)
          .catch(errorManager);
      },

      /**
       * Login a user
       * @param  {Object} userData an object containing 'email' and 'password'
       * @return {Promise}         a promise with the authentication data for the user
       */
      login: function (userData) {
        return frispoApi
          .login(userData)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(function (res) {
            res.email = userData.email; // Add the email from the input as it's missing from the response
            return res;
          })
          .then(resPipe.camelize)
          .then(resPipe.injectUserDefaults)
          .then(resPipe.updateCurrentUser)
          .then(resPipe.memorizeCurrentUser)
          .then(users.onLoggedIn)
          // angular-toastr (nella configurazione in uso) non permette messaggi
          // duplicati (e non possiamo attivarli). Per avere un feedback in caso
          // di ripetuti tentativi di login falliti, modifichiamo il messaggio di
          // errore ad ogni tentativo utilizzando un contatore (nascosto)
          .catch(function (err) {
            if (models.currentUser && !models.currentUser.errCnt)
              models.currentUser.errCnt = 0;

            models.currentUser.errCnt = models.currentUser.errCnt + 1;
            err.error[0].error_description =
              "<b class='ng-hide'>" + models.currentUser.errCnt + "</b>" + err.error[0].error_description;
            return $q.reject(err);
          })
          .catch(errorManager);
      },

      /**
       * Recover the password of an user
       */
      forgotPassword: function (userData) {
        return frispoApi
          .forgotPassword(userData)
          .then(resPipe.parseResponse)
          .catch(errorManager)
      },

      /**
       * Logout a user
       * @param  {Object} userData an object containing the user data
       * @return {Promise}          a promise that will be fullfilled after the logout
       */
      logout: function () {
        if (models.currentUser && models.currentUser.userToken) {
          return frispoApi
            .logout()
            .then(function (res) {
              $log.info('Frispo logout');
              return res;
            })
            .catch(errorManager)
            .finally(users.onLoggedOut)
            .then(function () {
              ezfb.logout();
            });
        }
        return $q.resolve();
      },

      /**
       * Login a user to frispo's server using the facebook login() response data
       * @param  {Object} facebookData The object returned by the Facebook SDK after a succesful login
       * @return {Promise}             A promise fulfilled with the authentication data for the user,
       */
      loginFacebook: function (facebookData, privacyObj) {
        return frispoApi
          .loginFacebook(facebookData, privacyObj)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.injectUserDefaults)
          .then(resPipe.updateCurrentUser)
          .then(resPipe.memorizeCurrentUser)
          .then(users.onLoggedIn)
          .catch(errorManager);
      },

      /**
       * Fetch all user info
       */
      info: function () {
        var infoCalls = [
          users.showPreferences(),
          users.show()
        ];
        return $q.all(infoCalls);
      },

      /**
       * Show basic user info
       */
      show: function () {
        return frispoApi
          .showUser()
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.updateMergeCurrentUser)
          .then(resPipe.memorizeCurrentUser)
          .catch(errorManager);
      },

      /**
       * Edit basic user info
       */
      update: function (userData) {
        return frispoApi
          .updateUser(userData)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.updateMergeCurrentUser)
          .then(resPipe.memorizeCurrentUser)
          .catch(errorManager);
      },

      /**
       * Edit user info
       */
      editUser: function (userData) {
        return frispoApi
          .editUser(userData)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.updateMergeCurrentUser)
          .then(resPipe.memorizeCurrentUser)
          .catch(errorManager);
      },

      /**
       * Delete user
       */
      deleteUser: function (userData) {
        return frispoApi
          .deleteUser(userData)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.updateMergeCurrentUser)
          .then(resPipe.memorizeCurrentUser)
          .then(users.logout)
          .catch(errorManager);
      },

      /**
       * Get the preferences of the user
       */
      showPreferences: function () {
        return frispoApi
          .showPreferences()
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.updatePreferences)
          .then(resPipe.memorizeCurrentUser)
          .catch(errorManager);
      },

      /**
       * This function is used as a callback whenever a user has been succesfully logged in
       * @param  {Object} userData The object containing the user data
       * @return {Object}          The same userData, useful for promise chaining
       */
      onLoggedIn: function (userData) {
        if ($state.current.name === 'main.access') {
          $state.go('main.admin.events');
        }
        uiState.privacyAcceptance =
          userData.userToken === null || userData.flgPrivacy === 0;
        if (!uiState.privacyAcceptance) {
          $log.info('Frispo login');
          users.info();
          uiState.loggedIn = true;
          $state.go('main.admin.events');
        }
        return $q.resolve(userData);
      },

      /**
       * This function is used as a callback whenever a user has been succesfully logged out
       */
      onLoggedOut: function () {
        models.reset();
        longTermMemory.oblivion();
        uiState.loggedIn = false;
        if ($state.current.name !== 'main.login' && $state.current.name !== 'main.register') {
          $timeout(function () {
            $state.go('main.login');
          })
        }
      },

      /**
       * Backup user data and setup the anonymous user for testing purposes
       */
      setAnonymousUser: function (res) {
        models.bkp = {
          uuid: models.currentUser.uuid,
          accessToken: models.currentUser.accessToken
        }
        models.currentUser.uuid = 'anonimo';
        models.currentUser.accessToken = '4e66c966e021918f0b088ddc929847f7'
        return $q.resolve(res);
      },

      /**
       * Restore user backup
       */
      unsetAnonymousUser: function (res) {
        models.currentUser.uuid = models.bkp.uuid;
        models.currentUser.accessToken = models.bkp.accessToken;
        delete models.bkp;
        return $q.resolve(res);
      },

      checkFacebookLogin: function () {
        return ezfb
          .getLoginStatus()
          .then(function (res) {
            if (res.status === 'connected') {
              return res;
            } else {
              return $q.reject(res);
            }
          });
      },

      /**
       * Configure the facebook login and events
       */
      configureFacebookCallbacks: function (privacyObj) {
        // Subscribe to FB login
        ezfb.Event.subscribe('auth.login', function (response) {
          $log.info('Facebook login');
          users.loginFacebook(response, privacyObj);
        });
        // Subscribe to FB logout
        ezfb.Event.subscribe('auth.logout', function () {
          $log.info('Facebook logout');
          if (uiState.loggedIn) {
            users.logout();
          }
        });
      },

      form2User: function (formData) {
        var userData = {};
        if (angular.isDefined(formData.email)) userData.email = formData.email;
        if (angular.isDefined(formData.flagMarketing)) userData.flag_marketing = formData.flagMarketing;
        if (angular.isDefined(formData.flagProfilazione)) userData.flag_profilazione = formData.flagProfilazione;
        return userData;
      },

      form2UserInfo: function (formData) {
        var userData = {
          user_extra: {}
        };
        if (angular.isDefined(formData.nome)) userData.user_extra.company_name = formData.nome;
        if (angular.isDefined(formData.username)) userData.user_username = formData.username;
        if (angular.isDefined(formData.address)) userData.user_address = formData.address;
        if (angular.isDefined(formData.phone)) userData.user_phone = formData.phone;
        if (angular.isDefined(formData.teamUrlLogo)) userData.user_extra.logo = 'https://s3-eu-west-1.amazonaws.com/com.iaetp.frispo/frispo-logo/' + formData.teamUrlLogo;
        return $q.resolve(userData);
      },

      form2Team: function (formData) {
        var userData = {};
        if (angular.isDefined(formData.type)) userData.type = formData.type;
        if (angular.isDefined(formData.subscription)) userData.subscription = formData.subscription;
        return $q.resolve(userData);
      },

      /**
       * Buy products in cart
       */
      buyProduct: function (cart) {
        return frispoApi
          .buyProduct(cart)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.memorizeCurrentUser)
          .catch(errorManager);
      },


      getTokenS3Logo:
        function () {
          return frispoApi
            .getTokenS3('com.iaetp.frispo')
            .catch(errorManager);
        },

      confirmUserPlan:
        function (userPlanPayload) {
          return frispoApi
            .confirmUserPlan(userPlanPayload)
            .catch(errorManager);
        },

        addPlanToCMS: function (planContent) {
          return frispoApi
            .addPlanToCMS(planContent)
            .catch(errorManager);
        }
    };

    return users;
  });

'use strict';

angular.module('frispo')
    /**
     * Event models manager
     */
    .factory('teams', function(frispoApi, errorManager, resPipe, $q, models, utils) {

        var teams = {
            /**
             * List the teams of the current event
             */
            list: function() {
                return frispoApi
                    .listTeams(models.currentEvent.evenId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(resPipe.decodificaGiorno)
                    .then(resPipe.updateTeams)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager)
            },

            listTemp: function() {
                return frispoApi
                    .listTempTeams(models.currentEvent.evenId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(resPipe.decodificaGiorno)
                    .then(resPipe.updateTempTeams)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager)
            },

            listcalendarteam: function() {
                return frispoApi
                    .listCalendarTeams(models.currentEvent.evenId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(resPipe.updateTeams)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager)
            },

            getTokenS3: function() {
                return frispoApi
                    .getTokenS3('com.codeploy.frispo.image.teams')
                    .catch(errorManager);
            },

            show: function(teamId) {
                return frispoApi
                    .showTeam(models.currentEvent.evenId, teamId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.updateTeam)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            create: function(team) {
                return frispoApi
                    .createTeam(models.currentEvent.evenId, team)
                    .then(resPipe.parseResponse)
                    .catch(errorManager);
            },

            update: function(teamId, team) {
                return frispoApi
                    .updateTeam(models.currentEvent.evenId, teamId, team)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.updateTeam)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            updatePlace: function(teamId, place) {
                return frispoApi
                    .updateTeamPlace(models.currentEvent.evenId, teamId, { team_place: place })
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.updateTeam)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            updatePointfoul: function(teamPointFoul) {
                return frispoApi
                    .updatePointfoul(models.currentEvent.evenId, teamPointFoul)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.updateTeam)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            showScoreboard: function() {
                var apiCall;
                // Torneo a gironi
                if (models.currentEvent.evenType === 1) {
                    apiCall = frispoApi.showTournamentScoreboard(models.currentEvent.evenId);
                } else {
                    apiCall = frispoApi.showEventScoreboard(models.currentEvent.evenId);
                }
                return apiCall
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(resPipe.updateScoreboard)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            destroy: function(team) {
                return frispoApi
                    .destroyTeam(models.currentEvent.evenId, team.teamId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return team;
                    })
                    .then(resPipe.removeTeam)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            destroyTemp: function(team) {
                return frispoApi
                    .destroyTeam(models.currentEvent.evenId, team.teamId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return team;
                    })
                    .then(resPipe.removeTempTeam)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Create a group of teams and add it to an event
             */
            addGroup: function(teamsData) {
                return frispoApi
                    .addGroupTeams(models.currentEvent.evenId, teamsData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .catch(errorManager);
            },

            listPlayers: function(teamId) {
                return frispoApi
                    .listPlayers(teamId || models.currentEvent.currentTeam.teamId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(resPipe.updatePlayers)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            updatePlayer: function(playerId, playerData) {
                return frispoApi
                    .updatePlayer(models.currentEvent.currentTeam.teamId, playerId, playerData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.updatePlayer)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            destroyPlayer: function(player) {
                return frispoApi
                    .destroyPlayer(models.currentEvent.currentTeam.teamId, player.playId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return player;
                    })
                    .then(resPipe.removePlayer)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            createPlayer: function(playerData) {
                return frispoApi
                    .createPlayer(models.currentEvent.currentTeam.teamId, playerData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.insertPlayer)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Translate data from a team form into an teamsData object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the teamsData object
             */
            form2Teams: function(formData) {
                var teamsData = { extra: [] };
                angular.forEach(formData.teams, function(team) {
                    teamsData.extra.push(teams.form2Team(team));
                });
                return $q.resolve(teamsData);
            },

            form2Team: function(formData) {
                var teamData = {};
                var teamTime = utils.str2Time(formData.time);
                if (angular.isDefined(formData.captain)) teamData.team_captain = formData.captain;
                if (angular.isDefined(teamTime)) teamData.team_time = teamTime;
                if (angular.isDefined(formData.name)) teamData.team_name = formData.name;
                if (angular.isDefined(formData.phone)) teamData.team_mobile_phone = formData.phone;
                if (angular.isDefined(formData.place)) teamData.team_place = formData.place;
                if (angular.isDefined(formData.playday)) teamData.team_playday = formData.playday.id;
                if (angular.isDefined(formData.round)) teamData.team_groups = formData.round;
                if(angular.isDefined(formData.temp)){
                    if(angular.isObject(formData.temp)){
                        teamData.team_temp = '' + formData.temp.id;
                    }
                    else{
                        teamData.team_temp = '' + formData.temp;
                    }
                }
                if (angular.isDefined(formData.teamUrlLogo)) teamData.team_url_logo = formData.teamUrlLogo;
                if (angular.isDefined(formData.desc)) teamData.team_description = formData.desc;
                return teamData;
            },

            form2Player: function(formData) {
                var playerData = {};
                if (angular.isDefined(formData.name)) playerData.player_name = formData.name;
                if (angular.isDefined(formData.surname)) playerData.player_surname = formData.surname;
                if (angular.isDefined(formData.name)) playerData.player_tessera = formData.tessera;
                if (angular.isDefined(formData.name)) playerData.player_recapito = formData.recapito;
                return $q.resolve(playerData);
            }
        };

        return teams;
    });

'use strict';

angular.module('frispo')
    /**
     * Event models manager
     */
    .factory('scorers', function(frispoApi, errorManager, resPipe, models) {
        var scorers = {
            getTokenS3: function() {
                return frispoApi
                    .getTokenS3('com.codeploy.frispoleague/scorer/import')
                    .catch(errorManager);
            },
            listImport: function() {
                return frispoApi
                    .listScorersImport(models.currentEvent.evenId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(resPipe.updateListImportScorers)
                    .then(resPipe.memorizeCurrentEvent)
                    .catch(errorManager)
            },
            importScorers: function(payload) {
                return frispoApi
                    .importScorers(models.currentEvent.evenId, payload)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(resPipe.memorizeCurrentEvent)
                    .catch(errorManager)
            },
            destroyImport: function(importId) {
                return frispoApi
                    .removeImportScorer(models.currentEvent.evenId, importId)
                    .then(resPipe.parseResponse)
                    .catch(errorManager);
            }
        };
        return scorers;
    });
'use strict';

angular.module('frispo')
  /**
   * Event models manager
   */
   .factory('press', function (frispoApi, errorManager, resPipe, $q, models) {

      var press = {
        /**
         * List the press of the current event
         */
        list: function () {
          return frispoApi
            .listPress(models.currentEvent.evenId)
            .then(resPipe.parseResponse)
            .then(resPipe.camelize)
            .then(resPipe.injectPressDefaults)
            .then(resPipe.updatePress)
            .then(resPipe.memorizeCurrentEvent)
            .then(resPipe.memorizeEvents)
            .catch(errorManager)
        },

        getTokenS3: function() {
          return frispoApi
              .getTokenS3('com.iaetp.frispo')
              .catch(errorManager);
        },

        show: function (pressId) {
          return frispoApi
            .showPress(models.currentEvent.evenId, pressId)
            .then(resPipe.parseResponse)
            .then(resPipe.unwrapArray)
            .then(resPipe.camelize)
            .then(resPipe.injectPressDefaults)
            .then(resPipe.updatePress)
            .then(resPipe.memorizeCurrentEvent)
            .then(resPipe.memorizeEvents)
            .catch(errorManager);
        },

        update: function (pressId, pressData) {
          return frispoApi
            .updatePress(models.currentEvent.evenId, pressId, pressData)
            .then(resPipe.parseResponse)
            .then(resPipe.unwrapArray)
            .then(resPipe.camelize)
            .then(resPipe.injectPressDefaults)
            .then(resPipe.updatePress)
            .then(resPipe.memorizeCurrentEvent)
            .then(resPipe.memorizeEvents)
            .catch(errorManager);
        },

        create: function (press) {
          return frispoApi
            .createPress(press)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        load: function (press) {
          return frispoApi
            .loadPress(press)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        //
        // update: function (pressId, press) {
        //   return frispoApi
        //     .updatePress(models.currentEvent.evenId, pressId, press)
        //     .then(resPipe.parseResponse)
        //     .then(resPipe.unwrapArray)
        //     .then(resPipe.camelize)
        //     .then(resPipe.updatePress)
        //     .then(resPipe.memorizeCurrentEvent)
        //     .then(resPipe.memorizeEvents)
        //     .catch(errorManager);
        // },

        destroy: function (press) {
          return frispoApi
            .destroyPress(models.currentEvent.evenId, press.presId)
            .then(resPipe.parseResponse)
            .then(function () {
              return press;
            })
            .then(resPipe.removePress)
            .then(resPipe.memorizeCurrentEvent)
            .then(resPipe.memorizeEvents)
            .catch(errorManager);
        },

        form2Press: function (formData) {
          var pressData = {};
          if(angular.isDefined(formData.name)) pressData.press_name = formData.name;
          if(angular.isDefined(formData.status) && angular.isObject(formData.status)) pressData.press_stato = formData.status.id;
          if(angular.isDefined(formData.ranking)) pressData.press_ranking = formData.ranking.id;
          if(angular.isDefined(formData.matches)) pressData.press_matches = formData.matches.id;
          if(angular.isDefined(formData.scorers)) pressData.press_scorers = formData.scorers.id;
          if(angular.isDefined(formData.yellowcards)) pressData.press_yellowcards = formData.yellowcards.id;
          if(angular.isDefined(formData.diffide)) pressData.press_diffide = formData.diffide.id;
          if(angular.isDefined(formData.squalifications)) pressData.press_squalifications = formData.squalifications.id;
          if(angular.isDefined(formData.amends)) pressData.press_amends = formData.amends.id;
          if(angular.isArray(formData.events)){
            pressData.press_events = [];
            angular.forEach(formData.events, function (event) {
              pressData.press_events.push({
                pres_even_id: ''+event.evenId
              });
            });
          }
          return pressData;
        }
      };

      return press;
   });

'use strict';

angular.module('frispo')
    /**
     * Event models manager
     */
    .factory('players', function(frispoApi, errorManager, resPipe, models) {
        var players = {
            getTokenS3: function() {
                return frispoApi
                    .getTokenS3('com.codeploy.frispoleague/player/import')
                    .catch(errorManager);
            },
            importPlayers: function(filename) {
                return frispoApi
                    .importPlayers(models.currentEvent.evenId, models.currentEvent.currentTeam.teamId, filename)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(resPipe.memorizeCurrentEvent)
                    .catch(errorManager)
            },
            destroyImport: function(importId) {
                return frispoApi
                    .removeImportScorer(models.currentEvent.evenId, importId)
                    .then(resPipe.parseResponse)
                    .catch(errorManager);
            }
        };
        return players;
    });
'use strict';

angular.module('frispo')
  /**
  * Models cache
  */
  .factory('models', function (longTermMemory) {

    var models = {
       reset: function () {
         models.events = longTermMemory.remember('events') || [];
         models.regions = longTermMemory.remember('regions') || [];
         models.currentUser = longTermMemory.remember('currentUser') || {};
         models.currentEvent = models.events.length>0 && longTermMemory.remember('currentEvent') || undefined;
       }
    };

    models.reset();

    return models;
  });

'use strict';

angular.module('frispo')
    /**
     * Matches models manager
     */
    .factory('matches', function(frispoApi, errorManager, resPipe, models, utils, $q) {

        var matches = {

            /**
             * Create a matches calendar for an event
             */
            createCalendar: function(eventId) {
                return frispoApi
                    .createMatchesCalendar(eventId)
                    .catch(errorManager);
            },

            /**
             * Export a matches calendar for an event
             */
             exportCalendar: function(eventId) {
                return frispoApi
                    .exportCalendar(eventId)
                    .catch(errorManager);
            },

            /**
             * Export a matches calendar for an event
             */
             importCalendar: function(eventId, payload) {
                return frispoApi
                    .importCalendar(eventId, payload)
                    .catch(errorManager);
            },

            /**
             * List the matches for a day of an event
             */
            list: function() {
                return frispoApi
                    .listMatches(models.currentEvent.evenId, models.currentEvent.currentDay.matcDayId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(resPipe.injectMatchDefaults)
                    .then(resPipe.updateMatches)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * List the scorers of a match
             */
            listScorers: function(matchId) {
                return frispoApi
                    .listMatchScorers(models.currentEvent.evenId, matchId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .then(function(res) {
                        return resPipe.updateMatchScorers(matchId, res);
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * List the weeks of a year
             */
            getWeeksOfYear: function(year) {
                return frispoApi
                    .getWeeksOfYear(year)
                    .then(resPipe.parseResponse)
                    .then(resPipe.camelize)
                    .catch(errorManager);
            },

            /**
             * Create a scorer
             */
            createScorer: function(matchId, scorerData, scorersKey) {
                return frispoApi
                    .createScorer(models.currentEvent.evenId, matchId, scorerData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(function(res) {
                        resPipe.insertScorer(matchId, res, scorersKey);
                        return res;
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Create a card
             */
            createCard: function(matchId, cardData, cardsKey) {
                return frispoApi
                    .createCard(models.currentEvent.evenId, matchId, cardData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.injectCardsDefaults)
                    .then(function(res) {
                        resPipe.insertCard(matchId, res, cardsKey);
                        return res;
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Create an amend
             */
            createAmend: function(matchId, amendData, amendsKey) {
                return frispoApi
                    .createAmend(models.currentEvent.evenId, matchId, amendData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.injectAmendsDefaults)
                    .then(function(res) {
                        resPipe.insertAmend(matchId, res, amendsKey);
                        return res;
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Destroy a scorer
             */
            destroyScorer: function(matchId, playerId, scorersKey) {
                return frispoApi.destroyScorerMatch(models.currentEvent.evenId, playerId, matchId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return resPipe.removeScorer(matchId, playerId, scorersKey);
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Destroy a card
             */
            destroyMatchCard: function(matchId, cardId, cardsKey) {
                return frispoApi.destroyCard(models.currentEvent.evenId, matchId, cardId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return resPipe.removeMatchCard(matchId, cardId, cardsKey);
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Destroy an amend
             */
            destroyMatchAmend: function(matchId, amendId, amendsKey) {
                return frispoApi.destroyAmend(models.currentEvent.evenId, matchId, amendId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return resPipe.removeMatchAmend(matchId, amendId, amendsKey);
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Destroy a card
             */
            destroyEventCard: function(matchId, playerId, cardId, cardsKey, cardMatchKey) {
                return frispoApi
                    .destroyCard(models.currentEvent.evenId, matchId, cardId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return resPipe.removeEventCard(matchId, playerId, cardId, cardsKey, cardMatchKey);
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Destroy an amend
             */
            destroyEventAmend: function(matchId, teamId, amendId, amendsKey, amendMatchKey) {
                return frispoApi
                    .destroyAmend(models.currentEvent.evenId, matchId, amendId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return resPipe.removeEventAmend(matchId, teamId, amendId, amendsKey, amendMatchKey);
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Update a card
             */
            updateEventCard: function(matchId, playerId, cardId, cardsKey, cardMatchKey, cardData) {
                return frispoApi
                    .updateCard(models.currentEvent.evenId, matchId, cardId, cardData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.injectCardsDefaults)
                    .then(function(res) {
                        return resPipe.updateEventCard(matchId, playerId, cardId, cardsKey, cardMatchKey, res);
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Update a card
             */
            updateEventAmend: function(matchId, teamId, cardId, cardsKey, cardMatchKey, cardData) {
                return frispoApi
                    .updateAmend(models.currentEvent.evenId, matchId, cardId, cardData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.injectAmendsDefaults)
                    .then(function(res) {
                        return resPipe.updateEventAmend(matchId, teamId, cardId, cardsKey, cardMatchKey, res);
                    })
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Update a match
             */
            update: function(matchDayId, matchData) {
                return frispoApi
                    .updateMatch(models.currentEvent.evenId, matchData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.injectMatchDefaults)
                    .then(function(res) {
                        res.matcDayId = matchDayId; // Inject the match day ID, as the server returns 0
                        return res;
                    })
                    .then(resPipe.updateMatch)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Update a GIORNATA
             */
            updateGiornata: function(giornataId, giornataData) {
                var mada_number_period = giornataData.mada_number_period;
                delete giornataData["mada_number_period"];
                return frispoApi
                    .updateGiornata(models.currentEvent.evenId, giornataId, giornataData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(function(res) {
                        res.matcYear = giornataData.mada_year;
                        res.matcSettimanaPeriodo = mada_number_period;
                        return res;
                    })
                    .then(resPipe.updateGiornata)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Create a match
             */
            create: function(matchData) {
                return frispoApi
                    .createMatch(models.currentEvent.evenId, models.currentEvent.currentDay.matcDayId, matchData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.log)
                    .catch(errorManager);
            },

            /**
             * Create a tournament group
             */
             createGroup: function(groupData) {
              return frispoApi
                  .createGroup(models.currentEvent.evenId, groupData)
                  .then(resPipe.parseResponse)
                  .then(resPipe.unwrapArray)
                  .then(resPipe.camelize)
                  .then(resPipe.insertGroup)
                  .then(resPipe.memorizeCurrentEvent)
                  .then(resPipe.memorizeEvents)
                  .catch(errorManager);
          },

          /**
             * List tournament groups
             */
           listGroups: function() {
            return frispoApi
                .listGroups(models.currentEvent.evenId)
                .then(resPipe.parseResponse)
                .then(resPipe.camelize)
                .catch(errorManager);
        },

            /**
             * Create a match day
             */
            createDay: function(dayData) {
                return frispoApi
                    .createDay(models.currentEvent.evenId, dayData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.insertMatchDay)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Destroy a match
             */
            destroy: function(matchData) {
                return frispoApi
                    .destroyMatch(models.currentEvent.evenId, models.currentEvent.currentDay.matcDayId, matchData.matcId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return matchData;
                    })
                    .then(resPipe.removeMatch)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Destroy giornata
             */
            destroyGiornata: function(giornata) {
                return frispoApi
                    .destroyGiornata(models.currentEvent.evenId, giornata.matcDayId)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return giornata;
                    })
                    .then(resPipe.removeMatchGiornata)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Destroy giornata
             */
            updateDateMatchFromWeek: function() {
                return frispoApi
                    .updateDateMatchFromWeek(models.currentEvent.evenId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.memorizeCurrentEvent)
                    .catch(errorManager);
            },

            /**
             * Show a match
             */
            show: function(matchId) {
                return frispoApi
                    .showMatch(models.currentEvent.evenId, matchId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.camelize)
                    .then(resPipe.updateMatch)
                    .then(resPipe.injectMatchDefaults)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },

            /**
             * Translate data from a match form into a matchData object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the matchData object
             */
            form2Match: function(formData) {
                var matchData = {};
                var matchTime = utils.str2Time(formData.time);
                var matchDate = utils.str2Date(formData.date);
                if (angular.isDefined(formData.matchId)) matchData.matc_id = formData.matchId;
                if (formData.teamA && angular.isDefined(formData.teamA.teamId)) matchData.matc_team_id_a = formData.teamA.teamId;
                if (formData.teamB && angular.isDefined(formData.teamB.teamId)) matchData.matc_team_id_b = formData.teamB.teamId;
                if (angular.isDefined(formData.scoreA)) matchData.matc_goal_team_a = formData.scoreA;
                if (angular.isDefined(formData.scoreB)) matchData.matc_goal_team_b = formData.scoreB;
                if (angular.isString(formData.dateExpected)) matchData.matc_date_expected = formData.dateExpected;
                if (angular.isString(matchDate)) matchData.matc_date_match = matchDate;
                if (angular.isString(matchTime)) matchData.matc_time = matchTime;
                if (angular.isString(formData.address)) matchData.matc_address = formData.address;
                if (formData.played && angular.isDefined(formData.played.value)) matchData.matc_flg_play = formData.played.value;
                if (angular.isDefined(formData.shootoutA)) matchData.matc_shootout_team_a = formData.shootoutA;
                if (angular.isDefined(formData.shootoutB)) matchData.matc_shootout_team_b = formData.shootoutB;
                if (angular.isString(formData.place)) matchData.matc_place = formData.place;
                if (angular.isDefined(formData.girone)) matchData.matc_name_groups = formData.girone.gironeName;
                return $q.resolve(matchData);
            },

            /**
             * Translate data from a match form into a matchData object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the matchData object
             */
            form2Giornata: function(formData) {
                var giornataData = {};
                if (angular.isDefined(formData.matcDayName)) giornataData.mada_name = formData.matcDayName;
                if (angular.isDefined(formData.matcDayName)) giornataData.mada_description = formData.matcDayName;
                if (angular.isDefined(formData.year)) giornataData.mada_year = formData.year;
                if (angular.isDefined(formData.weekOfYear)) giornataData.mada_number = formData.weekOfYear.number;
                if (angular.isDefined(formData.weekOfYear)) giornataData.mada_number_period = formData.weekOfYear.period;
                if (angular.isDefined(formData.update_ranking))  {
                    if (formData.update_ranking)
                      giornataData.mada_update_ranking = 1;
                    else giornataData.mada_update_ranking = 0;
                }
                return $q.resolve(giornataData);
            },

            /**
             * Translate data from a scorer form into a scorerData object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the scorerData object
             */
            form2Scorer: function(formData) {
                var scorerData = {};
                if (angular.isDefined(formData.teamId)) scorerData.team_id = '' + formData.teamId;
                if (angular.isDefined(formData.playId)) scorerData.play_id = '' + formData.playId;
                else scorerData.play_id = '0';
                if (angular.isDefined(formData.goals)) scorerData.goal = formData.goals;
                if (angular.isDefined(formData.name)) scorerData.play_name = formData.name;
                if (angular.isDefined(formData.surname)) scorerData.play_surname = formData.surname;
                return $q.resolve(scorerData);
            },

            /**
             * Translate data from a card form into a card object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the cardData object
             */
            form2CardMatch: function(formData) {
                var cardData = {};
                if (angular.isDefined(formData.playId)) cardData.play_id = formData.playId;
                if (angular.isDefined(formData.typeSqualifications)) cardData.flg_cards = formData.typeSqualifications.value;
                if (angular.isDefined(formData.daySqualifications)) cardData.day_squalification = formData.daySqualifications.value;
                if (angular.isDefined(formData.note)) cardData.note = formData.note;
                if (angular.isDefined(formData.squalificationStatus)) cardData.squalification_status = formData.squalificationStatus.value;
                return $q.resolve(cardData);
            },

            /**
             * Translate data from a amend form into a amend object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the amendData object
             */
            form2AmendMatch: function(formData) {
                var amendData = {};
                if (angular.isDefined(formData.teamId)) amendData.team_id = formData.teamId;
                if (angular.isDefined(formData.amenDescription)) amendData.amen_description = formData.amenDescription;
                if (angular.isDefined(formData.amenPoints)) amendData.amen_points = formData.amenPoints;
                if (angular.isDefined(formData.amenEuro)) amendData.amen_euro = formData.amenEuro;
                if (angular.isDefined(formData.amenStatus)) amendData.amen_status = formData.amenStatus.value + '';
                return $q.resolve(amendData);
            },

            /**
             * Translate data from a card form into a cardData object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the cardData object
             */
            form2Card: function(formData) {
                var cardData = {};
                if (angular.isDefined(formData.teamId)) cardData.team_id = '' + formData.teamId;
                if (angular.isDefined(formData.playId)) cardData.play_id = '' + formData.playId;
                else cardData.play_id = '0';
                if (angular.isDefined(formData.cardType) && angular.isDefined(formData.cardType.id)) cardData.flg_cards = '' + formData.cardType.id;
                if (angular.isDefined(formData.disqualificationDays)) cardData.day_squalification = '' + formData.disqualificationDays;
                if (angular.isDefined(formData.note)) cardData.note = '' + formData.note;
                if (angular.isDefined(formData.name)) cardData.play_name = '' + formData.name;
                if (angular.isDefined(formData.surname)) cardData.play_surname = '' + formData.surname;
                return $q.resolve(cardData);
            },

            /**
             * Translate data from an amend form into a amendData object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the amendData object
             */
            form2Amend: function(formData) {
                var amendData = {};
                if (angular.isDefined(formData.teamId)) amendData.amen_team_id = +formData.teamId;
                if (angular.isDefined(formData.description)) amendData.amen_description = '' + formData.description;
                if (angular.isDefined(formData.points)) amendData.amen_points = '' + formData.points;
                if (angular.isDefined(formData.euro)) amendData.amen_euro = '' + formData.euro;
                return $q.resolve(amendData);
            },

            /**
             * Translate data from a Day form into an dayData object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the dayData object
             */
            form2Day: function(formData) {
                var dayData = {};
                if (angular.isDefined(formData.name)) dayData.mada_name = formData.name;
                if (angular.isDefined(formData.desc)) dayData.mada_description = formData.desc;
                return $q.resolve(dayData);
            },

            /**
             * Translate data from a Group form into an groupData object
             * @param  {Object} formData The form input
             * @return {Promise}         A promise fulfilled with the groupData object
             */
            form2Girone: function(formData) {
              var groupData = {};
              if (angular.isDefined(formData.name)) groupData.girone_name = formData.name;
              return $q.resolve(groupData);
          }

        };

        return matches;
    });

'use strict';

angular.module('frispo')
    /**
     * Event models manager
     */
    .factory('iscrizioni', function(frispoApi, errorManager, resPipe, $q, models) {

        var iscrizioni = {
            /**
             * List the iscrizioni of the current event
             */
            list: function() {
                return frispoApi
                    .listIscrizioni(models.currentEvent.evenId)
                    .then(resPipe.parseResponse)
                    .then(resPipe.updateIscrizioni)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager)
            },
            form2Iscrizione: function(formData) {
                var iscrizioneData = {};
                if (angular.isDefined(formData.note)) iscrizioneData.note = formData.note;
                return $q.resolve(iscrizioneData);
            },
            updateIscrizione: function(iscrizioneId, iscrizioneData) {
                return frispoApi
                    .updateIscrizione(models.currentEvent.evenId, iscrizioneId, iscrizioneData)
                    .then(resPipe.parseResponse)
                    .then(resPipe.unwrapArray)
                    .then(resPipe.updateIscrizione)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            },
            destroyIscrizione: function(iscrizione) {
                return frispoApi
                    .destroyIscrizione(models.currentEvent.evenId, iscrizione.subscribe_id)
                    .then(resPipe.parseResponse)
                    .then(function() {
                        return iscrizione;
                    })
                    .then(resPipe.removeIscrizione)
                    .then(resPipe.memorizeCurrentEvent)
                    .then(resPipe.memorizeEvents)
                    .catch(errorManager);
            }
        };

        return iscrizioni;
    });
'use strict';

angular.module('frispo')
  /**
   * Event models manager
   */
   .factory('invitations', function (frispoApi, errorManager, resPipe, models) {

      var invitations = {
        /**
         * List the invitations sent by current user
         */
        listSent: function () {
          return frispoApi
            .listSentInvitations()
            .then(resPipe.parseResponse)
            .then(resPipe.camelize)
            .then(resPipe.injectInvitationsDefaults)
            .then(resPipe.updateSentInvitations)
            .then(resPipe.memorizeCurrentUser)
            .catch(errorManager);
        },

        /**
         * List the invitations sent by current user
         */
        listReceived: function () {
          return frispoApi
            .listReceivedInvitations()
            .then(resPipe.parseResponse)
            .then(resPipe.camelize)
            .then(resPipe.injectInvitationsDefaults)
            .then(resPipe.updateReceivedInvitations)
            .then(resPipe.memorizeCurrentUser)
            .catch(errorManager);
        },

        create: function (invitationData) {
          return frispoApi
            .createInvitation(invitationData)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        destroy: function (invitationData) {
          var invModel = {
            invitation_id: '' + invitationData.invitationId,
            mail_guest: invitationData.mailGuest,
            even_id: invitationData.evenId,
            status: '3' // status: 3 -> cancellato
          }
          return frispoApi
            .updateInvitation(invModel)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        accept: function (invitationData) {
          var invModel = {
            invitation_id: '' + invitationData.invitationId,
            mail_guest: invitationData.mailGuest,
            even_id: invitationData.evenId,
            status: '1' // status: 1 -> accettato
          }
          return frispoApi
            .updateInvitation(invModel)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        decline: function (invitationData) {
          var invModel = {
            invitation_id: '' + invitationData.invitationId,
            mail_guest: invitationData.mailGuest,
            even_id: invitationData.evenId,
            status: '2' // status: 2 -> rifiutato
          }
          return frispoApi
            .updateInvitation(invModel)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        form2Invitation: function (formData) {
          var invitationData = {};
          if(angular.isArray(formData.events) && angular.isDefined(formData.guestEmail)){
            invitationData.extra = [];
            angular.forEach(formData.events, function (event) {
              invitationData.extra.push({
                mail_invitingmember: models.currentUser.email,
                mail_guest: formData.guestEmail,
                even_id: event.evenId
              })
            });
          }
          return invitationData;
        }

        // show: function (invitationId) {
        //   return frispoApi
        //     .showTeam(models.currentEvent.evenId, invitationId)
        //     .then(resPipe.parseResponse)
        //     .then(resPipe.unwrapArray)
        //     .then(resPipe.camelize)
        //     .then(resPipe.updateTeam)
        //     .then(resPipe.memorizeCurrentEvent)
        //     .then(resPipe.memorizeEvents)
        //     .catch(errorManager);
        // },
        //
        // create: function (invitation) {
        //   return frispoApi
        //     .createTeam(models.currentEvent.evenId, invitation)
        //     .then(resPipe.parseResponse)
        //     .catch(errorManager);
        // },
        //
        // update: function (invitationId, invitation) {
        //   return frispoApi
        //     .updateTeam(models.currentEvent.evenId, invitationId, invitation)
        //     .then(resPipe.parseResponse)
        //     .then(resPipe.unwrapArray)
        //     .then(resPipe.camelize)
        //     .then(resPipe.updateTeam)
        //     .then(resPipe.memorizeCurrentEvent)
        //     .then(resPipe.memorizeEvents)
        //     .catch(errorManager);
        // },
        //
        // destroy: function (invitation) {
        //   return frispoApi
        //     .destroyTeam(models.currentEvent.evenId, invitation.invitationId)
        //     .then(resPipe.parseResponse)
        //     .then(function () {
        //       return invitation;
        //     })
        //     .then(resPipe.removeTeam)
        //     .then(resPipe.memorizeCurrentEvent)
        //     .then(resPipe.memorizeEvents)
        //     .catch(errorManager);
        // },
        //
        // /**
        //  * Create a group of invitations and add it to an event
        //  */
        // addGroup: function (invitationsData) {
        //   return frispoApi
        //     .addGroupTeams(models.currentEvent.evenId, invitationsData)
        //     .then(resPipe.parseResponse)
        //     .then(resPipe.unwrapArray)
        //     .then(resPipe.camelize)
        //     .catch(errorManager);
        // },
        //
        // listPlayers: function (invitationId) {
        //   return frispoApi
        //     .listPlayers(invitationId || models.currentEvent.currentTeam.invitationId)
        //     .then(resPipe.parseResponse)
        //     .then(resPipe.camelize)
        //     .then(resPipe.updatePlayers)
        //     .then(resPipe.memorizeCurrentEvent)
        //     .then(resPipe.memorizeEvents)
        //     .catch(errorManager);
        // },
        //
        // updatePlayer: function (playerId, playerData) {
        //   return frispoApi
        //     .updatePlayer(models.currentEvent.currentTeam.invitationId, playerId, playerData)
        //     .then(resPipe.parseResponse)
        //     .then(resPipe.unwrapArray)
        //     .then(resPipe.camelize)
        //     .then(resPipe.updatePlayer)
        //     .then(resPipe.memorizeCurrentEvent)
        //     .then(resPipe.memorizeEvents)
        //     .catch(errorManager);
        // },
        //
        // createPlayer: function (playerData) {
        //   return frispoApi
        //     .createPlayer(models.currentEvent.currentTeam.invitationId, playerData)
        //     .then(resPipe.parseResponse)
        //     .then(resPipe.unwrapArray)
        //     .then(resPipe.camelize)
        //     .then(resPipe.insertPlayer)
        //     .then(resPipe.memorizeCurrentEvent)
        //     .then(resPipe.memorizeEvents)
        //     .catch(errorManager);
        // },
        //
        // /**
        //  * Translate data from a invitation form into an invitationsData object
        //  * @param  {Object} formData The form input
        //  * @return {Promise}         A promise fulfilled with the invitationsData object
        //  */
        // form2Teams: function (formData) {
        //   var invitationsData = { extra: [] };
        //   angular.forEach(formData.invitations, function (invitation) {
        //     invitationsData.extra.push(invitations.form2Team(invitation));
        //   });
        //   return $q.resolve(invitationsData);
        // },
        //
        // form2Team: function (formData) {
        //   var invitationData = {};
        //   var invitationTime = utils.str2Time(formData.time);
        //   if(angular.isDefined(formData.captain)) invitationData.invitation_captain = formData.captain;
        //   if(angular.isDefined(invitationTime)) invitationData.invitation_time = invitationTime;
        //   if(angular.isDefined(formData.name)) invitationData.invitation_name = formData.name;
        //   if(angular.isDefined(formData.phone)) invitationData.invitation_mobile_phone = formData.phone;
        //   if(angular.isDefined(formData.place)) invitationData.invitation_place = formData.place;
        //   if(angular.isDefined(formData.round)) invitationData.invitation_groups = formData.round;
        //   if(angular.isDefined(formData.desc)) invitationData.invitation_description = formData.desc;
        //   return invitationData;
        // },
        //
        // form2Player: function (formData) {
        //   var playerData = {};
        //   if(angular.isDefined(formData.name)) playerData.player_name = formData.name;
        //   if(angular.isDefined(formData.surname)) playerData.player_surname = formData.surname;
        //   return $q.resolve(playerData);
        // }
      };

      return invitations;
   });

'use strict';

angular.module('frispo')
  /**
   * Event models manager
   */
  .factory('events', function (frispoApi, errorManager, resPipe, $q, utils) {

    var events = {
      /**
       * Show all events
       */
      list: function () {
        return frispoApi
          .listEvents()
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .then(resPipe.injectEventsDefaults)
          .then(resPipe.updateEvents)
          .then(resPipe.memorizeEvents)
          .catch(errorManager);
      },

      /**
       * Show all events managed by a user
       */
      listManaged: function () {
        return frispoApi
          .listManagedEvents()
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .then(resPipe.injectEventsDefaults)
          .then(resPipe.updateManagedEvents)
          .then(resPipe.memorizeCurrentUser)
          .catch(errorManager);
      },


      getTokenS3: function () {
        return frispoApi
          .getTokenS3('com.codeploy.frispo.image.events')
          .catch(errorManager);
      },

      getTokenS3Locandina: function () {
        return frispoApi
          .getTokenS3('com.codeploy.frispo.events.locandine')
          .catch(errorManager);
      },

      getTokenS3Import: function () {
        return frispoApi
          .getTokenS3('com.codeploy.frispoleague/events/import')
          .catch(errorManager);
      },

      /**
       * Create a new event
       */
      create: function (eventData) {
        return frispoApi
          .createEvent(eventData)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.injectEventsDefaults)
          .then(resPipe.updateCurrentEvent)
          .then(resPipe.memorizeCurrentEvent)
          .catch(errorManager);
      },

      /**
       * Show an event
       */
      show: function (eventId) {
        return frispoApi
          .showEvent(eventId)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.injectEventsDefaults)
          .then(resPipe.updateCurrentEvent)
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .catch(errorManager);
      },

      /**
       * Show the scoreboard of an event
       */
      showScoreboard: function (event) {
        var apiCall;
        // Torneo a gironi
        if (event.evenType === 1) {
          apiCall = frispoApi.showTournamentScoreboard(event.evenId);
        }
        else {
          apiCall = frispoApi.showEventScoreboard(event.evenId);
        }
        return apiCall
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .then(resPipe.updateScoreboard)
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .catch(errorManager);
      },

      getScoreboardOrdreCriteria: function (event) {

        return frispoApi.getScoreboardOrdreCriteria(event.evenId)
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .catch(errorManager);
      },

      postScoreboardOrdreCriteria: function (event, criteria) {

        return frispoApi
          .postScoreboardOrdreCriteria(event.evenId, criteria)
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .catch(errorManager);
      },

      /**
       * Show the scorers of an event
       */
      showScorers: function (eventId) {
        return frispoApi.showScorers(eventId)
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .then(resPipe.updateScorers)
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .catch(errorManager);
      },

      destroyScorerMatch: function (eventId, playerId, scorerMatch) {
        return frispoApi.destroyScorerMatch(eventId, playerId, scorerMatch.matcId)
          .then(resPipe.parseResponse)
          .then(function () {
            return resPipe.removeScorerMatch(playerId, scorerMatch);
          })
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .catch(errorManager);
      },

      updateScorerMatch: function (eventId, matchId, scorerMatchData) {
        return frispoApi.updateScorerMatch(eventId, matchId, scorerMatchData)
          .then(resPipe.parseResponse)
          .then(function () { // Mock a response
            return {
              matcId: matchId,
              matcScorerGoal: scorerMatchData.scor_goal
            };
          })
          .then(function (res) {
            return resPipe.updateScorerMatch(scorerMatchData.scor_play_id, res);
          })
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .catch(errorManager);
      },

      /**
       * Destroy an event
       */
      destroy: function (event) {
        return frispoApi
          .destroyEvent(event)
          .then(resPipe.parseResponse)
          .then(function () {
            return event;
          })
          .then(resPipe.removeEvent)
          .then(resPipe.memorizeEvents)
          .catch(errorManager)
      },

      /**
       * Update an event
       */
      update: function (eventId, eventData) {
        return frispoApi
          .updateEvent(eventId, eventData)
          .then(resPipe.parseResponse)
          .then(resPipe.unwrapArray)
          .then(resPipe.camelize)
          .then(resPipe.injectEventsDefaults)
          .then(resPipe.updateCurrentEvent)
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .catch(errorManager);
      },

      /**
      * List the active regions
      */
      listRegions: function () {
        return frispoApi
          .listRegions()
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .then(resPipe.updateRegions)
          .then(resPipe.memorizeRegions)
          .catch(errorManager);
      },

      /**
       * List the yellow cards for the event
       */
      listYellows: function (eventId) {
        return frispoApi
          .listYellowCards(eventId)
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .then(resPipe.injectEventCardsDefaults)
          .then(resPipe.updateYellows)
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .then(resPipe.log)
          .catch(errorManager)
      },

      /**
       * List the diffides for the event
       */
      listDiffides: function (eventId) {
        return frispoApi
          .listDiffides(eventId)
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .then(resPipe.injectEventCardsDefaults)
          .then(resPipe.updateDiffides)
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .then(resPipe.log)
          .catch(errorManager)
      },

      /**
       * List the squalifications for the event
       */
      listSqualifications: function (eventId) {
        return frispoApi
          .listSqualifications(eventId)
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .then(resPipe.injectEventCardsDefaults)
          .then(resPipe.updateSqualifications)
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .then(resPipe.log)
          .catch(errorManager)
      },

      /**
       * List the amends for the event
       */
      listAmends: function (eventId) {
        return frispoApi
          .listAmends(eventId)
          .then(resPipe.parseResponse)
          .then(resPipe.camelize)
          .then(resPipe.injectEventCardsDefaults)
          .then(resPipe.updateAmends)
          .then(resPipe.memorizeCurrentEvent)
          .then(resPipe.memorizeEvents)
          .then(resPipe.log)
          .catch(errorManager)
      },

      /**
       * Translate data from an event form into an eventData object
       * @param  {Object} formData The form input
       * @return {Promise}         A promise fulfilled with the eventData object
       */
      form2Event: function (formData) {
        var eventData = {};
        var dateRange = utils.str2Date(formData.dates);
        if (angular.isDefined(formData.name)) eventData.even_name = formData.name;
        if (angular.isDefined(formData.evenName)) eventData.even_name = formData.evenName;
        if (angular.isDefined(formData.even_flg_subscribe)) eventData.even_flg_subscribe = formData.even_flg_subscribe.id;
        if (angular.isDefined(formData.evenPointsWin)) eventData.even_points_win = formData.evenPointsWin;
        if (angular.isDefined(formData.evenPointsLose)) eventData.even_points_lose = formData.evenPointsLose;
        if (angular.isDefined(formData.evenPointsSame)) eventData.even_points_same = formData.evenPointsSame;
        if (angular.isDefined(formData.desc)) eventData.even_description = formData.desc;
        if (angular.isDefined(formData.evenDescription)) eventData.even_description = formData.evenDescription;
        if (angular.isDefined(formData.email)) eventData.even_email = formData.email;
        if (angular.isDefined(formData.address)) eventData.even_address = formData.address;
        if (angular.isDefined(formData.evenUrlLogo)) eventData.even_url_logo = formData.evenUrlLogo;
        if (angular.isDefined(formData.evenLocandina)) eventData.even_locandina = formData.evenLocandina;
        if (angular.isDefined(formData.type)) {
          if (angular.isObject(formData.type)) {
            eventData.even_type = '' + formData.type.id;
          }
          else {
            eventData.even_type = '' + formData.type;
          }
        }
        if (angular.isDefined(formData.formula)) {
          if (angular.isObject(formData.formula)) {
            eventData.even_formula = '' + formData.formula.id;
          }
          else {
            eventData.even_formula = '' + formData.formula;
          }
        }
        if (angular.isDefined(formData.evenNote)) eventData.even_note = formData.evenNote;
        if (angular.isDefined(formData.evenPremio1)) eventData.even_premio1 = formData.evenPremio1;
        if (angular.isDefined(formData.evenPremio2)) eventData.even_premio2 = formData.evenPremio2;
        if (angular.isDefined(formData.evenPremio3)) eventData.even_premio3 = formData.evenPremio3;
        if (angular.isDefined(formData.evenSitoWeb)) eventData.even_sitoweb = formData.evenSitoWeb;
        if (angular.isDefined(formData.evenQuota)) eventData.even_quota = formData.evenQuota;
        if (angular.isDefined(formData.evenEmail)) eventData.even_email = formData.evenEmail;
        if (angular.isDefined(formData.evenDateStart)) eventData.even_date_start = formData.evenDateStart;
        if (angular.isDefined(formData.evenAddress)) eventData.even_address = formData.evenAddress;
        if (angular.isDefined(formData.evenMobilePhone)) eventData.even_mobile_phone = formData.evenMobilePhone;
        if (angular.isDefined(formData.evenOrganizeBy)) eventData.even_organize_by = formData.evenOrganizeBy;
        if (angular.isDefined(formData.organizer)) eventData.even_organize_by = formData.organizer;
        if (angular.isDefined(formData.telephone)) eventData.even_mobile_phone = formData.telephone;
        if (angular.isDefined(formData.yellowPoints)) eventData.even_yellow_points = formData.yellowPoints;
        if (angular.isDefined(formData.redPoints)) eventData.even_red_points = formData.redPoints;
        if (angular.isDefined(formData.yellowDiffide)) eventData.even_yellow_diffide = formData.yellowDiffide;
        if (angular.isDefined(formData.yellowDiffide2)) eventData.even_yellow_diffide2 = formData.yellowDiffide2;
        if (angular.isArray(dateRange) && dateRange.length > 0 && dateRange[0]) eventData.even_date_start = dateRange[0];
        if (angular.isArray(dateRange) && dateRange.length > 1 && dateRange[1]) eventData.even_date_end = dateRange[1];
        if (formData.region && formData.region.regiId) eventData.regi_id = formData.region.regiId;
        // TODO: remove this line: it's a mock
        else eventData.regi_id = 1;
        if (formData.currentDay && formData.currentDay.matcDayId) eventData.even_day_active = formData.currentDay.matcDayId;
        return $q.resolve(eventData);
      }

    };

    return events;
  });

'use strict';

angular.module('frispo')
  .factory('arbiters', function(frispoApi, errorManager, resPipe, $q, models) {

        var arbiters = {

          create: function(arbiterData) {
            return frispoApi
              .createArbiter(models.currentEvent.evenId, arbiterData)
              .then(resPipe.parseResponse)
              .then(resPipe.unwrapArray)
              .catch(errorManager);
          },

          list: function() {
            return frispoApi.listArbiters(models.currentEvent.evenId)
              .then(resPipe.parseResponse)
              .catch(errorManager);
          },

          delete: function(arbiter) {
            return frispoApi.deleteArbiter(arbiter.arbi_id)
              .then(resPipe.parseResponse)
              .then(resPipe.unwrapArray)
              .catch(errorManager);
          },

          edit: function(arbiId, data) {
            return frispoApi.editArbiter(arbiId, data)
              .then(resPipe.parseResponse)
              .then(resPipe.unwrapArray)
              .catch(errorManager);
          },

          attachToMatch: function(arbiterId, matchId) {
            return frispoApi.attachArbiterToMatch(arbiterId, matchId)
              .then(resPipe.parseResponse)
              .then(resPipe.unwrapArray)
              .catch(errorManager);
          },

          getPageLink: function(arbiterId, matchId) {
            return frispoApi.getArbiterPageLink(arbiterId, matchId)
              .then(resPipe.parseResponse)
              .then(resPipe.unwrapArray);
          },

          getPageDataMail: function(arbiterId, matchId) {
            return frispoApi.getArbiterDataMail(arbiterId, matchId)
              .then(resPipe.parseResponse)
              .then(resPipe.unwrapArray);
          },

          sendEmail: function(arbiterId, matchId) {
            return frispoApi.sendEmailToArbiter(arbiterId, matchId)
              .then(resPipe.parseResponse)
              .then(resPipe.unwrapArray)
              .catch(errorManager);
          },

          sendEmailWithData: function(arbiterId, matchId) {
            return frispoApi.sendEmailToArbiterWithData(arbiterId, matchId)
              .then(resPipe.parseResponse)
              .then(resPipe.unwrapArray)
              .catch(errorManager);
          }
        };

        return arbiters;
    });

'use strict';

angular.module('frispo')
  /**
   * Event models manager
   */
   .factory('adminTeam', function (frispoApi, errorManager, resPipe, models) {

      var adminTeam = {
        /**
         * List the invitations sent by current user
         */
        listSentAdminTeam: function () {
          return frispoApi
            .listSentAdminTeam()
            .then(resPipe.parseResponse)
            .then(resPipe.camelize)
            .then(resPipe.injectInvitationsDefaults)
            .then(resPipe.updateSentInvitations)
            .then(resPipe.memorizeCurrentUser)
            .catch(errorManager);
        },

        /**
         * List the invitations sent by current user
         */
        listReceivedAdminTeam: function () {
          return frispoApi
            .listReceivedInvitations()
            .then(resPipe.parseResponse)
            .then(resPipe.camelize)
            .then(resPipe.injectInvitationsDefaults)
            .then(resPipe.updateReceivedInvitations)
            .then(resPipe.memorizeCurrentUser)
            .catch(errorManager);
        },

        create: function (invitationData) {
          return frispoApi
            .createInvitationAdminTeam(invitationData)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        destroy: function (invitationData) {
          return frispoApi
            .destroyAdminTeam(invitationData.invitationId)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        accept: function (invitationData) {
          var invModel = {
            invitation_id: '' + invitationData.invitationId,
            mail_guest: invitationData.mailGuest,
            even_id: invitationData.evenId,
            status: '1' // status: 1 -> accettato
          }
          return frispoApi
            .updateInvitation(invModel)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        decline: function (invitationData) {
          var invModel = {
            invitation_id: '' + invitationData.invitationId,
            mail_guest: invitationData.mailGuest,
            even_id: invitationData.evenId,
            status: '2' // status: 2 -> rifiutato
          }
          return frispoApi
            .updateInvitation(invModel)
            .then(resPipe.parseResponse)
            .catch(errorManager);
        },

        form2Invitation: function (formData) {
          var invitationData = {};
          if(angular.isDefined(formData)){
            invitationData.extra = [];
            invitationData.extra.push({
              mail_invitingmember: models.currentUser.email,
              mail_guest: formData.guestEmail,
              even_id: formData.events.evenId,
              team_id: formData.teams.teamId
            })
          }
          return invitationData;
        }

      };

      return adminTeam;
   });

(function() {
  'use strict';

  angular
    .module('frispo')
    .run(runBlock);

  /** @ngInject */
  function runBlock(
    $rootScope,
    uiState,
    defaultBodyClasses,
    models,
    users
  ) {
      // Bind the uiState to $rootScope as it's used in index.html
      $rootScope.uiState = uiState;

      // On state change
      var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState) {
        var pms = toState.params || {};
        uiState.bodyClasses = pms.bodyClasses || defaultBodyClasses;
      });

      // Update user info (if logged in)
      if(models.currentUser && models.currentUser.userToken){
        users.info();
      }

      // Destroy watchers
      $rootScope.$on('$destroy', function() {
        stateChangeSuccess();
      });
  }
})();

(function() {
    'use strict';

    angular
        .module('frispo')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        var requireLoggedIn = function($timeout, $state, models) {
            if (!models.currentUser || !models.currentUser.userToken) {
                $timeout(function() {
                    $state.go('main.access');
                });
            }
        };

        $stateProvider
            .state('main', {
                abstract: true,
                templateUrl: 'app/pages/main/main.html'
            })
            .state('main.admin.support', {
                url: '/support',
                templateUrl: 'app/pages/support/support.html',
                onEnter: requireLoggedIn
            })
            .state('main.admin', {
                abstract: true,
                templateUrl: 'app/pages/admin/admin.html',
                onEnter: requireLoggedIn
            })
            .state('main.access', {
                url: '/',
                templateUrl: 'app/pages/access/access.html',
                controller: 'AccessController',
                controllerAs: 'vm'
            })
            .state('main.admin.profile', {
                url: '/profile',
                templateUrl: 'app/pages/profile/profile.html',
                controller: 'ProfileController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.catalog', {
                url: '/catalog',
                templateUrl: 'app/pages/catalog/catalog.html',
                controller: 'CatalogController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.createEvent', {
                url: '/create-event',
                templateUrl: 'app/pages/createEvent/createEvent.html',
                controller: 'CreateEventController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.events', {
                url: '/events',
                templateUrl: 'app/pages/events/events.html',
                controller: 'EventsController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.teams', {
                url: '/teams',
                templateUrl: 'app/pages/teams/teams.html',
                controller: 'TeamsController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.players', {
                url: '/players',
                templateUrl: 'app/pages/players/players.html',
                controller: 'PlayersController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.playersMove', {
              url: '/players/move',
              templateUrl: 'app/pages/playersMove/movePlayers.html',
              controller: 'MovePlayersController',
              controllerAs: 'vm',
              onEnter: requireLoggedIn
          })
          .state('main.admin.arbiter', {
              url: '/arbiter',
              templateUrl: 'app/pages/arbiter/arbiter.html',
              controller: 'ArbiterController',
              controllerAs: 'vm',
              onEnter: requireLoggedIn
          })
            .state('main.admin.calendar', {
                url: '/calendar',
                templateUrl: 'app/pages/calendar/calendar.html',
                controller: 'CalendarController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.giornate', {
                url: '/giornate',
                templateUrl: 'app/pages/giornate/giornate.html',
                controller: 'GiornateController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.scoreboard', {
                url: '/scoreboard',
                templateUrl: 'app/pages/scoreboard/scoreboard.html',
                controller: 'ScoreboardController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.scorers', {
                url: '/scorers',
                templateUrl: 'app/pages/scorers/scorers.html',
                controller: 'ScorersController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.importScorers', {
                url: '/importScorers',
                templateUrl: 'app/pages/importScorers/importScorers.html',
                controller: 'ImportScorersController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.condividiTorneo', {
                url: '/condividiTorneo',
                templateUrl: 'app/pages/condividiTorneo/condividiTorneo.html',
                controller: 'CondividiTorneoController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.iscrizioni', {
                url: '/iscrizioni',
                templateUrl: 'app/pages/iscrizioni/iscrizioni.html',
                controller: 'IscrizioniController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.press', {
                url: '/press',
                templateUrl: 'app/pages/press/press.html',
                controller: 'PressController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.invitations', {
                url: '/invitations',
                templateUrl: 'app/pages/invitations/invitations.html',
                controller: 'InvitationsController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.adminTeam', {
                url: '/adminTeam',
                templateUrl: 'app/pages/adminTeam/adminTeam.html',
                controller: 'AdminTeamController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.disciplinary', {
                url: '/disciplinary',
                templateUrl: 'app/pages/disciplinary/disciplinary.html',
                controller: 'DisciplinaryController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.managerEvents', {
                url: '/manager-events',
                templateUrl: 'app/pages/managerEvents/managerEvents.html',
                controller: 'ManagerEventsController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.admin.managerMatches', {
                url: '/manager-matches',
                templateUrl: 'app/pages/managerMatches/managerMatches.html',
                controller: 'ManagerMatchesController',
                controllerAs: 'vm',
                onEnter: requireLoggedIn
            })
            .state('main.login', {
                url: '/login',
                templateUrl: 'app/pages/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                params: {
                    bodyClasses: 'hold-transition login-page'
                },
                onEnter: function($timeout, $state, uiState) {
                    if (uiState.loggedIn) {
                        $timeout(function() {
                            $state.go('main.access');
                        })
                    }
                }
            })
            .state('main.forgotPassword', {
                url: '/forgot-password',
                templateUrl: 'app/pages/forgotPassword/forgotPassword.html',
                controller: 'ForgotPasswordController',
                controllerAs: 'vm',
                params: {
                    bodyClasses: 'hold-transition login-page'
                },
                onEnter: function($timeout, $state, uiState) {
                    if (uiState.loggedIn) {
                        $timeout(function() {
                            $state.go('main.access');
                        })
                    }
                }
            })
            .state('main.register', {
                url: '/register',
                templateUrl: 'app/pages/register/register.html',
                controller: 'RegisterController',
                controllerAs: 'vm',
                params: {
                    bodyClasses: 'hold-transition register-page'
                },
                onEnter: function($timeout, $state, uiState) {
                    if (uiState.loggedIn) {
                        $timeout(function() {
                            $state.go('main.access');
                        })
                    }
                }
            })
            .state('main.logout', {
                url: '/logout',
                onEnter: function($timeout, users) {
                    $timeout(function() {
                        users.logout();
                    })
                }
            });
        $urlRouterProvider.otherwise('/');
    }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frispo')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('defaultBodyClasses', 'skin-green sidebar-mini')
    .constant('provisioningApiUrlB', 'https://api.frispo.it/api/provisioning/1.0.0/frispo/base/0')
    .constant('provisioningApiUrl', 'https://api.frispo.it/api/provisioning/1.0.0/frispo/base/0/users')
    .constant('eventsApiUrl', 'https://api.frispo.it/api/events/1.0.0/frispo/base/0')
    .constant('teamsApiUrl', 'https://api.frispo.it/api/teams/1.0.0/football/base/0')
    .constant('pressApiUrl', 'https://api.frispo.it/api/press/1.0.0/frispo/base/0')
    .constant('matchesApiUrl', 'https://api.frispo.it/api/matches/1.0.0/football/base/0')
    .constant('cardsApiUrl', 'https://api.frispo.it/api/cards/1.0.0/football/base/0')
    .constant('scorersApiUrl', 'https://api.frispo.it/api/scorers/1.0.0/football/base/0')
    .constant('rankingApiUrl', 'https://api.frispo.it/api/ranking/1.0.0/football/base/0')
    .constant('arbiterApiUrl', 'https://api.frispo.it/api/arbiter/1.0.0/frispo/base/0')
    .constant('userPlanApiUrl', 'https://api.frispo.it/api/users/1.0.0/frispo/base/0')
    .constant('userApiUrl', 'https://api.frispo.it/api/users/1.0.0/frispo/base/0')
    .constant('uploadApiUrl', 'https://api.frispo.it/api/upload/1.0.0/frispo/base/0')
    .constant('cmsApiUrl', 'https://api-manager.codeploy.cloud/api/console/manager/cms')
    .constant('transferPlayerApiUrl', 'https://api.frispo.it/api/transfer/1.0.0/frispo/base/0')
    .constant('authorization', 'Bearer 384d9a07-2c10-3999-9053-74778a0102dd')
    .constant('cmsAuth', 'Basic ' + btoa('codeployManagerP!20:c0d3pl0yManagerP2020!'))
    .constant('anonymousToken', 'CE6B7FD1B38E8395A382A715A6162web');
})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frispo')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('defaultBodyClasses', 'skin-green sidebar-mini')
    .constant('provisioningApiUrlB', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/provisioning/1.0.0/frispo/base/0')
    .constant('provisioningApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/provisioning/1.0.0/frispo/base/0/users')
    .constant('eventsApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/events/1.0.0/frispo/base/0')
    .constant('teamsApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/teams/1.0.0/football/base/0')
    .constant('pressApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/press/1.0.0/frispo/base/0')
    .constant('matchesApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/matches/1.0.0/football/base/0')
    .constant('cardsApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/cards/1.0.0/football/base/0')
    .constant('scorersApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/scorers/1.0.0/football/base/0')
    .constant('rankingApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/ranking/1.0.0/football/base/0')
    .constant('arbiterApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/arbiter/1.0.0/frispo/base/0')
    .constant('userPlanApiUrl', 'https://api-web.codeploy.cloud/api/web/public/status/v2')
    .constant('userApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/users/1.0.0/frispo/base/0')
    .constant('uploadApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/upload/1.0.0/frispo/base/1')
    .constant('transferPlayerApiUrl', 'https://8ff9tp6k7k.execute-api.eu-west-1.amazonaws.com/dev/api/transfer/1.0.0/frispo/base/0')
    .constant('managerCoreUrlTmp', 'https://api-manager.codeploy.cloud/api/console/')
    .constant('s3LogoUrl', 'https://s3.eu-west-1.amazonaws.com/com.iaetp.frispo/frispo-logo/')
    .constant('authorization', 'Bearer 384d9a07-2c10-3999-9053-74778a0102dd')
    .constant('anonymousToken', 'CE6B7FD1B38E8395A382A715A6162web');
})();

(function() {
  'use strict';

  angular
    .module('frispo')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $animateProvider, $locationProvider, ezfbProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Animate only elements with class "animate"
    $animateProvider.classNameFilter(/animate/);

    // Set options for toastr
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 5000;
    toastrConfig.positionClass = 'toast-top-center';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = false;

    //Removes '#' from the URL
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');

    // Configure facebook
    ezfbProvider.setLocale('it_IT');
    ezfbProvider.setInitParams({
      appId: '1025958327498737'
    });
  }

})();

angular.module("frispo").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/frispoHeader/frispoHeader.html","<header class=\"main-header frispo-header\"><a ui-sref=main.admin.events class=logo><!-- mini logo for sidebar mini 50x50 pixels --> <span class=logo-mini><img src=/assets/images/logo-64.png> </span><!-- logo for regular state and mobile devices --> <span class=logo-lg><img src=/assets/images/logo-title-64.png></span></a><nav class=\"navbar navbar-static-top\" role=navigation><!-- Sidebar toggle button--> <a href=# class=sidebar-toggle data-toggle=offcanvas role=button><span class=sr-only>Toggle navigation</span></a><div id=selector-wrapper><!-- Tendina di selezione dell\'evento\' --><div class=btn-group><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><span>Torneo</span><span class=separator>|</span> <span class=\"selectionLeft text-truncate\">{{ header.getCurrentEvent() ? header.getCurrentEvent().evenName : \'nessuna selezione\' }}</span> <span class=caret></span></button><ul class=dropdown-menu><li ng-if=\"header.getEventList().length === 0\" class=text-center><a href=javascript:void(0) disabled><i>Non ci sono eventi</i></a></li><li ng-repeat=\"event in header.getEventList()\"><a href=javascript:void(0) class=text-truncate ng-click=header.selectEvent(event)>{{ event.evenName }}</a></li></ul></div><!-- Tendina di selezione della giornata --><div class=btn-group><button ng-disabled=!header.getCurrentEvent() class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><span>Giornata corrente</span><span class=separator>|</span> <span class=\"selection text-truncate\">{{ header.getCurrentDay().matcDayName ? header.getCurrentDay().matcDayName : \'nessuna selezione\' }}</span> <span class=caret></span></button><ul class=dropdown-menu><li ng-if=\"!header.getCurrentEvent().matchDays ||\n                      header.getCurrentEvent().matchDays.length === 0\" class=text-center><a href=javascript:void(0) disabled><i>Non ci sono giornate</i></a></li><li ng-repeat=\"day in header.getCurrentEvent().matchDays\"><a href=javascript:void(0) class=text-truncate ng-click=header.selectCurrentMatchDay(day)>{{ day.matcDayName }}</a></li></ul></div></div><!-- Navbar Right Menu --><div class=navbar-custom-menu><ul class=\"nav navbar-nav\"><!--li class=\"dropdown user user-menu\">\n                    <a ui-sref=\"main.admin.catalog\">\n                        <span>Licenze e Piani</span>\n                        <i class=\"fa fa-credit-card\" aria-hidden=\"true\"></i>\n                    </a>\n                </li--><li class=\"dropdown user user-menu\"><a ui-sref=main.admin.catalog><span>Cambia piano</span></a></li><!-- <li class=\"dropdown user user-menu\">\n                    <a href=\"https://www.youtube.com/channel/UCSv5YgAU0Pf2uaTDQo4hC9Q/videos?&ab_channel=FrispoSportisFriendship\">\n                        <span>Videoguide</span>\n                        <img src=\"{{ header.getUser().image || \'/assets/images/youtube.png\' }}\" width=\"18%\" height=\"15%\" />\n                    </a>\n                </li> --><li class=\"dropdown user user-menu\"><a href=# class=dropdown-toggle data-toggle=dropdown aria-expanded=false><i class=\"fa fa-user\" aria-hidden=true></i></a><ul class=dropdown-menu><!-- User image --><li class=user-header><img class=img-circle alt=\"User Image\" src=\"{{ header.getUser().image || \'/assets/images/logo-64.png\' }}\" ng-class=\"{\'default-user-img\': !header.getUser().image}\"><p>{{ header.getUser().displayName }}</p></li><!-- Menu Footer--><li class=user-footer><div class=pull-left><a ui-sref=main.admin.profile class=\"btn btn-default btn-flat\">PROFILO</a></div><div class=pull-right><a ui-sref=main.logout class=\"btn btn-default btn-flat\">ESCI</a></div></li></ul></li></ul></div></nav></header>");
$templateCache.put("app/components/frispoFooter/frispoFooter.html","<footer class=main-footer><div class=\"pull-right hidden-xs\"><b>Version</b> 1.0.0</div><strong>Copyright © 2014-2016 <a href=http://codeploy.it>Codeploy srls a socio unico</a>.</strong> All rights reserved.</footer>");
$templateCache.put("app/components/frispoSidebar/frispoSidebar.html","<div class=main-sidebar><!-- Inner sidebar --><div class=sidebar><!-- Sidebar Menu --><ul class=sidebar-menu><!-- SECTION Main Menu --><li class=header>Funzionalità</li><!-- Eventi --><li class=\"treeview active\"><a href=#><i class=\"fa fa-star\"></i> <span>Tornei</span> <i class=\"fa fa-angle-left pull-right\"></i></a><ul class=treeview-menu><!-- style=\"display: block;\" --><!-- Crea Evento --><li ng-class=\"{active: sidebar.state.current.name === \'main.admin.createEvent\'}\"><a ui-sref=main.admin.createEvent><i class=\"fa fa-plus\"></i> Crea torneo</a></li><!-- Visualizza Eventi --><li ng-class=\"{active: sidebar.state.current.name === \'main.admin.events\'}\"><a ui-sref=main.admin.events><i class=\"fa fa-chevron-down\"></i> Gestisci tornei</a></li></ul></li><!-- !Eventi --><!-- Squadre & Giocatori --><li class=treeview><a href=#><i class=\"fa fa-users\" aria-hidden=true></i> <span>Squadre &amp; Giocatori</span> <i class=\"fa fa-angle-left pull-right\"></i></a><ul class=treeview-menu><!-- Squadre --><li ng-class=\"{active: sidebar.state.current.name === \'main.admin.teams\'}\"><a ui-sref=main.admin.teams><i class=\"fa fa-flag\"></i> Squadre</a></li><!--li ng-class=\"{active: sidebar.state.current.name === \'main.admin.support\'}\">\n            <a ui-sref=\"main.admin.support\">\n              <i class=\"fa fa-flag\">\n              </i> support\n            </a>\n          </li--><!-- Giocatori --><li ng-class=\"{active: sidebar.state.current.name === \'main.admin.players\'}\"><a ui-sref=main.admin.players><i class=\"fa fa-user\"></i> Giocatori</a></li><!-- Sposta Giocatori --><li ng-class=\"{active: sidebar.state.current.name === \'main.admin.playersMove\'}\"><a ui-sref=main.admin.playersMove><i class=\"fa fa-arrows\"></i> Sposta Giocatori</a></li></ul></li><!-- !Squadre & Giocatori --><!-- Calendario & Partite --><li class=treeview><a href=#><i class=\"fa fa-users\" aria-hidden=true></i> <span>Calendario &amp; Partite</span> <i class=\"fa fa-angle-left pull-right\"></i></a><ul class=treeview-menu><li ng-class=\"{active: sidebar.state.current.name === \'main.admin.calendar\'}\"><a ui-sref=main.admin.calendar><i class=\"fa fa-calendar\" aria-hidden=true></i> <span>Calendario &amp; Partite</span></a></li><li><a ui-sref=main.admin.giornate ng-class=\"{active: sidebar.state.current.name === \'main.admin.giornate\'}\"><i class=\"fa fa-calendar-o\" aria-hidden=true></i> <span>Giornate</span></a></li><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.scoreboard\'}\"><a ui-sref=main.admin.scoreboard><i class=\"fa fa-trophy\" aria-hidden=true></i> <span>Classifica</span></a></li></ul></li><!-- !Calendario & Partite --><!-- Giornate --><!--li class=\"treeview\" ng-class=\"{active: sidebar.state.current.name === \'main.admin.giornate\'}\">\n        <a ui-sref=\"main.admin.giornate\">\n          <i class=\"fa fa-calendar-o\" aria-hidden=\"true\"></i> <span>Giornate</span>\n        </a>\n      </li--><!-- !Giornate --><!-- Classifica --><!-- !Classifica --><!-- Marcatori --><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.scorers\'}\" can=scorers><a ui-sref=main.admin.scorers><i class=\"fa fa-futbol-o\" aria-hidden=true></i> <span>Marcatori</span></a></li><!-- !Marcatori --><li class=treeview can=discipline><a href=#><i class=\"fa fa-user\" aria-hidden=true></i> <span>Arbitri & Referti</span> <i class=\"fa fa-angle-left pull-right\"></i></a><ul class=treeview-menu><li class=treeview can=discipline ng-class=\"{active: sidebar.state.current.name === \'main.admin.arbiter\'}\"><a ui-sref=main.admin.arbiter><i class=\"fa fa-user\" aria-hidden=true></i> <span>Arbitri</span></a></li></ul></li><!-- TODO DA SCOMMENTARE QUANDO RILASCIO FUNZIONALITA SQUADRE --><li class=treeview><a href=#><i class=\"fa fa-flag\" aria-hidden=true></i> <span>Locandina</span> <i class=\"fa fa-angle-left pull-right\"></i></a><ul class=treeview-menu><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.condividiTorneo\'}\"><a ui-sref=main.admin.condividiTorneo><i class=\"fa fa-share-alt\" aria-hidden=true></i> <span>Condividi torneo</span></a></li><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.iscrizioni\'}\"><a ui-sref=main.admin.iscrizioni><i class=\"fa fa-pencil-square-o\" aria-hidden=true></i> <span>Iscrizioni</span></a></li></ul></li><li class=treeview can=scorers><a href=#><i class=\"fa fa-key\" aria-hidden=true></i> <span>Amministra ruoli</span> <i class=\"fa fa-angle-left pull-right\"></i></a><ul class=treeview-menu><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.invitations\'}\" can=useradmin><a ui-sref=main.admin.invitations><i class=\"fa fa-newspaper-o\"></i> <span>Dirigenti</span></a></li><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.adminTeam\'}\" can=adminteam><a ui-sref=main.admin.adminTeam><i class=\"fa fa-black-tie\"></i> <span>Responsabile Squadra</span></a></li></ul></li><!-- Disciplinare --><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.disciplinary\'}\" can=discipline><a ui-sref=main.admin.disciplinary><i class=\"fa fa-bolt\"></i> <span>Disciplinare</span></a></li><!-- !Disciplinare --><!-- Comunicati --><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.press\'}\" can=press><a ui-sref=main.admin.press><i class=\"fa fa-newspaper-o\"></i> <span>Comunicati</span></a></li><!-- !Comunicati --><!-- !Import marcatori --><!-- Iscrizioni --><!-- ATTIVARE A RILASCIO GESTIONE ISCRIZIONE --><!--li class=\"treeview\" ng-class=\"{active: sidebar.state.current.name === \'main.admin.iscrizioni\'}\" can=\"scorers\">\n        <a ui-sref=\"main.admin.iscrizioni\">\n          <i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> <span>Iscrizioni</span>\n        </a>\n      </li--><!-- !Iscrizioni --><!-- !SECTION Main Menu --><!-- SECTION Dirigente --><li class=header can=guest>Sei Dirigente</li><!-- Eventi dirigente --><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.manager_events\'}\" can=guest><a ui-sref=main.admin.managerEvents><i class=\"fa fa-newspaper-o\"></i> <span>Tornei da Dirigente</span></a></li><!-- !Eventi dirigente --><!-- Partite --><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.manager_matches\'}\" can=guest><a ui-sref=main.admin.managerMatches><i class=\"fa fa-check\"></i> <span>Partite da Dirigente</span></a></li><!-- !Partite --><!-- SECTION Amministra --><!--li class=\"header\" can=\"useradmin\">Amministra ruoli</li--><!-- Dirigenti --><!-- !Dirigenti --><!-- Responsabile Squadra --><!-- !Responsabile Squadra --><!-- !SECTION Amministra --><!-- SECTION Utili --><!--li class=\"header\" can=\"discipline\">Utili</li>\n      <li class=\"treeview\" ng-class=\"{active: sidebar.state.current.name === \'main.admin.disciplinary\'}\" can=\"discipline\">\n        <a ui-sref=\"main.admin.disciplinary\">\n          <i class=\"fa fa-bolt\"></i>\n          <span>Sposta squadre e giocatori</span>\n        </a>\n      </li--><!-- Disciplinare --><!--li class=\"treeview\" ng-class=\"{active: sidebar.state.current.name === \'main.admin.disciplinary\'}\" can=\"discipline\">\n        <a ui-sref=\"main.admin.disciplinary\">\n          <i class=\"fa fa-bolt\"></i>\n          <span>Disciplinare</span>\n        </a>\n      </li--><!-- !Disciplinare --><!-- Comunicati --><!--li class=\"treeview\" ng-class=\"{active: sidebar.state.current.name === \'main.admin.press\'}\" can=\"press\">\n        <a ui-sref=\"main.admin.press\">\n          <i class=\"fa fa-newspaper-o\"></i> <span>Comunicati</span>\n        </a>\n      </li--><!-- !Comunicati --><!-- !SECTION Utili --><!-- SECTION Support --><!--li class=\"header\">Support</li--><!-- Documentation --><!--li class=\"treeview\" ng-class=\"{active: sidebar.state.current.name === \'main.admin.documentation\'}\">\n                <a href=\"http://frispo.it/documentation/documentation/index.html\" target=\"_blank\">\n                    <i class=\"fa fa-info\" aria-hidden=\"true\"></i>\n                    <span>Documentazione</span>\n                </a>\n            </li--><!-- !Documentation --><!-- Contact Us --><li class=treeview ng-class=\"{active: sidebar.state.current.name === \'main.admin.contact\'}\"><a href=mailto:info@frispo.it><i class=\"fa fa-envelope\" aria-hidden=true></i> <span>Contattaci</span></a></li><!-- !Contact Us --><!-- !SECTION Support --></ul><!-- /.sidebar-menu --></div><!-- /.sidebar --></div><!-- /-->");
$templateCache.put("app/components/infoPopover/infoPopover.html","<a href=# data-toggle=popover style=\"margin-right: .2em\" data-html=true data-placement=bottom data-trigger=focus tabindex=0 title=\"{{ infoPopover.title }}\" data-content=\"{{ infoPopover.body }}\"><i class=\"fa fa-question-circle text-dark\" aria-hidden=true></i> </a>");
$templateCache.put("app/pages/access/access.html","<script src=https://sdk.amazonaws.com/js/aws-sdk-2.432.0.min.js></script><div class=access><div class=spinner-wrapper><i class=\"spinner fa fa-sun-o fa-spin\"></i></div></div>");
$templateCache.put("app/pages/admin/admin.html","<div class=wrapper><frispo-header></frispo-header><frispo-sidebar></frispo-sidebar><div class=content-wrapper><div ui-view></div></div><frispo-footer></frispo-footer></div>");
$templateCache.put("app/pages/adminTeam/adminTeam.html","<div class=invitations><section class=content-header><h1><info-popover title=\"Responsabili squadra\" body=\"Puoi permettere a un utente Frispo di diventare responsabile della propria squadra <br/> Potrá caricare i risultati delle partite della sua squadra\nsolo quando gioca in casa\" ></info-popover>Responsabili Squadra <small>dei tuoi tornei</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header><a role=button class=\"btn btn-success pull-left\" ng-click=vm.createNewInvitation()>Aggiungi un responsabile squadra</a></div><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentUser.sentInvitations><table class=table><tr><th>E-mail Responsabile Squadra</th><th>Evento</th><th>Squadra</th><th>Data invito</th><!--th>Stato invito</th--><th></th></tr><tr ng-repeat=\"adminTeam in vm.models.currentUser.sentInvitations\" admin-team-show=adminTeam></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div></div></div></div></section></div>");
$templateCache.put("app/pages/arbiter/arbiter.html","<div class=arbiter-section><section class=content-header><h1><info-popover title=Arbitri body=\"censisci gli arbitri dei tuoi tornei\" ></info-popover>Arbitri <small>inserimento e gestione</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header ng-show=vm.models.currentEvent><div class=pull-right><button class=\"btn btn-success form-control-button\" ng-click=vm.createNewArbiter()>Crea un nuovo arbitro</button></div></div><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentEvent><table class=table><tr><th>Nome</th><th>Cognome</th><th>Tessera</th><th>Mail</th><th>Telefono</th><th></th></tr><tr ng-repeat-start=\"arbiter in vm.arbiters\" arbiter-show=\"{ arbiter: arbiter, list: vm.arbiters }\"></tr><tr ng-repeat-end arbiter-edit=\"{ arbiter: arbiter, list: vm.arbiters }\"></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=\"no-content text-center text-muted\" ng-show=\"!vm.loading && !vm.models.currentEvent\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessun evento selezionato</h4><b><i>Seleziona un evento dal menu principale</i></b></div></div></div></div></section></div>");
$templateCache.put("app/pages/calendar/calendar.html","<div class=calendar><section class=content-header><h1><info-popover title=\"Calendario e partite\" body=\"In questa sezione puoi modificare le partite, inserire i risultati, marcatori e disciplinare nelle partite.<br/>\nPer aggiornare la classifica é necessario indicare lo stato della partita come <b> giocata si </b><br/>\nPuoi inoltre creare una nuova giornata e inserire al suo interno le partite che vuoi\" ></info-popover>Calendario <small>giornate e partite</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header ng-show=vm.models.currentEvent><div class=row><div class=\"col-sm-4 col-md-3 col-lg-2\"><div class=form-group><label for=selectDay>Seleziona la giornata</label><select id=selectDay name=day class=form-control ng-model=vm.models.currentEvent.currentDay ng-disabled=\"!vm.models.currentEvent.matchDays ||\n                      vm.models.currentEvent.matchDays.length === 0\" ng-options=\"day as (day.matcDayName) for day in (vm.models.currentEvent.matchDays) track by day.matcDayId\" ng-change=vm.updateMatchDay()></select></div></div><div class=\"col-sm-8 col-md-9 col-lg-10\"><div class=pull-right><button class=\"btn btn-success form-control-button\" ng-if=\"vm.models.currentEvent.evenType == 1\" ng-click=vm.createNewGroup()>Crea nuovo girone</button> <button class=\"btn btn-success form-control-button\" ng-click=vm.createNewDay()>Crea nuova giornata</button> <button class=\"btn btn-success form-control-button\" ng-disabled=\"!vm.models.currentEvent.matchDays ||\n                      vm.models.currentEvent.matchDays.length === 0\" ng-click=vm.createNewMatch()>Crea nuova partita</button> <button class=\"btn btn-success form-control-button\" ng-disabled=\"!vm.models.currentEvent.currentDay.matches ||\n                      vm.models.currentEvent.currentDay.matches.length === 0\" ng-click=vm.exportData(vm.models.currentEvent.currentDay.matches) alt=\"esporta partite\"><i class=\"fa fa-download\"></i></button> <button class=\"btn btn-success form-control-button\" alt=\"esporta classifca\" ng-click=vm.reloaData(vm.models.currentEvent)><i class=\"fa fa-refresh\"></i></button></div></div></div></div><div class=\"box-body table-responsive relative\" ng-show=\"vm.models.currentEvent.matchDays &&\n                vm.models.currentEvent.matchDays.length !== 0\"><table class=table><tr><th>Squadra Casa</th><th>Squadra Ospite</th><th>Goal Casa</th><th>Goal Ospiti</th><th>Data Partita</th><th>Ora</th><th>Indirizzo</th><th ng-if=\"vm.models.currentEvent.evenType == 1\">Girone</th><th>Giocata</th><th></th></tr><tr ng-repeat-start=\"match in vm.models.currentEvent.currentDay.matches\" match-show=match></tr><tr match-arbiter=\"{ match: match, arbiters: vm.arbiters }\"></tr><tr ng-repeat-end match-edit=\"{ match: match, groups: vm.groups}\"></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=\"no-content text-center text-muted\" ng-show=\"!vm.loading && !vm.models.currentEvent\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessun evento selezionato</h4><b><i>Seleziona un evento dal menu principale</i></b></div></div></div></div></section></div>");
$templateCache.put("app/pages/catalog/catalog.html","<br><section class=\"content catalog\"><div class=catalog__summary>Il tuo piano è: <span class=summary__bold>{{vm.userSaas.subscriptionName === \'premium\' ? \'premium\' : \'basic\'}}</span> <span ng-if=\"vm.userSaas.subscription !== \'LEAGUEFREE\'\">e scade il</span> <span ng-if=\"vm.userSaas.subscription !== \'LEAGUEFREE\'\" class=summary__bold>{{vm.userSaas.expireDate}}</span></div><div class=\"row flex-container\"><div class=\"col-sm-4 col-md-4 col-lg-4\" ng-repeat=\"plan in vm.plans\"><div class=\"box box-success catalog__plan\"><div class=\"box-body col text-center\"><div class=plan__title>{{plan.title}}</div><div class=plan__price>{{plan.price}}/<span class=price__time>{{plan.time}}</span></div><div class=plan__feature><div ng-repeat=\"feature in plan.features\">{{feature}}</div></div><div class=\"box-header text-center\" ng-if=\"plan.actionButton && plan.subscription !== vm.userSaas.subscription\"><button type=button class=\"btn btn-success\" ng-click=vm.confirmPlan(plan)>{{plan.actionButton}}</button></div></div></div></div></div></section>");
$templateCache.put("app/pages/condividiTorneo/condividiTorneo.html","<div class=\"content events\"><div class=row><div class=col-xs-5><div class=\"box box-default\" ng-show=\"vm.models.events.length === 0\"><div class=box-header><div class=box-title>Eventi</div></div><div class=box-body>Non sono stati trovati eventi.</div></div><div class=\"box box-success\"><div class=\"box box-success text-center\"><div class=box-header><h3 class=box-title><info-popover title=\"<b>Locandina</b>\" body=\"In questa sezione puoi aggiungere le informazioni al tuo torneo per creare la Locandina WEB\" ></info-popover>Eventi</h3><div class=box-tools><div class=\"input-group input-group-sm\" style=\"width: 150px\"><input ng-model=tableFilter.searchFilter.search type=text name=table_search class=\"form-control pull-right\" placeholder=Search><div class=input-group-btn><button type=submit class=\"btn btn-default\"><i class=\"fa fa-search\"></i></button></div><div class=\"box-tools pull-right\"><button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-minus\"></i></button></div></div></div></div><div class=\"box-body table-responsive\"><table ng-init=\"vm.formScopes = []\" class=\"table table-striped\"><tbody><tr><th>Nome</th><th>Stato</th><th></th></tr><tr dir-paginate-start=\"event in vm.models.events | filter:tableFilter.eventFilter | filter:tableFilter.searchFilter | itemsPerPage: 12\"><td>{{ event.evenName }}</td><td>{{ event.evenStatoEvento === \'1\' ? \"Pubblicato\" : \"Non pubblicato\" }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-click=vm.setCurrentEvent(event)><a role=button class=\"btn btn-sm btn-default accordion-toggle\"><i class=\"fa fa-info\"></i></a></div></td></tr><tr dir-paginate-end></tr></tbody></table></div></div></div><div ng-show=vm.currentEvent class=\"box box-info text-center\"><div class=box-header><h3 class=box-title>Link Sito Web</h3></div><div class=box-body><a href=\"http://locandina.frisposite.it/?e={{ vm.currentEvent.evenId }}\" target=_blank>http://locandina.frisposite.it/?e={{ vm.currentEvent.evenId }}</a></div></div><div class=text-center><dir-pagination-controls max-size=10 direction-links=true boundary-links=true style=align:center></dir-pagination-controls></div></div><div class=col-xs-7><div class=\"box box-info\"><div class=\"box box-info text-center\"><div class=box-header><h3 class=box-title><info-popover title=\"<b>Aggiungi le tue informazioni</b>\" body=\"Compila le informazioni utili al tuo torneo e alla tua locandina\" ></info-popover>Informazioni evento</h3><div class=box-tools><div class=\"input-group input-group-sm\" style=\"width: 150px\"><div class=\"box-tools pull-right\"><button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-minus\"></i></button></div></div></div></div><div class=box-body><form class=\"event-edit-form relative\" name=condividiTorneoEditForm ng-submit=vm.submit()><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenName.$dirty && condividiTorneoEditForm.evenName.$invalid}\"><label for=condividiTorneoEditForm-evenName>Modifica Nome</label><input id=condividiTorneoEditForm-evenName ng-model=vm.currentEvent.evenName name=evenName type=text class=form-control placeholder=\"Inserisci il nome dell\'evento\" required> <span ng-show=condividiTorneoEditForm.evenName.$dirty ng-messages=condividiTorneoEditForm.evenName.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenOrganizeBy.$dirty && condividiTorneoEditForm.evenOrganizeBy.$invalid}\"><label for=condividiTorneoEditForm-evenOrganizeBy>Modifica l\'organizzatore</label><input id=condividiTorneoEditForm-evenOrganizeBy ng-model=vm.currentEvent.evenOrganizeBy name=evenOrganizeBy type=text class=form-control placeholder=\"Inserisci l\'organizzatore dell\'evento\" required> <span ng-show=condividiTorneoEditForm.evenOrganizeBy.$dirty ng-messages=condividiTorneoEditForm.evenOrganizeBy.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenDescription.$dirty && condividiTorneoEditForm.evenDescription.$invalid}\"><label for=condividiTorneoEditForm-evenDescription>Modifica la descrizione</label><input id=condividiTorneoEditForm-evenDescription ng-model=vm.currentEvent.evenDescription name=evenDescription type=text class=form-control placeholder=\"Inserisci la descrizione dell\'evento\"> <span ng-show=condividiTorneoEditForm.evenDescription.$dirty ng-messages=condividiTorneoEditForm.evenDescription.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenDateStart.$dirty && condividiTorneoEditForm.evenDateStart.$invalid}\"><label for=condividiTorneoEditForm-evenDateStart>Modifica la data di inizio</label><input id=condividiTorneoEditForm-evenDateStart ng-model=vm.currentEvent.evenDateStart model=vm.currentEvent.evenDateStart name=evenDateStart type=text class=form-control placeholder=\"Inserisci la data di inizio evento\" datepicker required> <span ng-show=condividiTorneoEditForm.evenDateStart.$dirty ng-messages=condividiTorneoEditForm.evenDateStart.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenAddress.$dirty && condividiTorneoEditForm.evenAddress.$invalid}\"><label for=condividiTorneoEditForm-evenAddress>Modifica l\'indirizzo principale</label><input id=condividiTorneoEditForm-evenAddress ng-model=vm.currentEvent.evenAddress name=evenAddress type=text class=form-control placeholder=\"Inserisci l\'indirizzo principale dell\'evento\" required> <span ng-show=condividiTorneoEditForm.evenAddress.$dirty ng-messages=condividiTorneoEditForm.evenAddress.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenMobilePhone.$dirty && condividiTorneoEditForm.evenMobilePhone.$invalid}\"><label for=condividiTorneoEditForm-evenMobilePhone>Modifica il numero telefonico</label><input id=condividiTorneoEditForm-evenMobilePhone ng-model=vm.currentEvent.evenMobilePhone name=evenMobilePhone type=text class=form-control placeholder=\"Inserisci il numero telefonico\" required> <span ng-show=condividiTorneoEditForm.evenMobilePhone.$dirty ng-messages=condividiTorneoEditForm.evenMobilePhone.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenEmail.$dirty && condividiTorneoEditForm.evenEmail.$invalid}\"><label for=condividiTorneoEditForm-evenEmail>Modifica l\'email</label><input id=condividiTorneoEditForm-evenEmail ng-model=vm.currentEvent.evenEmail name=evenEmail type=text class=form-control placeholder=\"Inserisci l\'email\" required> <span ng-show=condividiTorneoEditForm.evenEmail.$dirty ng-messages=condividiTorneoEditForm.evenEmail.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-3 col-md-3 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenLocandina.$dirty && condividiTorneoEditForm.evenLocandina.$invalid}\"><label for=condividiTorneoEditForm-evenLocandina>Modifica la locandina <a href={{vm.currentEvent.evenLocandina}} target=_blank>[link]</a></label><label class=\"btn btn-primary form-control\"><input id=condividiTorneoEditForm-evenLocandina ng-model=vm.currentEvent.evenLocandina name=evenLocandina type=file ng-click=vm.loading() style=display:none> Carica nuova</label><span ng-show=condividiTorneoEditForm.evenLocandina.$dirty ng-messages=condividiTorneoEditForm.evenLocandina.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span><p id=upload-file-info></p></div></div><!-- <img src=\"{{vm.currentEvent.evenLocandina}}\" alt=\"\" width=\"20%\" height=\"20%\" alt=\"image\" /> --></div><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenQuota.$dirty && condividiTorneoEditForm.evenQuota.$invalid}\"><label for=condividiTorneoEditForm-evenQuota>Modifica la quota d\'iscrizione</label><input id=condividiTorneoEditForm-evenQuota ng-model=vm.currentEvent.evenQuota name=evenQuota type=text class=form-control placeholder=\"Inserisci la quota d\'iscrizione\"> <span ng-show=condividiTorneoEditForm.evenQuota.$dirty ng-messages=condividiTorneoEditForm.evenQuota.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenSitoWeb.$dirty && condividiTorneoEditForm.evenSitoWeb.$invalid}\"><label for=condividiTorneoEditForm-evenSitoWeb>Modifica il sito web</label><input id=condividiTorneoEditForm-evenSitoWeb ng-model=vm.currentEvent.evenSitoWeb name=evenSitoWeb type=text class=form-control placeholder=\"Inserisci il sito web\"> <span ng-show=condividiTorneoEditForm.evenSitoWeb.$dirty ng-messages=condividiTorneoEditForm.evenSitoWeb.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenPremio1.$dirty && condividiTorneoEditForm.evenPremio1.$invalid}\"><label for=condividiTorneoEditForm-evenPremio1>Modifica il primio premio classificato</label><input id=condividiTorneoEditForm-evenPremio1 ng-model=vm.currentEvent.evenPremio1 name=evenPremio1 type=text class=form-control placeholder=\"Inserisci il primo premio classificato\"> <span ng-show=condividiTorneoEditForm.evenPremio1.$dirty ng-messages=condividiTorneoEditForm.evenPremio1.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenPremio2.$dirty && condividiTorneoEditForm.evenPremio2.$invalid}\"><label for=condividiTorneoEditForm-evenPremio2>Modifica il secondo premio classificato</label><input id=condividiTorneoEditForm-evenPremio2 ng-model=vm.currentEvent.evenPremio2 name=evenPremio2 type=text class=form-control placeholder=\"Inserisci il secondo premio classificato\"> <span ng-show=condividiTorneoEditForm.evenPremio2.$dirty ng-messages=condividiTorneoEditForm.evenPremio2.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenPremio3.$dirty && condividiTorneoEditForm.evenPremio3.$invalid}\"><label for=condividiTorneoEditForm-evenPremio3>Modifica il terzo premio classificato</label><input id=condividiTorneoEditForm-evenPremio3 ng-model=vm.currentEvent.evenPremio3 name=evenPremio3 type=text class=form-control placeholder=\"Inserisci il terzo premio classificato\"> <span ng-show=condividiTorneoEditForm.evenPremio3.$dirty ng-messages=condividiTorneoEditForm.evenPremio3.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=\"col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': condividiTorneoEditForm.evenNote.$dirty && condividiTorneoEditForm.evenNote.$invalid}\"><label for=condividiTorneoEditForm-evenNote>Modifica le note dell\'evento</label><textarea id=condividiTorneoEditForm-evenNote rows=3 ng-model=vm.currentEvent.evenNote name=evenNote class=form-control placeholder=\"Inserisci le note dell\'evento\">\n                    </textarea><span ng-show=condividiTorneoEditForm.evenNote.$dirty ng-messages=condividiTorneoEditForm.evenNote.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=col-xs-12><div class=pull-left><p id=confirm></p></div><div class=pull-right><button type=submit class=\"btn btn-success\" ng-disabled=vm.isLoading>Salva</button></div></div></div></form></div></div></div></div></div></div>");
$templateCache.put("app/pages/disciplinary/disciplinary.html","<div class=disciplinary><section class=content-header><div class=row><div class=\"col-12 content-header\"><h1><info-popover title=Disciplinare body=\"In questa sezione puoi visualizzare le ammonizioni, le espulsioni e le ammende. <br/>\nRicordati di indicare quando un\'eventuale espulsione é stata scontata e gestisci il numero di giornate di penalitá previste\" ></info-popover>Disciplinare <small>ammonizioni, espulsioni e ammende</small></h1></div></div></section><section class=content><div class=row><div class=col-xs-12><div ng-repeat=\"cardConfig in vm.cardConfigs\" class=\"box {{ cardConfig.boxClass }}\"><div class=box-header><h4 class=box-title>{{ cardConfig.header }}</h4><div class=\"box-tools pull-right\"><button type=button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-minus\"></i></button></div></div><div class=\"box-body table-responsive relative\" ng-show=\"!vm.models.currentEvent[cardConfig.cardsKey] || vm.models.currentEvent[cardConfig.cardsKey].length === 0\"><strong>{{ cardConfig.emptyMessage }}</strong></div><div class=\"box-body table-responsive relative\" ng-show=\"vm.models.currentEvent[cardConfig.cardsKey].length > 0\"><table st-table=vm.models.currentEvent[cardConfig.cardsKey] class=table><thead><tr><th ng-repeat=\"field in cardConfig.fields\">{{ field.name }}</th><th></th></tr></thead><tbody><tr ng-repeat-start=\"card in vm.models.currentEvent[cardConfig.cardsKey]\" card-show=card config=cardConfig></tr><tr ng-repeat-end card-edit=card config=cardConfig ng-if=cardConfig.controls.edit></tr></tbody></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div></div></div></div></section></div>");
$templateCache.put("app/pages/createEvent/createEvent.html","<section class=create-event><section class=content-header><h1><info-popover title=\"<b>creare un torneo</b> in 3 step\" body=\"Da qui puoi creare un evento. Successivamente potrai modificarlo a tuo piacimento\n<ul>\n<li>aggiungendo e togliendo squadre</li>\n<li>cambiando formula</li>\n<li>ricreando il calendario</li>\n<li>aggiungendo partite </li>\n</ul>\n\" ></info-popover>Crea un evento <small>&nbsp;{{ vm.wizard | wizardTextProgress }}</small></h1><wizard-progress wizard=vm.wizard></wizard-progress></section><section class=content><span class=create-event__message-error ng-if=\"vm.hasEventPermission && vm.hasEvents\">Non puoi creare più di un torneo con l\'utenza free.</span><wizard-step-box step=1 wizard=vm.wizard title=\"Impostazioni evento\"><info-popover title=\"<b>step 1</b>\" body=\"Aggiungi le informazioni di base del tuo torneo\" ></info-popover><form id=formStep1 name=formStep1 ng-submit=vm.step1Done()><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep1.name.$dirty && formStep1.name.$invalid}\"><label for=formStep1-name>Nome</label><input id=formStep1-name ng-model=vm.step1.name name=name type=text class=form-control placeholder=\"Inserisci il nome dell\'evento\" required> <span ng-show=formStep1.name.$dirty ng-messages=formStep1.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep1.desc.$dirty && formStep1.desc.$invalid}\"><label for=formStep1-desc>Descrizione</label><textarea id=formStep1-desc rows=5 ng-model=vm.step1.desc name=desc class=form-control placeholder=\"Inserisci una descrizione dell\'evento\"></textarea><span ng-show=formStep1.desc.$dirty ng-messages=formStep1.desc.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep1.address.$dirty && formStep1.address.$invalid}\"><label for=formStep1-address>Indirizzo</label><input id=formStep1-address ng-model=vm.step1.address name=address type=text class=form-control placeholder=\"Inserisci l\'indirizzo principale dell\'evento\" required> <span ng-show=formStep1.address.$dirty ng-messages=formStep1.address.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep1.type.$dirty && formStep1.type.$invalid}\"><label for=formStep1-type>Tipologia</label><select id=formStep1-type ng-init=\"vm.step1.type = 0\" ng-model=vm.step1.type name=type class=form-control><option ng-selected=\"vm.step1.type === 0\" value=0>Campionato italiana</option><option ng-selected=\"vm.step1.type === 1\" value=1>Torneo a gironi</option></select><span ng-show=formStep1.type.$dirty ng-messages=formStep1.type.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep1.organizer.$dirty && formStep1.organizer.$invalid}\"><label for=formStep1-organizer>Organizzatore</label><input id=formStep1-organizer ng-model=vm.step1.organizer name=organizer type=text class=form-control placeholder=\"Inserisci il nome dell\'organizzatore\" required> <span ng-show=formStep1.organizer.$dirty ng-messages=formStep1.organizer.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep1.telephone.$dirty && formStep1.telephone.$invalid}\"><label for=formStep1-telephone>Telefono organizzatore</label><input id=formStep1-telephone ng-model=vm.step1.telephone name=telephone type=text class=form-control placeholder=\"Inserisci il numero di telefono dell\'organizzatore\" required> <span ng-show=formStep1.telephone.$dirty ng-messages=formStep1.telephone.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep1.email.$dirty && formStep1.email.$invalid}\"><label for=formStep1-email>E-mail organizzatore</label><input id=formStep1-email ng-model=vm.step1.email name=email type=email class=form-control placeholder=\"Inserisci l\'indirizzo e-mail dell\'organizzatore\" required> <span ng-show=formStep1.email.$dirty ng-messages=formStep1.email.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span> <span ng-message=email>Inserire un indirizzo email valido</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep1.dates.$dirty && formStep1.dates.$invalid}\"><label for=formStep1-dates>Periodo</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input id=formStep1-dates ng-model=vm.step1.dates model=vm.step1.dates name=dates type=text class=form-control placeholder=\"Inserisci la data di inizio e la data di fine\" datepicker=range required></div><!-- /.input group --> <span ng-show=formStep1.dates.$dirty ng-messages=formStep1.dates.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep1.formula.$dirty && formStep1.formula.$invalid}\"><label for=formStep1-formula>Formula</label><select id=formStep1-formula ng-init=\"vm.step1.formula = 1\" ng-model=vm.step1.formula name=formula class=form-control placeholder=\"Inserisci la formula desiderata\"><option ng-selected=\"vm.step1.formula === 1\" value=1>Andata e ritorno</option><option ng-selected=\"vm.step1.formula === 0\" value=0>Solo andata</option></select><span ng-show=formStep1.formula.$dirty ng-messages=formStep1.formula.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><!-- /.col --></div><!-- /.row --><div class=pull-right><input type=submit class=\"btn btn-success\" value=Continua></div></form></wizard-step-box><wizard-step-box step=2 wizard=vm.wizard title=\"Aggiungi squadre\"><info-popover title=\"<b>step 2</b>\" body=\"Aggiungi le squadre. Potrai aggiungerle o rimuoverle anche successivamente <br/>\n        Se inserisci giá in questo momento <b>giorno preferito</b> e <b>indirizzo preferito</b> verrá aggiornato l\'indirizzo delle partite\n        in casa della squadra di riferimento\" ></info-popover><form id=formStep2 name=formStep2 ng-submit=vm.step2Done()><div class=row><div ng-if=\"vm.step1.type == \'1\' && !vm.forceManualRounds\"><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep2.roundType.$dirty && formStep2.roundType.$invalid}\"><label for=formStep2-roundType>Inserimento Gironi</label><select id=formStep2-roundType ng-init=\"vm.step2.roundType = 0\" ng-model=vm.step2.roundType name=roundType class=form-control ng-change=vm.initDefaultTeams()><option value=0>Manuale</option><option value=1>Automatico</option></select><span ng-show=formStep2.roundType.$dirty ng-messages=formStep2.roundType.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6 ng-if=\"vm.step2.roundType == 1\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep2.roundNumber.$dirty && formStep2.roundNumber.$invalid}\"><label for=formStep2-roundNumber>Numero di gironi</label><input id=formStep2-roundNumber ng-model=team.roundNumber name=roundNumber type=text class=form-control placeholder=\"Inserisci il numero di gironi dell\'evento\" required> <span ng-show=formStep2.roundNumber.$dirty ng-messages=formStep2.roundNumber.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=clearfix></div><div class=col-sm-6 ng-repeat=\"team in vm.step2.teams\"><div class=\"panel panel-default\"><div class=panel-heading>Squadra {{ $index+1 }} <button tabindex=-1 type=button class=close ng-click=vm.removeTeam($index)><span>&times;</span></button></div><div class=panel-body><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep2[\'name\' + ($index+1)].$dirty && formStep2[\'name\' + ($index+1)].$invalid}\"><label for=formStep2-name{{$index+1}}>Nome</label><input id=formStep2-name{{$index+1}} ng-model=team.name name=name{{$index+1}} type=text class=form-control placeholder=\"Inserisci il nome della squadra\" required> <span ng-show=\"formStep2[\'name\' + ($index+1)].$dirty\" ng-messages=\"formStep2[\'name\' + ($index+1)].$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep2[\'captain\' + ($index+1)].$dirty && formStep2[\'captain\' + ($index+1)].$invalid}\"><label for=formStep2-captain{{$index+1}}>Capitano</label><input id=formStep2-captain{{$index+1}} ng-model=team.captain name=captain{{$index+1}} type=text class=form-control placeholder=\"Inserisci il nome del capitano della squadra\"> <span ng-show=\"formStep2[\'captain\' + ($index+1)].$dirty\" ng-messages=\"formStep2[\'captain\' + ($index+1)].$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep2[\'phone\' + ($index+1)].$dirty && formStep2[\'phone\' + ($index+1)].$invalid}\"><label for=formStep2-phone{{$index+1}}>Telefono</label><input id=formStep2-phone{{$index+1}} ng-model=team.phone name=phone{{$index+1}} type=text class=form-control placeholder=\"Inserisci il numero di telefono della squadra\"> <span ng-show=\"formStep2[\'phone\' + ($index+1)].$dirty\" ng-messages=\"formStep2[\'phone\' + ($index+1)].$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep2[\'time\' + ($index+1)].$dirty && formStep2[\'time\' + ($index+1)].$invalid}\"><label for=formStep2-time{{$index+1}}>Orario preferito</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-clock-o\"></i></div><input id=formStep2-time{{$index+1}} ng-model=team.time name=time{{$index+1}} type=text class=form-control timepicker placeholder=\"Inserisci l\'orario preferito della squadra per le partite\"></div><span ng-show=\"formStep2[\'time\' + ($index+1)].$dirty\" ng-messages=\"formStep2[\'time\' + ($index+1)].$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep2[\'place\' + ($index+1)].$dirty && formStep2[\'place\' + ($index+1)].$invalid}\"><label for=formStep2-place{{$index+1}}>Luogo preferito</label><input id=formStep2-place{{$index+1}} ng-model=team.place name=place{{$index+1}} type=text class=form-control placeholder=\"Inserisci il luogo preferito della squadra per le partite\"> <span ng-show=\"formStep2[\'place\' + ($index+1)].$dirty\" ng-messages=\"formStep2[\'place\' + ($index+1)].$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div ng-if=\"vm.step2.roundType == 0\" class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formStep2[\'round\' + ($index+1)].$dirty && formStep2[\'round\' + ($index+1)].$invalid}\"><label for=formStep2-round{{$index+1}}>Girone</label><select id=formStep2-round{{$index+1}} ng-init=\"team.round = \'A\'\" ng-model=team.round name=round{{$index+1}} class=form-control ng-options=\"roundName as roundName for roundName in vm.roundNames track by roundName\" required></select><span ng-show=\"formStep2[\'round\' + ($index+1)].$dirty\" ng-messages=\"formStep2[\'round\' + ($index+1)].$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div></div><div class=clearfix></div><div class=col-md-6><a role=button ng-click=vm.addTeam() class=\"btn btn-default btn-block\" ng-show=vm.step2.roundType>Aggiungi Squadra</a></div></div><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=vm.wizard.prev()>Indietro</a> <input type=submit class=\"btn btn-success\" value=Continua></div></form></wizard-step-box><wizard-step-box step=3 wizard=vm.wizard title=Riepilogo><info-popover title=\"<b>step 3</b>\" body=\"Crea il calendario delle partite in maniera automatica o manualmente. <br/>\n<b>E\' consigliato creare il calendario automaticamente</b>. Sará possibile successivamente modificare le partite e/o aggiungere e rimuovere\ngiornate e partite\" ></info-popover><form id=formStep3 name=formStep3 ng-submit=vm.submitWizard()><div class=row><div class=col-md-6><div class=form-group><label>Nome</label><p class=form-control-static>{{ vm.step1.name }}</p></div><div class=form-group><label>Descrizione</label><p class=form-control-static>{{ vm.step1.desc }}</p></div><div class=form-group><label>Indirizzo</label><p class=form-control-static>{{ vm.step1.address }}</p></div><div class=form-group><label>Tipologia</label><p class=form-control-static>{{ vm.step1.type == \'1\' ? \'Torneo a gironi\' : \'Campionato Italiana\' }}</p></div><div class=form-group><label>Numero di squadre</label><p class=form-control-static>{{ vm.step2.teams.length }}</p></div></div><div class=col-md-6><div class=form-group><label>Organizzatore</label><p class=form-control-static>{{ vm.step1.organizer }}</p></div><div class=form-group><label>Telefono organizzatore</label><p class=form-control-static>{{ vm.step1.telephone }}</p></div><div class=form-group><label>E-mail organizzatore</label><p class=form-control-static>{{ vm.step1.email }}</p></div><div class=form-group><label>Perioto</label><p class=form-control-static>{{ vm.step1.dates }}</p></div><div class=form-group><label>Formula</label><p class=form-control-static>{{ vm.step1.formula == \'0\' ? \'Solo andata\' : \'Andata e Ritorno\' }}</p></div></div></div><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=vm.wizard.prev()>Indietro</a> <input type=submit class=\"btn btn-success\" value=\"Crea partita automaticamente\"><a role=button class=\"btn btn-success\" ng-click=vm.manualSubmit()>Crea partita manualmente</a></div></form></wizard-step-box></section></section>");
$templateCache.put("app/pages/events/events.html","<section class=content-header><h1><info-popover title=\"<b>gestisci i tuoi tornei</b>\" body=\"Da qui puoi gestire i tuoi tornei. <br\\> Ricordati che i tornei NON pubblicati non sono visualizzati in app\n\" ></info-popover>Gestisci tornei<!--a target=\"_blank\" href=\"http://docs.frispo.it\" >Gestisci tornei</a--></h1></section><div class=\"content events\"><div class=row><div class=\"col-sm-6 col-md-4 col-lg-3\" ng-repeat=\"invitation in vm.models.currentUser.receivedInvitations\"><div class=\"box box-success box-solid\"><div class=box-header><div class=box-title>Invito ricevuto</div><div class=\"box-tools pull-right\"><button type=button class=\"btn btn-box-tool\" data-widget=remove><i class=\"fa fa-times\"></i></button></div></div><div class=box-body><p><strong>{{ invitation.mailInvitingmember }}</strong> ti ha invitato a gestire come <strong>Dirigente</strong> il suo evento &quot; <strong>{{ invitation.evenName }}</strong>&quot;</p><div class=pull-right><a role=button class=\"btn btn-danger\" ng-click=vm.declineInvitation(invitation)>Rifiuta</a> <a role=button class=\"btn btn-success\" ng-click=vm.acceptInvitation(invitation)>Accetta</a></div></div></div></div><div class=col-xs-12 ng-if=vm.models.currentUser.userNewsDescription><div class=\"box box-success\"><div class=box-header><div class=box-title><b>News</b></div><br><br><div class=\"box-tools pull-right\"><button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-minus\"></i></button></div></div><div class=box-body><p ng-bind-html=vm.models.currentUser.userNewsDescription></p></div></div></div><div class=col-xs-12><div class=\"box box-default\"><div class=box-header><div class=box-title><b>Aggiungi frispo sul tuo sito web</b></div><br><br><div class=\"box-tools pull-right\"><button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-minus\"></i></button></div><p>Da oggi puoi aggiungere frispo sul tuo portale web inserendo un semplice html dentro le pagine del tuo sito. Aggiungi il codice seguente</p></div><div class=box-body><ul><li><span>CLASSIFICA</span><pre><code>&LT;iframe style=\"height: 100%;width: 100%; margin: 0;position:absolute;\" src=\"http://widget.frispo.it/scoreboard?widget={{vm.models.currentUser.widgetIframe}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\"/> </code></pre></li><li><span>PARTITE</span><pre><code>&LT;iframe style=\"height: 100%;width: 100%; margin: 0;position:absolute;\" src=\"http://widget.frispo.it/calendar?widget={{vm.models.currentUser.widgetIframe}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\"/> </code></pre></li><li><span>MARCATORI</span><pre><code>&LT;iframe style=\"height: 100%;width: 100%; margin: 0;position:absolute;\" src=\"http://widget.frispo.it/scorers?widget={{vm.models.currentUser.widgetIframe}}\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\"/> </code></pre></li></ul></div></div></div><div class=col-xs-12><div class=\"box box-default\" ng-show=\"vm.models.events.length === 0\"><div class=box-header><div class=box-title><b>Tornei</b></div></div><div class=box-body>Non sono stati trovati tornei. <a ui-sref=main.admin.createEvent>Creane uno ora</a>.</div></div><div class=\"box {{ tableFilter.boxClass }}\" ng-repeat=\"tableFilter in vm.tableFilters\" ng-show=\"(vm.models.events | filter:tableFilter.eventFilter).length > 0\"><div class=\"box box-default text-center\"><div class=box-header><h3 class=box-title><b>{{ tableFilter.title }}</b></h3><div class=box-tools><div class=\"input-group input-group-sm\" style=\"width: 150px\"><input ng-model=tableFilter.searchFilter.search type=text name=table_search class=\"form-control pull-right\" placeholder=Search><div class=input-group-btn><button type=submit class=\"btn btn-default\"><i class=\"fa fa-search\"></i></button></div><div class=\"box-tools pull-right\"><button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-minus\"></i></button></div></div></div></div><div class=\"box-body table-responsive\"><table ng-init=\"vm.formScopes = []\" class=\"table table-striped\"><tbody><tr><th>Nome</th><th>Tipologia torneo</th><th>Formula</th><th>Regione</th><!--th>Giornata corrente</th--><th>Organizzatore</th><th class=text-bold>Codice torneo invito</th><th></th></tr><tr dir-paginate-start=\"event in vm.models.events | filter:tableFilter.eventFilter | filter:tableFilter.searchFilter |itemsPerPage:10\" event-show=event></tr><tr dir-paginate-end event-edit=event></tr></tbody></table></div><!-- /.box-body --></div><!-- /.box --></div><div class=text-center><dir-pagination-controls max-size=10 direction-links=true boundary-links=true style=align:center></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/pages/forgotPassword/forgotPassword.html","<div class=\"login login-box\"><div class=login-logo><img src=/assets/images/logo-title-64.png alt=Frispo></div><!-- /.login-logo --><div class=login-box-body><p class=login-box-msg>Inserisci la tua e-mail per recuperare la password</p><form id=loginForm name=loginForm ng-submit=vm.forgotPassword()><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': loginForm.email.$dirty && loginForm.email.$invalid}\"><input ng-model=vm.user.email name=email type=email class=form-control placeholder=Email required> <span class=\"glyphicon glyphicon-envelope form-control-feedback\"></span> <span ng-show=loginForm.email.$dirty ng-messages=loginForm.email.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span> <span ng-message=email>Inserire un indirizzo email valido</span></span></div><div class=row><!-- /.col --><div class=col-xs-12><button ng-disabled=loginForm.$invalid type=submit class=\"btn btn-primary btn-block btn-flat\">Recupera password</button></div><!-- /.col --></div></form><a ui-sref=main.login class=text-center>I already have a membership</a><br><a ui-sref=main.register class=text-center>Register a new membership</a></div><!-- /.login-box-body --></div>");
$templateCache.put("app/pages/giornate/giornate.html","<div class=calendar><section class=content-header><h1><info-popover title=\"Giornate calendario\" body=\"Modifica nome, settimana e anno di ogni giornata.\n<br/> <b>Aggiorna poi la data delle partite</b>. Se le squadre del torneo avranno il giorno preferito salvato, il sistema\nincrocierá il giorno preferito con la settimana della giornata <b>individuando automaticamente la data precisa della partita </b> \" ></info-popover>Giornate <small>gestisci le giornate del calendario</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header ng-show=vm.models.currentEvent><div class=pull-right><button class=\"btn btn-success form-control-button\" ng-click=vm.createNewDay()>Crea nuova giornata</button> <button class=\"btn btn-success form-control-button\" ng-disabled=!vm.models.currentEvent.currentDay.matches ng-click=vm.updateDayOfWeek()>Aggiorna date partite</button></div></div><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentEvent.currentDay.matches><table class=table><tr><th>Nome</th><th>Anno</th><th>Settimana</th><th>Aggiornamento classifica</th><th></th></tr><tr ng-repeat-start=\"giornata in vm.models.currentEvent.matchDays\" giornate-show=giornata></tr><tr ng-repeat-end giornate-edit=giornata></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=\"no-content text-center text-muted\" ng-show=\"!vm.loading && !vm.models.currentEvent\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessun evento selezionato</h4><b><i>Seleziona un evento dal menu principale</i></b></div></div></div></div></section></div>");
$templateCache.put("app/pages/invitations/invitations.html","<div class=invitations><section class=content-header><h1><info-popover title=Dirigenti body=\"Permetti a utenti Frispo di caricare i risultati degli eventi condivisi\" ></info-popover>Dirigenti <small>invitati</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header><a role=button class=\"btn btn-success pull-left\" ng-click=vm.createNewInvitation()>Manda un nuovo invito</a></div><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentUser.sentInvitations><table class=table><tr><th>E-mail dirigente</th><th>Evento</th><th>Data invito</th><th>Stato invito</th><th></th></tr><tr ng-repeat=\"invitation in vm.models.currentUser.sentInvitations\" invitation-show=invitation></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div></div></div></div></section></div>");
$templateCache.put("app/pages/login/login.html","<script src=https://sdk.amazonaws.com/js/aws-sdk-2.432.0.min.js></script><div class=\"login login-box\"><div class=login-logo><img src=/assets/images/logo-title-64.png alt=Frispo></div><!-- /.login-logo --><div class=login-box-body><p class=login-box-msg>Accedi a Frispo</p><form id=loginForm name=loginForm ng-submit=vm.login()><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': loginForm.email.$dirty && loginForm.email.$invalid}\"><input ng-model=vm.user.email name=email type=email class=form-control placeholder=Email required> <span class=\"glyphicon glyphicon-envelope form-control-feedback\"></span> <span ng-show=loginForm.email.$dirty ng-messages=loginForm.email.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span> <span ng-message=email>Inserire un indirizzo email valido</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': loginForm.password.$dirty && loginForm.password.$invalid}\"><input ng-model=vm.user.password name=password type=password class=form-control placeholder=Password required> <span class=\"glyphicon glyphicon-lock form-control-feedback\"></span> <span ng-show=loginForm.password.$dirty ng-messages=loginForm.password.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=row><!-- /.col --><div class=col-xs-12><button ng-disabled=loginForm.$invalid type=submit class=\"btn btn-primary btn-block btn-flat\">Accedi</button></div><!-- /.col --></div></form><!--form class=\"social-auth-links text-center\" name=\"facebookLogin\" ng-submit=\"vm.loginFacebook($event)\">\n      <p> O </p>\n      <button type=\"submit\" ng-disabled=\"facebookLogin.$invalid\"\n          class=\"btn btn-block btn-social btn-facebook btn-flat\">\n        <i class=\"fa fa-facebook\"></i> Accedi con Facebook\n      </button>\n      <div class=\"privacy-boxes text-left\" ng-if=\"vm.facebookPrivacyAcceptance()\">\n        <p class=\"text-warning\">\n          <b>Attenzione !!</b> Per accedere devi accettare l\'informativa privacy\n        </p>\n        <div class=\"form-group has-feedback \"\n          ng-class=\"{\'has-error\': facebookLogin.flag_privacy.$dirty && facebookLogin.flag_privacy.$invalid}\">\n          <div class=\"checkbox icheck\">\n            <div class=\"icheckbox_square-blue pull-right\" aria-checked=\"false\" aria-disabled=\"false\">\n              <input ng-model=\"vm.privacy.flag_privacy\" name=\"flag_privacy\" type=\"checkbox\" required>\n            </div>\n            <label for=\"flag_privacy\">\n            accetto l\'<a href=\"http://frispo.it/privacy_policy/frispo_privacypolicy.pdf\">informativa privacy</a> e i <a href=\"http://frispo.it/privacy_policy/frispo_terminiecondizioni.pdf\">termini e condizioni d\'uso</a> di Frispo\n            </label>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <div class=\"checkbox icheck\">\n            <div class=\"icheckbox_square-blue pull-right\" aria-checked=\"false\" aria-disabled=\"false\">\n              <input ng-model=\"vm.privacy.flag_marketing\" name=\"flag_marketing\" type=\"checkbox\">\n            </div>\n            <label for=\"flag_marketing\">\n              accetto di ricevere comunicazioni commerciali\n            </label>\n          </div>\n        </div>\n        <div class=\"form-group\">\n          <div class=\"checkbox icheck\">\n            <div class=\"icheckbox_square-blue pull-right\" aria-checked=\"false\" aria-disabled=\"false\">\n              <input ng-model=\"vm.privacy.flag_profilazione\" name=\"flag_profilazione\" type=\"checkbox\">\n            </div>\n            <label for=\"flag_profilazione\">\n                accetto la profilazione con l\'obiettivo di ricevere un servizio più personalizzato\n            </label>\n          </div>\n        </div>\n      </div>\n\n    </form--><!-- /.social-auth-links --><!--a ui-sref=\"main.register\" class=\"text-center\">REGISTRATI</a><br--> <a ui-sref=main.forgotPassword class=text-center>HAI DIMENTICATO LA PASSWORD ?</a><p><br>Accedi con lo stesso utente utilizzato nell\'applicazione Mobile</p></div><!-- /.login-box-body --></div>");
$templateCache.put("app/pages/iscrizioni/iscrizioni.html","<div class=calendar><section class=content-header><h1><info-popover title=\"<b>Gestisci le tue iscrizioni<b/>\" body=\"qui puoi visualizzare gli utenti che si sono iscritti al tuo torneo dalla locandina\" ></info-popover>Iscrizioni</h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentEvent.iscrizioni><table class=table><tr><th>Nome squadra</th><th>Nome</th><th>Cognome</th><th>Email</th><th>Recapito</th><th>Note</th><th></th></tr><tr dir-paginate-start=\"iscrizione in vm.models.currentEvent.iscrizioni | itemsPerPage:10\" iscrizione-show=iscrizione></tr><tr dir-paginate-end iscrizione-edit=iscrizione></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=text-center><dir-pagination-controls max-size=10 direction-links=true boundary-links=true style=align:center></dir-pagination-controls></div></div></div></div></section></div>");
$templateCache.put("app/pages/main/main.html","<script src=https://sdk.amazonaws.com/js/aws-sdk-2.432.0.min.js></script><div class=animate ui-view></div>");
$templateCache.put("app/pages/managerEvents/managerEvents.html","<section class=content-header><h1><info-popover title=Dirigente body=\"Elenco dei tornei che gestisci come dirigente\" ></info-popover>Tornei gestiti come dirigente</h1></section><div class=\"content events\"><div class=row><div class=col-xs-12><div class=\"box box-default\" ng-show=\"vm.models.currentUser.managedEvents.length === 0\"><div class=box-header><div class=box-title></div></div><div class=box-body>Non gestisci alcun evento.</div></div><div class=\"box box-success\" ng-show=\"vm.models.currentUser.managedEvents.length > 0\"><div class=box-header><div class=box-tools><div class=\"input-group input-group-sm\" style=\"width: 150px\"><input ng-model=tableFilter.searchFilter.search type=text name=table_search class=\"form-control pull-right\" placeholder=Search><div class=input-group-btn><button type=submit class=\"btn btn-default\"><i class=\"fa fa-search\"></i></button></div></div></div></div><!-- /.box-header --><div class=\"box-body table-responsive\"><table class=table ng-init=\"vm.formScopes = []\"><tbody><tr><th>Nome</th><th>Evento</th><th>Formula</th><th>Regione</th><th>Giornata corrente</th><th></th></tr><tr ng-repeat=\"event in vm.models.currentUser.managedEvents\" event-show=event hide-controls=true></tr></tbody></table></div><!-- /.box-body --></div><!-- /.box --></div></div></div>");
$templateCache.put("app/pages/managerMatches/managerMatches.html","<div class=calendar><section class=content-header><h1><info-popover title=\"Partite dirigente\" body=\"Questi sono i tornei per i quali sei dirigente. Sono quindi tornei di altri utenti che ti hanno invitato\nper poter gestire i risultati degli incontri \" ></info-popover>Calendario <small>partite che gestisci come dirigente</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header><div class=row><div class=\"col-sm-4 col-md-3 col-lg-2\"><div class=form-group><label for=selectEvent>Seleziona l\'evento</label><select id=selectEvent ng-model=vm.models.currentEvent name=event class=form-control ng-options=\"event as event.evenName for event in vm.models.currentUser.managedEvents track by event.evenId\" ng-change=vm.updateCurrentEvent()></select></div></div><div class=\"col-sm-4 col-md-3 col-lg-2\"><div class=form-group><label for=selectDay>Seleziona la giornata</label><select id=selectDay ng-model=vm.models.currentEvent.currentDay name=day class=form-control ng-options=\"day as (day.matcDayName) for day in (vm.models.currentEvent.matchDays) track by day.matcDayId\" ng-change=vm.updateMatchDay()></select></div></div></div></div><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentEvent.currentDay.matches><table class=table><tr><th>Squadra Casa</th><th>Squadra Ospite</th><th>Goal Casa</th><th>Goal Ospiti</th><th>Data Partita</th><th>Ora</th><th>Indirizzo</th><th ng-if=\"vm.models.currentEvent.evenType == 1\">Girone</th><th>Giocata</th><th></th></tr><tr ng-repeat-start=\"match in vm.models.currentEvent.currentDay.matches\" manager-match-show=match></tr><tr ng-repeat-end manager-match-edit=match></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div></div></div></div></section></div>");
$templateCache.put("app/pages/players/players.html","<div class=calendar><section class=content-header><h1><info-popover title=\"<b>Giocatori</b>\" body=\"in questa sezione puoi gestire i giocatori della tua squadra\" ></info-popover>Giocatori <small>gestisci i giocatori delle squadre</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header ng-show=vm.models.currentEvent.currentTeam.players><div class=row><div class=\"col-sm-4 col-md-3 col-lg-2\"><div class=form-group><label for=selectDay>Seleziona la squadra</label><select id=selectDay ng-model=vm.models.currentEvent.currentTeam name=team class=form-control ng-disabled=!vm.models.currentEvent.currentTeam.players ng-options=\"team as (team.teamName) for team in (vm.models.currentEvent.teams) track by team.teamId\" ng-change=vm.updateTeam()></select></div></div><div class=\"col-sm-8 col-md-9 col-lg-10\"><div class=pull-right><button class=\"btn btn-success form-control-button\" style=\"margin-right: .4rem\" ng-click=vm.importPlayers()>Import giocatori</button> <button class=\"btn btn-success form-control-button\" style=\"margin-right: .4rem\" ng-disabled=!vm.models.currentEvent.currentTeam.players ng-click=vm.createNewPlayer()>Crea nuovo giocatore</button> <button class=\"btn btn-success form-control-button\" ng-click=vm.exportData(vm.models.currentEvent.currentTeam.players) alt=\"esporta squadre\"><i class=\"fa fa-download\"></i></button> <button class=\"btn btn-success form-control-button\" alt=\"refresh giocatori\" ng-click=vm.reloaData(vm.models.currentEvent)><i class=\"fa fa-refresh\"></i></button></div></div></div></div><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentEvent.currentTeam.players><table class=table><tr><th>Nome</th><th>Cognome</th><th>Tessera</th><th>Recapito</th><th></th></tr><tr ng-repeat-start=\"player in vm.models.currentEvent.currentTeam.players\" player-show=player></tr><tr ng-repeat-end player-edit=player></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=\"no-content text-center text-muted\" ng-show=\"!vm.loading && !vm.models.currentEvent.currentTeam.players\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessun evento selezionato</h4><b><i>Seleziona un evento dal menu principale</i></b></div></div></div></div></section></div>");
$templateCache.put("app/pages/playersMove/movePlayers.html","<div class=calendar><section class=content-header><h1><info-popover title=\"<b>Sposta Giocatori</b>\" body=\"in questa sezione puoi spostare i giocatori tra squadre diverse. <br/>\nSe li copi avrai semplicemente lo stesso giocatore presente anche sulla squadra di destinazione (cosi non devi riscriverlo).<br/>\nSe li sposti verranno tolti dalla squadra di origine e copiati nella seconda mantenendo anche i marcatori\" ></info-popover>Sposta Giocatori <small>sposta i giocatori tra le varie squadre</small></h1></section><section class=content><div class=row><div class=col-xs-12><form class=\"box box-success move-players-wrapper\"><div class=row style=\"width: 100%; margin: 0\"><div class=col-sm-6><div class=selector-wrapper><!-- Tendina di selezione dell\'evento\' --><div class=btn-group><button class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><span>Torneo</span><span class=separator>|</span> <span class=\"selection text-truncate\">{{ vm.selectedEventFrom ? vm.selectedEventFrom.evenName : \'nessuna selezione\' }}</span> <span class=caret></span></button><ul class=dropdown-menu><li ng-if=\"vm.models.events.length === 0\" class=text-center><a href=javascript:void(0) disabled><i>Non ci sono eventi</i></a></li><li ng-repeat=\"event in vm.models.events\"><a href=javascript:void(0) class=text-truncate ng-click=vm.selectEventFrom(event)>{{ event.evenName }}</a></li></ul></div><!-- Tendina di selezione della giornata --><div class=btn-group><button ng-disabled=!vm.selectedEventFrom class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><span>Squadra</span><span class=separator>|</span> <span class=\"selection text-truncate\">{{ vm.selectedTeamFrom ? vm.selectedTeamFrom.teamName : \'nessuna selezione\' }}</span> <span class=caret></span></button><ul class=dropdown-menu><li ng-if=\"vm.currentTeamsFrom.length === 0\" class=text-center><a href=javascript:void(0) disabled><i>Non ci sono squadre</i></a></li><li ng-repeat=\"team in vm.currentTeamsFrom\"><a href=javascript:void(0) class=text-truncate ng-click=vm.selectTeam(team)>{{ team.teamName }}</a></li></ul></div></div><div ng-if=\"vm.currentPlayerList.length !== 0\"><div class=\"players-list row\"><div class=\"player-row col-sm-6\" ng-repeat=\"player in vm.currentPlayerList\"><label class=custom-checkbox><input type=checkbox ng-model=vm.selectedPlayers[$index] ng-true-value=\"{{ player.playId }}\"> <span class=checkmark></span> <span class=checkbox-label>{{ player.playFirstname }} {{ player.playSurname }}</span></label></div></div><div class=move-players-btns-wrapper><button class=\"btn btn-default\" ng-click=vm.checkAll()>Seleziona tutti</button> <button class=\"btn btn-success\" ng-disabled=\"vm.getPlayerList().length === 0 || !vm.selectedTeamTo\" ng-click=\"vm.showConfirmPopup(\'move\')\">Sposta</button> <button class=\"btn btn-success\" ng-disabled=\"vm.getPlayerList().length === 0 || !vm.selectedTeamTo\" ng-click=\"vm.showConfirmPopup(\'copy\')\">Copia</button></div></div><div ng-if=\"!vm.selectedTeamFrom || vm.currentPlayerList.length === 0\" class=\"no-content text-center text-muted\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessuna squadra selezionata</h4><b><i>Seleziona un evento<br>ed una squadra dal menu in alto</i></b></div></div><div class=col-sm-6><div class=selector-wrapper style=\"text-align: center\"><!-- Tendina di selezione dell\'evento\' --><div class=btn-group><button ng-disabled=!vm.selectedTeamFrom class=\"btn btn-default dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false><span>Torneo</span><span class=separator>|</span> <span class=\"selection text-truncate\">{{ vm.selectedEventTo ? vm.selectedEventTo.evenName : \'nessuna selezione\' }} </span><span class=caret></span></button><ul class=dropdown-menu><li ng-if=\"vm.models.events.length === 0\" class=text-center><a href=javascript:void(0) disabled><i>Non ci sono eventi</i></a></li><li ng-repeat=\"event in vm.models.events\"><a href=javascript:void(0) class=text-truncate ng-click=vm.selectEventTo(event)>{{ event.evenName }}</a></li></ul></div></div><div ng-if=vm.selectedEventTo class=move-players-team-wrapper><div ng-repeat=\"team in vm.currentTeamsTo\" class=move-players-team><input type=radio name=team ng-model=vm.selectedTeamTo value=\"{{ team.teamId }}\"><div><div class=img-wrapper><span class=helper></span> <img src=\"{{ team.teamUrlLogo }}\"></div><div class=img-label-wrapper><span><b>{{ team.teamName }}</b></span><br><span class=text-muted>{{ team.teamPlace || \"-\" }}</span></div></div></div></div><div ng-if=\"!vm.selectedEventTo || vm.currentTeamsTo.length === 0\" class=\"no-content text-center text-muted\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessun evento selezionato</h4><b><i>Seleziona un evento dal menu in alto</i></b></div></div></div></form></div></div><p><b>Copia</b>: con l\'operazione COPIA i giocatori verranno copiati nella squadra di destinazione, ma rimarranno inalterati in quella di origine<br><b>Sposta</b>: con l\'operazione SPOSTA i giocatori verranno SPOSTATI dalla squadra di origine a quella di destinazione. Non saranno quindi piú presenti nella squadra iniziale. Con questa operazione vengono spostati anche i marcatori</p></section></div>");
$templateCache.put("app/pages/press/press.html","<div class=press><section class=content-header><h1><info-popover title=Comunicati body=\"Genera i comunicati (pdf,word) o importa quelli da te generati. <br/> Saranno visualizzati direttamente sull\'applicazione\" ></info-popover>Comunicati <small>visualizzabili su app</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header ng-show=vm.models.currentEvent.press><button class=\"btn btn-success form-control-button pull-right\" ng-disabled=!vm.models.currentEvent ng-click=vm.createNewPress()>Crea nuovo comunicato</button> <button class=\"btn btn-success form-control-button pull-right\" style=\"margin-right: 1rem\" ng-disabled=!vm.models.currentEvent ng-click=vm.loadPress()>Carica comunicato</button></div><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentEvent.press><table class=table><tr><th>Nome</th><th>Stato</th><th>PDF</th><th>WORD</th><th>Data</th><th></th></tr><tr dir-paginate-start=\"press in vm.models.currentEvent.press |itemsPerPage:10\" press-show=press></tr><tr dir-paginate-end press-edit=press></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=text-center><dir-pagination-controls max-size=10 direction-links=true boundary-links=true style=align:center></dir-pagination-controls></div><div class=\"no-content text-center text-muted\" ng-show=\"!vm.loading && !vm.models.currentEvent\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessun evento selezionato</h4><b><i>Seleziona un evento dal menu principale</i></b></div></div></div></div></section></div>");
$templateCache.put("app/pages/profile/profile.html","<div class=profile><section class=content><div class=row><div class=col-xs-12><div class=\"box box-default\"><div class=box-header><div class=box-title>PROFILO ORGANIZZATORE</div><div class=\"box-tools pull-right\"><button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-plus\"></i></button></div></div><div class=box-body><form name=profile-edit ng-submit=vm.submitInfo()><div class=row><div class=\"col-sm-8 col-md-8 col-lg-8\"><div class=\"form-group has-feedback\"><label class=\"col-sm-4 col-md-4 col-lg-4\" for=formStep1-nome>Username</label><input class=\"col-sm-4 col-md-4 col-lg-4\" id=formStep1-nome ng-model=vm.formInfo.username name=nome type=text class=form-control></div></div></div><div class=row style=\"padding-top: 5px\"><div class=\"col-sm-8 col-md-8 col-lg-8\"><div class=\"form-group has-feedback\"><label class=\"col-sm-4 col-md-4 col-lg-4\" for=formStep1-address>Indirizzo</label><input class=\"col-sm-4 col-md-4 col-lg-4\" id=formStep1-address ng-model=vm.formInfo.address name=address type=text class=form-control></div></div></div><div class=row style=\"padding-top: 5px\"><div class=\"col-sm-8 col-md-8 col-lg-8\"><div class=\"form-group has-feedback\"><label class=\"col-sm-4 col-md-4 col-lg-4\" for=formStep1-phone>Telefono</label><input class=\"col-sm-4 col-md-4 col-lg-4\" id=formStep1-phone ng-model=vm.formInfo.phone name=phone type=text class=form-control></div></div></div><div class=row style=\"padding-top: 5px\"><div class=\"col-sm-2 col-md-2 col-lg-1\"><div class=form-group><label>&nbsp;</label><input type=submit value=Salva class=\"btn btn-success form-control\"></div></div></div></form><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div></div></div><div class=col-xs-12><div class=\"box box-default collapsed-box\"><div class=box-header><div class=box-title>LOGO</div><div class=\"box-tools pull-right\"><button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-plus\"></i></button></div></div><div class=box-body><form name=profile-edit ng-submit=vm.submitInfo()><div class=\"col-sm-12 col-md-12 col-lg-12\" style=\"padding-top: 5px\"><div class=\"col-sm-12 col-md-12 col-lg-12 mb-2\"><img src=\"{{vm.formInfo.teamUrlLogo || \'assets/images/logo-64.png\'}}\" style=\"width:\'100%\'; height:\'100%\'; margin-bottom: 10px\"></div><div class=\"col-sm-12 col-md-12 col-lg-12\"><label class=\"btn btn-primary\" for=userLogo><input id=userLogo ng-model=vm.formInfo.teamUrlLogo name=userLogo type=file style=display:none> Carica Logo</label><button class=\"btn btn-warning\" ng-click=vm.submitIfLogoCanceledInfo()>Cancella Logo</button></div></div><div class=row style=\"padding-top: 5px\"><div class=\"col-sm-2 col-md-2 col-lg-1\"><div class=form-group><label>&nbsp;</label><input type=submit value=Salva class=\"btn btn-success form-control\"></div></div></div></form><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div></div></div><div class=col-xs-12><div class=\"box box-default collapsed-box\"><div class=box-header><div class=box-title>ACCESSO & CONSENSI</div><div class=\"box-tools pull-right\"><button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-plus\"></i></button></div></div><div class=box-body><form name=profile-edit ng-submit=vm.submit()><div class=row><div class=\"col-sm-5 col-md-4 col-lg-3 form-inline\"><div class=\"form-group has-feedback\"><label for=formStep1-email>Email</label>N.B. cambiando la mail dovrai effettuare nuovamente l\'accesso con la nuova mail inserita<br><input id=formStep1-email ng-model=vm.form.email name=email type=text class=form-control></div></div></div><br><div class=row><div class=\"col-sm-5 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\"><input id=flg-marketing ng-model=vm.form.flagMarketing name=flagMarketing type=checkbox><label for=formStep1-flagMarketing>accetto di ricevere comunicazioni commerciali</label></div></div></div><div class=row><div class=\"col-sm-5 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\"><input id=flg-profilazione ng-model=vm.form.flagProfilazione name=flagProfilazione type=checkbox><label for=formStep1-flagProfilazione>accetto profilazione per un servizio più personalizzato</label></div></div></div><div class=row><div class=\"col-sm-2 col-md-2 col-lg-1\"><div class=form-group><label>&nbsp;</label><input type=submit value=Salva class=\"btn btn-success form-control\"></div></div></div></form><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div></div></div></div><p><b>Vuoi cancellarti da Frispo ? <a ng-click=vm.deleteUser()>Clicca qui</a> e i tuoi tornei e i tuoi dati verranno cancellati nel giro di 24 ore</b></p><!--div class=\"pull-right\" id=\"deleteUser\">\n            <a role=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"vm.deleteUser()\">\n                <i class=\"fa fa-trash\"></i>\n            </a>\n        </div--><!--div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"box box-success\">\n          <div class=\"box-body\">\n            <form name=\"user-edit\" ng-submit=\"vm.submit()\">\n              <div class=\"row\">\n                <div class=\"col-sm-5 col-md-4 col-lg-3\">\n                  <div class=\"form-group\">\n                    <label for=\"user-edit-type\">Tipologia utente</label>\n                    <select\n                      id=\"user-edit-type\"\n                      name=\"type\"\n                      ng-model=\"vm.form.type\"\n                      class=\"form-control\"\n                      ng-options=\"type.num as type.name for type in vm.userTypes\"\n                      required\n                    >\n                    </select>\n                  </div>\n                </div>\n                <div class=\"col-sm-5 col-md-4 col-lg-3\">\n                  <div class=\"form-group\">\n                    <label for=\"user-edit-subscription\">Abbonamento</label>\n                    <select\n                      id=\"user-edit-subscription\"\n                      name=\"subscription\"\n                      ng-model=\"vm.form.subscription\"\n                      class=\"form-control\"\n                      ng-options=\"subscription.num as subscription.name for subscription in vm.userSubscriptions\"\n                      required\n                    >\n                    </select>\n                  </div>\n                </div>\n                <div class=\"col-sm-2 col-md-2 col-lg-1\">\n                  <div class=\"form-group\">\n                    <label>&nbsp;</label>\n                    <input type=\"submit\" value=\"Salva\" class=\"btn btn-success form-control\">\n                  </div>\n                </div>\n              </div>\n            </form>\n            <div ng-show=\"vm.loading\" class=\"overlay absolute fill\">\n              <i class=\"fa fa-refresh fa-spin\"></i>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div--><!--div class=\"row\">\n            <div class=\"pricing-container\">\n                <ul class=\"pricing-list bounce-invert\">\n                    <li>\n                        <ul class=\"pricing-wrapper\">\n                            <li data-type=\"monthly\" class=\"is-visible\">\n                                <header class=\"pricing-header\">\n                                    <h2>Basic</h2>\n                                    <div class=\"price\">\n                                        <span class=\"currency\">€</span>\n                                        <span class=\"value\">free</span>\n                                    </div>\n                                </header>\n                                <div class=\"pricing-body\">\n                                    <ul class=\"pricing-features\">\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Crea evento (1 attivo)</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Gestisci Calendario e Risultati</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Squadre e Giocatori</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Inserisci risultati da App</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Crea Evento da App</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Support</li>\n                                        <li> </li>\n                                        <li> </li>\n                                        <li> </li>\n                                        <li> </li>\n                                    </ul>\n                                </div>\n                            </li>\n                            <li data-type=\"yearly\" class=\"is-hidden\">\n                                <header class=\"pricing-header\">\n                                    <h2>Basic</h2>\n                                    <div class=\"price\">\n                                        <span class=\"currency\">€</span>\n                                        <span class=\"value\">free</span>\n                                    </div>\n                                </header>\n                                <div class=\"pricing-body\">\n                                    <ul class=\"pricing-features\">\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Crea evento (1 attivo)</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Gestisci Calendario e Risultati</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Squadre e Giocatori</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Inserisci risultati da App</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Crea Evento da App</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Support</li>\n                                        <li> </li>\n                                        <li> </li>\n                                        <li> </li>\n                                        <li> </li>\n                                    </ul>\n                                </div>\n                            </li>\n                        </ul>\n                    </li>\n                    <li class=\"exclusive\">\n                        <ul class=\"pricing-wrapper\">\n                            <li data-type=\"monthly\" class=\"is-visible\">\n                                <header class=\"pricing-header\">\n                                    <h2>Standard</h2>\n                                    <div class=\"price\">\n                                        <span class=\"currency\">€</span>\n                                        <span class=\"value\">9</span>\n                                        <span class=\"duration\">mese</span>\n                                    </div>\n                                </header>\n                                <div class=\"pricing-body\">\n                                    <ul class=\"pricing-features\">\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Crea evento</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Gestisci Calendario e Risultati</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Squadre e Giocatori</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Inserisci risultati da App</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Crea Evento da App</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Gestisci marcatori</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> 3 Dirigenti Per Aiutarti A Inserire I Risultati</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Support</li>\n                                        <li> </li>\n                                        <li> </li>\n                                    </ul>\n                                </div>\n                            </li>\n                            <li data-type=\"yearly\" class=\"is-hidden\">\n                                <header class=\"pricing-header\">\n                                    <h2>Standard</h2>\n                                    <div class=\"price\">\n                                        <span class=\"currency\">€</span>\n                                        <span class=\"value\">9</span>\n                                        <span class=\"duration\">mese</span>\n                                    </div>\n                                </header>\n                                <div class=\"pricing-body\">\n                                    <ul class=\"pricing-features\">\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Crea evento</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Gestisci Calendario e Risultati</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Squadre e Giocatori</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Inserisci risultati da App</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Crea Evento da App</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Gestisci marcatori</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> 3 Dirigenti Per Aiutarti A Inserire I Risultati</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Support</li>\n                                        <li> </li>\n                                        <li> </li>\n                                    </ul>\n                                </div>\n                            </li>\n                        </ul>\n                    </li>\n                    <li>\n                        <ul class=\"pricing-wrapper\">\n                            <li data-type=\"monthly\" class=\"is-visible\">\n                                <header class=\"pricing-header\">\n                                    <h2>Premium</h2>\n                                    <div class=\"price\">\n                                        <span class=\"currency\">€</span>\n                                        <span class=\"value\">20</span>\n                                        <span class=\"duration\">mese</span>\n                                    </div>\n                                </header>\n                                <div class=\"pricing-body\">\n                                    <ul class=\"pricing-features\">\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Crea evento</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Gestisci Calendario e Risultati</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Squadre e Giocatori</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Inserisci risultati da App</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Crea Evento da App</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Gestisci marcatori</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> 6 Dirigenti Per Aiutarti A Inserire I Risultati</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Disciplinare </li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Comunicati Pdf</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Support</li>\n                                    </ul>\n                                </div>\n                            </li>\n                            <li data-type=\"yearly\" class=\"is-hidden\">\n                                <header class=\"pricing-header\">\n                                    <h2>Premium</h2>\n                                    <div class=\"price\">\n                                        <span class=\"currency\">€</span>\n                                        <span class=\"value\">20</span>\n                                        <span class=\"duration\">mese</span>\n                                    </div>\n                                </header>\n                                <div class=\"pricing-body\">\n                                    <ul class=\"pricing-features\">\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Crea evento</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Gestisci Calendario e Risultati</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Squadre e Giocatori</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Inserisci risultati da App</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Crea Evento da App</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Gestisci marcatori</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> 6 Dirigenti Per Aiutarti A Inserire I Risultati</li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Disciplinare </li>\n                                        <li>\n                                            <em>\n                        <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i>\n                      </em> Comunicati Pdf</li>\n                                        <li>\n                                            <i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i> Support</li>\n                                    </ul>\n                                </div>\n                            </li>\n                        </ul>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </section>\n</div--></section></div>");
$templateCache.put("app/pages/register/register.html","<div class=register-box><div class=register-logo><img src=/assets/images/logo-title-64.png alt=Frispo></div><div class=register-box-body><p class=login-box-msg>REGISTRATI</p><form id=registerForm name=registerForm ng-submit=vm.register($event)><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': registerForm.email.$dirty && registerForm.email.$invalid}\"><input ng-model=vm.user.email name=email type=email class=form-control placeholder=Email required> <span class=\"glyphicon glyphicon-envelope form-control-feedback\"></span> <span ng-show=registerForm.email.$dirty ng-messages=registerForm.email.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span> <span ng-message=email>Inserire un indirizzo email valido</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': registerForm.password.$dirty && registerForm.password.$invalid}\"><input ng-model=vm.user.password name=password type=password class=form-control placeholder=Password required minlength=8> <span class=\"glyphicon glyphicon-lock form-control-feedback\"></span> <span ng-show=registerForm.password.$dirty ng-messages=registerForm.password.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span> <span ng-message=minlength>La password deve essere lunga almeno 8 caratteri</span></span></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': registerForm.retypePassword.$dirty && registerForm.retypePassword.$invalid}\"><input ng-model=vm.user.retypePassword name=retypePassword type=password class=form-control placeholder=\"Retype password\" required compare-to=vm.user.password> <span class=\"glyphicon glyphicon-log-in form-control-feedback\"></span> <span ng-show=registerForm.retypePassword.$dirty ng-messages=registerForm.retypePassword.$error class=help-block role=alert><span ng-message=compareTo>Le due password non coincidono</span></span></div><div class=checkbox-wrapper><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': registerForm.flag_privacy.$dirty && registerForm.flag_privacy.$invalid}\"><div class=\"checkbox icheck\"><div class=\"icheckbox_square-blue pull-right\" aria-checked=false aria-disabled=false><input ng-model=vm.privacy.flag_privacy name=flag_privacy type=checkbox required></div><label for=flag_privacy>accetto <a href=http://frispo.it/privacy_policy/frispo_privacypolicy.pdf>informativa privacy</a> e <a href=http://frispo.it/privacy_policy/frispo_terminiecondizioni.pdf>termini e condizioni d\'uso</a></label></div></div><div class=form-group><div class=\"checkbox icheck\"><div class=\"icheckbox_square-blue pull-right\" aria-checked=false aria-disabled=false><input ng-model=vm.privacy.flag_marketing name=flag_marketing type=checkbox></div><label for=flag_marketing>accetto di ricevere comunicazioni commerciali</label></div></div><div class=form-group><div class=\"checkbox icheck\"><div class=\"icheckbox_square-blue pull-right\" aria-checked=false aria-disabled=false><input ng-model=vm.privacy.flag_profilazione name=flag_profilazione type=checkbox></div><label for=flag_profilazione>accetto la profilazione con l\'obiettivo di ricevere un servizio più personalizzato</label></div></div></div><div class=row><!-- /.col --><div class=col-xs-12><button ng-disabled=registerForm.$invalid type=submit class=\"btn btn-primary btn-block btn-flat\">REGISTRATI</button></div><!-- /.col --></div></form><a ui-sref=main.login class=text-center>ACCEDI</a></div><!-- /.form-box --></div><!-- /.register-box -->");
$templateCache.put("app/pages/scoreboard/scoreboard.html","<div class=calendar><section class=content-header><h1><info-popover title=Classifica body=\"Puoi controllare in questa sezione la classifica dei tuoi tornei. <br/> Puoi inoltre modificarla aggiungendo o togliendo punti e punti disciplina\" ></info-popover>Classifica <small>la classifica dei tuoi tornei</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header><div class=pull-right><button class=\"btn btn-success form-control-button\" style=\"margin-top: 0\" alt=\"esporta classifca\" ng-click=vm.exportData(vm.models.currentEvent.scoreboard)><i class=\"fa fa-download\"></i></button> <button class=\"btn btn-success form-control-button\" style=\"margin-top: 0\" alt=\"esporta classifca\" ng-click=vm.reloaData(vm.models.currentEvent)><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"box-body table-responsive relative\" ng-if=\"vm.models.currentEvent.evenType === 0\"><table class=table><tr><th>Squadra</th><th>Punti</th><th>Partite giocate</th><th>Vittorie</th><th>Pareggi</th><th>Sconfitte</th><th>Goal fatti</th><th>Goal subiti</th><th>Diff Reti</th><th>Disciplina</th></tr><!--  <tr ng-repeat=\"score in vm.models.currentEvent.scoreboard\">\n                <td>{{ score.rankTeamName }}</td>\n                <td>{{ score.rankPoints }}</td>\n                <td>{{ score.rankNumberPlayed }}</td>\n                <td>{{ score.rankWon }}</td>\n                <td>{{ score.rankSame }}</td>\n                <td>{{ score.rankLose }}</td>\n                <td>{{ score.rankGoalScored }}</td>\n                <td>{{ score.rankGoalConceded}}</td>\n                <td>{{ score.rankFoul }}</td>\n              </tr>--><tr ng-repeat-start=\"score in vm.models.currentEvent.scoreboard\" scoreboard-show=score></tr><tr ng-repeat-end scoreboard-edit=score></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=\"box-body table-responsive relative\" ng-if=\"vm.models.currentEvent.evenType === 1\"><div ng-repeat=\"scoreboard in vm.models.currentEvent.scoreboard\"><h4>Girone {{ scoreboard.tournament[0].rankNameGroups }}</h4><table class=table><tr><th>Squadra</th><th>Punti</th><th>Partite giocate</th><th>Vittorie</th><th>Pareggi</th><th>Sconfitte</th><th>Goal fatti</th><th>Goal subiti</th><th>Diff Reti</th><th>Disciplina</th></tr><!--<tr ng-repeat=\"score in scoreboard.tournament\">\n                  <td>{{ score.rankTeamName }}</td>\n                  <td>{{ score.rankNumberPlayed }}</td>\n                  <td>{{ score.rankPoints }}</td>\n                  <td>{{ score.rankWon }}</td>\n                  <td>{{ score.rankSame }}</td>\n                  <td>{{ score.rankLose }}</td>\n                  <td>{{ score.rankGoalScored }}</td>\n                  <td>{{ score.rankGoalConceded}}</td>\n                  <td>{{ score.rankFoul }}</td>\n                </tr>--><tr ng-repeat-start=\"score in scoreboard.tournament \" scoreboard-show=score></tr><tr ng-repeat-end scoreboard-edit=score></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div></div><div class=\"no-content text-center text-muted\" ng-show=\"!vm.loading && !vm.models.currentEvent\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessun evento selezionato</h4><b><i>Seleziona un evento dal menu principale</i></b></div></div></div></div></section><section class=content-header><h1><info-popover title=\"Ordinamento della classifica\" body=\"\" ></info-popover>Ordinamento <small>ordinamento personalizzato della classifica</small></h1></section><section class=content scoreboard-showorder=vm.orderCriteria></section></div>");
$templateCache.put("app/pages/scorers/scorers.html","<div class=scorers><section class=content-header><h1><info-popover title=Marcatori body=\"In questa sezione puoi visualizzare la classifica marcatori <br/> Per ogni marcatore visualizzi le partite e puoi modificare i goal fatti\nin quella partita\" ></info-popover>Classifica marcatori <small>dei tuoi tornei</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header><div class=pull-right><button class=\"btn btn-success form-control-button\" style=\"margin-top: 0\" ng-click=vm.importScorers()>Import marcatori</button> <button class=\"btn btn-success form-control-button\" style=\"margin-top: 0\" alt=\"esporta marcatori\" ng-click=vm.exportData(vm.models.currentEvent.scorers)><i class=\"fa fa-download\"></i></button> <button class=\"btn btn-success form-control-button\" style=\"margin-top: 0\" alt=\"refresh marcatori\" ng-click=vm.reloaData(vm.models.currentEvent)><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentEvent.scorers><table class=table><tr><th>Nome</th><th>Cognome</th><th>Squadra</th><th>Goal</th><th></th></tr><tr dir-paginate-start=\"scorer in vm.models.currentEvent.scorers |itemsPerPage:15\" scorer-show=scorer></tr><tr dir-paginate-end scorer-edit=scorer></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=text-center><dir-pagination-controls max-size=10 direction-links=true boundary-links=true style=align:center></dir-pagination-controls></div><div class=\"no-content text-center text-muted\" ng-show=\"!vm.loading && !vm.models.currentEvent\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessun evento selezionato</h4><b><i>Seleziona un evento dal menu principale</i></b></div></div></div></div></section></div>");
$templateCache.put("app/pages/support/support.html","<div class=profile><!--section class=\"content-header\">\n    <h1>\n      Gestione Profilo\n    </h1>\n  </section--><section class=content><iframe style=\"height: 100%;width: 100%; margin: 0;position:absolute\" src=https://s3-eu-west-1.amazonaws.com/com.frispo.documentation/index.html frameborder=0 marginheight=0 marginwidth=0>Loading...</iframe><!--div class=\"row\">\n      <div class=\"col-xs-12\">\n        <div class=\"box box-success\">\n          <div class=\"box-body\">\n            <form name=\"user-edit\" ng-submit=\"vm.submit()\">\n              <div class=\"row\">\n                <div class=\"col-sm-5 col-md-4 col-lg-3\">\n                  <div class=\"form-group\">\n                    <label for=\"user-edit-type\">Tipologia utente</label>\n                    <select\n                      id=\"user-edit-type\"\n                      name=\"type\"\n                      ng-model=\"vm.form.type\"\n                      class=\"form-control\"\n                      ng-options=\"type.num as type.name for type in vm.userTypes\"\n                      required\n                    >\n                    </select>\n                  </div>\n                </div>\n                <div class=\"col-sm-5 col-md-4 col-lg-3\">\n                  <div class=\"form-group\">\n                    <label for=\"user-edit-subscription\">Abbonamento</label>\n                    <select\n                      id=\"user-edit-subscription\"\n                      name=\"subscription\"\n                      ng-model=\"vm.form.subscription\"\n                      class=\"form-control\"\n                      ng-options=\"subscription.num as subscription.name for subscription in vm.userSubscriptions\"\n                      required\n                    >\n                    </select>\n                  </div>\n                </div>\n                <div class=\"col-sm-2 col-md-2 col-lg-1\">\n                  <div class=\"form-group\">\n                    <label>&nbsp;</label>\n                    <input type=\"submit\" value=\"Salva\" class=\"btn btn-success form-control\">\n                  </div>\n                </div>\n              </div>\n            </form>\n            <div ng-show=\"vm.loading\" class=\"overlay absolute fill\">\n              <i class=\"fa fa-refresh fa-spin\"></i>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div--><div class=row><!--<div class=\"col-xs-12\">--><!--</div>--></div></section></div>");
$templateCache.put("app/pages/teams/teams.html","<div class=teams><section class=content-header><h1><info-popover title=Squadre body=\"Gestisci in questa pagina le squadre del tuo evento. <br/> Inserisci le informazioni, carica il logo e aggiorna l\'Indirizzo\nnelle partite\" ></info-popover>Squadre <small>gestisci le squadre dei tuoi tornei</small></h1></section><section class=content><div class=row><div class=col-xs-12><div class=\"box box-success\"><div class=box-header ng-show=vm.models.currentEvent.teams><div class=pull-right><button class=\"btn btn-success form-control-button\" style=\"margin-right: .4rem\" ng-click=vm.createNewTeam()>Crea nuova squadra</button> <button class=\"btn btn-success form-control-button\" ng-click=vm.exportData(vm.models.currentEvent.teams) alt=\"esporta squadre\"><i class=\"fa fa-download\"></i></button> <button class=\"btn btn-success form-control-button\" alt=\"refresh squadre\" ng-click=vm.reloaData(vm.models.currentEvent)><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"box-body table-responsive relative\" ng-show=vm.models.currentEvent.teams><table class=table><tr><th>Nome</th><th>Capitano</th><th>Telefono</th><th>Orario Preferito</th><th>Giorno Preferito</th><th>Indirizzo Preferito</th><th ng-if=\"vm.models.currentEvent.evenType == 1\">Girone</th><th></th></tr><tr ng-repeat-start=\"team in vm.models.currentEvent.teams\" team-show=team></tr><tr ng-repeat-end team-edit=team></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=box-header ng-show=vm.models.currentEvent.teams><div class=row><div class=\"col-sm-4 col-md-3 col-lg-2\"><div class=form-group><label for=selectEvent>Squadre temporanee</label></div></div></div><div class=\"box-body table-responsive relative\" style=\"min-height: 60px\"><table class=table><tr><th>Nome</th><th>Capitano</th><th>Telefono</th><th>Orario Preferito</th><th>Giorno Preferito</th><th>Indirizzo Preferito</th><th ng-if=\"vm.models.currentEvent.evenType == 1\">Girone</th><th></th></tr><tr ng-repeat-start=\"team in vm.models.currentEvent.tempTeams\" team-show=team></tr><tr ng-repeat-end team-edit=team></tr></table><div ng-show=vm.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div></div><div class=\"no-content text-center text-muted\" ng-show=\"!vm.loading && !vm.models.currentEvent.teams\"><i class=\"fa fa-exclamation-triangle\" aria-hidden=true></i><h4>Nessun evento selezionato</h4><b><i>Seleziona un evento dal menu principale</i></b></div></div></div></div></section></div>");
$templateCache.put("app/components/wizard/wizardProgress/wizardProgress.html","<div class=wizard-progress><i ng-repeat=\"i in wizardProgress.range(wizardProgress.wizard.totalSteps) track by $index\" class=fa ng-class=\"{\n      \'fa-circle\': $index+1 === wizardProgress.wizard.currentStep,\n      \'fa-circle-thin\': $index+1 !== wizardProgress.wizard.currentStep\n    }\">&nbsp;</i></div>");
$templateCache.put("app/components/wizard/wizardStepBox/wizardStepBox.html","<div class=\"wizard-step-box box\" ng-class=\"{\'box-success\': wizardStepBox.active, \'box-default\': !wizardStepBox.active}\"><div class=\"box-header with-border\"><h3 class=box-title>{{ wizardStepBox.title }}</h3><div class=\"box-tools pull-right hidden\"><button class=\"btn btn-box-tool\" data-widget=collapse><i class=\"fa fa-minus\"></i></button></div></div><!-- /.box-header --><div class=box-body><ng-transclude></ng-transclude></div><!-- /.box-body --><div ng-show=\"wizardStepBox.active && wizardStepBox.wizard.loading\" class=overlay><i class=\"fa fa-refresh fa-spin\"></i></div></div><!-- /.box -->");
$templateCache.put("app/pages/adminTeam/create/create.html","<form id=adminTeamCreateForm class=\"invitation-create-form relative\" name=adminTeamCreateForm ng-submit=adminTeamCreate.ok()><div class=modal-header><a role=button class=close ng-click=adminTeamCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Invita nuovo responsabile squadra</h3></div><div class=modal-body><div class=row><div class=col-sm-4><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': adminTeamCreateForm.guestEmail.$dirty && adminTeamCreateForm.guestEmail.$invalid}\"><label for=adminTeamCreateForm-guestEmail>E-mail responsabile</label><input id=adminTeamCreateForm-guestEmail ng-model=adminTeamCreate.form.guestEmail name=guestEmail type=email class=form-control required></div></div><div class=col-sm-4><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': adminTeamCreateForm.events.$dirty && adminTeamCreateForm.events.$invalid}\"><label for=adminTeamCreateForm-events>Seleziona l\'evento</label><select id=adminTeamCreateForm-events ng-model=adminTeamCreate.form.events name=event class=form-control ng-options=\"event as event.evenName for event in adminTeamCreate.events track by event.evenId\" ng-change=adminTeamCreate.updateCurrentEventB()></select></div></div><div class=col-sm-4><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': adminTeamCreateForm.teams.$dirty && adminTeamCreateForm.teams.$invalid}\"><label for=adminTeamCreateForm-teams>Seleziona il team</label><select id=adminTeamCreateForm-teams ng-model=adminTeamCreate.form.teams name=teams class=form-control ng-disabled=!adminTeamCreate.form.events ng-options=\"team as team.teamName for team in adminTeamCreate.teams track by team.teamId\"></select></div></div></div><div ng-show=adminTeamCreate.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=adminTeamCreate.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Manda invito\"></div></form>");
$templateCache.put("app/pages/adminTeam/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=adminTeamDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=adminTeamDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=adminTeamDestroy.ok()>Elimina responsabile squadra</a></div>");
$templateCache.put("app/pages/adminTeam/show/show.html","<tr><td>{{ adminTeamShow.invitation.mailGuest }}</td><td>{{ adminTeamShow.invitation.evenName }}</td><td>{{ adminTeamShow.invitation.teamName }}</td><td>{{ adminTeamShow.invitation.dateInvitationPretty }}</td><!--td>{{ adminTeamShow.invitation.statusPretty }}</td--><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': adminTeamShow.showControls }\"><a role=button class=\"btn btn-sm btn-danger\" ng-click=adminTeamShow.destroy() ng-show=\"AdminTeamShow.invitation.status != \'3\'\"><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/arbiter/create/create.html","<form id=arbiterCreateForm class=relative novalidate name=arbiterCreateForm ng-submit=arbiterCreate.ok(arbiterCreateForm)><div class=modal-header><a role=button class=close ng-click=arbiterCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Crea nuovo arbitro</h3></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterCreate.submitted && arbiterCreateForm.name.$invalid}\"><label for=arbiterCreateForm-name>Nome</label><input id=arbiterCreateForm-name ng-model=arbiterCreate.form.name name=name type=text class=form-control required> <span ng-show=arbiterCreate.submitted ng-messages=arbiterCreateForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterCreate.submitted && arbiterCreateForm.surname.$invalid}\"><label for=arbiterCreateForm-surname>Cognome</label><input id=arbiterCreateForm-surname ng-model=arbiterCreate.form.surname name=surname type=text class=form-control required> <span ng-show=arbiterCreate.submitted ng-messages=arbiterCreateForm.surname.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterCreate.submitted && arbiterCreateForm.card.$invalid}\"><label for=arbiterCreateForm-card>Tessera</label><input id=arbiterCreateForm-card ng-model=arbiterCreate.form.card name=card type=text class=form-control> <span ng-show=arbiterCreate.submitted ng-messages=arbiterCreateForm.card.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterCreate.submitted && arbiterCreateForm.email.$invalid}\"><label for=arbiterCreateForm-email>Mail</label><input id=arbiterCreateForm-email ng-model=arbiterCreate.form.mail name=email type=email class=form-control required> <span ng-show=\"arbiterCreate.submitted && arbiterCreateForm.email.$invalid\" class=help-block role=alert><span>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterCreate.submitted && arbiterCreateForm.phone.$invalid}\"><label for=arbiterCreateForm-phone>Telefono</label><input id=arbiterCreateForm-phone ng-model=arbiterCreate.form.phone name=phone type=tel class=form-control> <span ng-show=arbiterCreate.submitted ng-messages=arbiterCreateForm.phone.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\"><label for=arbiterCreateForm-phone>Evento</label><input id=arbiterCreateForm-phone ng-model=arbiterCreate.event.evenName name=phone type=text class=form-control disabled></div></div></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=arbiterCreate.cancel()>Annulla </a><input type=submit class=\"btn btn-outline\" value=\"Crea arbitro\"></div></form>");
$templateCache.put("app/pages/arbiter/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=arbiterDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=arbiterDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=arbiterDestroy.ok()>Elimina arbitro</a></div>");
$templateCache.put("app/pages/arbiter/edit/edit.html","<tr><td colspan=6 class=\"hidden-row active\"><div id=arbiter-edit-form-{{arbiterEdit.arbiter.arbi_id}} class=\"accordion-body collapse arbiter-edit-form-{{arbiterEdit.arbiter.arbi_id}}\"><form id=arbiterEditForm class=relative novalidate name=arbiterEditForm ng-submit=arbiterEdit.submit(arbiterEditForm)><div class=row><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterEdit.submitted && arbiterEditForm.name.$invalid}\"><label for=arbiterEditForm-name>Nome</label><input id=arbiterEditForm-name-{{arbiterEdit.arbiter.arbi_id}} ng-model=arbiterEdit.form.name ng-init=\"arbiterEdit.form.name = arbiterEdit.arbiter.arbi_name\" name=name type=text class=form-control required> <span ng-show=arbiterEdit.submitted ng-messages=arbiterEditForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterEdit.submitted && arbiterEditForm.surname.$invalid}\"><label for=arbiterEditForm-surname>Cognome</label><input id=arbiterEditForm-surname-{{arbiterEdit.arbiter.arbi_id}} ng-model=arbiterEdit.form.surname ng-init=\"arbiterEdit.form.surname = arbiterEdit.arbiter.arbi_surname\" name=surname type=text class=form-control required> <span ng-show=arbiterEdit.submitted ng-messages=arbiterEditForm.surname.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterEdit.submitted && arbiterEditForm.card.$invalid}\"><label for=arbiterEditForm-card>Tessera</label><input id=arbiterEditForm-card-{{arbiterEdit.arbiter.arbi_id}} ng-model=arbiterEdit.form.card ng-init=\"arbiterEdit.form.card = arbiterEdit.arbiter.arbi_card\" name=card type=text class=form-control required> <span ng-show=arbiterEdit.submitted ng-messages=arbiterEditForm.card.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterEdit.submitted && arbiterEditForm.email.$invalid}\"><label for=arbiterEditForm-email>Mail</label><input id=arbiterEditForm-email-{{arbiterEdit.arbiter.arbi_id}} ng-model=arbiterEdit.form.mail ng-init=\"arbiterEdit.form.mail = arbiterEdit.arbiter.arbi_mail\" name=email type=email class=form-control required> <span ng-show=\"arbiterEdit.submitted && arbiterEditForm.email.$invalid\" class=help-block role=alert><span>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': arbiterEdit.submitted && arbiterEditForm.phone.$invalid}\"><label for=arbiterEditForm-phone>Telefono</label><input id=arbiterEditForm-phone-{{arbiterEdit.arbiter.arbi_id}} ng-model=arbiterEdit.form.phone ng-init=\"arbiterEdit.form.phone = arbiterEdit.arbiter.arbi_phone\" name=phone type=tel class=form-control> <span ng-show=arbiterEdit.submitted ng-messages=arbiterEditForm.phone.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=col-xs-12 style=padding-top:10px><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=arbiterEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div></div></div><div ng-show=arbiterEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/cardMatch/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=cardMatchDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=cardMatchDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=cardMatchDestroy.ok()>Elimina</a></div>");
$templateCache.put("app/pages/cardMatch/show/show.html","<tr><td>{{ cardMatchShow.cardMatch.matcTeamA }} vs {{ cardMatchShow.cardMatch.matcTeamB }}</td><td ng-repeat=\"field in cardMatchShow.config.detailFields\"><form ng-if=cardMatchShow.config.controls.editDetail[field.key] class=\"cardMatch-edit-form relative no-padding\" name=cardMatchShowForm ng-submit=\"\"><select ng-if=\"cardMatchShow.config.controls.editDetail[field.key].type === \'select\'\" ng-model=cardMatchShow.form[field.key] ng-init=\"cardMatchShow.form[field.key] = { value: cardMatchShow.cardMatch[field.key] }\" name={{field.key}} class=\"form-control no-padding\" ng-options=\"opt as opt.name for opt in cardMatchShow.config.controls.editDetail[field.key].options track by opt.value\"><input ng-if=\"cardMatchShow.config.controls.editDetail[field.key].type === \'text\'\" ng-model=cardMatchShow.form[field.key] ng-init=\"cardMatchShow.form[field.key] = cardMatchShow.cardMatch[field.key]\" name={{field.key}} type=text class=form-control></select></form><span ng-if=!cardMatchShow.config.controls.editDetail[field.key]>{{ cardMatchShow.cardMatch[field.key] }}</span></td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': cardMatchShow.showControls }\"><a ng-show=cardMatchShow.config.controls.editDetail role=button class=\"btn btn-sm btn-success\" ng-click=cardMatchShow.submit()>Salva </a><a role=button class=\"btn btn-sm btn-danger\" ng-click=cardMatchShow.destroy() ng-show=cardMatchShow.config.controls.deleteDetail><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/arbiter/show/show.html","<tr><td>{{ arbiterShow.arbiter.arbi_name }}</td><td>{{ arbiterShow.arbiter.arbi_surname }}</td><td>{{ arbiterShow.arbiter.arbi_card }}</td><td>{{ arbiterShow.arbiter.arbi_mail }}</td><td>{{ arbiterShow.arbiter.arbi_phone }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': arbiterShow.showControls }\"><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.arbiter-edit-form-{{arbiterShow.arbiter.arbi_id}}><i class=\"fa fa-pencil\"></i> </a><a role=button class=\"btn btn-sm btn-danger\" ng-click=arbiterShow.destroy()><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/calendar/advancedEdit/advancedEdit.html","<div class=modal-header><a role=button class=close ng-click=matchAdvEdit.cancel()><span aria-hidden=true>×</span></a><h3 class=text-center>{{matchAdvEdit.match.matcTeamA}} vs {{matchAdvEdit.match.matcTeamB}}</h3></div><div class=\"modal-body match-advanced-edit\"><form class=\"match-adv-edit-form relative\" name=matchAdvEditForm ng-submit=matchAdvEdit.submit()><div class=row><div class=\"col-xs-6 input-small-right\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchAdvEditForm.scoreA.$dirty && matchAdvEditForm.scoreA.$invalid}\"><label for=matchAdvEditForm-scoreA>Goal {{matchAdvEdit.match.matcTeamA}}</label><select id=matchAdvEditForm-scoreA ng-model=matchAdvEdit.form.scoreA ng-init=\"matchAdvEdit.form.scoreA = matchAdvEdit.match.matcScoreTeamA\" name=scoreA class=form-control ng-options=\"score as score for score in matchAdvEdit.scores track by score\" ng-change=matchAdvEdit.submit() required></select><span ng-show=matchAdvEditForm.scoreA.$dirty ng-messages=matchAdvEditForm.scoreA.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-xs-6 input-small-left\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchAdvEditForm.scoreB.$dirty && matchAdvEditForm.scoreB.$invalid}\"><label for=matchAdvEditForm-scoreB>Goal {{matchAdvEdit.match.matcTeamB}}</label><select id=matchAdvEditForm-scoreB ng-model=matchAdvEdit.form.scoreB ng-init=\"matchAdvEdit.form.scoreB = matchAdvEdit.match.matcScoreTeamB\" name=scoreB class=form-control ng-options=\"score as score for score in matchAdvEdit.scores track by score\" ng-change=matchAdvEdit.submit() required></select><span ng-show=matchAdvEditForm.scoreB.$dirty ng-messages=matchAdvEditForm.scoreB.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-xs-6 input-small-right\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchAdvEditForm.shootoutA.$dirty && matchAdvEditForm.shootoutA.$invalid}\"><label for=matchAdvEditForm-shootoutA>Rigori {{matchAdvEdit.match.matcTeamA}}</label><select id=matchAdvEditForm-shootoutA ng-model=matchAdvEdit.form.shootoutA ng-init=\"matchAdvEdit.form.shootoutA = matchAdvEdit.match.matcShootoutTeamA\" name=shootoutA class=form-control ng-options=\"score as score for score in matchAdvEdit.scores track by score\" ng-change=matchAdvEdit.submit() required></select><span ng-show=matchAdvEditForm.shootoutA.$dirty ng-messages=matchAdvEditForm.shootoutA.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-xs-6 input-small-left\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchAdvEditForm.shootoutB.$dirty && matchAdvEditForm.shootoutB.$invalid}\"><label for=matchAdvEditForm-shootoutB>Rigori {{matchAdvEdit.match.matcTeamB}}</label><select id=matchAdvEditForm-shootoutB ng-model=matchAdvEdit.form.shootoutB ng-init=\"matchAdvEdit.form.shootoutB = matchAdvEdit.match.matcShootoutTeamB\" name=shootoutB class=form-control ng-options=\"score as score for score in matchAdvEdit.scores track by score\" ng-change=matchAdvEdit.submit() required></select><span ng-show=matchAdvEditForm.shootoutB.$dirty ng-messages=matchAdvEditForm.shootoutB.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div></form><div class=row><div class=col-sm-6><scorers-box scorers=matchAdvEdit.match.matchPlayersTeamA team-name=matchAdvEdit.match.matcTeamA team-id=matchAdvEdit.match.matcTeamIdA match-id=matchAdvEdit.match.matcId scorers-key=matchPlayersTeamA autocomplete=matchAdvEdit.autocompleteA></scorers-box></div><div class=col-sm-6><scorers-box scorers=matchAdvEdit.match.matchPlayersTeamB team-name=matchAdvEdit.match.matcTeamB team-id=matchAdvEdit.match.matcTeamIdB match-id=matchAdvEdit.match.matcId scorers-key=matchPlayersTeamB autocomplete=matchAdvEdit.autocompleteB></scorers-box></div></div><div class=row><div class=col-sm-6><cards-box cards=matchAdvEdit.match.matchCardsTeamA team-name=matchAdvEdit.match.matcTeamA team-id=matchAdvEdit.match.matcTeamIdA match-id=matchAdvEdit.match.matcId cards-key=matchCardsTeamA autocomplete=matchAdvEdit.autocompleteA></cards-box></div><div class=col-sm-6><cards-box cards=matchAdvEdit.match.matchCardsTeamB team-name=matchAdvEdit.match.matcTeamB team-id=matchAdvEdit.match.matcTeamIdB match-id=matchAdvEdit.match.matcId cards-key=matchCardsTeamB autocomplete=matchAdvEdit.autocompleteB></cards-box></div></div><div class=row><div class=col-sm-6><amends-box amends=matchAdvEdit.match.matchAmendsTeamA team-name=matchAdvEdit.match.matcTeamA team-id=matchAdvEdit.match.matcTeamIdA match-id=matchAdvEdit.match.matcId amends-key=matchAmendsTeamA autocomplete=matchAdvEdit.autocompleteA></amends-box></div><div class=col-sm-6><amends-box amends=matchAdvEdit.match.matchAmendsTeamB team-name=matchAdvEdit.match.matcTeamB team-id=matchAdvEdit.match.matcTeamIdB match-id=matchAdvEdit.match.matcId amends-key=matchAmendsTeamB autocomplete=matchAdvEdit.autocompleteB></amends-box></div></div></div><div class=modal-footer><a role=button class=\"btn btn-default pull-left\" ng-click=matchAdvEdit.cancel()>Annulla</a> <a role=button class=\"btn btn-success\" ng-click=matchAdvEdit.ok()>Chiudi</a></div>");
$templateCache.put("app/pages/calendar/addArbiter/add.arbiter.html","<tr><td colspan=10 class=\"hidden-row active\"><div id=match-add-arbiter-form-{{matchArbiter.match.matcId}} class=\"accordion-body collapse match-add-arbiter-form-{{matchArbiter.match.matcId}}\"><form class=\"match-add-arbiter-form relative\" name=matchArbiterForm ng-submit=matchArbiter.submit(matchArbiterForm) novalidate><div class=row><div class=\"col-sm-6 col-lg-4\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchArbiter.submitted && matchArbiterForm.arbiter.$invalid}\"><label for=matchArbiterForm{{matchArbiter.match.matcId}}-arbiter>Assegna arbitro alla partita</label><select id=matchArbiterForm{{matchArbiter.match.matcId}}-arbiter ng-model=matchArbiter.form.arbiter ng-init=\"matchArbiter.form.arbiter = matchArbiter.arbiter\" name=arbiter class=form-control ng-options=\"arbi as (arbi.arbi_name + \' \' + arbi.arbi_surname)\n                    for arbi in matchArbiter.arbiters track by arbi.arbi_id\" ng-change=matchArbiter.onArbiterSelection() required></select><span ng-show=\"matchArbiter.submitted && matchArbiterForm.arbiter.$invalid\" ng-messages=matchArbiterForm.arbiter.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=col-xs-12><div class=pull-left><p ng-if=\"matchArbiter.actualLink.length > 0\" style=\"padding: .8rem; margin: 0; word-break: break-all\"><b>Link referto:</b> <a href=\"{{ matchArbiter.actualLink }}\">{{ matchArbiter.actualLink }}</a><br><b>Codice accesso:</b> {{ matchArbiter.code }}</p></div><div class=pull-right><a ng-if=\"matchArbiter.actualLink.length === 0\" role=button class=\"btn btn-default\" ng-click=matchArbiter.getArbiterDataMail()><i class=\"fa fa-eye-slash\" aria-hidden=true></i> &nbsp;Mostra il link alla pagina del referto </a><a role=button class=\"btn btn-default\" ng-click=matchArbiter.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"> <a role=button class=\"btn btn-info\" ng-click=matchArbiter.sendEmail()>Invia email all\'arbitro</a></div></div></div><div ng-show=matchArbiter.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/calendar/create/create.html","<form id=matchCreateForm class=\"match-create-form relative\" name=matchCreateForm ng-submit=matchCreate.ok()><div class=modal-header><a role=button class=close ng-click=matchCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Crea nuova partita</h3></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchCreateForm.teamA.$dirty && matchCreateForm.teamA.$invalid}\"><label for=matchCreateForm-teamA>Squadra Casa</label><select id=matchCreateForm-teamA ng-model=matchCreate.form.teamA name=teamA class=form-control ng-options=\"team as team.teamName for team in matchCreate.models.currentEvent.teams track by team.teamId\" required></select><span ng-show=matchCreateForm.teamA.$dirty ng-messages=matchCreateForm.teamA.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchCreateForm.teamB.$dirty && matchCreateForm.teamB.$invalid}\"><label for=matchCreateForm-teamB>Squadra Ospite</label><select id=matchCreateForm-teamB ng-model=matchCreate.form.teamB name=teamB class=form-control ng-options=\"team as team.teamName for team in matchCreate.models.currentEvent.teams track by team.teamId\" required></select><span ng-show=matchCreateForm.teamB.$dirty ng-messages=matchCreateForm.teamB.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchCreateForm.scoreA.$dirty && matchCreateForm.scoreA.$invalid}\"><label for=matchCreateForm-scoreA>Goal Casa</label><select id=matchCreateForm-scoreA ng-model=matchCreate.form.scoreA name=scoreA class=form-control ng-options=\"score as score for score in matchCreate.scores track by score\" required></select><span ng-show=matchCreateForm.scoreA.$dirty ng-messages=matchCreateForm.scoreA.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchCreateForm.scoreB.$dirty && matchCreateForm.scoreB.$invalid}\"><label for=matchCreateForm-scoreB>Goal Ospiti</label><select id=matchCreateForm-scoreB ng-model=matchCreate.form.scoreB name=scoreB class=form-control ng-options=\"score as score for score in matchCreate.scores track by score\" required></select><span ng-show=matchCreateForm.scoreB.$dirty ng-messages=matchCreateForm.scoreB.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchCreateForm.date.$dirty && matchCreateForm.date.$invalid}\"><label for=matchCreateForm-date>Data Partita</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input id=matchCreateForm-date ng-model=matchCreate.form.date model=matchCreate.form.date name=date type=text class=form-control datepicker></div></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchCreateForm.time.$dirty && matchCreateForm.time.$invalid}\"><label for=matchCreateForm-time>Ora</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-clock-o\"></i></div><input id=matchCreateForm-time ng-model=matchCreate.form.time name=time type=text class=form-control timepicker></div></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchCreateForm.address.$dirty && matchCreateForm.address.$invalid}\"><label for=matchCreateForm-address>Indirizzo</label><input id=matchCreateForm-address ng-model=matchCreate.form.address name=address type=text class=form-control></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchCreateForm.played.$dirty && matchCreateForm.played.$invalid}\"><label for=matchCreateForm-played>Giocata</label><select id=matchCreateForm-played ng-model=matchCreate.form.played name=played class=form-control ng-options=\"played as played.label for played in [{value: 0, label: \'no\'}, {value: 1, label: \'si\'}, {value:2, label:\'rinviata\'}] track by played.value\" required></select><span ng-show=matchCreateForm.played.$dirty ng-messages=matchCreateForm.played.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchCreateForm.round.$dirty && matchCreateForm.round.$invalid}\"><label for=matchCreateForm-round>Girone</label><select id=matchCreateForm-round ng-model=matchCreate.form.round name=round class=form-control ng-options=\"round for round in matchCreate.models.currentEvent.evenGironi\" required></select><span ng-show=matchCreateForm.round.$dirty ng-messages=matchCreateForm.round.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div ng-show=matchCreate.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=matchCreate.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Crea partita\"></div></form>");
$templateCache.put("app/pages/calendar/createGroup/create.html","<form id=groupCreateForm class=\"match-create-form relative\" name=groupCreateForm ng-submit=groupCreate.ok()><div class=modal-header><a role=button class=close ng-click=groupCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Crea nuovo gruppo</h3></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': groupCreateForm.name.$dirty && groupCreateForm.name.$invalid}\"><label for=groupCreateForm-name>Nome gruppo</label><input id=groupCreateForm-name ng-model=groupCreate.form.name name=name type=text class=form-control required> <span ng-show=groupCreateForm.name.$dirty ng-messages=groupCreateForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div ng-show=groupCreate.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=groupCreate.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Crea gruppo\"></div></form>");
$templateCache.put("app/pages/calendar/createDay/create.html","<form id=dayCreateForm class=\"match-create-form relative\" name=dayCreateForm ng-submit=dayCreate.ok()><div class=modal-header><a role=button class=close ng-click=dayCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Crea nuova giornata</h3></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': dayCreateForm.name.$dirty && dayCreateForm.name.$invalid}\"><label for=dayCreateForm-name>Nome giornata</label><input id=dayCreateForm-name ng-model=dayCreate.form.name name=name type=text class=form-control required> <span ng-show=dayCreateForm.name.$dirty ng-messages=dayCreateForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><!--div class=\"col-sm-6\">\n        <div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': dayCreateForm.desc.$dirty && dayCreateForm.desc.$invalid}\">\n          <label for=\"dayCreateForm-desc\">Descrizione</label>\n          <input\n            id=\"dayCreateForm-desc\"\n            ng-model=\"dayCreate.form.desc\"\n            name=\"desc\"\n            type=\"text\"\n            class=\"form-control\">\n          <span ng-show=\"dayCreateForm.desc.$dirty\" ng-messages=\"dayCreateForm.desc.$error\" class=\"help-block\" role=\"alert\">\n            <span ng-message=\"required\">Questo campo è obbligatorio</span>\n          </span>\n        </div>\n      </div--></div><div ng-show=dayCreate.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=dayCreate.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Crea giornata\"></div></form>");
$templateCache.put("app/pages/calendar/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=matchDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=matchDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=matchDestroy.ok()>Elimina partita</a></div>");
$templateCache.put("app/pages/calendar/edit/edit.html","<tr><td colspan=10 class=\"hidden-row active\"><div id=match-edit-form-{{matchEdit.match.matcId}} class=\"accordion-body collapse match-edit-form-{{matchEdit.match.matcId}}\"><form class=\"match-edit-form relative\" name=matchEditForm ng-submit=matchEdit.submit()><div class=row><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchEditForm.teamA.$dirty && matchEditForm.teamA.$invalid}\"><label for=matchEditForm{{matchEdit.match.matcId}}-teamA>Modifica Squadra Casa</label><select id=matchEditForm{{matchEdit.match.matcId}}-teamA ng-model=matchEdit.form.teamA ng-init=\"matchEdit.form.teamA = { teamId: matchEdit.match.matcTeamIdA }\" name=teamA class=form-control ng-options=\"team as team.teamName for team in matchEdit.models.currentEvent.teams track by team.teamId\" required></select><span ng-show=matchEditForm.teamA.$dirty ng-messages=matchEditForm.teamA.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchEditForm.teamB.$dirty && matchEditForm.teamB.$invalid}\"><label for=matchEditForm{{matchEdit.match.matcId}}-teamB>Modifica Squadra Ospite</label><select id=matchEditForm{{matchEdit.match.matcId}}-teamB ng-model=matchEdit.form.teamB ng-init=\"matchEdit.form.teamB = { teamId: matchEdit.match.matcTeamIdB }\" name=teamB class=form-control ng-options=\"team as team.teamName for team in matchEdit.models.currentEvent.teams track by team.teamId\" required></select><span ng-show=matchEditForm.teamB.$dirty ng-messages=matchEditForm.teamB.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchEditForm.scoreA.$dirty && matchEditForm.scoreA.$invalid}\"><label for=matchEditForm{{matchEdit.match.matcId}}-scoreA>Modifica Goal Casa</label><select id=matchEditForm{{matchEdit.match.matcId}}-scoreA ng-model=matchEdit.form.scoreA ng-init=\"matchEdit.form.scoreA = matchEdit.match.matcScoreTeamA\" name=scoreA class=form-control ng-options=\"score as score for score in matchEdit.scores track by score\" required></select><span ng-show=matchEditForm.scoreA.$dirty ng-messages=matchEditForm.scoreA.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchEditForm.scoreB.$dirty && matchEditForm.scoreB.$invalid}\"><label for=matchEditForm{{matchEdit.match.matcId}}-scoreB>Modifica Goal Ospiti</label><select id=matchEditForm{{matchEdit.match.matcId}}-scoreB ng-model=matchEdit.form.scoreB ng-init=\"matchEdit.form.scoreB = matchEdit.match.matcScoreTeamB\" name=scoreB class=form-control ng-options=\"score as score for score in matchEdit.scores track by score\" required></select><span ng-show=matchEditForm.scoreB.$dirty ng-messages=matchEditForm.scoreB.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchEditForm.date.$dirty && matchEditForm.date.$invalid}\"><label for=matchEditForm{{matchEdit.match.matcId}}-date>Modifica Data Partita</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input id=matchEditForm{{matchEdit.match.matcId}}-date ng-model=matchEdit.form.date model=matchEdit.form.date ng-init=\"matchEdit.form.date = matchEdit.match.matcDateMatch\" name=date type=text class=form-control datepicker></div></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchEditForm.time.$dirty && matchEditForm.time.$invalid}\"><label for=matchEditForm{{matchEdit.match.matcId}}-time>Modifica Ora</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-clock-o\"></i></div><input id=matchEditForm{{matchEdit.match.matcId}}-time ng-model=matchEdit.form.time ng-init=\"matchEdit.form.time = matchEdit.match.matcTime\" name=time type=text class=form-control timepicker></div></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchEditForm.address.$dirty && matchEditForm.address.$invalid}\"><label for=matchEditForm{{matchEdit.match.matcId}}-address>Modifica Indirizzo</label><input id=matchEditForm{{matchEdit.match.matcId}}-address ng-model=matchEdit.form.address ng-init=\"matchEdit.form.address = matchEdit.match.matcAddress\" name=address type=text class=form-control></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchEditForm.played.$dirty && matchEditForm.played.$invalid}\"><label for=matchEditForm{{matchEdit.match.matcId}}-played>Modifica Giocata</label><select id=matchEditForm{{matchEdit.match.matcId}}-played ng-model=matchEdit.form.played ng-init=\"matchEdit.form.played = {value: matchEdit.match.matcFlgPlay}\" name=played class=form-control ng-options=\"played as played.label for played in [{value: 0, label: \'no\'}, {value: 1, label: \'si\'},{value:2, label: \'rinviata\'}] track by played.value\" required></select><span ng-show=matchEditForm.played.$dirty ng-messages=matchEditForm.played.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div ng-if=\"matchEdit.models.currentEvent.evenTypePretty !== \'Campionato italiana\'\" class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': matchEditForm.girone.$dirty && matchEditForm.girone.$invalid}\"><label for=matchEditForm{{matchEdit.match.matcId}}-girone>Modifica Girone</label><select id=matchEditForm{{matchEdit.match.matcId}}-girone ng-model=matchEdit.form.girone ng-init=\"matchEdit.form.girone = { gironeName: matchEdit.match.matcNameGroups }\" name=girone class=form-control ng-options=\"group as group.gironeName for group in matchEdit.groups track by group.gironeName\" required></select><span ng-show=matchEditForm.girone.$dirty ng-messages=matchEditForm.girone.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=col-xs-12><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=matchEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div></div></div><div ng-show=matchEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/calendar/show/show.html","<tr><td>{{ matchShow.match.matcTeamA }}</td><td>{{ matchShow.match.matcTeamB }}</td><td>{{ matchShow.match.matcScoreTeamA }}</td><td>{{ matchShow.match.matcScoreTeamB }}</td><td>{{ matchShow.match.matcDateMatchPretty }}</td><td>{{ matchShow.match.matcTime }}</td><td>{{ matchShow.match.matcAddress }}</td><td ng-if=\"matchShow.models.currentEvent.evenType == 1\">{{ matchShow.match.matcNameGroups }}</td><td>{{ matchShow.match.matcFlgPlay === 1 ? \'si\' : (matchShow.match.matcFlgPlay === 0 ? \'no\' : \'rinviata\') }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': matchShow.showControls }\"><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.match-add-arbiter-form-{{matchShow.match.matcId}} ng-show=\"matchShow.match.matcTeamIdA !== 0 && matchShow.match.matcTeamIdB !== 0\" can=discipline><i class=\"fa fa-user\"></i> </a><a role=button class=\"btn btn-sm btn-default\" ng-click=matchShow.advancedEdit() ng-show=\"matchShow.match.matcTeamIdA !== 0 && matchShow.match.matcTeamIdB !== 0\" can=updatematchfull><i class=\"fa fa-futbol-o\"></i> </a><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.match-edit-form-{{matchShow.match.matcId}}><i class=\"fa fa-pencil\"></i> </a><a role=button class=\"btn btn-sm btn-danger\" ng-click=matchShow.destroy()><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/catalog/confirm/confirm.html","<div class=modal-header><a role=button class=close ng-click=catalogConfirm.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Conferma piano</h3></div><div class=modal-body><p>Vuoi confermare il cambio piano? Verrai contattato.</p></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=catalogConfirm.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=catalogConfirm.ok()>Conferma</a></div>");
$templateCache.put("app/pages/catalog/show/show.html","<button type=button class=\"btn btn-lg\" ng-click=catalogShow.info() data-target=.{{$index}}><span class=\"fa fa-info\"></span></button>");
$templateCache.put("app/pages/catalog/info/info.html","<div class=modal-header><a role=button class=close ng-click=vm.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>{{catalogInfo.product.product_name}}</h3></div><div class=modal-body><p ng-bind-html=catalogInfo.description></p></div><div class=modal-footer><!-- <a role=\"button\" class=\"btn btn-outline pull-left\" ng-click=\"vm.cancel()\">Annulla</a> --></div>");
$templateCache.put("app/pages/catalog/thanks/thanks.html","<div class=modal-header><a role=button class=close ng-click=catalogThanks.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Ringraziamenti</h3></div><div class=modal-body><p>Ti ringraziamo per la richiesta inoltrata. Sarai contattato via mail.</p></div>");
$templateCache.put("app/pages/disciplinary/edit/edit.html","<tr><td colspan=8 class=\"hidden-row active\"><div id=card-edit-form-{{cardEdit.card[cardEdit.config.idKey]}} class=\"accordion-body collapse card-edit-form-{{cardEdit.card[cardEdit.config.idKey]}}\"><table class=table style=\"background: transparent\"><tr><th>Partita</th><th ng-repeat=\"field in cardEdit.config.detailFields\">{{ field.name }}</th><th></th></tr><tr ng-repeat=\"cardMatch in cardEdit.card[cardEdit.config.cardMatchKey]\" card-match-show=cardMatch config=cardEdit.config card-match-player-id=cardEdit.card.playId card-match-team-id=cardEdit.card.teamId></tr></table></div></td></tr>");
$templateCache.put("app/pages/disciplinary/show/show.html","<tr><td ng-repeat=\"field in cardShow.config.fields\">{{ cardShow.card[field.key] }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': cardShow.showControls }\"><a ng-show=cardShow.config.controls.edit role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.card-edit-form-{{cardShow.card[cardShow.config.idKey]}}><i class=\"fa fa-pencil\"></i></a></div></td></tr>");
$templateCache.put("app/pages/events/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=eventDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Se elimini questo evento, verranno eliminati anche tutti dati relativi alle squadre e alle partite associate.<br>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=eventDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=eventDestroy.ok()>Elimina evento</a></div>");
$templateCache.put("app/pages/events/edit/edit.html","<tr><td colspan=8 class=\"hidden-row active\"><div id=event-edit-form-{{eventEdit.event.evenId}} class=\"accordion-body collapse event-edit-form-{{eventEdit.event.evenId}}\"><form class=\"event-edit-form relative\" name=eventEditForm ng-submit=eventEdit.submit()><div class=row><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.name.$dirty && eventEditForm.name.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-name>Modifica Nome</label><input id=eventEditForm{{eventEdit.event.evenId}}-name ng-model=eventEdit.form.name ng-init=\"eventEdit.form.name = eventEdit.event.evenName\" name=name type=text class=form-control placeholder=\"Inserisci il nome dell\'evento\" required> <span ng-show=eventEditForm.name.$dirty ng-messages=eventEditForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.desc.$dirty && eventEditForm.desc.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-desc>Modifica Descrizione</label><input id=eventEditForm{{eventEdit.event.evenId}}-desc ng-model=eventEdit.form.desc ng-init=\"eventEdit.form.desc = eventEdit.event.evenDescription\" name=desc type=text class=form-control placeholder=\"Inserisci una descrizione dell\'evento\" required> <span ng-show=eventEditForm.desc.$dirty ng-messages=eventEditForm.desc.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><!--\n          <div class=\"col-sm-6 col-md-4 col-lg-3\">\n            <div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.currentDay.$dirty && eventEditForm.currentDay.$invalid}\">\n              <label for=\"eventEditForm{{eventEdit.event.evenId}}-currentDay\">Modifica Giornata Corrente</label>\n              <select\n                id=\"eventEditForm{{eventEdit.event.evenId}}-currentDay\"\n                ng-model=\"eventEdit.form.currentDay\"\n                ng-init=\"eventEdit.form.currentDay = eventEdit.event.evenCurrentDay\"\n                name=\"currentDay\"\n                class=\"form-control\"\n                ng-options=\"day as day.matcDayName for day in eventEdit.event.matchDays track by day.matcDayId\"\n                required>\n              </select>\n              <span ng-show=\"eventEditForm.currentDay.$dirty\" ng-messages=\"eventEditForm.currentDay.$error\" class=\"help-block\" role=\"alert\">\n                <span ng-message=\"required\">Questo campo è obbligatorio</span>\n              </span>\n            </div>\n          </div>\n          --><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.dates.$dirty && eventEditForm.dates.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-dates>Modifica Periodo</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input id=eventEditForm{{eventEdit.event.evenId}}-dates ng-model=eventEdit.form.dates model=eventEdit.form.dates ng-init=\"eventEdit.form.dates = eventEdit.event.dates\" name=dates type=text class=form-control placeholder=\"Inserisci la data di inizio e la data di fine\" datepicker=range required></div><span ng-show=eventEditForm.dates.$dirty ng-messages=eventEditForm.dates.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.address.$dirty && eventEditForm.address.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-address>Modifica Indirizzo</label><input id=eventEditForm{{eventEdit.event.evenId}}-address ng-model=eventEdit.form.address ng-init=\"eventEdit.form.address = eventEdit.event.evenAddress\" name=address type=text class=form-control placeholder=\"Inserisci l\'indirizzo dell\'evento\" required> <span ng-show=eventEditForm.address.$dirty ng-messages=eventEditForm.address.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.region.$dirty && eventEditForm.region.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-region>Modifica Regione</label><select id=eventEditForm{{eventEdit.event.evenId}}-region ng-model=eventEdit.form.region ng-init=\"eventEdit.form.region = eventEdit.event.regions\" name=region class=form-control ng-options=\"region as region.regiName for region in eventEdit.models.regions track by region.regiId\" required></select><span ng-show=eventEditForm.region.$dirty ng-messages=eventEditForm.region.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.telephone.$dirty && eventEditForm.telephone.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-telephone>Modifica Telefono Organizzatore</label><input id=eventEditForm{{eventEdit.event.evenId}}-telephone ng-model=eventEdit.form.telephone ng-init=\"eventEdit.form.telephone = eventEdit.event.evenMobilePhone\" name=telephone type=text class=form-control placeholder=\"Inserisci il numero di telefono dell\'organizzatore dell\'evento\" required> <span ng-show=eventEditForm.telephone.$dirty ng-messages=eventEditForm.telephone.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.email.$dirty && eventEditForm.email.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-email>Modifica E-mail Organizzatore</label><input id=eventEditForm{{eventEdit.event.evenId}}-email ng-model=eventEdit.form.email ng-init=\"eventEdit.form.email = eventEdit.event.evenEmail\" name=email type=text class=form-control placeholder=\"Inserisci l\'e-mail dell\'organizzatore dell\'evento\" required> <span ng-show=eventEditForm.email.$dirty ng-messages=eventEditForm.email.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.type.$dirty && eventEditForm.type.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-type>Modifica Tipologia Evento</label><select id=eventEditForm{{eventEdit.event.evenId}}-type ng-model=eventEdit.form.type ng-init=\"eventEdit.form.type = {id: eventEdit.event.evenType}\" name=type class=form-control ng-options=\"type as type.name for type in eventEdit.eventTypes track by type.id\" required></select><span ng-show=eventEditForm.type.$dirty ng-messages=eventEditForm.type.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.formula.$dirty && eventEditForm.formula.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-formula>Modifica Formula</label><select id=eventEditForm{{eventEdit.event.evenId}}-formula ng-model=eventEdit.form.formula ng-init=\"eventEdit.form.formula = {id: eventEdit.event.evenFormula}\" name=formula class=form-control ng-options=\"formula as formula.name for formula in eventEdit.eventFormulas track by formula.id\" required></select><span ng-show=eventEditForm.formula.$dirty ng-messages=eventEditForm.formula.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><!-- DA ATTIVARE A GESTIONE CANALE ISCRIZIONE --><!--div class=\"col-sm-6 col-md-4 col-lg-3\">\n            <div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.even_flg_subscribe.$dirty && eventEditForm.even_flg_subscribe.$invalid}\">\n              <label for=\"eventEditForm{{eventEdit.event.evenId}}-even_flg_subscribe\">Modifica possibilità di iscrizione</label>\n              <select\n                id=\"eventEditForm{{eventEdit.event.evenId}}-even_flg_subscribe\"\n                ng-model=\"eventEdit.form.even_flg_subscribe\"\n                ng-init=\"eventEdit.form.even_flg_subscribe = {id: eventEdit.event.evenFlgSubscribe}\"\n                name=\"even_flg_subscribe\"\n                class=\"form-control\"\n                ng-options=\"even_flg_subscribe as even_flg_subscribe.value for even_flg_subscribe in eventEdit.even_flg_subscribe track by even_flg_subscribe.id\"\n                required>\n              </select>\n              <span ng-show=\"eventEditForm.even_flg_subscribe.$dirty\" ng-messages=\"eventEditForm.even_flg_subscribe.$error\" class=\"help-block\" role=\"alert\">\n                <span ng-message=\"required\">Questo campo è obbligatorio</span>\n              </span>\n            </div>\n          </div--><div class=\"col-sm-6 col-md-4 col-lg-3\" can=discipline><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.yellowPoints.$dirty && eventEditForm.yellowPoints.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-yellowPoints>Punti disciplina ammonizioni</label><select id=eventEditForm{{eventEdit.event.evenId}}-yellowPoints ng-model=eventEdit.form.yellowPoints ng-init=\"eventEdit.form.yellowPoints = eventEdit.event.evenYellowPoints || 0\" name=yellowPoints class=form-control ng-options=\"yellowPoints as yellowPoints for yellowPoints in eventEdit.pointsOptions track by yellowPoints\" required></select><span ng-show=eventEditForm.yellowPoints.$dirty ng-messages=eventEditForm.yellowPoints.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\" can=discipline><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.redPoints.$dirty && eventEditForm.redPoints.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-redPoints>Punti disciplina espulsioni</label><select id=eventEditForm{{eventEdit.event.evenId}}-redPoints ng-model=eventEdit.form.redPoints ng-init=\"eventEdit.form.redPoints = eventEdit.event.evenRedPoints || 0\" name=redPoints class=form-control ng-options=\"redPoints as redPoints for redPoints in eventEdit.pointsOptions track by redPoints\" required></select><span ng-show=eventEditForm.redPoints.$dirty ng-messages=eventEditForm.redPoints.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\" can=discipline><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.yellowDiffide.$dirty && eventEditForm.yellowDiffide.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-yellowDiffide>Numero ammonizioni diffidato</label><select id=eventEditForm{{eventEdit.event.evenId}}-yellowDiffide ng-model=eventEdit.form.yellowDiffide ng-init=\"eventEdit.form.yellowDiffide = eventEdit.event.evenYellowDiffide || 0\" name=yellowDiffide class=form-control ng-options=\"yellowDiffide as yellowDiffide for yellowDiffide in eventEdit.pointsOptions track by yellowDiffide\" required></select><span ng-show=eventEditForm.yellowDiffide.$dirty ng-messages=eventEditForm.yellowDiffide.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\" can=discipline><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.yellowDiffide2.$dirty && eventEditForm.yellowDiffide2.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-yellowDiffide2>N. ammonizioni diffidato dopo squalifica</label><select id=eventEditForm{{eventEdit.event.evenId}}-yellowDiffide2 ng-model=eventEdit.form.yellowDiffide2 ng-init=\"eventEdit.form.yellowDiffide2 = eventEdit.event.evenYellowDiffide2 || 0\" name=yellowDiffide2 class=form-control ng-options=\"yellowDiffide2 as yellowDiffide2 for yellowDiffide2 in eventEdit.pointsOptions track by yellowDiffide2\" required></select><span ng-show=eventEditForm.yellowDiffide2.$dirty ng-messages=eventEditForm.yellowDiffide2.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.event.organizer.$dirty && eventEditForm.event.organizer.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-organizer>Organizzatore</label><input id=eventEditForm{{eventEdit.event.evenId}}-organizer ng-model=eventEdit.form.organizer ng-init=\"eventEdit.form.organizer = eventEdit.event.evenOrganizeBy\" name=organizer class=form-control required><span ng-show=eventEditForm.organizer.$dirty ng-messages=eventEditForm.organizer.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\" can=discipline><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.evenPointsWin.$dirty && eventEditForm.evenPointsWin.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-evenPointsWin>Numero punti per vittoria</label><input id=eventEditForm{{eventEdit.event.evenId}}-evenPointsWin ng-model=eventEdit.form.evenPointsWin ng-init=\"eventEdit.form.evenPointsWin = eventEdit.event.evenPointsWin\" name=evenPointsWin type=number class=form-control placeholder=\"Inserisci numero di punti per vitoria\" required> <span ng-show=eventEditForm.evenPointsWin.$dirty ng-messages=eventEditForm.evenPointsWin.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\" can=discipline><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.evenPointsLose.$dirty && eventEditForm.evenPointsLose.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-evenPointsLose>Numero punti per sconfitta</label><input id=eventEditForm{{eventEdit.event.evenId}}-evenPointsLose ng-model=eventEdit.form.evenPointsLose ng-init=\"eventEdit.form.evenPointsLose = eventEdit.event.evenPointsLose\" name=evenPointsLose type=number class=form-control placeholder=\"Inserisci numero di punti per sconfitta\" required> <span ng-show=eventEditForm.evenPointsLose.$dirty ng-messages=eventEditForm.evenPointsLose.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\" can=discipline><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': eventEditForm.evenPointsSame.$dirty && eventEditForm.evenPointsSame.$invalid}\"><label for=eventEditForm{{eventEdit.event.evenId}}-evenPointsSame>Numero punti per pareggio</label><input id=eventEditForm{{eventEdit.event.evenId}}-evenPointsSame ng-model=eventEdit.form.evenPointsSame ng-init=\"eventEdit.form.evenPointsSame = eventEdit.event.evenPointsSame\" name=evenPointsSame type=number class=form-control placeholder=\"Inserisci numero di punti per pareggio\" required> <span ng-show=eventEditForm.evenPointsSame.$dirty ng-messages=eventEditForm.evenPointsSame.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><!--label>Link Logo</label--> <img src={{eventEdit.event.evenUrlLogo}} width=50% height=50%><!--a role=\"button\" class=\"btn btn-primary form-control\" ng-click=\"eventEdit.showLogo(eventEdit.event.evenUrlLogo)\">Clicca per visualizzare</a--></div></div><div class=row><div class=col-xs-12><div class=pull-left><a role=button class=\"btn btn-primary\" ng-click=eventEdit.recreateCalendar()>Ricrea calendario</a><!--a role=\"button\" class=\"btn btn-primary\" ng-click=\"eventEdit.importCalendar()\">Importa calendario</a--><!--a role=\"button\" class=\"btn btn-primary\" ng-click=\"eventEdit.exportCalendar()\">Esporta calendario</a--> <a role=button class=\"btn btn-primary\" ng-click=eventEdit.recreateCalendar()>Ricrea calendario</a> <a role=button class=\"btn btn-primary\" ng-click=eventEdit.publish() ng-show=\"eventEdit.event.evenStatoEvento != 1\">Pubblica evento</a> <a role=button class=\"btn btn-primary\" ng-click=eventEdit.unpublish() ng-show=\"eventEdit.event.evenStatoEvento == 1\">Imposta come offline</a><label class=\"btn btn-primary\" for=eventEditForm{{eventEdit.event.evenId}}-evenUrlLogo><input id=eventEditForm{{eventEdit.event.evenId}}-evenUrlLogo ng-model=eventEdit.form.evenUrlLogo ng-init=\"eventEdit.form.evenUrlLogo = eventEdit.event.evenUrlLogo\" name=evenUrlLogo type=file onchange=angular.element(this).scope().eventEdit.loadtmp() style=display:none> Carica Logo</label><span id={{eventEdit.event.evenId}}-upload-file-info></span></div><div class=pull-right><div><a role=button class=\"btn btn-default\" ng-click=eventEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div></div></div></div><div ng-show=eventEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/events/edit/exportCalendar.html","<div class=modal-header><a role=button class=close ng-click=exportCalendar.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Esporta calendario</h3></div><div class=modal-body>Vuoi scaricare il calendario completo?</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=exportCalendar.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=exportCalendar.ok()>Esporta</a></div>");
$templateCache.put("app/pages/events/edit/importCalendar.html","<form id=importCalendarForm class=\"player-create-form relative\" name=importCalendarForm ng-submit=importCalendar.ok()><div class=modal-header><a role=button class=close ng-click=importCalendar.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Attenzione</h3></div><div class=modal-body><div class=row><div class=col-sm-12>Importando il calendario le precedenti partite, risultati e classifiche del torneo andranno persi. Questa operazione non è reversibile. Scarica il template per fare l\'import. <a style=\"color: #fff\" href=https://s3-eu-west-1.amazonaws.com/com.codeploy.frispoleague/template_import_calendario.xlsx target=_blank>(clicca qui)</a><div class=form-group style=padding-top:25px><label class=\"btn btn-outline\" for=importCalendarFormFile><input id=importCalendarFormFile ng-model=importCalendar.form.file ng-init=\"importCalendar.form.file = importCalendar.form.file || 0\" name=file type=file ng-click=importCalendar.loadtmp() style=display:none> Carica file</label><span style=\"padding-left: 5px\" id=esitoFileImportCalendar></span></div></div></div><div ng-show=importCalendar.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=importCalendar.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Importa calendario\"></div></form>");
$templateCache.put("app/pages/events/edit/recreateCalendar.html","<div class=modal-header><a role=button class=close ng-click=eventRecreateCalendar.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Tutte le partite e le giornate saranno ricreate. Quelle presenti ora verranno eliminate.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=eventRecreateCalendar.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=eventRecreateCalendar.ok()>Ricrea calendario dell\'evento</a></div>");
$templateCache.put("app/pages/events/show/show.html","<tr style=text-align:left><td>{{ eventShow.event.evenName }}</td><td>{{ eventShow.event.evenTypePretty }}</td><td>{{ eventShow.event.evenFormulaPretty }}</td><td>{{ eventShow.event.regions.regiName }}</td><!--td>{{ eventShow.event.evenDayActiveName }}</td--><td>{{ eventShow.event.evenOrganizeBy }}</td><td class=text-bold style=\"color: #08b7b7\">{{ eventShow.event.evenCode }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': eventShow.showControls }\" ng-show=!eventShow.hideControls><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.event-edit-form-{{eventShow.event.evenId}}><i class=\"fa fa-pencil\"></i> </a><a role=button class=\"btn btn-sm btn-danger\" ng-click=eventShow.destroy()><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/giornate/edit/edit.html","<tr><td colspan=10 class=\"hidden-row active\"><div id=giornata-edit-form class=\"accordion-body collapse giornate-edit-form-{{giornateEdit.giornata.matcDayId}}\"><form class=\"giornate-edit-form relative\" name=giornateEditForm ng-submit=giornateEdit.submit()><div class=row><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': giornateEditForm.matcDayName.$dirty && giornateEditForm.matcDayName.$invalid}\"><label for=giornateEditForm-matcDayName>Modifica Nome</label><input id=giornateEditForm-matcDayName ng-model=giornateEdit.form.matcDayName ng-init=\"giornateEdit.form.matcDayName = giornateEdit.giornata.matcDayName\" name=name type=text class=form-control required></div><span ng-show=giornateEditForm.matcDayName.$dirty ng-messages=giornateEditForm.matcDayName.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': giornateEditForm.year.$dirty && giornateEditForm.year.$invalid}\"><label for=giornateEditForm-year>Modifica anno</label><select id=giornateEditForm-year ng-model=giornateEdit.form.year name=year class=form-control ng-init=\"giornateEdit.form.year = giornateEdit.giornata.matcYear\" ng-change=giornateEdit.getWeeksOfYear() ng-options=\"year as year for year in [\'2017\', \'2018\',\'2019\',\'2020\',\'2021\',\'2022\',\'2023\',\'2024\',\'2025\']\" required></select><span ng-show=giornateEditForm.year.$dirty ng-messages=giornateEditForm.year.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': giornateEditForm.weekOfYear.$dirty && giornateEditForm.weekOfYear.$invalid}\"><label for=giornateEditForm-weekOfYear>Modifica settimana</label><select id=giornateEditForm-weekOfYear ng-model=giornateEdit.form.weekOfYear name=weekOfYear ng-init=\"giornateEdit.form.weekOfYear = giornateEdit.giornata.weekOfYear\" class=form-control ng-options=\"week as week.period for week in giornateEdit.weeksOfYear\" required></select><span ng-show=giornateEditForm.weekOfYear.$dirty ng-messages=giornateEditForm.weekOfYear.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\"><label for=giornateEditForm-update_ranking style=\"margin-right: .5em\">Impatto classifica</label><input ng-if=\"giornateEdit.giornata.matcUpdateRanking==1\" type=checkbox ng-init=\"giornateEdit.form.update_ranking = true\" ng-model=giornateEdit.form.update_ranking name=update_ranking> <input ng-if=\"giornateEdit.giornata.matcUpdateRanking==0\" type=checkbox ng-init=\"giornateEdit.form.update_ranking = false\" ng-model=giornateEdit.form.update_ranking name=update_ranking></div></div></div><div class=row><div class=col-xs-12><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=giornateEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div></div></div><div ng-show=giornateEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/giornate/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=giornateDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=giornateDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=giornateDestroy.ok()>Elimina partita</a></div>");
$templateCache.put("app/pages/giornate/show/show.html","<tr><td>{{ giornateShow.match.matcDayName }}</td><td>{{ giornateShow.match.matcYear }}</td><td>{{ giornateShow.match.matcSettimanaPeriodo }}</td><td ng-if=\"giornateShow.match.matcUpdateRanking==1\">SI</td><td ng-if=\"giornateShow.match.matcUpdateRanking==0\">NO</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': giornateShow.showControls }\"><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.giornate-edit-form-{{giornateShow.match.matcDayId}}><i class=\"fa fa-pencil\"></i> </a><a role=button class=\"btn btn-sm btn-danger\" ng-click=giornateShow.destroy()><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/invitations/create/create.html","<form id=invitationCreateForm class=\"invitation-create-form relative\" name=invitationCreateForm ng-submit=invitationCreate.ok()><div class=modal-header><a role=button class=close ng-click=invitationCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Invita nuovo dirigente</h3></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': invitationCreateForm.guestEmail.$dirty && invitationCreateForm.guestEmail.$invalid}\"><label for=invitationCreateForm-guestEmail>E-mail dirigente</label><input id=invitationCreateForm-guestEmail ng-model=invitationCreate.form.guestEmail name=guestEmail type=email class=form-control required> <span ng-show=invitationCreateForm.guestEmail.$dirty ng-messages=invitationCreateForm.guestEmail.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span> <span ng-message=email>Inserire un indirizzo email valido</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': invitationCreateForm.events.$dirty && invitationCreateForm.events.$invalid}\"><label for=invitationCreateForm-events>Eventi</label><isteven-multi-select id=invitationCreateForm-events name=events input-model=invitationCreate.events output-model=invitationCreate.form.events button-label=evenName item-label=evenName tick-property=ticked output-properties=evenId helper-elements=\"all none filter\" translation=invitationCreate.multiSelectTranslation></isteven-multi-select><span ng-show=invitationCreateForm.events.$dirty ng-messages=invitationCreateForm.events.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div ng-show=invitationCreate.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=invitationCreate.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Manda invito\"></div></form>");
$templateCache.put("app/pages/giornate/updateDay/create.html","<div class=modal-header><a role=button class=close ng-click=updateDayCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Confermando sovrascriverai tutte le date delle partite attualmente impostate. ATTENZIONE! Verranno cambiate solo le date delle partite delle squadre con Giorno Preferito impostato</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=updateDayCreate.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=updateDayCreate.ok()>Conferma</a></div>");
$templateCache.put("app/pages/giornate/updateDay/error.html","<div class=modal-header><a role=button class=close ng-click=updateDayError.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Errore</h3></div><div class=modal-body>Per un errore del sistema la modifica non è avvenuta!</div><div class=modal-footer><a role=button class=\"btn btn-outline\" ng-click=updateDayError.cancel()>Ok</a></div>");
$templateCache.put("app/pages/giornate/updateDay/success.html","<div class=modal-header><a role=button class=close ng-click=updateDaySuccess.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Ottimo</h3></div><div class=modal-body>La modifica è avvenuta correttamente!</div><div class=modal-footer><a role=button class=\"btn btn-outline\" ng-click=updateDaySuccess.cancel()>Ok</a></div>");
$templateCache.put("app/pages/invitations/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=invitationDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=invitationDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=invitationDestroy.ok()>Elimina dirigente</a></div>");
$templateCache.put("app/pages/invitations/show/show.html","<tr><td>{{ invitationShow.invitation.mailGuest }}</td><td>{{ invitationShow.invitation.evenName }}</td><td>{{ invitationShow.invitation.dateInvitationPretty }}</td><td>{{invitationShow.invitation.status === \'0\' ? \'in attesa\' : (invitationShow.invitation.status === \'1\' ? \'confermato\' : (invitationShow.invitation.status === \'2\' ? \'rifiutato\' : \'cancellato\') )}}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': invitationShow.showControls }\"><a role=button class=\"btn btn-sm btn-danger\" ng-click=invitationShow.destroy() ng-show=\"invitationShow.invitation.status != \'3\'\"><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/iscrizioni/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=iscrizioneDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=iscrizioneDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=iscrizioneDestroy.ok()>Elimina iscrizione</a></div>");
$templateCache.put("app/pages/iscrizioni/edit/edit.html","<tr><td colspan=10 class=\"hidden-row active\"><div id=iscrizione-edit-form-{{iscrizioneEdit.iscrizione.subscribe_id}} class=\"accordion-body collapse iscrizione-edit-form-{{iscrizioneEdit.iscrizione.subscribe_id}}\"><form class=\"iscrizione-edit-form relative\" name=iscrizioneEditForm ng-submit=iscrizioneEdit.submit()><div class=row><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': iscrizioneEditForm.note.$dirty && iscrizioneEditForm.note.$invalid}\"><label for=iscrizioneEditForm{{iscrizioneEdit.iscrizione.subscribe_id}}-note>Modifica note</label><input id=iscrizioneEditForm{{iscrizioneEdit.iscrizione.subscribe_id}}-note ng-model=iscrizioneEdit.form.note ng-init=\"iscrizioneEdit.form.note = iscrizioneEdit.iscrizione.note\" name=note type=text class=form-control required></div><span ng-show=iscrizioneEditForm.note.$dirty ng-messages=iscrizioneEditForm.note.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=row><div class=col-xs-12><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=iscrizioneEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div></div></div><div ng-show=iscrizioneEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/iscrizioni/show/show.html","<tr><td>{{ iscrizioneShow.iscrizione.nome_squadra }}</td><td>{{ iscrizioneShow.iscrizione.nome }}</td><td>{{ iscrizioneShow.iscrizione.cognome }}</td><td>{{ iscrizioneShow.iscrizione.email }}</td><td>{{ iscrizioneShow.iscrizione.recapito }}</td><td>{{ iscrizioneShow.iscrizione.note }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': iscrizioneShow.showControls }\"><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.iscrizione-edit-form-{{iscrizioneShow.iscrizione.subscribe_id}}><i class=\"fa fa-pencil\"></i> </a><a role=button class=\"btn btn-sm btn-danger\" ng-click=iscrizioneShow.destroy()><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/managerMatches/edit/edit.html","<tr><td colspan=10 class=\"hidden-row active\"><div id=manager-match-edit-form-{{managerMatchEdit.match.matcId}} class=\"accordion-body collapse manager-match-edit-form-{{managerMatchEdit.match.matcId}}\"><form class=\"manager-match-edit-form relative\" name=managerMatchEditForm ng-submit=managerMatchEdit.submit()><div class=row><input id=managerMatchEditForm{{managerMatchEdit.match.matcId}}-teamA ng-model=managerMatchEdit.form.teamA ng-init=\"managerMatchEdit.form.teamA = { teamId: managerMatchEdit.match.matcTeamIdA }\" type=hidden name=teamA required> <input id=managerMatchEditForm{{managerMatchEdit.match.matcId}}-teamB ng-model=managerMatchEdit.form.teamB ng-init=\"managerMatchEdit.form.teamB = { teamId: managerMatchEdit.match.matcTeamIdB }\" type=hidden name=teamB required><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': managerMatchEditForm.scoreA.$dirty && managerMatchEditForm.scoreA.$invalid}\"><label for=managerMatchEditForm{{managerMatchEdit.match.matcId}}-scoreA>Modifica Goal Casa</label><select id=managerMatchEditForm{{managerMatchEdit.match.matcId}}-scoreA ng-model=managerMatchEdit.form.scoreA ng-init=\"managerMatchEdit.form.scoreA = managerMatchEdit.match.matcScoreTeamA\" name=scoreA class=form-control ng-options=\"score as score for score in managerMatchEdit.scores track by score\" required></select><span ng-show=managerMatchEditForm.scoreA.$dirty ng-messages=managerMatchEditForm.scoreA.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': managerMatchEditForm.scoreB.$dirty && managerMatchEditForm.scoreB.$invalid}\"><label for=managerMatchEditForm{{managerMatchEdit.match.matcId}}-scoreB>Modifica Goal Ospiti</label><select id=managerMatchEditForm{{managerMatchEdit.match.matcId}}-scoreB ng-model=managerMatchEdit.form.scoreB ng-init=\"managerMatchEdit.form.scoreB = managerMatchEdit.match.matcScoreTeamB\" name=scoreB class=form-control ng-options=\"score as score for score in managerMatchEdit.scores track by score\" required></select><span ng-show=managerMatchEditForm.scoreB.$dirty ng-messages=managerMatchEditForm.scoreB.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': managerMatchEditForm.date.$dirty && managerMatchEditForm.date.$invalid}\"><label for=managerMatchEditForm{{managerMatchEdit.match.matcId}}-date>Modifica Data Partita</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-calendar\"></i></div><input id=managerMatchEditForm{{managerMatchEdit.match.matcId}}-date ng-model=managerMatchEdit.form.date model=managerMatchEdit.form.date ng-init=\"managerMatchEdit.form.date = managerMatchEdit.match.matcDateMatch\" name=date type=text class=form-control datepicker></div></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': managerMatchEditForm.time.$dirty && managerMatchEditForm.time.$invalid}\"><label for=managerMatchEditForm{{managerMatchEdit.match.matcId}}-time>Modifica Ora</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-clock-o\"></i></div><input id=managerMatchEditForm{{managerMatchEdit.match.matcId}}-time ng-model=managerMatchEdit.form.time ng-init=\"managerMatchEdit.form.time = managerMatchEdit.match.matcTime\" name=time type=text class=form-control timepicker></div></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': managerMatchEditForm.address.$dirty && managerMatchEditForm.address.$invalid}\"><label for=managerMatchEditForm{{managerMatchEdit.match.matcId}}-address>Modifica Indirizzo</label><input id=managerMatchEditForm{{managerMatchEdit.match.matcId}}-address ng-model=managerMatchEdit.form.address ng-init=\"managerMatchEdit.form.address = managerMatchEdit.match.matcAddress\" name=address type=text class=form-control></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': managerMatchEditForm.played.$dirty && managerMatchEditForm.played.$invalid}\"><label for=managerMatchEditForm{{managerMatchEdit.match.matcId}}-played>Modifica Giocata</label><select id=managerMatchEditForm{{managerMatchEdit.match.matcId}}-played ng-model=managerMatchEdit.form.played ng-init=\"managerMatchEdit.form.played = {value: managerMatchEdit.match.matcFlgPlay}\" name=played class=form-control ng-options=\"played as played.label for played in [{value: 0, label: \'no\'}, {value: 1, label: \'si\'}, {value:2, label: \'rinviata\'}] track by played.value\" required></select><span ng-show=managerMatchEditForm.played.$dirty ng-messages=managerMatchEditForm.played.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=col-xs-12><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=managerMatchEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div></div></div><div ng-show=managerMatchEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/managerMatches/show/show.html","<tr><td>{{ managerMatchShow.match.matcTeamA }}</td><td>{{ managerMatchShow.match.matcTeamB }}</td><td>{{ managerMatchShow.match.matcScoreTeamA }}</td><td>{{ managerMatchShow.match.matcScoreTeamB }}</td><td>{{ managerMatchShow.match.matcDateMatchPretty }}</td><td>{{ managerMatchShow.match.matcTime }}</td><td>{{ managerMatchShow.match.matcAddress }}</td><td ng-if=\"managerMatchShow.models.currentEvent.evenType == 1\">{{ managerMatchShow.match.matcNameGroups }}</td><td>{{ managerMatchShow.match.matcFlgPlay === 1 ? \'si\' : ( managerMatchShow.match.matcFlgPlay === 0 ? \'no\' : \'rinviata\') }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': managerMatchShow.showControls }\"><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.manager-match-edit-form-{{managerMatchShow.match.matcId}}><i class=\"fa fa-pencil\"></i></a></div></td></tr>");
$templateCache.put("app/pages/players/create/create.html","<form id=playerCreateForm class=\"player-create-form relative\" name=playerCreateForm ng-submit=playerCreate.ok()><div class=modal-header><a role=button class=close ng-click=playerCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Crea nuovo giocatore</h3></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': playerCreateForm.name.$dirty && playerCreateForm.name.$invalid}\"><label for=playerCreateForm-name>Nome</label><input id=playerCreateForm-name ng-model=playerCreate.form.name name=name type=text class=form-control required></div><span ng-show=playerCreateForm.name.$dirty ng-messages=playerCreateForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': playerCreateForm.surname.$dirty && playerCreateForm.surname.$invalid}\"><label for=playerCreateForm-surname>Cognome</label><input id=playerCreateForm-surname ng-model=playerCreate.form.surname name=surname type=text class=form-control required></div><span ng-show=playerCreateForm.surname.$dirty ng-messages=playerCreateForm.surname.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': playerCreateForm.tessera.$dirty && playerCreateForm.tessera.$invalid}\"><label for=playerCreateForm-tessera>Tessera</label><input id=playerCreateForm-tessera ng-model=playerCreate.form.tessera name=tessera type=text class=form-control></div><span ng-show=playerCreateForm.tessera.$dirty ng-messages=playerCreateForm.tessera.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': playerCreateForm.recapito.$dirty && playerCreateForm.recapito.$invalid}\"><label for=playerCreateForm-recapito>Recapito</label><input id=playerCreateForm-recapito ng-model=playerCreate.form.recapito name=recapito type=text class=form-control></div><span ng-show=playerCreateForm.recapito.$dirty ng-messages=playerCreateForm.recapito.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div ng-show=playerCreate.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=playerCreate.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Crea giocatore\"></div></form>");
$templateCache.put("app/pages/players/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=playerDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=playerDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=playerDestroy.ok()>Elimina giocatore</a></div>");
$templateCache.put("app/pages/players/import/import.html","<form id=importPlayersForm class=\"player-create-form relative\" name=importPlayersForm ng-submit=importPlayers.ok()><div class=modal-header><a role=button class=close ng-click=importPlayers.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Import giocatori</h3></div><div class=modal-body><div class=row><div class=col-sm-12>Scarica il template per fare l\'import. <a style=\"color: #fff\" href=https://s3-eu-west-1.amazonaws.com/com.codeploy.frispoleague/template_import_giocatori.xlsx target=_blank>(clicca qui)</a><div class=form-group style=padding-top:25px><label class=\"btn btn-outline\" for=importPlayersFormFile><input id=importPlayersFormFile ng-model=importPlayers.form.file ng-init=\"importPlayers.form.file = importPlayers.form.file || 0\" name=file type=file onchange=angular.element(this).scope().importPlayers.loadtmp() style=display:none> Carica file</label><span style=\"padding-left: 5px\" id=esitoFileImportPlayers></span></div></div></div><div ng-show=importPlayers.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=importPlayers.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Importa giocatori\"></div></form>");
$templateCache.put("app/pages/players/edit/edit.html","<tr><td colspan=10 class=\"hidden-row active\"><div id=player-edit-form-{{playerEdit.player.playId}} class=\"accordion-body collapse player-edit-form-{{playerEdit.player.playId}}\"><form class=\"player-edit-form relative\" name=playerEditForm ng-submit=playerEdit.submit()><div class=row><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': playerEditForm.name.$dirty && playerEditForm.name.$invalid}\"><label for=playerEditForm{{playerEdit.player.playId}}-name>Modifica Nome</label><input id=playerEditForm{{playerEdit.player.playId}}-name ng-model=playerEdit.form.name ng-init=\"playerEdit.form.name = playerEdit.player.playFirstname\" name=name type=text class=form-control required></div><span ng-show=playerEditForm.name.$dirty ng-messages=playerEditForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': playerEditForm.surname.$dirty && playerEditForm.surname.$invalid}\"><label for=playerEditForm{{playerEdit.player.playId}}-surname>Modifica Cognome</label><input id=playerEditForm{{playerEdit.player.playId}}-surname ng-model=playerEdit.form.surname ng-init=\"playerEdit.form.surname = playerEdit.player.playSurname\" name=surname type=text class=form-control required></div><span ng-show=playerEditForm.surname.$dirty ng-messages=playerEditForm.surname.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': playerEditForm.tessera.$dirty && playerEditForm.tessera.$invalid}\"><label for=playerEditForm{{playerEdit.player.playId}}-tessera>Modifica Tessera</label><input id=playerEditForm{{playerEdit.player.playId}}-tessera ng-model=playerEdit.form.tessera ng-init=\"playerEdit.form.tessera = playerEdit.player.playTessera\" name=tessera type=text class=form-control></div><span ng-show=playerEditForm.tessera.$dirty ng-messages=playerEditForm.tessera.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': playerEditForm.recapito.$dirty && playerEditForm.recapito.$invalid}\"><label for=playerEditForm{{playerEdit.player.playId}}-recapito>Modifica Recapito</label><input id=playerEditForm{{playerEdit.player.playId}}-recapito ng-model=playerEdit.form.recapito ng-init=\"playerEdit.form.recapito = playerEdit.player.playRecapito\" name=recapito type=text class=form-control></div><span ng-show=playerEditForm.recapito.$dirty ng-messages=playerEditForm.recapito.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=row><div class=col-xs-12><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=playerEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div></div></div><div ng-show=playerEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/players/show/show.html","<tr><td>{{ playerShow.player.playFirstname }}</td><td>{{ playerShow.player.playSurname }}</td><td>{{ playerShow.player.playTessera }}</td><td>{{ playerShow.player.playRecapito }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': playerShow.showControls }\"><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.player-edit-form-{{playerShow.player.playId}}><i class=\"fa fa-pencil\"></i> </a><a role=button class=\"btn btn-sm btn-danger\" ng-click=playerShow.destroy()><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/playersMove/confirmPopup/confirm.html","<div class=modal-header><a role=button class=close ng-click=confirmPopup.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>{{operazione}}</h3></div><div class=modal-body ng-if=\"operazione == \'Sposta giocatori\'\">Sei sicuro di voler procedere ? Questa operazione <strong>non è reversibile</strong>. Ti ricordiamo che con l\'operazione Sposta perderai i giocatori dalla squadra di origine. Verranno spostati i giocatori e anche i marcatori verranno spostati</div><div class=modal-body ng-if=\"operazione == \'Copia giocatori\'\">Sei sicuro di voler procedere ? Questa operazione <strong>non è reversibile</strong>. I giocatori verranno copiati nella squadra di destinazione, ma non verranno rimossi dalla prima</div><div class=modal-footer><a role=button class=\"btn btn-default\" ng-click=confirmPopup.cancel()>Annulla</a> <a role=button class=\"btn btn-success\" ng-click=confirmPopup.ok()>Conferma</a></div>");
$templateCache.put("app/pages/press/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=pressDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=pressDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=pressDestroy.ok()>Elimina comunicato</a></div>");
$templateCache.put("app/pages/press/create/create.html","<form id=pressCreateForm class=\"press-create-form relative\" name=pressCreateForm ng-submit=pressCreate.ok()><div class=modal-header><a role=button class=close ng-click=pressCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Crea nuovo comunicato</h3><p>La giornata presa in considerazione è quella di partenza. Per cambiarla accedi alla sezione eventi.</p></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': pressCreateForm.name.$dirty && pressCreateForm.name.$invalid}\"><label for=pressCreateForm-name>Nome comunicato</label><input id=pressCreateForm-name ng-model=pressCreate.form.name name=name type=text class=form-control required> <span ng-show=pressCreateForm.name.$dirty ng-messages=pressCreateForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6 ng-repeat=\"field in pressCreate.selectFields\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': pressCreateForm[field.key].$dirty && pressCreateForm[field.key].$invalid}\"><label for=pressCreateForm-round>{{ field.name }}</label><select id=pressCreateForm-round ng-init=\"pressCreate.form[field.key] = { id: 1 }\" ng-model=pressCreate.form[field.key] name={{field.key}} class=form-control ng-options=\"opt as opt.name for opt in field.options track by opt.id\"></select><span ng-show=pressCreateForm.round.$dirty ng-messages=pressCreateForm.round.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-12><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': pressCreateForm.events.$dirty && pressCreateForm.events.$invalid}\"><label for=pressCreateForm-events>Eventi inclusi nel comunicato</label><isteven-multi-select id=pressCreateForm-events name=events input-model=pressCreate.events output-model=pressCreate.form.events button-label=evenName item-label=evenName tick-property=ticked output-properties=evenId helper-elements=\"all none filter\" translation=pressCreate.multiSelectTranslation></isteven-multi-select><span ng-show=pressCreateForm.events.$dirty ng-messages=pressCreateForm.events.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div ng-show=pressCreate.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=pressCreate.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Crea comunicato\"></div></form>");
$templateCache.put("app/pages/press/edit/edit.html","<tr><td colspan=8 class=\"hidden-row active\"><div id=press-edit-form-{{pressEdit.press.presId}} class=\"accordion-body collapse press-edit-form-{{pressEdit.press.presId}}\"><form class=\"press-edit-form relative\" name=pressEditForm ng-submit=pressEdit.submit()><div class=row><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': pressEditForm.name.$dirty && pressEditForm.name.$invalid}\"><label for=pressEditForm{{pressEdit.press.presId}}-name>Modifica Nome</label><input id=pressEditForm{{pressEdit.press.presId}}-name ng-model=pressEdit.form.name ng-init=\"pressEdit.form.name = pressEdit.press.pressName\" name=name type=text class=form-control required> <span ng-show=pressEditForm.name.$dirty ng-messages=pressEditForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': pressEditForm.status.$dirty && pressEditForm.status.$invalid}\"><label for=pressEditForm{{pressEdit.press.presId}}-status>Modifica Stato</label><select id=pressEditForm{{pressEdit.press.presId}}-status ng-model=pressEdit.form.status ng-init=\"pressEdit.form.status = {id: pressEdit.press.pressStato}\" name=status class=form-control ng-options=\"status as status.name for status in pressEdit.pressStatuses track by status.id\" required></select><span ng-show=pressEditForm.status.$dirty ng-messages=pressEditForm.status.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=col-xs-12><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=pressEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div></div></div><div ng-show=pressEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/press/load/load.html","<form id=pressLoadForm class=\"press-create-form relative\" name=pressLoadForm ng-submit=pressLoad.ok()><div class=modal-header><a role=button class=close ng-click=pressLoad.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Carica comunicato</h3></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': pressLoadForm.name.$dirty && pressLoadForm.name.$invalid }\"><label for=pressLoadForm-name>Nome comunicato</label><input ng-model=pressLoad.form.name id=pressLoadForm-name name=name type=text class=form-control required> <span ng-show=pressLoadForm.name.$dirty ng-messages=pressLoadForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': pressLoadForm.events.$dirty && pressLoadForm.events.$invalid}\"><label for=pressLoadForm-events>Eventi inclusi nel comunicato</label><isteven-multi-select id=pressLoadForm-events name=events required input-model=pressLoad.events output-model=pressLoad.form.events button-label=evenName item-label=evenName tick-property=ticked output-properties=evenId helper-elements=\"all none filter\" translation=pressLoad.multiSelectTranslation></isteven-multi-select><span ng-show=pressLoadForm.events.$dirty ng-messages=pressLoadForm.events.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-12><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': pressLoadForm.file.$dirty && pressLoadForm.file.$invalid}\"><label for=pressLoadForm-file>Scegli il comunicato</label><br><label class=\"btn btn-outline\" for=pressLoadForm-file><input id=pressLoadForm-file ng-model=pressLoad.form.file name=file type=file accept=application/pdf style=display:none required onchange=\"$(\'#upload-file-info\').html($(this)[0].files[0].name)\"> Cerca</label><span class=label id=upload-file-info></span></div></div></div><div ng-show=pressCreate.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=pressLoad.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Carica comunicato\"></div></form>");
$templateCache.put("app/pages/press/show/show.html","<tr><td>{{ pressShow.press.pressName }}</td><td>{{ pressShow.press.pressStatoPretty }}</td><td><a href={{pressShow.press.pressUrl}} target=_blank>Scarica il PDF</a></td><td><a href={{pressShow.press.pressUrlWord}} target=_blank>Scarica WORD</a></td><td>{{ pressShow.press.pressDatePretty }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': pressShow.showControls }\"><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.press-edit-form-{{pressShow.press.presId}}><i class=\"fa fa-pencil\"></i> </a><a role=button class=\"btn btn-sm btn-danger\" ng-click=pressShow.destroy()><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/profile/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=profileDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Se elimini il profilo, verranno eliminati anche tutti i tuoi dati relativi alle squadre, partite e tornei.<br>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=profileDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=profileDestroy.ok()>Elimina profilo</a></div>");
$templateCache.put("app/pages/scoreboard/edit/edit.html","<tr><td colspan=10 class=\"hidden-row active\"><div id=scoreboard-edit-form-{{scoreboardEdit.event.rankTeamId}} class=\"accordion-body collapse scoreboard-edit-form-{{scoreboardEdit.event.rankTeamId}}\"><form class=\"scoreboard-edit-form relative\" name=scoreboardEditForm ng-submit=scoreboardEdit.submit()><div class=row><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': scoreboardEditForm.punti.$dirty && scoreboardEditForm.punti.$invalid}\"><label for=scoreboardEditForm{{scoreboardEdit.event.rankTeamId}}-punti>Modifica punti</label><input id=scoreboardEditForm{{scoreboardEdit.event.rankTeamId}}-punti ng-model=scoreboardEdit.form.punti ng-init=\"scoreboardEdit.form.punti = scoreboardEdit.event.rankVarPoints\" name=punti type=number class=form-control placeholder=\"Inserisci i punti della squadra\" required> <span ng-show=scoreboardEditForm.punti.$dirty ng-messages=scoreboardEditForm.punti.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': scoreboardEditForm.disciplina.$dirty && scoreboardEditForm.disciplina.$invalid}\"><label for=scoreboardEditForm{{scoreboardEdit.event.rankTeamId}}-disciplina>Modifica disciplina</label><input id=scoreboardEditForm{{scoreboardEdit.event.rankTeamId}}-disciplina ng-model=scoreboardEdit.form.disciplina ng-init=\"scoreboardEdit.form.disciplina = scoreboardEdit.event.rankVarFoul\" name=disciplina type=number class=form-control placeholder=\"Inserisci la disciplina della squadra\" required> <span ng-show=scoreboardEditForm.disciplina.$dirty ng-messages=scoreboardEditForm.disciplina.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div class=row><div class=col-xs-12><div class=pull-right><div><a role=button class=\"btn btn-default\" ng-click=scoreboardEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div></div></div></div><div ng-show=scoreboardEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/scoreboard/show/show.html","<tr><td>{{ scoreboardShow.event.rankTeamName }}</td><td>{{ scoreboardShow.event.rankPoints }}</td><td>{{ scoreboardShow.event.rankNumberPlayed }}</td><td>{{ scoreboardShow.event.rankWon }}</td><td>{{ scoreboardShow.event.rankSame }}</td><td>{{ scoreboardShow.event.rankLose }}</td><td>{{ scoreboardShow.event.rankGoalScored }}</td><td>{{ scoreboardShow.event.rankGoalConceded }}</td><td>{{ scoreboardShow.event.rankDiffReti }}</td><td>{{ scoreboardShow.event.rankFoul }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': scoreboardShow.showControls }\" ng-show=!scoreboardShow.hideControls><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.scoreboard-edit-form-{{scoreboardShow.event.rankTeamId}}><i class=\"fa fa-pencil\"></i></a></div></td></tr>refresh");
$templateCache.put("app/pages/scoreboard/showorder/showorder.html","<div class=row><div class=\"col-xs-12 dnd-order-wrapper\"><div class=\"box box-success\"><ul dnd-list=scoreboardShoworder.lists><li ng-repeat=\"item in scoreboardShoworder.lists\" dnd-draggable=item dnd-moved=\"scoreboardShoworder.lists.splice($index, 1)\" dnd-effect-allowed=move dnd-selected=\"scoreboardShoworder.selected = item\" ng-class=\"{\'selected\': scoreboardShoworder.selected === item}\">{{item.name}}</li></ul></div><a role=button class=\"btn btn-success\" ng-click=scoreboardShoworder.saveOrder()>Salva ordinamento</a></div></div>");
$templateCache.put("app/pages/scorerMatch/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=scorerMatchDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=scorerMatchDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=scorerMatchDestroy.ok()>Elimina punteggio</a></div>");
$templateCache.put("app/pages/scorerMatch/show/show.html","<tr><td>{{scorerMatchShow.scorerMatch.matcTeamA == \'Riposo\' && scorerMatchShow.scorerMatch.matcTeamB == \'Riposo\' ? \'IMPORTAZIONE MARCATORI\' : scorerMatchShow.scorerMatch.matcTeamA+\' vs \'+scorerMatchShow.scorerMatch.matcTeamB+\' - data partita: \'+scorerMatchShow.scorerMatch.matcDateMatch }}</td><td><form class=\"scorerMatch-edit-form relative no-padding\" name=scorerMatchShowForm ng-submit=scorerMatchShow.submit()><select ng-model=scorerMatchShow.form.goal ng-init=\"scorerMatchShow.form.goal = scorerMatchShow.scorerMatch.matcScorerGoal\" name=goal type=text class=\"form-control no-padding\" style=\"max-width: 80px\" ng-options=\"goal as goal for goal in scorerMatchShow.scores track by goal\" ng-change=scorerMatchShow.submitGoal()></select></form></td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': scorerMatchShow.showControls }\"><a role=button class=\"btn btn-sm btn-danger\" ng-click=scorerMatchShow.destroy()><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/scorers/edit/edit.html","<tr><td colspan=8 class=\"hidden-row active\"><div id=scorer-edit-form-{{scorerEdit.scorer.scorId}} class=\"accordion-body collapse scorer-edit-form-{{scorerEdit.scorer.scorId}}\"><table class=table style=\"background: transparent\"><tr><th>Partita</th><th>Goal</th><th></th></tr><tr ng-repeat=\"scorerMatch in scorerEdit.scorer.matcScorers\" scorer-match-show=scorerMatch scorer-match-player-id=scorerEdit.scorer.scorPlayId></tr></table></div></td></tr>");
$templateCache.put("app/pages/scorers/import/import.html","<form id=importScorersForm class=\"player-create-form relative\" name=importScorersForm ng-submit=importScorers.ok()><div class=modal-header><a role=button class=close ng-click=importScorers.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Import marcatori</h3></div><div class=modal-body><div class=row><div class=col-sm-12>Scarica il template per fare l\'import. <a style=\"color: #fff\" href=https://s3-eu-west-1.amazonaws.com/com.codeploy.frispoleague/template_import_marcatori.xlsx target=_blank>(clicca qui)</a><div class=form-group style=padding-top:25px><label class=\"btn btn-outline\" for=importScorersFormFile><input id=importScorersFormFile ng-model=importScorers.form.file ng-init=\"importScorers.form.file = importScorers.form.file || 0\" name=file type=file onchange=angular.element(this).scope().importScorers.loadtmp() style=display:none> Carica file</label><span style=\"padding-left: 5px\" id=esitoFileImportScorers></span></div></div></div><div ng-show=importScorers.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=importScorers.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Importa marcatori\"></div></form>");
$templateCache.put("app/pages/teams/create/create.html","<form id=teamCreateForm class=\"team-create-form relative\" name=teamCreateForm ng-submit=teamCreate.ok()><div class=modal-header><a role=button class=close ng-click=teamCreate.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Crea nuova squadra</h3></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamCreateForm.name.$dirty && teamCreateForm.name.$invalid}\"><label for=teamCreateForm-name>Nome</label><input id=teamCreateForm-name ng-model=teamCreate.form.name name=name type=text class=form-control required> <span ng-show=teamCreateForm.name.$dirty ng-messages=teamCreateForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamCreateForm.captain.$dirty && teamCreateForm.captain.$invalid}\"><label for=teamCreateForm-captain>Capitano</label><input id=teamCreateForm-captain ng-model=teamCreate.form.captain name=captain type=text class=form-control> <span ng-show=teamCreateForm.captain.$dirty ng-messages=teamCreateForm.captain.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamCreateForm.phone.$dirty && teamCreateForm.phone.$invalid}\"><label for=teamCreateForm-phone>Telefono</label><input id=teamCreateForm-phone ng-model=teamCreate.form.phone name=phone type=text class=form-control> <span ng-show=teamCreateForm.phone.$dirty ng-messages=teamCreateForm.phone.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamCreateForm.time.$dirty && teamCreateForm.time.$invalid}\"><label for=teamCreateForm-time>Orario Preferito</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-clock-o\"></i></div><input id=teamCreateForm-time ng-model=teamCreate.form.time name=time type=text class=form-control timepicker></div><span ng-show=teamCreateForm.time.$dirty ng-messages=teamCreateForm.time.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamCreateForm.place.$dirty && teamCreateForm.place.$invalid}\"><label for=teamCreateForm-place>Luogo Preferito</label><input id=teamCreateForm-place ng-model=teamCreate.form.place name=place type=text class=form-control> <span ng-show=teamCreateForm.place.$dirty ng-messages=teamCreateForm.place.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamCreateForm.address.$dirty && teamCreateForm.address.$invalid}\"><label for=teamCreateForm-address>Indirizzo</label><input id=teamCreateForm-address ng-model=teamCreate.form.address name=address type=text class=form-control> <span ng-show=teamCreateForm.address.$dirty ng-messages=teamCreateForm.address.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6 ng-show=\"teamCreate.models.currentEvent.evenType == 1\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamCreateForm.round.$dirty && teamCreateForm.round.$invalid}\"><label for=teamCreateForm-round>Girone</label><select id=teamCreateForm-round ng-init=\"teamCreate.form.round = \'A\'\" ng-model=teamCreate.form.round name=round class=form-control ng-options=\"roundName as roundName for roundName in teamCreate.roundNames track by roundName\" required></select><span ng-show=teamCreateForm.round.$dirty ng-messages=teamCreateForm.round.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=col-sm-6 ng-show=\"teamCreate.models.currentEvent.evenType == 1\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamCreateForm.temp.$dirty && teamCreateForm.temp.$invalid}\"><label for=teamCreateForm-temp>Tipo Squadra</label><select id=teamCreateForm-temp ng-init=\"teamCreate.form.temp.id = 1\" ng-model=teamCreate.form.temp name=temp class=form-control ng-options=\"temp as temp.name for temp in teamCreate.teamFormulas track by temp.id==1\" required></select><span ng-show=teamCreateForm.temp.$dirty ng-messages=teamCreateForm.temp.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div></div><div ng-show=teamCreate.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=teamCreate.cancel()>Annulla</a> <input type=submit class=\"btn btn-outline\" value=\"Crea squadra\"></div></form>");
$templateCache.put("app/pages/scorers/show/show.html","<tr><td>{{ scorerShow.scorer.scorPlayFirstname }}</td><td>{{ scorerShow.scorer.scorPlaySurname }}</td><td>{{ scorerShow.scorer.scorTeamName }}</td><td>{{ scorerShow.scorer.scorGoal }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': scorerShow.showControls }\"><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.scorer-edit-form-{{scorerShow.scorer.scorId}}><i class=\"fa fa-pencil\"></i></a></div></td></tr>");
$templateCache.put("app/pages/teams/destroy/destroy.html","<div class=modal-header><a role=button class=close ng-click=teamDestroy.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro?</h3></div><div class=modal-body>Questa operazione <strong>non è reversibile</strong>.</div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=teamDestroy.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=teamDestroy.ok()>Elimina squadra</a></div>");
$templateCache.put("app/pages/teams/edit/edit.html","<tr><td colspan=8 class=\"hidden-row active\"><div id=team-edit-form-{{teamEdit.team.teamId}} class=\"accordion-body collapse team-edit-form-{{teamEdit.team.teamId}}\"><form class=\"team-edit-form relative\" name=teamEditForm ng-submit=teamEdit.submit()><div class=row><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamEditForm.name.$dirty && teamEditForm.name.$invalid}\"><label for=teamEditForm{{teamEdit.team.teamId}}-name>Nome</label><input id=teamEditForm{{teamEdit.team.teamId}}-name ng-model=teamEdit.form.name ng-init=\"teamEdit.form.name = teamEdit.team.teamName\" name=name type=text class=form-control required> <span ng-show=teamEditForm.name.$dirty ng-messages=teamEditForm.name.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamEditForm.captain.$dirty && teamEditForm.captain.$invalid}\"><label for=teamEditForm{{teamEdit.team.teamId}}-captain>Capitano</label><input id=teamEditForm{{teamEdit.team.teamId}}-captain ng-model=teamEdit.form.captain ng-init=\"teamEdit.form.captain = teamEdit.team.teamCaptain\" name=captain type=text class=form-control> <span ng-show=teamEditForm.captain.$dirty ng-messages=teamEditForm.captain.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamEditForm.phone.$dirty && teamEditForm.phone.$invalid}\"><label for=teamEditForm{{teamEdit.team.teamId}}-phone>Telefono</label><input id=teamEditForm{{teamEdit.team.teamId}}-phone ng-model=teamEdit.form.phone ng-init=\"teamEdit.form.phone = teamEdit.team.teamMobilePhone\" name=phone type=text class=form-control> <span ng-show=teamEditForm.phone.$dirty ng-messages=teamEditForm.phone.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamEditForm.time.$dirty && teamEditForm.time.$invalid}\"><label for=teamEditForm{{teamEdit.team.teamId}}-time>Orario Preferito</label><div class=input-group><div class=input-group-addon><i class=\"fa fa-clock-o\"></i></div><input id=teamEditForm{{teamEdit.teamId}}-time ng-model=teamEdit.form.time ng-init=\"teamEdit.form.time = teamEdit.team.teamTime\" name=time type=text class=form-control timepicker></div><span ng-show=teamEditForm.time.$dirty ng-messages=teamEditForm.time.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamEditForm.playday.$dirty && teamEditForm.playday.$invalid}\"><label for=teamEditForm{{teamEdit.team.teamId}}-playday>Modifica giorno preferito</label><select id=teamEditForm{{teamEdit.teamId}}-playday ng-model=teamEdit.form.playday name=playday class=form-control ng-init=\"teamEdit.form.playday = teamEdit.team.teamPlayday\" ng-options=\"day as day.value for day in teamEdit.week track by day.id\" required></select><span ng-show=teamEditForm.year.$dirty ng-messages=teamEditForm.year.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamEditForm.place.$dirty && teamEditForm.place.$invalid}\"><label for=teamEditForm{{teamEdit.team.teamId}}-place>Indirizzo Preferito</label><input id=teamEditForm{{teamEdit.team.teamId}}-place ng-model=teamEdit.form.place ng-init=\"teamEdit.form.place = teamEdit.team.teamPlace\" name=place type=text class=form-control> <span ng-show=teamEditForm.place.$dirty ng-messages=teamEditForm.place.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\" ng-show=\"teamEdit.models.currentEvent.evenType == 1\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamEditForm.round.$dirty && teamEditForm.round.$invalid}\"><label for=teamEditForm{{teamEdit.team.teamId}}-round>Gruppo</label><input id=teamEditForm{{teamEdit.team.teamId}}-round ng-model=teamEdit.form.round ng-init=\"teamEdit.form.round = teamEdit.team.teamGroups\" name=round type=text class=form-control> <span ng-show=teamEditForm.round.$dirty ng-messages=teamEditForm.round.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamEditForm.temp.$dirty && teamEditForm.temp.$invalid}\"><label for=teamEditForm{{teamEdit.team.teamId}}-temp>Modifica Tipologia Squadra</label><select id=teamEditForm{{teamEdit.team.teamId}}-temp ng-model=teamEdit.form.temp ng-init=\"teamEdit.form.temp = {id: teamEdit.team.teamTemp}\" name=temp class=form-control ng-options=\"temp as temp.name for temp in teamEdit.teamFormulas track by temp.id\" required></select><span ng-show=teamEditForm.temp.$dirty ng-messages=teamEditForm.temp.$error class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-6 col-md-4 col-lg-3\"><!--label>Logo</label--> <img src={{teamEdit.team.teamUrlLogo}} width=50% height=50%><!--a role=\"button\" class=\"btn btn-primary form-control\" ng-click=\"teamEdit.showLogo(teamEdit.team.teamUrlLogo)\">Clicca per visualizzare</a--></div></div><div class=row><div class=col-xs-12 style=padding-top:10px><div class=pull-left><label class=\"btn btn-primary\" for=teamEditForm{{teamEdit.team.teamId}}-teamUrlLogo><input id=teamEditForm{{teamEdit.team.teamId}}-teamUrlLogo ng-model=teamEdit.form.teamLogo ng-init=\"teamEdit.form.teamLogo = teamEdit.form.teamLogo || 0\" name=teamLogo type=file onchange=angular.element(this).scope().teamEdit.loadtmp() style=display:none> Carica Logo</label><span id={{teamEdit.team.teamId}}-upload-file-info></span></div><div class=pull-right><a role=button class=\"btn btn-default\" ng-click=teamEdit.cancel()>Annulla</a> <input type=submit value=Salva class=\"btn btn-success\"></div><div class=\"col-xs-3 pull-left\"><a role=button class=\"btn btn-primary\" ng-click=teamEdit.updatePlace(teamEdit.team.teamPlace)>Aggiorna Indirizzo su partite</a></div></div></div><div ng-show=teamEdit.loading class=\"overlay absolute fill\"><i class=\"fa fa-refresh fa-spin\"></i></div></form></div></td></tr>");
$templateCache.put("app/pages/teams/edit/updatePlace.html","<form id=teamCreateForm class=\"team-create-form relative\" name=teamCreateForm ng-submit=teamUpdatePlace.ok()><div class=modal-header><a role=button class=close ng-click=teamUpdatePlace.cancel()><span aria-hidden=true>×</span></a><h3 class=modal-title>Sei sicuro di voler aggiornare l\'indirizzo di tutte le partite di casa della squadra ?</h3></div><div class=modal-body><div class=row><div class=col-sm-6><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': teamEditForm.place.$dirty && teamEditForm.place.$invalid}\"><label for=teamEditForm{{teamEdit.team.teamId}}-place>indirizzo</label><input id=teamEditForm{{teamUpdatePlace.team.teamId}}-place ng-model=teamUpdatePlace.luogo name=place type=text class=form-control></div></div></div></div><div class=modal-footer><a role=button class=\"btn btn-outline pull-left\" ng-click=teamUpdatePlace.cancel()>Annulla</a> <a role=button class=\"btn btn-outline\" ng-click=teamUpdatePlace.ok()>Salva</a></div></form>");
$templateCache.put("app/pages/teams/show/show.html","<tr><td>{{ teamShow.team.teamName }}</td><td>{{ teamShow.team.teamCaptain }}</td><td>{{ teamShow.team.teamMobilePhone }}</td><td>{{ teamShow.team.teamTime }}</td><td>{{ teamShow.team.teamPlayday.value }}</td><td>{{ teamShow.team.teamPlace }}</td><td ng-if=\"teamShow.models.currentEvent.evenType == 1\">{{ teamShow.team.teamGroups }}</td><td><div class=\"pull-right no-opacity opacity-transition\" ng-class=\"{ \'full-opacity\': teamShow.showControls }\"><a role=button class=\"btn btn-sm btn-default accordion-toggle\" data-toggle=collapse data-target=.team-edit-form-{{teamShow.team.teamId}}><i class=\"fa fa-pencil\"></i> </a><a role=button class=\"btn btn-sm btn-danger\" ng-click=teamShow.destroy()><i class=\"fa fa-trash\"></i></a></div></td></tr>");
$templateCache.put("app/pages/calendar/advancedEdit/amendsBox/amendsBox.html","<div class=\"panel panel-primary\"><div class=panel-heading>Ammende {{ amendsBox.teamName }}</div><div class=panel-body><table class=table ng-show=\"amendsBox.amends.length  > 0\"><tr><th>Descrizione</th><th>Punti</th><th>Euro</th><th></th></tr><tr ng-repeat=\"amend in amendsBox.amends\" show-on-hover=\"#removeAmendButton{{ amend.amenId }}\"><td>{{ amend.amenDescription }}</td><td>{{ amend.amenPoints }}</td><td>{{ amend.amenEuro }}</td><td><div class=pull-right id=\"removeAmendButton{{ amend.amenId }}\"><a role=button class=\"btn btn-sm btn-danger\" ng-click=amendsBox.destroyAmend(amend)><i class=\"fa fa-trash\"></i></a></div></td></tr></table><form id=\"createAmendForm{{ amendsBox.teamId }}\" name=\"createAmendForm{{ amendsBox.teamId }}\" ng-submit=amendsBox.createAmend()><div class=row><div class=col-sm-12><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createAmendForm\' + amendsBox.teamId].description.$dirty && this[\'createAmendForm\' + amendsBox.teamId].description.$invalid}\"><label for=\"createAmendForm{{ amendsBox.teamId }}-description\">Descrizione</label><input id=\"createAmendForm{{ amendsBox.teamId }}-description\" type=text ng-model=amendsBox.form.description placeholder=\"Note ammenda\" class=form-control name=description> <span ng-show=\"this[\'createAmendForm\' + amendsBox.teamId].description.$dirty\" ng-messages=\"this[\'createAmendForm\' + amendsBox.teamId].description.$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-5 small-padding-right\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createAmendForm\' + amendsBox.teamId].points.$dirty && this[\'createAmendForm\' + amendsBox.teamId].points.$invalid}\"><label for=\"createAmendForm{{ amendsBox.teamId }}-points\">Punti</label><input id=\"createAmendForm{{ amendsBox.teamId }}-points\" type=text ng-model=amendsBox.form.points placeholder=\"Punti ammenda\" class=form-control name=points> <span ng-show=\"this[\'createAmendForm\' + amendsBox.teamId].points.$dirty\" ng-messages=\"this[\'createAmendForm\' + amendsBox.teamId].points.$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-4 small-padding-left small-padding-right\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createAmendForm\' + amendsBox.teamId].euro.$dirty && this[\'createAmendForm\' + amendsBox.teamId].euro.$invalid}\"><label for=\"createAmendForm{{ amendsBox.teamId }}-euro\">Euro</label><input id=\"createAmendForm{{ amendsBox.teamId }}-euro\" type=text ng-model=amendsBox.form.euro placeholder=\"Euro ammenda\" class=form-control name=euro> <span ng-show=\"this[\'createAmendForm\' + amendsBox.teamId].euro.$dirty\" ng-messages=\"this[\'createAmendForm\' + amendsBox.teamId].euro.$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-3 small-padding-left\"><label>&nbsp;</label><input class=\"btn btn-primary form-control\" type=submit value=Aggiungi></div></div></form></div></div>");
$templateCache.put("app/pages/calendar/advancedEdit/cardsBox/cardsBox.html","<div class=\"panel panel-primary\"><div class=panel-heading>Cartellini {{ cardsBox.teamName }}</div><div class=panel-body><table class=table ng-show=\"cardsBox.cards.length  > 0\"><tr><th>Marcatore</th><th>Tipo diffida</th><th></th></tr><tr ng-repeat=\"card in cardsBox.cards\" show-on-hover=\"#removeCardButton{{ card.playId + \'\' + card.cardId }}\"><td>{{ card.playName }} {{ card.playSurname }}</td><td>{{ card.flgCardsPretty }}</td><td><div class=pull-right id=\"removeCardButton{{ card.playId + \'\' + card.cardId }}\"><a role=button class=\"btn btn-sm btn-danger\" ng-click=cardsBox.destroyCard(card)><i class=\"fa fa-trash\"></i></a></div></td></tr></table><form id=\"createCardForm{{ cardsBox.teamId }}\" name=\"createCardForm{{ cardsBox.teamId }}\" ng-submit=cardsBox.createCard()><div class=row><div class=\"col-sm-7 small-padding-right\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createCardForm\' + cardsBox.teamId].name.$dirty && this[\'createCardForm\' + cardsBox.teamId].name.$invalid}\"><label for=\"createCardForm{{ cardsBox.teamId }}-name\">Nome Marcatore</label><input id=\"createCardForm{{ cardsBox.teamId }}-name\" type=text ng-model=cardsBox.typeaheadName ng-model-options=\"{getterSetter: true}\" placeholder=\"Nome marcatore\" uib-typeahead=\"player as (player.name + \' \' + player.surname) for player in cardsBox.autocomplete | filter:{name:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 autocomplete=off class=form-control name=name> <span ng-show=\"this[\'createCardForm\' + cardsBox.teamId].name.$dirty\" ng-messages=\"this[\'createCardForm\' + cardsBox.teamId].name.$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-5 small-padding-left\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createCardForm\' + cardsBox.teamId].cardType.$dirty && this[\'createCardForm\' + cardsBox.teamId].cardType.$invalid}\"><label for=\"createCardForm{{ cardsBox.teamId }}-cardType\">Tipo diffida</label><select id=\"createCardForm{{ cardsBox.teamId }}-cardType\" ng-model=cardsBox.form.cardType ng-init=\"cardsBox.form.cardType = cardsBox.cardTypes[0]\" name=cardType class=\"form-control no-padding-right\" ng-options=\"cardType as cardType.name for cardType in cardsBox.cardTypes track by cardType.id\" required></select></div></div><div class=\"col-sm-7 small-padding-right\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createCardForm\' + cardsBox.teamId].surname.$dirty && this[\'createCardForm\' + cardsBox.teamId].surname.$invalid}\"><label for=\"createCardForm{{ cardsBox.teamId }}-surname\">Cognome Marcatore</label><input id=\"createCardForm{{ cardsBox.teamId }}-surname\" type=text ng-model=cardsBox.typeaheadSurname ng-model-options=\"{getterSetter: true}\" placeholder=\"Cognome marcatore\" uib-typeahead=\"player as (player.name + \' \' + player.surname) for player in cardsBox.autocomplete | filter:{surname:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 autocomplete=off class=form-control name=surname> <span ng-show=\"this[\'createCardForm\' + cardsBox.teamId].surname.$dirty\" ng-messages=\"this[\'createCardForm\' + cardsBox.teamId].surname.$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-5 small-padding-left\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createCardForm\' + cardsBox.teamId].disqualificationDays.$dirty && this[\'createCardForm\' + cardsBox.teamId].disqualificationDays.$invalid}\"><label for=\"createCardForm{{ cardsBox.teamId }}-disqualificationDays\">Giorni di squalifica</label><select id=\"createCardForm{{ cardsBox.teamId }}-disqualificationDays\" ng-model=cardsBox.form.disqualificationDays ng-init=\"cardsBox.form.disqualificationDays = 0\" ng-disabled=\"cardsBox.form.cardType.id === 0\" name=disqualificationDays class=\"form-control no-padding-right\" ng-options=\"day as day for day in cardsBox.disqualificationDays track by day\" required></select></div></div><div class=\"col-sm-9 small-padding-right\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createCardForm\' + cardsBox.teamId].note.$dirty && this[\'createCardForm\' + cardsBox.teamId].note.$invalid}\"><label for=\"createCardForm{{ cardsBox.teamId }}-note\">Note</label><input id=\"createCardForm{{ cardsBox.teamId }}-note\" type=text ng-model=cardsBox.form.note placeholder=\"Note diffida\" class=form-control name=note> <span ng-show=\"this[\'createCardForm\' + cardsBox.teamId].note.$dirty\" ng-messages=\"this[\'createCardForm\' + cardsBox.teamId].note.$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-3 small-padding-left\"><label>&nbsp;</label><input class=\"btn btn-primary form-control\" type=submit value=Aggiungi></div></div></form></div></div>");
$templateCache.put("app/pages/calendar/advancedEdit/scorersBox/scorersBox.html","<div class=\"panel panel-primary\"><div class=panel-heading>Marcatori {{ scorersBox.teamName }}</div><div class=panel-body><table class=table ng-show=\"scorersBox.scorers.length  > 0\"><tr><th>Marcatore</th><th>Goal</th><th></th></tr><tr ng-repeat=\"scorer in scorersBox.scorers\" show-on-hover=\"#removeScorerButton{{ scorer.playId }}\"><td>{{ scorer.playName }} {{ scorer.playSurname }}</td><td>{{ scorer.goal }}</td><td><div class=pull-right id=\"removeScorerButton{{ scorer.playId }}\"><a role=button class=\"btn btn-sm btn-danger\" ng-click=scorersBox.destroyScorer(scorer)><i class=\"fa fa-trash\"></i></a></div></td></tr></table><form id=\"createScorerForm{{ scorersBox.teamId }}\" name=\"createScorerForm{{ scorersBox.teamId }}\" ng-submit=scorersBox.createScorer()><div class=row><div class=\"col-sm-9 small-padding-right\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createScorerForm\' + scorersBox.teamId].name.$dirty && this[\'createScorerForm\' + scorersBox.teamId].name.$invalid}\"><label for=\"createScorerForm{{ scorersBox.teamId }}-name\">Nome Marcatore</label><input id=\"createScorerForm{{ scorersBox.teamId }}-name\" type=text ng-model=scorersBox.typeaheadName ng-model-options=\"{getterSetter: true}\" placeholder=\"Nome marcatore\" uib-typeahead=\"player as (player.name + \' \' + player.surname) for player in scorersBox.autocomplete | filter:{name:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 autocomplete=off class=form-control name=name> <span ng-show=\"this[\'createScorerForm\' + scorersBox.teamId].name.$dirty\" ng-messages=\"this[\'createScorerForm\' + scorersBox.teamId].name.$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-3 small-padding-left\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createScorerForm\' + scorersBox.teamId].goals.$dirty && this[\'createScorerForm\' + scorersBox.teamId].goals.$invalid}\"><label for=\"createScorerForm{{ scorersBox.teamId }}-goals\">Goals</label><select id=\"createScorerForm{{ scorersBox.teamId }}-goals\" ng-model=scorersBox.form.goals name=goals class=\"form-control no-padding-right\" ng-options=\"score as score for score in scorersBox.scores track by score\" required></select></div></div><div class=\"col-sm-9 small-padding-right\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': this[\'createScorerForm\' + scorersBox.teamId].surname.$dirty && this[\'createScorerForm\' + scorersBox.teamId].surname.$invalid}\"><label for=\"createScorerForm{{ scorersBox.teamId }}-surname\">Cognome Marcatore</label><input id=\"createScorerForm{{ scorersBox.teamId }}-surname\" type=text ng-model=scorersBox.typeaheadSurname ng-model-options=\"{getterSetter: true}\" placeholder=\"Cognome marcatore\" uib-typeahead=\"player as (player.name + \' \' + player.surname) for player in scorersBox.autocomplete | filter:{surname:$viewValue}\" typeahead-show-hint=true typeahead-min-length=0 autocomplete=off class=form-control name=surname> <span ng-show=\"this[\'createScorerForm\' + scorersBox.teamId].surname.$dirty\" ng-messages=\"this[\'createScorerForm\' + scorersBox.teamId].surname.$error\" class=help-block role=alert><span ng-message=required>Questo campo è obbligatorio</span></span></div></div><div class=\"col-sm-3 small-padding-left\"><label>&nbsp;</label><input class=\"btn btn-primary form-control\" type=submit value=Aggiungi></div></div></form></div></div>");}]);